webpackJsonp([1],{

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);


/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

var GlobalDirectives = {
    install: function install(Vue) {
        Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+YzX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            album: {
                status: 0,
                tracks_number: 0,
                translations: [],
                image_src: null,
                image_src_full: null,
                sort: 1
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/albums');
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var album = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.album));

            album.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/albums/create', album, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0410\u043B\u044C\u0431\u043E\u043C \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/albums');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.album.image_src = data.url;
                self.album.image_src_full = data.url_full;
                self.album.image_src_size = data.filesize;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }
    }
});

/***/ }),

/***/ "+daF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Категории")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('c_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить категорию\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):(column === 'templates')?_c('span',[_vm._v("количество шаблонов")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'name')?_c('span',[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активна")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активна")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+iwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__ = __webpack_require__("Pfth");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dd0fec1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__ = __webpack_require__("+daF");
function injectStyle (ssrContext) {
  __webpack_require__("xtqh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1dd0fec1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dd0fec1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/4dZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/8N7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("pEA8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_249c0dc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("0TtX");
function injectStyle (ssrContext) {
  __webpack_require__("y4V3")
  __webpack_require__("CBL3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-249c0dc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_249c0dc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/ANq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Bd9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n                © 2017, made with\n                "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n            ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/ERI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostsPreviewNola_vue__ = __webpack_require__("THFC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffe7be4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostsPreviewNola_vue__ = __webpack_require__("I94V");
function injectStyle (ssrContext) {
  __webpack_require__("Rfq/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ffe7be4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostsPreviewNola_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffe7be4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostsPreviewNola_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Ffv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("xdsI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4853698a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("a5f4");
function injectStyle (ssrContext) {
  __webpack_require__("0Itt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4853698a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4853698a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/nKp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("JWN9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fc98031_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("nQqz");
function injectStyle (ssrContext) {
  __webpack_require__("YdHr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fc98031"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fc98031_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "06e1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__("M4fF");
var axios = __webpack_require__("mtWM");
var moment = __webpack_require__("PJh5");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        var self = this;

        var token = localStorage.getItem('token');

        axios.get(this.$hostname + '/admin/categories/', {
            'params': {},
            'headers': {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (response) {
            self.loading = false;
            self.categories = response.data;

            self.get();
        }).catch(function (error) {
            self.loading = false;
            console.log(error);
        });
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'is_premium', 'push_type', 'videos', 'duration', 'sort', 'status', ''],
            data: [],
            role: parseInt(localStorage.getItem('role')) || 0,
            categoryId: localStorage.getItem('ctt_category') ? localStorage.getItem('ctt_category') : "",
            status: localStorage.getItem('ctt_status') ? localStorage.getItem('ctt_status') : "",
            isTrendy: localStorage.getItem('ctt_is_trendy') ? localStorage.getItem('ctt_is_trendy') : "",
            isCopyrighted: localStorage.getItem('ctt_is_copyrighted') ? localStorage.getItem('ctt_is_copyrighted') : "",
            isNew: localStorage.getItem('ctt_is_new') ? localStorage.getItem('ctt_is_new') : "",
            categories: [],
            filteredId: null,
            limit: 20,
            offset: parseInt(localStorage.getItem('ctt_active_offset')) || 0
        };
    },

    filters: {
        toEasyDate: function toEasyDate(value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY HH:mm');
            } else {
                return '';
            }
        },
        toShortText: function toShortText(value) {
            if (value) {
                return value.length > 10 ? value.substr(0, 10) + '...' : value.substr(0, 10);
            } else {
                return '';
            }
        }
    },
    methods: {
        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        isWrongDuration: function isWrongDuration(template) {

            var sum = 0;
            _.map(template.parts, function (p) {
                if (isNaN(parseFloat(p.duration))) {
                    sum += 0;
                } else {
                    sum += parseFloat(p.duration);
                }
            });

            return parseFloat(sum.toFixed(2)) !== template.duration;
        },
        add: function add() {
            this.$router.push('/memories/create');
        },
        filter: function filter() {
            localStorage.setItem('ctt_active_offset', "0");
            this.offset = 0;
            this.get();
        },
        edit: function edit(id) {
            if (this.role === 2) {
                return false;
            }
            //localStorage.setItem('w_last_opened_id', parseInt(id));
            this.$router.push({
                name: 'edit-for-you',
                params: { id: id }
            });
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            var status = this.status === null ? '' : this.status;
            var isCopyrighted = this.isCopyrighted === null ? '' : this.isCopyrighted;
            var isNew = this.isNew === null ? '' : this.isNew;
            var filteredId = this.filteredId === null ? '' : this.filteredId;

            axios.get(this.$hostname + '/admin/created', {
                'params': {
                    status: status,
                    isCopyrighted: isCopyrighted,
                    isNew: isNew,
                    limit: self.limit,
                    offset: self.offset,
                    filteredId: filteredId
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                var data = response.data;

                self.data = data.templates;
            }).catch(function (error) {
                console.log(error);
            });
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('ctt_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('ctt_active_offset', parseInt(this.offset));
            }
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('templates') < 1) {
            localStorage.setItem('ctt_active_offset', "0");
            localStorage.setItem('ctt_category', "");
            localStorage.setItem('ctt_status', "");
            localStorage.setItem('ctt_is_trendy', "");
            localStorage.setItem('ctt_is_copyrighted', "");
        }
        next();
    }
});

/***/ }),

/***/ "0AsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("MDnB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_629d6826_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("G0RX");
function injectStyle (ssrContext) {
  __webpack_require__("7707")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_629d6826_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0Itt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0TtX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                            Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"text","label":"Название шаблона","placeholder":""},model:{value:(_vm.template.name),callback:function ($$v) {_vm.$set(_vm.template, "name", $$v)},expression:"template.name"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип шаблона")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.type),expression:"template.type"}],staticClass:"form-control",attrs:{"id":"type-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("1. По дате: прошлая неделя")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2. По дате: прошлый месяц")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3. По дате: текущий месяц")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4. По дате: прошлый год")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5. По дате: текущий год")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("6. По дате: прошлые выходные")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("7. По дате: будние дни на прошлой неделе")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("8. По дате: Лето")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("9. По дате: Осень")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10. По дате: Зима")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("11. По дате: Весна")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("12. По дате: Лето прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("13. По дате: Осень прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("14. По дате: Зима прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15. По дате: Весна прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("16. По местоположению: Путешествие")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("17. По местоположению: Дом")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("18. One day of my life")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("19. Recently")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20. Day of my life with date")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("21. Spring Camera Roll")]),_vm._v(" "),_c('option',{attrs:{"value":"22"}},[_vm._v("22. Spring  Recap")]),_vm._v(" "),_c('option',{attrs:{"value":"23"}},[_vm._v("23. По дате: за последние 6 месяцев")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.status),expression:"template.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Опубликовано")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ожидает")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимированный тип шаблона")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.format_type),expression:"template.format_type"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "format_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Обычный")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Slide 2 кусочка (справа-налево)")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Slide 3 кусочка (справа-налево)")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Slide 2 кусочка (снизу-вверх)")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Slide 3 кусочка (снизу-вверх)")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Slide слева вниз, справа вверх")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Разъезжается центральный кадр")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Slide 2 кусочка (слева-направо)")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Slide 3 кусочка (слева-направо)")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Slide 2 кусочка (сверху-вниз)")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Slide 3 кусочка (сверху-вниз)")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Разъезжается первый кадр")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Появляются по очереди 3 кусочка и уезжают вверх")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("Cutout (смешанный)")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("14")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("16")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("17")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("18")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("19")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Минимальная версия")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.v),expression:"template.v"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "v", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Все версии")]),_vm._v(" "),_vm._l((_vm.versions),function(version){return _c('option',{key:version,domProps:{"value":version}},[_vm._v("\n                                                "+_vm._s(version)+"\n                                            ")])})],2)]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.template.sort),callback:function ($$v) {_vm.$set(_vm.template, "sort", $$v)},expression:"template.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название трека","placeholder":""},model:{value:(_vm.template.song),callback:function ($$v) {_vm.$set(_vm.template, "song", $$v)},expression:"template.song"}}),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на Reels audio","placeholder":""},model:{value:(_vm.template.song_insta),callback:function ($$v) {_vm.$set(_vm.template, "song_insta", $$v)},expression:"template.song_insta"}}):_vm._e(),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на TikTok audio","placeholder":""},model:{value:(_vm.template.song_tiktok),callback:function ($$v) {_vm.$set(_vm.template, "song_tiktok", $$v)},expression:"template.song_tiktok"}}):_vm._e(),_vm._v(" "),_c('fg-input',{attrs:{"type":"date","label":"Дата публикации (формат ДД.ММ.ГГГГ)","placeholder":""},model:{value:(_vm.template.release_date),callback:function ($$v) {_vm.$set(_vm.template, "release_date", $$v)},expression:"template.release_date"}}),_vm._v(" "),(_vm.template.release_date)?_c('fg-input',{attrs:{"type":"time","label":"Время публикации (формат HH:MM)","placeholder":""},model:{value:(_vm.template.release_time),callback:function ($$v) {_vm.$set(_vm.template, "release_time", $$v)},expression:"template.release_time"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 checkbox-block"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_premium),expression:"template.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_premium)?_vm._i(_vm.template.is_premium,null)>-1:(_vm.template.is_premium)},on:{"change":function($event){var $$a=_vm.template.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"new-control"}},[_vm._v("Новое")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_new),expression:"template.is_new"}],staticClass:"form-check-inline",attrs:{"id":"new-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_new)?_vm._i(_vm.template.is_new,null)>-1:(_vm.template.is_new)},on:{"change":function($event){var $$a=_vm.template.is_new,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_new", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_new", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_new", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"copyrighted-control"}},[_vm._v("Copyrighted-музыка")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_copyrighted),expression:"template.is_copyrighted"}],staticClass:"form-check-inline",attrs:{"id":"copyrighted-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_copyrighted)?_vm._i(_vm.template.is_copyrighted,null)>-1:(_vm.template.is_copyrighted)},on:{"change":function($event){var $$a=_vm.template.is_copyrighted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_copyrighted", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_copyrighted", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_copyrighted", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"text-control"}},[_vm._v("Наложение\n                                            текста/объекта")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.is_text_active),expression:"is_text_active"}],staticClass:"form-check-inline",attrs:{"id":"text-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.is_text_active)?_vm._i(_vm.is_text_active,null)>-1:(_vm.is_text_active)},on:{"change":[function($event){var $$a=_vm.is_text_active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.is_text_active=$$a.concat([$$v]))}else{$$i>-1&&(_vm.is_text_active=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.is_text_active=$$c}},function($event){return _vm.toggleText()}]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                            Видео: "),(_vm.template.preview_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.preview_src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):(_vm.template.preview_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.preview_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"previewFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'preview_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.previewFileInput.click()}}},[_vm._v("\n                                                Загрузить\n                                            ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                            Аудио: "),(_vm.template.audio)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.audio_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):(_vm.template.audio_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.audio_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"audioFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"audio/mp3"},on:{"change":function($event){return _vm.uploadFile($event, 'audio')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.audioFileInput.click()}}},[_vm._v("\n                                                Загрузить\n                                            ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.template.videos || !_vm.template.type || !_vm.template.name
                                        || !_vm.template.song || !_vm.template.audio || !_vm.template.preview_src
                                        || (_vm.template.is_copyrighted === true && (!_vm.template.song_insta && !_vm.template.song_tiktok))},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                    Сохранить\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),(_vm.show_collage_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeCollageModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.collages),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill collage-category",class:{ 'active' : t.name === _vm.active_collage_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectCollageCategory(t.name)}}},[_vm._v("\n                                            "+_vm._s(t.name)+"\n                                        ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return _vm._l((_vm.collages),function(t,index){return _c('div',_vm._l((t.data),function(c,index){return (t.name === _vm.active_collage_category)?_c('div',{staticClass:"collage-item"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.renderCollage(c))},on:{"click":_vm.addCollage}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeCollageModal}},[_vm._v("\n                                            Закрыть\n                                        ")])]})],2)])])]):_vm._e(),_vm._v(" "),(_vm.is_text_active)?_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                            Текст")]),_vm._v(" "),(_vm.is_text_active)?_c('div',{staticClass:"texts-buttons"},[_vm._l((_vm.template.texts),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_text && _vm.active_type === 'text'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectText(index)}}},[_vm._v(_vm._s(t.text)+"\n                                "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.template.objects),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_object && _vm.active_type === 'object'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObject(index)}}},[_c('img',{staticClass:"button-preview",style:({ backgroundImage: 'url(\'' + _vm.objectPlayerSrc(t) + '\')' }),attrs:{"alt":""}}),_vm._v(" "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.active_type === 'text' ? _vm.addText(_vm.active_text) : _vm.addObject(null, _vm.active_object)}}},[_vm._v("\n                                Копировать\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.addText()}}},[_vm._v("Добавить\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showSVGModal()}}},[_vm._v("Добавить объект\n                            ")])],2):_vm._e(),_vm._v(" "),(_vm.show_svg_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeSVGModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.server_graphics),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : t.name === _vm.active_object_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObjectCategory(t.name)}}},[_vm._v("\n                                                "+_vm._s(t.name)+"\n                                            ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return _vm._l((_vm.server_graphics),function(t,index){return _c('div',_vm._l((t.data),function(c,index){return (t.name === _vm.active_object_category)?_c('div',{staticClass:"object-item",on:{"click":function($event){return _vm.addObject(c)}}},[_c('img',{staticClass:"image",attrs:{"src":("" + _vm.graphicsUrl + (c.src))}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeSVGModal}},[_vm._v("\n                                                Закрыть\n                                            ")])]})],2)])])]):_vm._e(),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.is_text_active && _vm.active_type === 'text')?_c('div',{staticClass:"col-md-4 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Текст")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text),expression:"template.texts[active_text].text"}],staticClass:"text-area",domProps:{"value":(_vm.template.texts[_vm.active_text].text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления текста (0 - c начала)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_start),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_start", $$v)},expression:"template.texts[active_text].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_end),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_end", $$v)},expression:"template.texts[active_text].time_end"}})],1)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер шрифта: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].font_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"5","max":"200","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].font_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "font_size", $$v)},expression:"template.texts[active_text].font_size"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Шрифт")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].font_name),expression:"template.texts[active_text].font_name"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "font_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.sortedFonts),function(f){return _c('option',{domProps:{"value":f.name}},[_vm._v(_vm._s(f.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control1"}},[_vm._v("По центру по горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control1","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_x == 0.5},on:{"change":function($event){return _vm.setTextPosition(0.5, null)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control2"}},[_vm._v("По центру по вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control2","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_y == 0.5},on:{"change":function($event){return _vm.setTextPosition(null, 0.5)}}})]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот текста (градусы)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].angle),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "angle", $$v)},expression:"template.texts[active_text].angle"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межбуквенный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].letter_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "letter_spacing", $$v)},expression:"template.texts[active_text].letter_spacing"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межстрочный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].line_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "line_spacing", $$v)},expression:"template.texts[active_text].line_spacing"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет текста: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].text_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_color),expression:"template.texts[active_text].text_color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].text_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'color')}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет фона:\n                                            "),(_vm.template.texts[_vm.active_text].background_color === 'transparent')?_c('span',{staticClass:"param-span"},[_vm._v("Прозрачный")]):_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].background_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].background_color),expression:"template.texts[active_text].background_color"},{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "background_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"background-control"}},[_vm._v("Прозрачный")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"background-control","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].background_color === 'transparent'},on:{"change":function($event){return _vm.toggleBackground()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.texts[_vm.active_text].background_color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'background')}}})}),0)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "alpha", $$v)},expression:"template.texts[active_text].alpha"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Направление текста")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].direction),expression:"template.texts[active_text].direction"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "direction", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"normal"}},[_vm._v("normal")]),_vm._v(" "),_c('option',{attrs:{"value":"vertical"}},[_vm._v("vertical")]),_vm._v(" "),_c('option',{attrs:{"value":"round"}},[_vm._v("round")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].animation_type),expression:"template.texts[active_text].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name))])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].animation_duration)+" сек")])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"20","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "animation_duration", $$v)},expression:"template.texts[active_text].animation_duration"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Выравнивание "),_c('br'),_vm._v("(если больше одной строки)")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_align),expression:"template.texts[active_text].text_align"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "text_align", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.text_aligns),function(ta){return _c('option',{domProps:{"value":ta.name}},[_vm._v(_vm._s(ta.name)+"\n                                            ")])}),0)]),_vm._v(" "),_c('label',{attrs:{"for":"shadow-color"}},[_vm._v("Цвет тени:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].shadow_color),expression:"template.texts[active_text].shadow_color"}],attrs:{"type":"color","id":"shadow-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "shadow_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Радиус размытия тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_blur))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_blur),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_blur", $$v)},expression:"template.texts[active_text].shadow_blur"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_alpha", $$v)},expression:"template.texts[active_text].shadow_alpha"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер обводки: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].stroke_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].stroke_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "stroke_size", $$v)},expression:"template.texts[active_text].stroke_size"}}),_vm._v(" "),_c('label',{attrs:{"for":"stroke-color"}},[_vm._v("Цвет обводки:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].stroke_color),expression:"template.texts[active_text].stroke_color"}],attrs:{"type":"color","id":"stroke-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].stroke_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "stroke_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].z_index),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "z_index", $$v)},expression:"template.texts[active_text].z_index"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeText(_vm.active_text)}}},[_vm._v("Удалить текст\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),(_vm.is_text_active && _vm.active_type === 'object')?_c('div',{staticClass:"col-md-4 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Объект")]),_vm._v(" "),_c('img',{staticClass:"object-preview",attrs:{"alt":"","src":_vm.objectPlayerSrc(_vm.template.objects[_vm.active_object])},on:{"click":function($event){return _vm.changeObject()}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления объекта (0 - c начала)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_start),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_start", $$v)},expression:"template.objects[active_object].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_end),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_end", $$v)},expression:"template.objects[active_object].time_end"}})],1)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].scale))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0.03","max":"5","step":"0.005","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].scale),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "scale", $$v)},expression:"template.objects[active_object].scale"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control3"}},[_vm._v("По центру по горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control3","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_x == 0.5},on:{"change":function($event){return _vm.setObjectPosition(0.5, null)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control4"}},[_vm._v("По центру по вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control4","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_y == 0.5},on:{"change":function($event){return _vm.setObjectPosition(null, 0.5)}}})]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот объекта (градусы)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].angle),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "angle", $$v)},expression:"template.objects[active_object].angle"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].id.indexOf('nocolor') < 0 && !_vm.isGifSrc(_vm.template.objects[_vm.active_object].id)),expression:"template.objects[active_object].id.indexOf('nocolor') < 0 && !isGifSrc(template.objects[active_object].id)"}],staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].color),expression:"template.objects[active_object].color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.objects[_vm.active_object].color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.objects[_vm.active_object], "color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.objects[_vm.active_object].color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setObjColor(c)}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].animation_type),expression:"template.objects[active_object].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.objects[_vm.active_object], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name))])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].animation_duration))])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"20","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "animation_duration", $$v)},expression:"template.objects[active_object].animation_duration"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].alpha),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "alpha", $$v)},expression:"template.objects[active_object].alpha"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].z_index),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "z_index", $$v)},expression:"template.objects[active_object].z_index"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeObject(_vm.active_object)}}},[_vm._v("Удалить объект\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{attrs:{"id":"preview-container"}},[_c('div',{attrs:{"id":"player"}},[_c('video',{ref:"videoContainer",staticStyle:{"max-width":"100%","cursor":"pointer"},attrs:{"controls":"","disablepictureinpicture":"","muted":"","controlsList":"nofullscreen nodownload noremoteplayback noplaybackrate","playsinline":"","id":"video_player"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.template.preview_src_full}})]),_vm._v(" "),_vm._l((_vm.template.texts),function(tt,index){return (tt.font_size)?_c('div',{ref:"draggableContainer",refInFor:true,staticClass:"draggable-container",attrs:{"id":("" + index)}},[(_vm.fonts.length > 1)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header",domProps:{"innerHTML":_vm._s(_vm.text_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e()]):_vm._e()}),_vm._v(" "),_vm._l((_vm.template.objects),function(tt,index){return (tt.scale)?_c('div',{ref:"draggableContainer2",refInFor:true,staticClass:"draggable-container",attrs:{"id":("o" + index)}},[(tt.id.indexOf('.svg') > 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header nospace",domProps:{"innerHTML":_vm._s(_vm.object_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e(),_vm._v(" "),(tt.id.indexOf('.svg') < 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header nospace",domProps:{"innerHTML":_vm._s(_vm.image_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e()]):_vm._e()})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-toggle",class:{ 'active-state': _vm.template.src_full },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.showPreview()}}},[_vm._v("\n                                            Показать превью\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Параметры видео")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Длительность, сек.","placeholder":""},on:{"input":function($event){return _vm.formatVideoDuration($event)}},model:{value:(_vm.template.duration),callback:function ($$v) {_vm.$set(_vm.template, "duration", $$v)},expression:"template.duration"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество фрагментов","placeholder":""},on:{"input":_vm.changeVideoCount},model:{value:(_vm.template.videos),callback:function ($$v) {_vm.$set(_vm.template, "videos", $$v)},expression:"template.videos"}}),_vm._v(" "),(_vm.template.videos)?_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Фрагменты "),_c('br'),_vm._v("\n                                        (длительность:\n                                        "),(Math.abs(_vm.sumParts - _vm.template.duration) > 0.05)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.sumParts))]):_c('span',[_vm._v(_vm._s(_vm.sumParts))]),_vm._v("):\n                                    ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.client_parts),function(itm,index){return (_vm.template.videos)?_c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('span',{staticClass:"block-number"},[_vm._v(_vm._s(index + 1)+".")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Длительн.","placeholder":""},on:{"input":function($event){return _vm.formatDuration($event, index)}},model:{value:(_vm.client_parts[index].duration),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "duration", $$v)},expression:"client_parts[index].duration"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Скорость","placeholder":""},on:{"input":function($event){return _vm.formatSpeed($event, index)}},model:{value:(_vm.client_parts[index].speed),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "speed", $$v)},expression:"client_parts[index].speed"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Эффект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].effect_type),expression:"client_parts[index].effect_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "effect_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeEffectType(index, _vm.client_parts[index].effect_type)}]}},_vm._l((_vm.effect_types),function(e){return _c('option',{domProps:{"value":e.id}},[_vm._v(_vm._s(e.name))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row",class:{ bordered: _vm.client_parts[index].effect_type === 0 }},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-text btn-fill active control-btn collage-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showCollageModal(index)}}},[_vm._v("Коллаж +\n                                                        ")])])]),_vm._v(" "),(_vm.client_parts[index].collage_type)?_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Время начала","placeholder":""},on:{"input":function($event){return _vm.formatStartTime($event, index, 'start_time')}},model:{value:(_vm.client_parts[index].start_time),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "start_time", $$v)},expression:"client_parts[index].start_time"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип контента")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].content_type),expression:"client_parts[index].content_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "content_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.content_types),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v("\n                                                                "+_vm._s(c.name)+"\n                                                            ")])}),0)])])]),_vm._v(" "),(_vm.client_parts[index].collage_type)?_c('div',{staticClass:"row bordered"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"collage-preview",domProps:{"innerHTML":_vm._s(_vm.renderCollagePart(_vm.client_parts[index].collage_type))},on:{"click":function($event){return _vm.showCollageModal(index)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-danger btn-fill btn-delete-collage",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removeCollageFromPart(index)}}},[_vm._v("Удалить коллаж\n                                                    ")])])]):_vm._e(),_vm._v(" "),((_vm.client_parts[index].effect_type === 1 || _vm.client_parts[index].effect_type === 2) && _vm.client_parts[index].effect_values)?_c('div',{staticClass:"row bordered"},[_c('div',{staticClass:"effect-values"},[_vm._v(_vm._s(_vm.effect_types[_vm.client_parts[index].effect_type].name)+" - Параметры")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"effect-preview",on:{"click":function($event){return _vm.changeEffectPosition($event, index)}}},[_c('span',{staticClass:"effect-area",style:({'top': _vm.client_parts[index].effect_values.y * 87 - 15 + 'px',
                                                                        'left': _vm.client_parts[index].effect_values.x * 48 - 15 + 'px'})},[_c('span',{staticClass:"effect-center"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"#" + String(index + 1) + " - Начальное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.from),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "from", $$v)},expression:"client_parts[index].effect_values.from"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"#" + String(index + 1) + " - Конечное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.to),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "to", $$v)},expression:"client_parts[index].effect_values.to"}})],1)]):_vm._e()])]):_vm._e()})],2)])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0n91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0q5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Категории шрифтов")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('grf_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить категорию\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):(column === 'object_count')?_c('span',[_vm._v("количество объектов")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'name')?_c('span',[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активна")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активна")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1D72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tabs_vue__ = __webpack_require__("b3fz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1a51ba4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tabs_vue__ = __webpack_require__("iBrQ");
function injectStyle (ssrContext) {
  __webpack_require__("8bB9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d1a51ba4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1a51ba4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1IYL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[(_vm.album)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.album.status),expression:"album.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.album, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.album.sort),callback:function ($$v) {_vm.$set(_vm.album, "sort", $$v)},expression:"album.sort"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.album.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.album)?_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1bPL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Отчеты")]),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"is-premium-filter"}},[_vm._v("Начальная дата")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateStart),expression:"dateStart"}],staticClass:"form-control",attrs:{"id":"date-start-filter","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dateStart=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.dates_start),function(d){return _c('option',{domProps:{"value":d}},[_vm._v(_vm._s(_vm._f("toEasyDate")(d)))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"is-premium-filter"}},[_vm._v("Конечная дата")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateEnd),expression:"dateEnd"}],staticClass:"form-control",attrs:{"id":"date-start-filter","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dateEnd=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.dates_end),function(d){return _c('option',{domProps:{"value":d}},[_vm._v(_vm._s(_vm._f("toEasyDate")(d)))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                        Фильтровать\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"}),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                        Загрузить отчет\n                                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'period')?_c('span',[_vm._v("Период")]):(column === 'my_feed')?_c('span',[_vm._v("My Feed, $")]):(column === 'muse')?_c('span',[_vm._v("Muse, $")]):(column === 'nola')?_c('span',[_vm._v("Nola, $")]):(column === 'wallpapers')?_c('span',[_vm._v("Wallpapers, $")]):(column === 'cleaner')?_c('span',[_vm._v("Cleaner, $")]):(column === 'other')?_c('span',[_vm._v("Other, $")]):(column === 'summary')?_c('span',[_vm._v("Всего, $")]):_c('span')])})})],2),_vm._v(" "),_c('tbody',[_vm._l((_vm.data),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm._f("toEasyDate")(item.date_start))+" - "+_vm._s(_vm._f("toEasyDate")(item.date_end)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.info[0])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.info[1])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.info[7])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.info[2])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.info[6])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.other(item.info))))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.summary)))]),_vm._v(" "),_c('td')])}),_vm._v(" "),(_vm.summary)?_c('tr',{staticClass:"summary"},[_c('td',[(_vm.data.length > 0)?_c('span',[_vm._v(_vm._s(_vm._f("toEasyDate")(_vm.data[0].date_start))+" - "+_vm._s(_vm._f("toEasyDate")(_vm.data[_vm.data.length - 1].date_end)))]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.summary[0])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.summary[1])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.summary[7])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.summary[2])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.summary[6])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.other(_vm.summary))))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.summary[8])))])]):_vm._e()],2)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1c16":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");
var _ = __webpack_require__("M4fF");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            categories: [],
            active_layout: 0,
            data: {},
            object: {
                status: 0,
                category_id: 0,
                src: null,
                src_full: null,
                is_premium: 0,
                no_color: 1,
                sort: 1,
                layouts: [],
                params: []
            },
            default_layout: {
                w: 0,
                h: 0,
                x: 0,
                y: 0,
                b_tl: 0,
                b_tr: 0,
                b_br: 0,
                b_bl: 0
            },
            default_param: {
                original_w: 0,
                original_h: 0,
                w: 0,
                h: 0,
                x: 0,
                y: 0,
                b_tl: 0,
                b_tr: 0,
                b_br: 0,
                b_bl: 0
            }
        };
    },

    created: function created() {
        this.getCategories();
        this.addLayout(true);
    },
    computed: {
        graphicsUrl: function graphicsUrl() {
            return this.$graphicsUrl;
        }
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/frames');
        },
        getCategories: function getCategories() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/frames/categories', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.categories = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            this.calculateParams();

            var object = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.object));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/frames/create', object, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0424\u0440\u0435\u0439\u043C \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/frames');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        remove: function remove() {
            var self = this;

            if (confirm("Подтверждение удаления фрейма")) {

                self.waiting = true;

                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/frames/' + this.id + '/remove', {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                }).then(function (response) {

                    var notification = {
                        template: '<span><b>\u0424\u0440\u0435\u0439\u043C \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.waiting = false;

                    self.$router.push('/frames');
                }).catch(function (error) {
                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;
                });
            }
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.object.src = data.url;
                self.object.src_full = data.url_full;
                self.object.src_size = data.filesize;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        layout_html: function layout_html(index) {
            var layoutModel = this.object.layouts[index];
            var rawData = this.object.params[index];

            var scale = 360 / parseFloat(rawData.original_w);

            var overlay = {
                w: rawData.w * scale,
                h: rawData.h * scale,
                x: rawData.x * scale,
                y: rawData.y * scale,
                b_tl: parseFloat(rawData.b_tl * scale).toFixed(2),
                b_tr: parseFloat(rawData.b_tr * scale).toFixed(2),
                b_br: parseFloat(rawData.b_br * scale).toFixed(2),
                b_bl: parseFloat(rawData.b_bl * scale).toFixed(2)
            };

            var colors = ['rgba(255, 0, 0, 0.4)', 'rgba(0, 128, 0, 0.4)', 'rgba(0, 0, 255, 0.4)', 'rgba(255, 165, 0, 0.4)', 'rgba(128, 0, 128, 0.4)', 'rgba(0, 206, 209, 0.4)', 'rgba(255, 192, 203, 0.4)', 'rgba(255, 255, 0, 0.4)', 'rgba(165, 42, 42, 0.4)', 'rgba(128, 128, 128, 0.4)'];

            var layout = '<div class="overlay ' + (index === this.active_layout ? 'active' : '') + '"></div>';

            var style = ' style="position: absolute; background: ' + (colors[index] ? colors[index] : colors[0]) + '; top: ' + overlay.y + 'px; left: ' + overlay.x + 'px; width: ' + overlay.w + 'px; height: ' + overlay.h + 'px; border-radius: ' + overlay.b_tl + 'px ' + overlay.b_tr + 'px ' + overlay.b_br + 'px ' + overlay.b_bl + 'px; z-index: ' + layoutModel.z_index + '"';

            layout = this.insertAt(layout, style, 5);

            return layout;
        },
        insertAt: function insertAt(str, sub, pos) {
            return '' + str.slice(0, pos) + sub + str.slice(pos);
        },

        openResource: function openResource(url) {
            window.open(url, "_blank");
        },
        selectLayout: function selectLayout(layout) {
            this.active_layout = layout;
        },
        addLayout: function addLayout() {
            var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.object.layouts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.default_layout)));

            if (!first) {
                this.default_param.original_w = _.last(this.object.params).original_w;
                this.default_param.original_h = _.last(this.object.params).original_h;
            }

            this.object.params.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.default_param)));
            this.active_layout = this.object.layouts.length - 1;
        },
        removeLayout: function removeLayout(index) {
            var self = this;

            if (self.object.layouts.length === 1) {
                alert('Нельзя удалить последний layout');
                return;
            }

            if (confirm("Подтверждение удаления layout " + (parseInt(index) + 1))) {
                self.active_layout = 0;

                self.object.params = self.object.params.filter(function (t, i) {
                    return i !== index;
                });
                self.object.layouts = self.object.layouts.filter(function (t, i) {
                    return i !== index;
                });
            }
        },

        calculateParams: function calculateParams() {

            for (var i = 0; i < this.object.layouts.length; i++) {

                var rawData = this.object.params[i];

                this.object.layouts[i] = {
                    w: parseFloat(parseFloat(rawData.w) / parseFloat(rawData.original_w)).toFixed(6),
                    h: parseFloat(parseFloat(rawData.h) / parseFloat(rawData.original_h)).toFixed(6),
                    x: parseFloat(parseFloat(rawData.x) / parseFloat(rawData.original_w)).toFixed(6),
                    y: parseFloat(parseFloat(rawData.y) / parseFloat(rawData.original_h)).toFixed(6),
                    b_tl: parseFloat(parseFloat(rawData.b_tl) / parseFloat(rawData.original_w)).toFixed(6),
                    b_tr: parseFloat(parseFloat(rawData.b_tr) / parseFloat(rawData.original_w)).toFixed(6),
                    b_br: parseFloat(parseFloat(rawData.b_br) / parseFloat(rawData.original_w)).toFixed(6),
                    b_bl: parseFloat(parseFloat(rawData.b_bl) / parseFloat(rawData.original_w)).toFixed(6)
                    //z_index: parseInt(this.object.layouts[i].z_index)
                };
            }
        }

    }
});

/***/ }),

/***/ "1lSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");



/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

var GlobalComponents = {
    install: function install(Vue) {
        Vue.component('fg-input', __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
        Vue.component('drop-down', __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
        Vue.component('vue-multiselect', window.VueMultiselect.default);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "1mif":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "28ys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_tooltip__ = __webpack_require__("VN6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globalComponents__ = __webpack_require__("1lSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss__ = __webpack_require__("Sczw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss__ = __webpack_require__("/4dZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css__ = __webpack_require__("947H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__);

// Notifications plugin

// A plugin file where you could register global components used across the app

// A plugin file where you could register global directives

// Sidebar on the right. Used as a local plugin in DashboardLayout.vue


// asset imports





// library auto imports


/**
 * This is the main Light Bootstrap Dashboard Vue plugin where dashboard related plugins are registerd.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue) {
        Vue.use(__WEBPACK_IMPORTED_MODULE_2__globalComponents__["a" /* default */]);
        Vue.use(__WEBPACK_IMPORTED_MODULE_3__globalDirectives__["a" /* default */]);
        Vue.use(__WEBPACK_IMPORTED_MODULE_4__components_UIComponents_SidebarPlugin__["a" /* default */]);
        Vue.use(__WEBPACK_IMPORTED_MODULE_1_vue_notifyjs___default.a);
        Vue.use(__WEBPACK_IMPORTED_MODULE_0_v_tooltip__["a" /* default */]);
    }
});

/***/ }),

/***/ "2R7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue__ = __webpack_require__("EZIe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3dfcc46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preview_vue__ = __webpack_require__("dhsv");
function injectStyle (ssrContext) {
  __webpack_require__("2tJV")
  __webpack_require__("IA/J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b3dfcc46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3dfcc46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2X6/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Шрифты")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryId),expression:"categoryId"}],staticClass:"form-control",attrs:{"id":"category-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('fonts_category', _vm.categoryId)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('fonts_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Поиск по названию","placeholder":""},model:{value:(_vm.filteredName),callback:function ($$v) {_vm.filteredName=$$v},expression:"filteredName"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить шрифт\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'category')?_c('span',[_vm._v("категория")]):(column === 'is_premium')?_c('span',[_vm._v("премиум")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'name')?_c('span',[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === 'image_src_full')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[_c('div',{staticClass:"device-block device1",style:({ backgroundImage: 'url(' + item[column] + ')' })})]):(column === 'is_premium')?_c('span',[(item[column] === 1)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/premium.png"}}):_vm._e()]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")]),_vm._v(" "),_c('img',{staticClass:"new-tab",attrs:{"src":"/static/img/new-tab.png"},on:{"click":function($event){return _vm.openNewTab(item['id'])}}})]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активен")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активен")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77256d8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("U6AA");
function injectStyle (ssrContext) {
  __webpack_require__("DomV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77256d8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77256d8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2cU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostsPreview_vue__ = __webpack_require__("3b0w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6fccaa6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostsPreview_vue__ = __webpack_require__("TS8z");
function injectStyle (ssrContext) {
  __webpack_require__("IuHN")
  __webpack_require__("uq3p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c6fccaa6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostsPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6fccaa6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostsPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2fJT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2sb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Эффекты")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryId),expression:"categoryId"}],staticClass:"form-control",attrs:{"id":"category-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('effr_category', _vm.categoryId)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('effr_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить эффект\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'category')?_c('span',[_vm._v("категория")]):(column === 'preview_src')?_c('span',[_vm._v("эффект")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'preview_src')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[_c('img',{staticClass:"device-block device1",attrs:{"src":("" + _vm.effectsUrl + (item[column]))}})]):(column === 'name')?_c('span',{on:{"click":function($event){return _vm.edit(item['id'])}}},[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активен")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активен")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2tJV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2zcV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",style:(_vm.sidebarStyle),attrs:{"data-color":_vm.backgroundColor,"data-image":_vm.backgroundImage}},[_c('div',{staticClass:"sidebar-wrapper"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"simple-text",attrs:{"href":"/templates"}},[_vm._m(0),_vm._v("\n                "+_vm._s(_vm.title)+"\n            ")])]),_vm._v(" "),_vm._t("content"),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._t("default",function(){return _vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-link',{key:link.name + index,attrs:{"to":link.path,"link":link},on:{"click":_vm.closeNavbar}},[_c('i',{class:link.icon}),_vm._v(".nav-link\n                    "),_c('p',[_vm._v(_vm._s(link.name))])])})})],2)],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-img"},[_c('img')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Q3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inheritAttrs: false,
    inject: {
        autoClose: {
            default: true
        }
    },
    props: {
        link: {
            type: [String, Object],
            default: function _default() {
                return {
                    name: '',
                    path: '',
                    icon: ''
                };
            }
        },
        tag: {
            type: String,
            default: 'router-link'
        }
    },
    methods: {
        hideSidebar: function hideSidebar() {
            if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
                this.$sidebar.displaySidebar(false);
            }
        }
    }
});

/***/ }),

/***/ "3R5Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_mixins_previewBackLink__ = __webpack_require__("dHGc");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");
var _ = __webpack_require__("M4fF");



/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_5_src_mixins_previewBackLink__["a" /* default */]],
    name: 'EditAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            object: null,
            originalStatus: null,
            categories: [],
            active_layout: 0,
            show_usage_modal: false,
            usage_loading: false,
            usage: {
                templates: [],
                carousels: []
            },
            data: {},
            default_layout: {
                w: 0,
                h: 0,
                x: 0,
                y: 0,
                b_tl: 0,
                b_tr: 0,
                b_br: 0,
                b_bl: 0
            },
            default_param: {
                original_w: 0,
                original_h: 0,
                w: 0,
                h: 0,
                x: 0,
                y: 0,
                b_tl: 0,
                b_tr: 0,
                b_br: 0,
                b_bl: 0
            }
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.getCategories();
    },
    computed: {
        graphicsUrl: function graphicsUrl() {
            return this.$graphicsUrl;
        }
    },
    methods: {
        // back to the preview if the page was opened from it, otherwise to the list
        goBack: function goBack() {
            this.leaveTo('/frames');
        },
        isVideo: function isVideo(url) {
            return url && url.indexOf('.mp4') > -1;
        },
        pluralize: function pluralize(n, one, few, many) {
            var num = Math.abs(parseInt(n, 10)) || 0;
            var mod100 = num % 100;
            var mod10 = num % 10;

            if (mod100 > 10 && mod100 < 20) {
                return many;
            }

            if (mod10 === 1) {
                return one;
            }

            if (mod10 >= 2 && mod10 <= 4) {
                return few;
            }

            return many;
        },
        updatedCountText: function updatedCountText(templates, carousels) {
            return '\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u043E: ' + templates + ' ' + this.pluralize(templates, 'шаблон', 'шаблона', 'шаблонов') + ', ' + carousels + ' ' + this.pluralize(carousels, 'карусель', 'карусели', 'каруселей');
        },
        usageCountText: function usageCountText(templates, carousels) {
            return templates + ' ' + this.pluralize(templates, 'шаблоне', 'шаблонах', 'шаблонах') + ' \u0438 ' + carousels + ' ' + this.pluralize(carousels, 'карусели', 'каруселях', 'каруселях');
        },
        openUsage: function openUsage() {
            var self = this;

            self.show_usage_modal = true;
            self.usage_loading = true;
            self.usage = {
                templates: [],
                carousels: []
            };

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/frames/' + this.id + '/usage', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {
                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data)) || {};
                self.usage = {
                    templates: data.templates || [],
                    carousels: data.carousels || []
                };
                self.usage_loading = false;
            }).catch(function (error) {
                self.usage_loading = false;
                self.show_usage_modal = false;

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        closeUsage: function closeUsage() {
            this.show_usage_modal = false;
        },
        openTemplate: function openTemplate(id) {
            var routeData = this.$router.resolve({
                name: 'edit-template',
                params: { id: id }
            });

            window.open(routeData.href, '_blank');
        },
        openCarousel: function openCarousel(id) {
            var routeData = this.$router.resolve({
                name: 'edit-post',
                params: { id: id }
            });

            window.open(routeData.href, '_blank');
        },
        getCategories: function getCategories() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/frames/categories', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.categories = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data));

                self.get(self.id);
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/frames/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.object = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data));
                self.originalStatus = self.object.status;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        fetchUsageCounts: function fetchUsageCounts() {
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/frames/' + this.id + '/usage', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {
                var usage = response.data || {};

                return {
                    templates: (usage.templates || []).length,
                    carousels: (usage.carousels || []).length
                };
            });
        },
        confirmIfUsed: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(usedActionText, emptyConfirmText) {
                var counts;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.fetchUsageCounts();

                            case 2:
                                counts = _context.sent;

                                if (!(counts.templates > 0 || counts.carousels > 0)) {
                                    _context.next = 5;
                                    break;
                                }

                                return _context.abrupt('return', confirm('\u042D\u0442\u043E\u0442 \u0444\u0440\u0435\u0439\u043C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0432 ' + this.usageCountText(counts.templates, counts.carousels) + '. ' + usedActionText));

                            case 5:
                                if (!emptyConfirmText) {
                                    _context.next = 7;
                                    break;
                                }

                                return _context.abrupt('return', confirm(emptyConfirmText));

                            case 7:
                                return _context.abrupt('return', true);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function confirmIfUsed(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return confirmIfUsed;
        }(),
        notifyError: function notifyError(message) {
            var notification = {
                template: '<span><b>' + message + '</b></span>'
            };

            this.$notifications.notify({
                component: notification,
                icon: 'nc-icon nc-simple-remove',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'danger'
            });
        },
        save: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var self, statusDeactivated, confirmed, object;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                self = this;
                                statusDeactivated = parseInt(this.originalStatus, 10) === 1 && parseInt(this.object.status, 10) === 0;

                                if (!statusDeactivated) {
                                    _context2.next = 18;
                                    break;
                                }

                                self.waiting = true;

                                _context2.prev = 4;
                                _context2.next = 7;
                                return this.confirmIfUsed('При сохранении этот объект пропадет из этих шаблонов. Продолжить?');

                            case 7:
                                confirmed = _context2.sent;

                                self.waiting = false;

                                if (confirmed) {
                                    _context2.next = 11;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 11:
                                _context2.next = 18;
                                break;

                            case 13:
                                _context2.prev = 13;
                                _context2.t0 = _context2['catch'](4);

                                self.waiting = false;
                                this.notifyError(_context2.t0.response && _context2.t0.response.data && _context2.t0.response.data.message ? _context2.t0.response.data.message : 'Не удалось проверить использования фрейма');
                                return _context2.abrupt('return');

                            case 18:

                                this.calculateParams();
                                object = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.object));


                                self.waiting = true;

                                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$hostname + '/admin/frames/' + this.id + '/update', object, {
                                    'headers': {
                                        'Authorization': 'Bearer ' + this.token
                                    }
                                }).then(function (response) {

                                    var data = response.data || {};
                                    self.originalStatus = object.status;
                                    var message = 'Фрейм был успешно обновлен';

                                    if (data.usages) {
                                        message += '. ' + self.updatedCountText(data.usages.templates, data.usages.carousels);
                                    }

                                    var notification = {
                                        template: '<span><b>' + message + '</b></span>'
                                    };

                                    self.$notifications.notify({
                                        component: notification,
                                        icon: 'nc-icon nc-explore-2',
                                        horizontalAlign: 'right',
                                        verticalAlign: 'top',
                                        type: 'info'
                                    });

                                    self.waiting = false;
                                }).catch(function (error) {
                                    var notification = {
                                        template: '<span><b>' + error.response.data.message + '</b></span>'
                                    };

                                    self.$notifications.notify({
                                        component: notification,
                                        icon: 'nc-icon nc-simple-remove',
                                        horizontalAlign: 'right',
                                        verticalAlign: 'top',
                                        type: 'danger'
                                    });

                                    self.waiting = false;
                                });

                            case 22:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[4, 13]]);
            }));

            function save() {
                return _ref2.apply(this, arguments);
            }

            return save;
        }(),
        remove: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var self, confirmed;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                self = this;


                                self.waiting = true;

                                _context3.prev = 2;
                                _context3.next = 5;
                                return this.confirmIfUsed('При удалении этот объект пропадет из этих шаблонов. Продолжить?', 'Подтверждение удаления фрейма');

                            case 5:
                                confirmed = _context3.sent;

                                self.waiting = false;

                                if (confirmed) {
                                    _context3.next = 9;
                                    break;
                                }

                                return _context3.abrupt('return');

                            case 9:
                                _context3.next = 16;
                                break;

                            case 11:
                                _context3.prev = 11;
                                _context3.t0 = _context3['catch'](2);

                                self.waiting = false;
                                this.notifyError(_context3.t0.response && _context3.t0.response.data && _context3.t0.response.data.message ? _context3.t0.response.data.message : 'Не удалось проверить использования фрейма');
                                return _context3.abrupt('return');

                            case 16:

                                self.waiting = true;

                                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/frames/' + this.id + '/remove', {
                                    'headers': {
                                        'Authorization': 'Bearer ' + this.token
                                    }
                                }).then(function (response) {

                                    var notification = {
                                        template: '<span><b>\u0424\u0440\u0435\u0439\u043C \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D</b></span>'
                                    };

                                    self.$notifications.notify({
                                        component: notification,
                                        icon: 'nc-icon nc-explore-2',
                                        horizontalAlign: 'right',
                                        verticalAlign: 'top',
                                        type: 'info'
                                    });

                                    self.waiting = false;

                                    self.leaveTo('/frames');
                                }).catch(function (error) {
                                    var notification = {
                                        template: '<span><b>' + error.response.data.message + '</b></span>'
                                    };

                                    self.$notifications.notify({
                                        component: notification,
                                        icon: 'nc-icon nc-simple-remove',
                                        horizontalAlign: 'right',
                                        verticalAlign: 'top',
                                        type: 'danger'
                                    });

                                    self.waiting = false;
                                });

                            case 18:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[2, 11]]);
            }));

            function remove() {
                return _ref3.apply(this, arguments);
            }

            return remove;
        }(),
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data));

                self.object.src = data.url;
                self.object.src_full = data.url_full;
                self.object.src_size = data.filesize;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        layout_html: function layout_html(index) {
            var layoutModel = this.object.layouts[index];
            var rawData = this.object.params[index];

            var scale = 360 / parseFloat(rawData.original_w);

            var overlay = {
                w: rawData.w * scale,
                h: rawData.h * scale,
                x: rawData.x * scale,
                y: rawData.y * scale,
                b_tl: parseFloat(rawData.b_tl * scale).toFixed(2),
                b_tr: parseFloat(rawData.b_tr * scale).toFixed(2),
                b_br: parseFloat(rawData.b_br * scale).toFixed(2),
                b_bl: parseFloat(rawData.b_bl * scale).toFixed(2)
            };

            var colors = ['rgba(255, 0, 0, 0.4)', 'rgba(0, 128, 0, 0.4)', 'rgba(0, 0, 255, 0.4)', 'rgba(255, 165, 0, 0.4)', 'rgba(128, 0, 128, 0.4)', 'rgba(0, 206, 209, 0.4)', 'rgba(255, 192, 203, 0.4)', 'rgba(255, 255, 0, 0.4)', 'rgba(165, 42, 42, 0.4)', 'rgba(128, 128, 128, 0.4)'];

            var layout = '<div class="overlay ' + (index === this.active_layout ? 'active' : '') + '"></div>';

            var style = ' style="position: absolute; background: ' + (colors[index] ? colors[index] : colors[0]) + '; top: ' + overlay.y + 'px; left: ' + overlay.x + 'px; width: ' + overlay.w + 'px; height: ' + overlay.h + 'px; border-radius: ' + overlay.b_tl + 'px ' + overlay.b_tr + 'px ' + overlay.b_br + 'px ' + overlay.b_bl + 'px; z-index: ' + layoutModel.z_index + '"';

            layout = this.insertAt(layout, style, 5);

            return layout;
        },
        insertAt: function insertAt(str, sub, pos) {
            return '' + str.slice(0, pos) + sub + str.slice(pos);
        },

        openResource: function openResource(url) {
            window.open(url, "_blank");
        },
        selectLayout: function selectLayout(layout) {
            this.active_layout = layout;
        },
        addLayout: function addLayout() {
            this.object.layouts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.default_layout)));
            this.default_param.original_w = _.last(this.object.params).original_w;
            this.default_param.original_h = _.last(this.object.params).original_h;
            this.object.params.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.default_param)));
            this.active_layout = this.object.layouts.length - 1;
        },
        removeLayout: function removeLayout(index) {
            var self = this;

            if (self.object.layouts.length === 1) {
                alert('Нельзя удалить последний layout');
                return;
            }

            if (confirm("Подтверждение удаления layout " + (parseInt(index) + 1))) {
                self.active_layout = 0;

                self.object.params = self.object.params.filter(function (t, i) {
                    return i !== index;
                });
                self.object.layouts = self.object.layouts.filter(function (t, i) {
                    return i !== index;
                });
            }
        },

        calculateParams: function calculateParams() {

            for (var i = 0; i < this.object.layouts.length; i++) {

                var rawData = this.object.params[i];

                this.object.layouts[i] = {
                    w: parseFloat(parseFloat(rawData.w) / parseFloat(rawData.original_w)).toFixed(6),
                    h: parseFloat(parseFloat(rawData.h) / parseFloat(rawData.original_h)).toFixed(6),
                    x: parseFloat(parseFloat(rawData.x) / parseFloat(rawData.original_w)).toFixed(6),
                    y: parseFloat(parseFloat(rawData.y) / parseFloat(rawData.original_h)).toFixed(6),
                    b_tl: parseFloat(parseFloat(rawData.b_tl) / parseFloat(rawData.original_w)).toFixed(6),
                    b_tr: parseFloat(parseFloat(rawData.b_tr) / parseFloat(rawData.original_w)).toFixed(6),
                    b_br: parseFloat(parseFloat(rawData.b_br) / parseFloat(rawData.original_w)).toFixed(6),
                    b_bl: parseFloat(parseFloat(rawData.b_bl) / parseFloat(rawData.original_w)).toFixed(6)
                    //z_index: parseInt(this.object.layouts[i].z_index)
                };
            }

            console.log(this.object);
        }

    }
});

/***/ }),

/***/ "3b0w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_mixins_previewPage__ = __webpack_require__("LToN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__("M4fF");
var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1_src_mixins_previewPage__["a" /* default */]],
    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a
    },
    props: {
        type: {
            type: String,
            default: 'carousel'
        }
    },
    created: function created() {
        this.get();
    },
    data: function data() {
        return {
            data: [],
            activePreview: "",
            previewType: this.type,
            waiting: false,
            categoryId: null,
            role: parseInt(localStorage.getItem('role')) || 0,
            activeId: null,
            postOrders: [],
            categoryOrderDirty: false,
            dragGuard: false,
            categoryDragGuard: false,
            showDev: true
        };
    },

    computed: {
        selectedCategory: function selectedCategory() {
            var categoryId = parseInt(this.categoryId, 10);
            return _.find(this.data, function (category) {
                return parseInt(category.id, 10) === categoryId;
            }) || null;
        },
        emptyListLabel: function emptyListLabel() {
            return this.previewType === 'stories' ? 'Нет сторис' : 'Нет каруселей';
        },
        hasUnsavedOrder: function hasUnsavedOrder() {
            return this.postOrders.length > 0 || this.categoryOrderDirty;
        },
        visiblePosts: {
            get: function get() {
                var category = this.selectedCategory;
                if (!category || !category.posts) {
                    return [];
                }
                if (this.showDev) {
                    return category.posts;
                }
                var self = this;
                return _.filter(category.posts, function (post) {
                    return !self.isDev(post.status);
                });
            },
            set: function set(posts) {
                var category = this.selectedCategory;
                if (!category) {
                    return;
                }
                if (this.showDev) {
                    category.posts = posts;
                    return;
                }
                var self = this;
                var queue = posts.slice();
                category.posts = _.map(category.posts, function (post) {
                    if (self.isDev(post.status)) {
                        return post;
                    }
                    return queue.length ? queue.shift() : post;
                });
            }
        }
    },
    methods: {
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            self.waiting = true;

            axios.get(this.$hostname + '/admin/posts/preview', {
                'params': {
                    type: this.previewType
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.waiting = false;
                self.postOrders = [];
                self.categoryOrderDirty = false;
                self.data = response.data || [];
                var selectedExists = _.some(self.data, function (category) {
                    return parseInt(category.id, 10) === parseInt(self.categoryId, 10);
                });
                if (!selectedExists && self.data.length) {
                    self.categoryId = self.data[0].id;
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        save: function save() {
            var self = this;

            var token = localStorage.getItem('token');

            self.waiting = true;

            axios.post(this.$hostname + '/admin/posts/preview/resort', {
                categoryIds: this.categoryOrderDirty ? _.map(this.data, 'id') : [],
                postOrders: this.postOrders
            }, {
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function () {
                self.postOrders = [];
                self.categoryOrderDirty = false;
                self.get();
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        onPostsDragStart: function onPostsDragStart() {
            this.dragGuard = true;
        },
        onPostsDragEnd: function onPostsDragEnd() {
            var _this = this;

            setTimeout(function () {
                _this.dragGuard = false;
            }, 150);
        },
        onCategoriesDragStart: function onCategoriesDragStart() {
            this.categoryDragGuard = true;
        },
        onCategoriesDragEnd: function onCategoriesDragEnd() {
            var _this2 = this;

            setTimeout(function () {
                _this2.categoryDragGuard = false;
            }, 150);
        },
        onCategoriesReorder: function onCategoriesReorder() {
            this.categoryOrderDirty = true;
        },
        isSelectedCategory: function isSelectedCategory(id) {
            return parseInt(id, 10) === parseInt(this.categoryId, 10);
        },
        selectCategory: function selectCategory(id) {
            if (this.categoryDragGuard) {
                return;
            }
            this.categoryId = id;
        },
        onPostsReorder: function onPostsReorder(category) {
            if (!category || !category.posts) {
                return;
            }

            var categoryId = parseInt(category.id, 10);
            var ids = _.map(category.posts, 'id');
            this.postOrders = _.filter(this.postOrders, function (order) {
                return parseInt(order.categoryId, 10) !== categoryId;
            });
            this.postOrders.push({
                categoryId: categoryId,
                ids: ids
            });
            this.syncOtherCategoryOrders(categoryId, ids);
        },
        syncOtherCategoryOrders: function syncOtherCategoryOrders(sourceCategoryId, orderedIds) {
            var subset = {};
            _.forEach(orderedIds, function (id) {
                subset[id] = true;
            });

            _.forEach(this.data, function (category) {
                if (parseInt(category.id, 10) === sourceCategoryId || !category.posts || !category.posts.length) {
                    return;
                }

                var byId = {};
                _.forEach(category.posts, function (post) {
                    byId[post.id] = post;
                });

                var queue = [];
                _.forEach(orderedIds, function (id) {
                    if (byId[id]) {
                        queue.push(byId[id]);
                    }
                });

                if (!queue.length) {
                    return;
                }

                category.posts = _.map(category.posts, function (post) {
                    if (!subset[post.id]) {
                        return post;
                    }
                    return queue.length ? queue.shift() : post;
                });
            });
        },
        cardRatioClass: function cardRatioClass(ratio) {
            var value = parseInt(ratio, 10);
            if (value === 2) {
                return 'is-wide';
            }
            if (value === 3) {
                return 'is-tall';
            }
            if (value === 4) {
                return 'is-square';
            }
            return 'is-portrait';
        },
        getTemplateType: function getTemplateType() {
            return 'video/mp4';
        },
        isVideo: function isVideo(url) {
            return url && url.indexOf('.mp4') > -1;
        },
        previewImage: function previewImage(post) {
            if (post.preview_src_full && !this.isVideo(post.preview_src_full)) {
                return post.preview_src_full;
            }
            return null;
        },
        cardVideoSrc: function cardVideoSrc(post) {
            if (post.video_src_full) {
                return post.video_src_full;
            }
            if (this.isVideo(post.preview_src_full)) {
                return post.preview_src_full;
            }
            return null;
        },
        previewMedia: function previewMedia(post) {
            return this.cardVideoSrc(post) || this.previewImage(post) || '';
        },
        isDev: function isDev(status) {
            return parseInt(status, 10) === 0;
        },
        isFree: function isFree(isPremium) {
            return parseInt(isPremium, 10) !== 1;
        },
        openPreview: function openPreview(src, id) {
            if (this.dragGuard) {
                return;
            }
            this.activeId = id;
            this.activePreview = src;
        },
        openPost: function openPost() {
            this.$router.push({
                name: 'edit-post',
                params: { id: this.activeId }
            });
        },
        closePreview: function closePreview() {
            this.activeId = null;
            this.activePreview = "";
        }
    }
});

/***/ }),

/***/ "4EL8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Music_vue__ = __webpack_require__("81Wq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84cd656c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Music_vue__ = __webpack_require__("XCOI");
function injectStyle (ssrContext) {
  __webpack_require__("fign")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84cd656c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Music_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84cd656c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Music_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4PKd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("Jqgy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b2421f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("En8V");
function injectStyle (ssrContext) {
  __webpack_require__("Zp+p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b2421f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b2421f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4SD2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fullcalendar_core_internal_common__ = __webpack_require__("Ro7l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Graphics_vue__ = __webpack_require__("sFCw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_mixins_unsavedLeaveGuard__ = __webpack_require__("WSC3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_mixins_replaceGraphicSize__ = __webpack_require__("g69p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_mixins_gifGraphic__ = __webpack_require__("pJH4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_mixins_stickyLayers__ = __webpack_require__("P+tE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_mixins_pastePartDurations__ = __webpack_require__("nsOS");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _ = __webpack_require__("M4fF");

var moment = __webpack_require__("PJh5");










/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditCategory',
    mixins: [__WEBPACK_IMPORTED_MODULE_9_src_mixins_unsavedLeaveGuard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_src_mixins_replaceGraphicSize__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11_src_mixins_gifGraphic__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13_src_mixins_pastePartDurations__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12_src_mixins_stickyLayers__["a" /* default */]],
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            showP: false,
            token: localStorage.getItem('token'),
            template: null,
            activeVideo: '',
            waiting: false,
            textWaiting: false,
            visibilityRaf: null,
            lock_waiting: false,
            is_playing: false,
            show_svg_modal: false,
            show_collage_modal: false,
            show_frames_modal: false,
            is_object_changing: false,
            is_frame_changing: false,
            video: null,
            categories: JSON.parse(localStorage.getItem('categories')),
            sizes: JSON.parse(localStorage.getItem('sizes')),
            compression: false,
            preview: null,
            source: null,
            client_parts: [],
            is_text_active: false,
            active_text: 0,
            active_object: 0,
            active_frame: 0,
            draggable_index: 0,
            draggable_type: null,
            active_type: 'text',
            realVideoDuration: null,
            realAudioDuration: null,
            effect: "",
            effect_intensity: 100,
            filter: "",
            filter_intensity: 100,
            heightCanvas: 640,
            active_object_category: null,
            active_frame_category: 1,
            active_collage_category: '2',
            previous_collage_id: null,
            active_part_index: null,
            default_custom_collage_rawData: {
                original_w: 1080,
                original_h: 1920,
                w: 0,
                h: 0,
                x: 0,
                y: 0,
                b_tl: 0,
                b_tr: 0,
                b_br: 0,
                b_bl: 0
            },
            custom_collage_rawData: {
                original_w: 1080,
                original_h: 1920,
                w: 0,
                h: 0,
                x: 0,
                y: 0,
                b_tl: 0,
                b_tr: 0,
                b_br: 0,
                b_bl: 0
            },
            tags: [],
            server_effects: [],
            server_graphics: [],
            server_filters: [],
            server_fonts: [],
            server_frames: [],
            svg_sources: [],
            default_text: {
                text: 'Default text',
                font_name: 'SF Pro',
                font_size: 30,
                text_color: "#ffffff",
                letter_spacing: 0,
                line_spacing: 0,
                alpha: 1,
                bg_alpha: 1,
                text_align: 'center',
                background_color: 'transparent',
                position_x: 0.49,
                position_y: 0.49,
                is_text_brush: 0,
                text_brush_data: [],
                z_index: 1,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                is_animated: 0,
                angle: 0,
                direction: 'normal',
                shadow_color: '#ffffff',
                shadow_alpha: 0,
                shadow_distance: 0,
                shadow_blur: 0,
                animation_type: 0,
                animation_duration: 0,
                stroke_size: 0,
                stroke_color: '#000000'
            },
            default_object: {
                id: "b-330x298.svg",
                scale: 1,
                source: '<span>SVG</span>',
                color: '#ffffff',
                alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                animation_type: 0,
                animation_duration: 0,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                is_animated: 0,
                angle: 0,
                shadow_color: '#ffffff',
                shadow_alpha: 0,
                shadow_distance: 0,
                shadow_blur: 0
            },
            texts: [],
            objects: [],
            colors: ["#FFFFFF", "#000000", "#F9F7F4", "#FAF5ED", "#F2E8DD", "#F4E4DD", "#D9BEBD", "#C5AEB6", "#E3C2D2", "#F1E0EF", "#D5C9E9", "#C8ACE0", "#E06E97", "#E64F3C", "#AB613E", "#B97959", "#D99056", "#E8BF88", "#EDD8AB", "#FAE389", "#F5C154", "#B78C3A", "#585B3B", "#7B7C41", "#BBB595", "#DFE7DA", "#C0DED3", "#B4C5C9", "#C9D9F0", "#4E63EC", "#4F5E8D", "#725B6E", "#F0F0F0", "#D9D9D9", "#616161", "#3C3C3C"],
            fonts: [{
                params: "'SF Pro', sans-serif;",
                code: "SF Pro",
                name: "SF Pro"
            }],
            widget_types: [{
                id: 1,
                name: "Message (справа)"
            }, {
                id: 5,
                name: "Message (слева)"
            }, {
                id: 2,
                name: "Time"
            }, {
                id: 3,
                name: "Location"
            }, {
                id: 4,
                name: "Custom tag (снизу)"
            }, {
                id: 6,
                name: "Custom tag (сверху)"
            }, {
                id: 7,
                name: "Selection"
            }],
            animation_types: [{
                id: 0,
                name: "-"
            }, {
                id: 1,
                name: "Fade"
            }, {
                id: 4,
                name: "Zoom In"
            }, {
                id: 31,
                name: "Zoom Out"
            }, {
                id: 6,
                name: "Reveal ↓"
            }, {
                id: 7,
                name: "Reveal ↑"
            }, {
                id: 8,
                name: "Reveal →"
            }, {
                id: 9,
                name: "Reveal ←"
            }, {
                id: 10,
                name: "Float ↓"
            }, {
                id: 11,
                name: "Float ↑"
            }, {
                id: 12,
                name: "Float →"
            }, {
                id: 13,
                name: "Float ←"
            }, {
                id: 14,
                name: "Typewriter"
            }, {
                id: 15,
                name: "Typewriter Fade In"
            }, {
                id: 16,
                name: "Typewriter By Word"
            }, {
                id: 17,
                name: "Typewriter By Word Fade In"
            }],
            effect_types: [{
                id: 0,
                name: "-"
            }, {
                id: 1,
                name: "Zoom in"
            }, {
                id: 2,
                name: "Zoom out"
            }, {
                id: 3,
                name: "Snow"
            }, {
                id: 4,
                name: "VHS"
            }],
            collage_types: [{
                id: 0,
                name: "-",
                params: null
            }, {
                id: 1,
                name: "1/4",
                params: { x: 0, y: 0, w: 0.5, h: 0.5 }
            }, {
                id: 2,
                name: "2/4",
                params: { x: 0.5, y: 0, w: 0.5, h: 0.5 }
            }, {
                id: 3,
                name: "3/4",
                params: { x: 0, y: 0.5, w: 0.5, h: 0.5 }
            }, {
                id: 4,
                name: "4/4",
                params: { x: 0.5, y: 0.5, w: 0.5, h: 0.5 }
            }, {
                id: 5,
                name: "1/3",
                params: { x: 0, y: 0, w: 1, h: 0.3333 }
            }, {
                id: 6,
                name: "2/3",
                params: { x: 0, y: 0.3333, w: 1, h: 0.3333 }
            }, {
                id: 7,
                name: "3/3",
                params: { x: 0, y: 0.6666, w: 1, h: 0.3333 }
            }, {
                id: 8,
                name: "1/2",
                params: { x: 0, y: 0, w: 1, h: 0.5 }
            }, {
                id: 9,
                name: "2/2",
                params: { x: 0, y: 0.5, w: 1, h: 0.5 }
            }, {
                id: 10,
                name: "1/6",
                params: { x: 0, y: 0, w: 0.5, h: 0.3333 }
            }, {
                id: 11,
                name: "2/6",
                params: { x: 0.5, y: 0, w: 0.5, h: 0.3333 }
            }, {
                id: 12,
                name: "3/6",
                params: { x: 0, y: 0.3333, w: 0.5, h: 0.3333 }
            }, {
                id: 13,
                name: "4/6",
                params: { x: 0.5, y: 0.3333, w: 0.5, h: 0.3333 }
            }, {
                id: 14,
                name: "5/6",
                params: { x: 0, y: 0.6666, w: 0.5, h: 0.3333 }
            }, {
                id: 15,
                name: "6/6",
                params: { x: 0.5, y: 0.6666, w: 0.5, h: 0.3333 }
            }],
            content_types: [{
                id: 0,
                name: "Обычный"
            }, {
                id: 1,
                name: "Статика"
            }, {
                id: 2,
                name: "Цвет"
            }],
            text_aligns: [{
                name: "center"
            }, {
                name: "start"
            }, {
                name: "end"
            }],
            default_positions: {
                clientX: undefined,
                clientY: undefined,
                movementX: 0,
                movementY: 0
            },
            positions: [],
            object_positions: [],
            frame_positions: [],
            collages: [{
                name: '2',
                data: [{
                    id: '2_1',
                    frames: [{ x: 0, y: 0, width: 1.0, height: 0.5 }, { x: 0, y: 0.5, width: 1.0, height: 0.5 }]
                }, {
                    id: '2_2',
                    frames: [{ x: 0, y: 0, width: 1.0, height: 0.491 }, { x: 0, y: 0.509, width: 1.0, height: 0.491 }]
                }, {
                    id: '2_3',
                    frames: [{ x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474 }, { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474 }]
                }, {
                    id: '2_4',
                    frames: [{ x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '2_5',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 1.0 }, { x: 0.5, y: 0, width: 0.5, height: 1.0 }]
                }, {
                    id: '2_6',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.315 }, { x: 0, y: 0.315, width: 1, height: 0.685 }]
                }, {
                    id: '2_7',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.685 }, { x: 0, y: 0.685, width: 1, height: 0.315 }]
                }, {
                    id: '2_8',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: '2_9',
                    frames: [{ x: 0.2375, y: 0.1223, width: 0.532, height: 0.3647 }, { x: 0.2375, y: 0.5133, width: 0.532, height: 0.3647 }]
                }]
            }, {
                name: '3',
                data: [{
                    id: "3_1",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3334 }, { x: 0, y: 0.6667, width: 1, height: 0.3333 }]
                }, {
                    id: "3_2",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.326783 }, { x: 0, y: 0.336758, width: 1, height: 0.326783 }, { x: 0, y: 0.673216, width: 1, height: 0.326783 }]
                }, {
                    id: "3_3",
                    frames: [{ x: 0.028, y: 0.015625, width: 0.944, height: 0.3125 }, { x: 0.028, y: 0.34375, width: 0.944, height: 0.3125 }, { x: 0.028, y: 0.671875, width: 0.944, height: 0.3125 }]
                }, {
                    id: "3_4",
                    frames: [{
                        x: 0.028,
                        y: 0.015625,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }, {
                        x: 0.028,
                        y: 0.34375,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }, {
                        x: 0.028,
                        y: 0.671875,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }]
                }, {
                    id: "3_5",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6667, width: 0.5, height: 0.3333 }]
                }, {
                    id: "3_6",
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 1 }, { x: 0.3333, y: 0, width: 0.3333, height: 1 }, { x: 0.6667, y: 0, width: 0.3333, height: 1 }]
                }, {
                    id: "3_7",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_8",
                    frames: [{ x: 0, y: 0.5, width: 1, height: 0.5 }, { x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_9",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_10",
                    frames: [{ x: 0.0648, y: 0.064, width: 0.4815, height: 0.28125 }, { x: 0.0648, y: 0.35925, width: 0.4815, height: 0.28125 }, { x: 0.0648, y: 0.6564, width: 0.4815, height: 0.28125 }]
                }]
            }, {
                name: '4',
                data: [{
                    id: "4_1",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.25 }, { x: 0, y: 0.25, width: 1, height: 0.25 }, { x: 0, y: 0.5, width: 1, height: 0.25 }, { x: 0, y: 0.75, width: 1, height: 0.25 }]
                }, {
                    id: "4_2",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.24267 }, { x: 0, y: 0.25264333, width: 1, height: 0.24267 }, { x: 0, y: 0.50498666, width: 1, height: 0.24267 }, { x: 0, y: 0.75733, width: 1, height: 0.24267 }]
                }, {
                    id: "4_3",
                    frames: [{ x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875 }]
                }, {
                    id: "4_4",
                    frames: [{ x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }]
                }, {
                    id: "4_5",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "4_6",
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.4948 }, { x: 0.50925, y: 0, width: 0.49075, height: 0.4948 }, { x: 0, y: 0.5052, width: 0.49075, height: 0.4948 }, { x: 0.50925, y: 0.5052, width: 0.49075, height: 0.4948 }]
                }, {
                    id: "4_7",
                    frames: [{ x: 0.0315, y: 0.017708, width: 0.45925, height: 0.410417 }, { x: 0.50925, y: 0.017708, width: 0.45927, height: 0.410417 }, { x: 0.0315, y: 0.438542, width: 0.45927, height: 0.410417 }, { x: 0.50925, y: 0.438542, width: 0.45927, height: 0.410417 }]
                }, {
                    id: "4_8",
                    frames: [{ x: 0.0407, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.5213, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.0407, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.5213, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }]
                }, {
                    id: "4_9",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.5 }, { x: 0, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 }]
                }, {
                    id: "4_10",
                    frames: [{ x: 0.01852, y: 0.010717, width: 0.96296, height: 0.48381425 }, { x: 0.01852, y: 0.50546875, width: 0.30864, height: 0.48411425 }, { x: 0.34568, y: 0.50546875, width: 0.30864, height: 0.48411425 }, { x: 0.67284, y: 0.50546875, width: 0.30864, height: 0.48411425 }]
                }, {
                    id: "4_11",
                    frames: [{ x: 0.01852, y: 0.010417, width: 0.400926, height: 0.4843745 }, { x: 0.437966, y: 0.010417, width: 0.543514, height: 0.4843745 }, { x: 0.01852, y: 0.5052085, width: 0.543514, height: 0.4843745 }, { x: 0.580554, y: 0.5052085, width: 0.400926, height: 0.4843745 }]
                }, {
                    id: "4_12",
                    frames: [{ x: 0, y: 0, width: 0.49074, height: 0.4895829967 }, { x: 0.50926, y: 0, width: 0.49074, height: 0.4895829967 }, { x: 0, y: 0.4999996633, width: 1, height: 0.2447917 }, { x: 0, y: 0.7552083, width: 1, height: 0.2447917 }]
                }]
            }, {
                name: '5',
                data: [{
                    id: '5_1',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.2 }, { x: 0, y: 0.2, width: 1, height: 0.2 }, { x: 0, y: 0.4, width: 1, height: 0.2 }, { x: 0, y: 0.6, width: 1, height: 0.2 }, { x: 0, y: 0.8, width: 1, height: 0.2 }]
                }, {
                    id: '5_2',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.1875 }, { x: 0, y: 0.203125, width: 1, height: 0.1875 }, { x: 0, y: 0.40625, width: 1, height: 0.1875 }, { x: 0, y: 0.609375, width: 1, height: 0.1875 }, { x: 0, y: 0.8125, width: 1, height: 0.1875 }]
                }, {
                    id: '5_3',
                    frames: [{ x: 0.028, y: 0.015825, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095 }]
                }, {
                    id: '5_4',
                    frames: [{ x: 0.028, y: 0.015825, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '5_5',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.5, height: 0.3334 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '5_6',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 1 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0.3333, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0, width: 0.3334, height: 1 }]
                }, {
                    id: '5_7',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.6666, y: 0, width: 0.3334, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3333 }, { x: 0, y: 0.6666, width: 1, height: 0.3334 }]
                }, {
                    id: '5_8',
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.4947915 }, { x: 0, y: 0.5052085, width: 0.49075, height: 0.4947915 }, { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.33710567, width: 0.49075, height: 0.32608867 }, { x: 0.50927, y: 0.67361134, width: 0.49075, height: 0.32638867 }]
                }, {
                    id: '5_9',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '5_11',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 }]
                }]
            }, {
                name: '6',
                data: [{
                    id: '6_1',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.16697 }, { x: 0, y: 0.16637, width: 1, height: 0.16697 }, { x: 0, y: 0.33304, width: 1, height: 0.16697 }, { x: 0, y: 0.49971, width: 1, height: 0.16697 }, { x: 0, y: 0.66638, width: 1, height: 0.16696 }, { x: 0, y: 0.83304, width: 1, height: 0.16696 }]
                }, {
                    id: '6_2',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.15798583 }, { x: 0, y: 0.16790283, width: 1, height: 0.15798583 }, { x: 0, y: 0.33680566, width: 1, height: 0.15798583 }, { x: 0, y: 0.50520849, width: 1, height: 0.15798583 }, { x: 0, y: 0.67361132, width: 1, height: 0.15798583 }, { x: 0, y: 0.84201415, width: 1, height: 0.15798583 }]
                }, {
                    id: '6_3',
                    frames: [{ x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152 }]
                }, {
                    id: '6_4',
                    frames: [{ x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '6_14',
                    frames: [{ x: 0, y: 0, width: 0.1667, height: 1 }, { x: 0.1667, y: 0, width: 0.1666, height: 1 }, { x: 0.3333, y: 0, width: 0.1667, height: 1 }, { x: 0.5, y: 0, width: 0.1667, height: 1 }, { x: 0.6667, y: 0, width: 0.1666, height: 1 }, { x: 0.8333, y: 0, width: 0.1667, height: 1 }]
                }, {
                    id: '6_5',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0.6666, width: 0.3333, height: 0.3334 }]
                }, {
                    id: '6_6',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.5, height: 0.3334 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '6_7',
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0, y: 0.33685567, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.33685567, width: 0.49075, height: 0.32638867 }, { x: 0, y: 0.67321134, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.67321134, width: 0.49075, height: 0.32638867 }]
                }, {
                    id: '6_8',
                    frames: [{ x: 0, y: 0, width: 0.369444, height: 0.25 }, { x: 0, y: 0.25, width: 0.369444, height: 0.25 }, { x: 0.369444, y: 0, width: 0.630556, height: 0.5 }, { x: 0, y: 0.5, width: 0.630556, height: 0.5 }, { x: 0.630556, y: 0.5, width: 0.369444, height: 0.25 }, { x: 0.630556, y: 0.75, width: 0.369444, height: 0.25 }]
                }, {
                    id: '6_9',
                    frames: [{ x: 0, y: 0, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.2526175, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.505235, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.7578525, width: 0.369444, height: 0.2421475 }, { x: 0.387964, y: 0, width: 0.612036, height: 0.4947915 }, { x: 0.387964, y: 0.505235, width: 0.612036, height: 0.4947915 }]
                }, {
                    id: '6_10',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.65833 }, { x: 0, y: 0.65833, width: 0.3333, height: 0.34167 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.34167 }, { x: 0.3333, y: 0.34167, width: 0.3333, height: 0.65833 }, { x: 0.6666, y: 0, width: 0.3334, height: 0.65833 }, { x: 0.6666, y: 0.65833, width: 0.3334, height: 0.34167 }]
                }, {
                    id: '6_11',
                    frames: [{ x: 0, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0.33950667, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0.67851334, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0, y: 0.33685867, width: 0.32098667, height: 0.32638867 }, { x: 0, y: 0.67321734, width: 0.32098667, height: 0.32638867 }, { x: 0.33950667, y: 0.33685867, width: 0.66049333, height: 0.66314133 }]
                }, {
                    id: '6_12',
                    frames: [{ x: 0, y: 0, width: 0.68611, height: 0.3333 }, { x: 0.68611, y: 0, width: 0.31389, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.31389, height: 0.3333 }, { x: 0.31389, y: 0.3333, width: 0.68611, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.68611, height: 0.3334 }, { x: 0.68611, y: 0.6666, width: 0.31389, height: 0.3334 }]
                }, {
                    id: '6_13',
                    frames: [{ x: 0.084185, y: 0.14375, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.14375, width: 0.391667, height: 0.22013867 }, { x: 0.084185, y: 0.38993067, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.38993067, width: 0.391667, height: 0.22013867 }, { x: 0.084185, y: 0.63611134, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.63611134, width: 0.391667, height: 0.22013867 }]
                }]
            }, {
                name: '9',
                data: [{
                    id: '9_1',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.6666, y: 0, width: 0.3333, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.3333, height: 0.3334 }, { x: 0.3333, y: 0.3333, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0.3333, width: 0.3333, height: 0.3334 }, { x: 0, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0.6666, width: 0.3333, height: 0.3334 }]
                }]
            }, {
                name: '10',
                data: [{
                    id: '10_1',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.2 }, { x: 0.5, y: 0, width: 0.5, height: 0.2 }, { x: 0, y: 0.2, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.2, width: 0.5, height: 0.2 }, { x: 0, y: 0.4, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.4, width: 0.5, height: 0.2 }, { x: 0, y: 0.6, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.6, width: 0.5, height: 0.2 }, { x: 0, y: 0.8, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.8, width: 0.5, height: 0.2 }]
                }, {
                    id: '10_2',
                    frames: [{ x: 0, y: 0, width: 0.2, height: 0.5 }, { x: 0, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.2, y: 0, width: 0.2, height: 0.5 }, { x: 0.2, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.4, y: 0, width: 0.2, height: 0.5 }, { x: 0.4, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.6, y: 0, width: 0.2, height: 0.5 }, { x: 0.6, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.8, y: 0, width: 0.2, height: 0.5 }, { x: 0.8, y: 0.5, width: 0.2, height: 0.5 }]
                }]
            }, {
                name: '12',
                data: [{
                    id: '12_1',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0, width: 0.3333, height: 0.25 }, { x: 0, y: 0.25, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0.25, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0.25, width: 0.3333, height: 0.25 }, { x: 0, y: 0.5, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0.5, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0.5, width: 0.3333, height: 0.25 }, { x: 0, y: 0.75, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0.75, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0.75, width: 0.3333, height: 0.25 }]
                }]
            }, {
                name: '20',
                data: [{
                    id: '20_1',
                    frames: [{ x: 0, y: 0, width: 0.25, height: 0.2 }, { x: 0.25, y: 0, width: 0.25, height: 0.2 }, { x: 0.5, y: 0, width: 0.25, height: 0.2 }, { x: 0.75, y: 0, width: 0.25, height: 0.2 }, { x: 0, y: 0.2, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.2, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.2, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.2, width: 0.25, height: 0.2 }, { x: 0, y: 0.4, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.4, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.4, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.4, width: 0.25, height: 0.2 }, { x: 0, y: 0.6, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.6, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.6, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.6, width: 0.25, height: 0.2 }, { x: 0, y: 0.8, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.8, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.8, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.8, width: 0.25, height: 0.2 }]
                }]
            }]
        };
    },

    watch: {
        is_playing: function is_playing(val) {
            if (val) {
                this.startVisibilityLoop();
            } else {
                this.stopVisibilityLoop();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.stopVisibilityLoop();
        document.removeEventListener('keydown', this._nudgeKeydownHandler, true);
    },
    created: function created() {
        var self = this;
        self.id = this.$route.params.id;

        self.getResources();

        self.get(self.id);

        self._nudgeKeydownHandler = self.onNudgeKeydown.bind(self);
        document.addEventListener('keydown', self._nudgeKeydownHandler, true);
    },
    computed: {
        graphicsUrl: function graphicsUrl() {
            return this.$graphicsUrl;
        },
        fontsUrl: function fontsUrl() {
            return this.$fontsUrl;
        },
        framesUrl: function framesUrl() {
            return this.$framesUrl;
        },
        sumParts: function sumParts() {
            var sum = 0;
            _.map(this.visibleClientParts, function (p) {
                if (!p.cutout_only) {
                    var duration = parseFloat(p.duration);
                    duration = isNaN(duration) ? 0 : duration;

                    // Collages block
                    if (p.collage_type !== 0) {
                        var startTime = parseFloat(p.start_time);
                        startTime = isNaN(startTime) ? 0 : startTime;

                        var collageDuration = startTime + duration;
                        duration = sum > collageDuration ? 0 : collageDuration - sum;
                    }

                    sum += duration;
                }
            });

            return sum.toFixed(2);
        },
        sortedFonts: function sortedFonts() {
            return _.sortBy(this.fonts, function (f) {
                return f.name;
            });
        },
        versions: function versions() {
            var result = [];
            var start = 101;
            var end = start + 19;

            for (var i = start; i <= end; i++) {
                result.push((i / 10).toFixed(1));
            }

            return result;
        },
        collageModalFrameText: function collageModalFrameText() {
            var frame = null;

            if (this.active_collage_category === 'Custom') {
                frame = this.buildCustomCollageFrame(false);
            } else if (this.active_part_index !== null && this.client_parts[this.active_part_index]) {
                frame = this.client_parts[this.active_part_index].frame;
            }

            if (!frame) {
                return '';
            }

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(frame).replace(/:/g, ': ').replace(/,/g, ', ');
        }
    },
    methods: {
        text_html: function text_html(index) {
            var textModel = this.template.texts[index];

            var text = _.find(this.fonts, function (f) {
                return f.name === textModel.font_name;
            });
            if (!text) {
                alert('Шрифт ' + textModel.font_name + ' не найден. Пожалуйста, замените на другой.');

                text = _.first(this.fonts);
            }

            var line_height = parseFloat(textModel.font_size) + parseFloat(textModel.line_spacing);
            var alpha = textModel.alpha;

            var bgColor = textModel.background_color;

            if (parseFloat(textModel.bg_alpha) < 0.99) {
                bgColor = textModel.background_color + ('' + textModel.bg_alpha * 100);
            }

            var direction = '';
            if (textModel.direction === 'vertical') {
                direction = '  writing-mode: vertical-rl;\n' + '  text-orientation: upright;\n';
            }

            var offset = 4 / 88 * textModel.font_size;
            var blur = 0.29 * textModel.font_size / 88 * textModel.shadow_blur;
            var shadow = 'text-shadow: ' + offset + 'px ' + offset + 'px ' + blur + 'px ' + textModel.shadow_color + this.convertAlphaToHex(textModel.shadow_alpha) + ';';

            return '<span style="color: ' + textModel.text_color + '; ' + 'background-color: ' + bgColor + '; ' + 'font-size: ' + textModel.font_size + 'px; ' + 'letter-spacing: ' + textModel.letter_spacing + 'px; ' + 'opacity: ' + alpha + '; ' + 'line-height: ' + line_height + 'px; ' + 'transform: rotate( ' + textModel.angle + 'deg); ' + 'display: block;' + direction + shadow + 'text-align: ' + textModel.text_align + '; ' + 'z-index: ' + textModel.z_index + '; ' + 'font-family:' + text.params + ';">' + textModel.text + '</span>';
        },
        object_html: function object_html(index) {
            return this.renderSvgObjectHtml(this.template.objects[index]);
        },
        frame_html: function frame_html(index) {
            var frameModel = this.template.frames[index];
            if (!frameModel) {
                return "";
            }

            var rawData = frameModel.rawData || {};
            var originalW = parseFloat(rawData.original_w);
            if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(originalW) || originalW <= 0) {
                originalW = 1080;
            }

            var scale = 360 / originalW;
            var rawW = parseFloat(rawData.w);
            var width = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(rawW) ? rawW * scale : (parseFloat(frameModel.w) || 1) * 360;

            var img = '<img src="' + this.framesUrl + frameModel.src + '">';

            var style = ' style="width: ' + width + 'px; opacity: ' + frameModel.alpha + '; padding: 0px; transform: rotate(' + frameModel.angle + 'deg); z-index: ' + frameModel.z_index + '; display: block;"';

            img = this.insertAt(img, style, 5);

            return img;
        },
        image_html: function image_html(index) {
            var objectModel = this.template.objects[index];

            if (!objectModel.source || !objectModel.dimensions) {
                return "";
            }

            var width = objectModel.dimensions.width;
            var height = objectModel.dimensions.height;

            width = width * parseFloat(objectModel.scale);
            height = height * parseFloat(objectModel.scale);

            var img = '<img src="' + this.objectPlayerSrc(objectModel) + '">';

            var style = ' style="width: ' + width + 'px; height: ' + height + 'px; opacity: ' + objectModel.alpha + '; padding: 0px; transform: rotate(' + objectModel.angle + 'deg); z-index: ' + objectModel.z_index + '; display: block;"';

            img = this.insertAt(img, style, 5);

            return img;
        },

        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        getUnsavedState: function getUnsavedState() {
            return this.stringifyUnsaved({
                template: this.template,
                client_parts: this.client_parts,
                effect: this.effect,
                effect_intensity: this.effect_intensity,
                filter: this.filter,
                filter_intensity: this.filter_intensity
            });
        },

        goBack: function goBack() {
            this.$router.push('/templates');
        },
        insertAt: function insertAt(str, sub, pos) {
            return '' + str.slice(0, pos) + sub + str.slice(pos);
        },
        formatStartTime: function formatStartTime(event, index, object) {
            this.client_parts[index][object] = this.client_parts[index][object].replace(',', '.');
        },
        formatDuration: function formatDuration(event, index) {
            this.client_parts[index].duration = this.client_parts[index].duration.replace(',', '.');
        },
        formatSpeed: function formatSpeed(event, index) {
            this.client_parts[index].speed = this.client_parts[index].speed.replace(',', '.');
        },
        formatVideoDuration: function formatVideoDuration(event, index) {
            this.template.duration = this.template.duration.replace(',', '.');
        },
        addText: function addText() {
            var copy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var tool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            // if copied
            if (copy !== false) {
                var copiedText = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(self.template.texts[self.active_text]));
                copiedText.z_index = self.template.texts.length + self.template.objects.length + 1;
                copiedText.text = 'Default text';

                self.template.texts.push(copiedText);

                var positions = self.positions[self.active_text];
                positions.clientX = positions.clientX ? positions.clientX + 5 : positions.clientX;
                positions.clientY = positions.clientY ? positions.clientY + 5 : positions.clientY;
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(positions)));

                setTimeout(function () {

                    self.$refs.draggableContainer[self.template.texts.length - 1].style.left = self.$refs.draggableContainer[self.active_text].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = self.$refs.draggableContainer[self.active_text].offsetTop + 5 + 'px';

                    self.active_text = self.template.texts.length - 1;
                    self.active_type = 'text';

                    //console.log(self.$refs.draggableContainer[self.template.texts.length - 1].style.left);
                }, 100);
            } else {
                var newText = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(self.default_text));

                if (tool) {
                    newText.type = 1;
                    newText.background_color = '#448AF7';
                }

                newText.z_index = self.template.texts.length + self.template.objects.length + 1;
                self.template.texts.push(newText);
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                self.active_text = self.template.texts.length - 1;
                self.active_type = 'text';
            }
        },
        addObject: function addObject(object) {
            var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            // if copied
            if (copy !== false) {
                var copiedObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(self.template.objects[self.active_object]));
                copiedObject.z_index = self.template.texts.length + self.template.objects.length + 1;

                self.template.objects.push(copiedObject);
                self.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(self.object_positions[self.active_object])));

                setTimeout(function () {

                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.left = self.$refs.draggableContainer2[self.active_object].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.top = self.$refs.draggableContainer2[self.active_object].offsetTop + 5 + 'px';

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object';
                }, 100);
            } else {
                self.placeGraphicObject(object);
            }
        },
        changeObject: function changeObject() {
            this.is_object_changing = true;
            this.show_svg_modal = true;
        },
        changeFrame: function changeFrame() {
            this.is_frame_changing = true;
            this.show_frames_modal = true;
        },
        addCollage: function addCollage(e) {
            // 888
            var data = e.target.dataset.params;
            var params = data.split(';');
            var id = params[0];
            var part = params[1];
            var x = params[2];
            var y = params[3];
            var w = params[4];
            var h = params[5];

            this.client_parts[this.active_part_index].collage_type = id + ';' + part;
            this.client_parts[this.active_part_index].frame = {
                x: parseFloat(x),
                y: parseFloat(y),
                w: parseFloat(w),
                h: parseFloat(h)
            };

            this.previous_collage_id = id;

            this.show_collage_modal = false;
        },
        addCustomCollage: function addCustomCollage() {
            var frame = this.buildCustomCollageFrame(true);

            if (!frame) {
                alert('Заполните размеры фрейма и редактируемой области');
                return;
            }

            this.client_parts[this.active_part_index].collage_type = 'custom';
            this.client_parts[this.active_part_index].frame = frame;

            this.previous_collage_id = 'custom';
            this.show_collage_modal = false;
        },
        buildCustomCollageFrame: function buildCustomCollageFrame() {
            var withRawData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            var raw = this.custom_collage_rawData;
            var originalW = parseFloat(raw.original_w);
            var originalH = parseFloat(raw.original_h);
            var w = parseFloat(raw.w);
            var h = parseFloat(raw.h);
            var x = parseFloat(raw.x) || 0;
            var y = parseFloat(raw.y) || 0;
            var bTl = parseFloat(raw.b_tl) || 0;
            var bTr = parseFloat(raw.b_tr) || 0;
            var bBr = parseFloat(raw.b_br) || 0;
            var bBl = parseFloat(raw.b_bl) || 0;

            if (!originalW || !originalH || !w || !h) {
                return null;
            }

            var frame = {
                w: parseFloat((w / originalW).toFixed(6)),
                h: parseFloat((h / originalH).toFixed(6)),
                x: parseFloat((x / originalW).toFixed(6)),
                y: parseFloat((y / originalH).toFixed(6)),
                b_tl: parseFloat((bTl / w).toFixed(6)),
                b_tr: parseFloat((bTr / w).toFixed(6)),
                b_br: parseFloat((bBr / w).toFixed(6)),
                b_bl: parseFloat((bBl / w).toFixed(6))
            };

            if (withRawData) {
                frame.rawData = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(raw));
            }

            return frame;
        },
        convertCollageTypeToNewFormat: function convertCollageTypeToNewFormat(oldType) {

            if (oldType === 'custom') return oldType;
            if (oldType.toString().indexOf('_') > 0) return oldType;

            var oldTypeName = _.find(this.collage_types, function (c) {
                return c.id === parseInt(oldType);
            }).name;
            var oldCategory = oldTypeName.split('/');
            var collageCategory = parseInt(oldCategory[1]) === 6 ? 6 : 1;

            return oldCategory[1] + '_' + collageCategory + ';' + oldCategory[0];
        },
        convertAlphaToHex: function convertAlphaToHex(alpha) {
            if (alpha < 0.08) return '00';
            return Math.floor(alpha * 255).toString(16);
        },
        selectText: function selectText(text) {
            this.active_text = text;
            this.active_type = 'text';
        },
        selectObject: function selectObject(object) {
            this.active_object = object;
            this.active_type = 'object';
        },
        selectFrame: function selectFrame(frame) {
            this.active_frame = frame;
            this.active_type = 'frame';
        },
        selectFrameCategory: function selectFrameCategory(id) {
            this.active_frame_category = id;
        },
        addFrame: function addFrame(frame) {
            var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            if (!self.template.frames) {
                self.template.frames = [];
            }

            if (copy !== false) {
                var copiedFrame = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(self.template.frames[self.active_frame]));

                self.template.frames.push(copiedFrame);
                self.frame_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(self.default_positions)));
                self.active_frame = self.template.frames.length - 1;
                self.active_type = 'frame';
                self.syncFrameCalculations(self.active_frame);

                self.$nextTick(function () {
                    self.applyFrameContainerPosition(self.active_frame);
                });
            } else if (self.is_frame_changing) {
                var current = self.template.frames[self.active_frame];
                current.id = frame.id;
                current.src = frame.src;
                current.layouts = frame.layouts;
                self.is_frame_changing = false;
                self.show_frames_modal = false;
            } else {
                self.template.frames.push({
                    id: frame.id,
                    src: frame.src,
                    z_index: 1,
                    angle: 0,
                    alpha: 1,
                    layouts: frame.layouts,
                    w: 0,
                    x: 0,
                    y: 0,
                    time_start: 0,
                    time_end: "",
                    is_visible: 1,
                    rawData: {
                        original_w: 1080,
                        w: 540,
                        x: 0,
                        y: 0
                    }
                });

                self.frame_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(self.default_positions)));
                self.active_frame = self.template.frames.length - 1;
                self.active_type = 'frame';
                self.syncFrameCalculations(self.active_frame);
                self.show_frames_modal = false;

                self.$nextTick(function () {
                    self.applyFrameContainerPosition(self.active_frame);
                });
            }
        },
        removeFrame: function removeFrame(index) {
            var self = this;

            if (confirm("Подтверждение удаления фрейма " + (parseInt(index) + 1))) {
                self.template.frames = self.template.frames.filter(function (t, i) {
                    return i !== index;
                });
                self.frame_positions = self.frame_positions.filter(function (t, i) {
                    return i !== index;
                });
                self.active_frame = 0;
                self.syncOverlayActiveType();
            }
        },

        calculateFrames: function calculateFrames() {
            var frames = this.template.frames || [];
            for (var j = 0; j < frames.length; j++) {
                this.syncFrameCalculations(j);
            }
        },
        syncFrameCalculations: function syncFrameCalculations(index) {
            var frame = this.template.frames[index];
            if (!frame || !frame.rawData) {
                return;
            }

            var originalH = this.getOriginalH(frame.rawData.original_w);

            frame.w = parseFloat(parseFloat(frame.rawData.w) / parseFloat(frame.rawData.original_w)).toFixed(6);
            frame.x = parseFloat(parseFloat(frame.rawData.x) / parseFloat(frame.rawData.original_w)).toFixed(6);
            frame.y = parseFloat(parseFloat(frame.rawData.y) / parseFloat(originalH)).toFixed(6);
        },
        applyFrameContainerPosition: function applyFrameContainerPosition(index) {
            var frame = this.template.frames[index];
            var containers = this.$refs.draggableContainer3;
            if (!frame || !frame.rawData || !containers || !containers[index]) {
                return;
            }

            var scale = 360 / parseFloat(frame.rawData.original_w);
            containers[index].style.left = parseFloat(frame.rawData.x) * scale + 'px';
            containers[index].style.top = parseFloat(frame.rawData.y) * scale + 'px';
        },
        onFrameRawDataChange: function onFrameRawDataChange() {
            this.syncFrameCalculations(this.active_frame);
            this.applyFrameContainerPosition(this.active_frame);
        },
        updateFramePositionFromDom: function updateFramePositionFromDom(index) {
            var frame = this.template.frames[index];
            var containers = this.$refs.draggableContainer3;
            if (!frame || !frame.rawData || !containers || !containers[index]) {
                return;
            }

            var scale = 360 / parseFloat(frame.rawData.original_w);
            frame.rawData.x = parseFloat((containers[index].offsetLeft / scale).toFixed(2));
            frame.rawData.y = parseFloat((containers[index].offsetTop / scale).toFixed(2));
            this.syncFrameCalculations(index);
        },
        getOriginalH: function getOriginalH(originalW) {
            originalW = parseFloat(originalW);
            var ratio = parseInt(this.template.ratio);

            if (ratio === 2) {
                // Горизонтальный 16:9
                return originalW * 9 / 16;
            }

            if (ratio === 3) {
                // Горизонтальный 5:1
                return originalW / 5;
            }

            // Обычный 9:16
            return originalW / 9 * 16;
        },
        selectObjectCategory: function selectObjectCategory(category) {
            this.active_object_category = category;
        },
        selectCollageCategory: function selectCollageCategory(category) {
            this.active_collage_category = category;
        },
        removeCollageFromPart: function removeCollageFromPart(index) {
            var self = this;

            if (confirm("Подтверждение удаления коллажа")) {
                self.client_parts[index].collage_type = 0;
                self.client_parts[index].frame = null;
            }
        },
        removeText: function removeText(index) {
            var self = this;

            if (confirm("Подтверждение удаления текста: " + self.template.texts[index].text)) {
                self.template.texts = self.template.texts.filter(function (t, i) {
                    return i !== index;
                });
                self.active_text = 0;
                self.syncOverlayActiveType();
            }
        },
        removeObject: function removeObject(index) {
            var self = this;

            if (confirm("Подтверждение удаления объекта")) {
                self.template.objects = self.template.objects.filter(function (t, i) {
                    return i !== index;
                });
                self.active_object = 0;
                self.syncOverlayActiveType();
            }
        },
        syncOverlayActiveType: function syncOverlayActiveType() {
            var self = this;

            if (self.template.texts.length > 0) {
                self.active_type = 'text';
                self.active_text = Math.min(self.active_text, self.template.texts.length - 1);
            } else if (self.template.objects.length > 0) {
                self.active_type = 'object';
                self.active_object = Math.min(self.active_object, self.template.objects.length - 1);
            } else if ((self.template.frames || []).length > 0) {
                self.active_type = 'frame';
                self.active_frame = Math.min(self.active_frame, self.template.frames.length - 1);
            } else {
                self.active_type = 'text';
            }
        },
        toggleText: function toggleText() {
            var self = this;

            if (self.is_text_active) {
                self.active_type = 'text';

                setTimeout(function () {
                    self.video = self.$refs.videoContainer;
                    if (!self.video) return;

                    self.video.addEventListener("playing", function () {
                        //console.log('play ' + self.video.currentTime);

                        self.is_playing = true;
                    });

                    self.video.addEventListener("timeupdate", function () {
                        self.checkElementsVisibility(self.video.currentTime);
                    });

                    self.video.addEventListener("pause", function () {
                        //console.log('pause ' + self.video.currentTime);

                        self.is_playing = false;
                    });
                }, 500);
            } else {
                self.template.texts = [];
                self.template.objects = [];
                self.template.frames = [];
                self.positions = [];
                self.frame_positions = [];
            }
        },
        toggleBackground: function toggleBackground() {
            if (this.template.texts[this.active_text].background_color === 'transparent') {
                this.setColor('#FFFFFF', 'background');
            } else {
                this.setColor('transparent', 'background');
            }
        },

        setTextPosition: function setTextPosition(x, y) {
            // x = parseFloat(x);
            // y = parseFloat(y);

            if (x) {
                this.template.texts[this.active_text].position_x = x;

                var centerX = x * 360 - this.$refs.draggableContainer[this.active_text].clientWidth / 2;

                this.$refs.draggableContainer[this.active_text].style.left = centerX + 'px';
            }

            if (y) {
                this.template.texts[this.active_text].position_y = y;

                var centerY = y * this.heightCanvas - this.$refs.draggableContainer[this.active_text].clientHeight / 2;

                this.$refs.draggableContainer[this.active_text].style.top = centerY + 'px';
            }
        },
        setObjectPosition: function setObjectPosition(x, y) {
            if (x) {
                this.template.objects[this.active_object].position_x = x;
            }

            if (y) {
                this.template.objects[this.active_object].position_y = y;
            }

            this.applyObjectContainerPosition(this.active_object);
        },
        onNudgeKeydown: function onNudgeKeydown(event) {
            if (!this.template) {
                return;
            }

            if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
                return;
            }

            var target = event.target;
            var tag = target && target.tagName;
            if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target && target.isContentEditable) {
                return;
            }

            if (this.show_svg_modal || this.show_frames_modal || this.show_collage_modal) {
                return;
            }

            var dx = 0;
            var dy = 0;
            if (event.key === 'ArrowLeft') {
                dx = -1;
            } else if (event.key === 'ArrowRight') {
                dx = 1;
            } else if (event.key === 'ArrowUp') {
                dy = -1;
            } else if (event.key === 'ArrowDown') {
                dy = 1;
            }

            if (!this.nudgeSelectedLayer(dx, dy)) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
        },
        nudgeSelectedLayer: function nudgeSelectedLayer(dx, dy) {
            if (this.active_type === 'text') {
                return this.nudgeText(dx, dy);
            }
            if (this.active_type === 'object') {
                return this.nudgeObject(dx, dy);
            }
            if (this.active_type === 'frame') {
                return this.nudgeFrame(dx, dy);
            }
            return false;
        },
        nudgeText: function nudgeText(dx, dy) {
            var index = this.active_text;
            var text = this.template.texts[index];
            var containers = this.$refs.draggableContainer;
            if (!text || !containers || !containers[index]) {
                return false;
            }

            var step = 0.0005;
            text.position_x = parseFloat((parseFloat(text.position_x) + dx * step).toFixed(4));
            text.position_y = parseFloat((parseFloat(text.position_y) + dy * step).toFixed(4));

            var el = containers[index];
            el.style.left = text.position_x * 360 - el.clientWidth / 2 + 'px';
            el.style.top = text.position_y * this.heightCanvas - el.clientHeight / 2 + 'px';
            return true;
        },
        nudgeObject: function nudgeObject(dx, dy) {
            var index = this.active_object;
            var obj = this.template.objects[index];
            if (!obj) {
                return false;
            }

            var step = 0.0005;
            obj.position_x = parseFloat((parseFloat(obj.position_x) + dx * step).toFixed(4));
            obj.position_y = parseFloat((parseFloat(obj.position_y) + dy * step).toFixed(4));
            this.applyObjectContainerPosition(index);
            return true;
        },
        nudgeFrame: function nudgeFrame(dx, dy) {
            var index = this.active_frame;
            var frame = this.template.frames[index];
            if (!frame || !frame.rawData) {
                return false;
            }

            frame.rawData.x = parseFloat((parseFloat(frame.rawData.x) + dx).toFixed(2));
            frame.rawData.y = parseFloat((parseFloat(frame.rawData.y) + dy).toFixed(2));
            this.syncFrameCalculations(index);
            this.applyFrameContainerPosition(index);
            return true;
        },
        changeEffectType: function changeEffectType(index, type) {

            if (type !== 1 || type !== 2) {
                return;
            }

            var from = 1;
            var to = 0.85;
            if (type === 2) {
                from = 0.85;
                to = 1;
            }

            this.client_parts[index].effect_values = {
                from: from,
                to: to,
                x: 0.5,
                y: 0.5
            };
        },
        changeContentType: function changeContentType(index, type) {
            this.client_parts[index].content = type === 2 ? '#000000' : null;
        },
        changeRatioType: function changeRatioType() {
            this.heightCanvas = 640;
            var ratio = parseInt(this.template.ratio);

            if (ratio > 1) {
                this.heightCanvas = ratio === 2 ? 202.5 : ratio === 3 ? 72 : 640;
            }
        },

        changeEffectPosition: function changeEffectPosition(event, index) {
            var offsetX = void 0;
            var offsetY = void 0;

            if (event.target.className !== 'effect-preview') {
                var parent = event.target.parentElement;
                if (parent.className !== 'effect-preview') {
                    parent = parent.parentElement;
                } else {}

                offsetX = 0;
                offsetY = 0;
            } else {
                offsetX = event.offsetX < 0 ? 0 : event.offsetX;
                offsetY = event.offsetY < 0 ? 0 : event.offsetY;
            }

            this.client_parts[index].effect_values.x = (offsetX / 50).toFixed(2);
            if (this.client_parts[index].effect_values.x > 1) {
                this.client_parts[index].effect_values.x = 1;
            }

            this.client_parts[index].effect_values.y = (offsetY / 89).toFixed(2);
            if (this.client_parts[index].effect_values.y > 1) {
                this.client_parts[index].effect_values.y = 1;
            }
        },
        changeCutoutPosition: function changeCutoutPosition(event, index) {
            var offsetX = void 0;
            var offsetY = void 0;

            if (event.target.className !== 'cutout-preview') {
                var parent = event.target.parentElement;
                if (parent.className !== 'cutout-preview') {
                    parent = parent.parentElement;
                } else {}

                offsetX = 0;
                offsetY = 0;
            } else {
                offsetX = event.offsetX < 0 ? 0 : event.offsetX;
                offsetY = event.offsetY < 0 ? 0 : event.offsetY;
            }

            this.client_parts[index].cutout_x = (offsetX / 50).toFixed(2);
            if (this.client_parts[index].cutout_x > 1) {
                this.client_parts[index].cutout_x = 1;
            }

            this.client_parts[index].cutout_y = (offsetY / 89).toFixed(2);
            if (this.client_parts[index].cutout_y > 1) {
                this.client_parts[index].cutout_y = 1;
            }

            this.$forceUpdate();
        },
        refreshTags: function refreshTags() {
            var _this = this;

            _.map(this.tags, function (t) {
                t.active = _this.template.tags.indexOf(t.id) > -1;
            });
        },
        toggleTag: function toggleTag(tag) {
            var tags = this.template.tags;
            var index = tags.indexOf(tag.id);
            index > -1 ? tags.splice(index, 1) : tags.push(tag.id);

            this.refreshTags();
        },
        setColor: function setColor(color, type) {
            if (type === 'color') {
                this.template.texts[this.active_text].text_color = color;
            }

            if (type === 'background') {
                this.template.texts[this.active_text].background_color = color;
            }
        },
        changeWidgetType: function changeWidgetType(index, type) {
            var current = (this.template.texts[this.active_text].background_color || '').toUpperCase();
            var isCustom = current && current !== 'TRANSPARENT' && current !== '#448AF7' && current !== '#888888';
            if (isCustom) {
                return;
            }
            if (type === 1 || type === 5 || type === 7) {
                this.template.texts[this.active_text].background_color = '#448AF7';
            }
            if (type === 2 || type === 3 || type === 4 || type === 6) {
                this.template.texts[this.active_text].background_color = '#888888';
            }
        },

        getContentColor: function getContentColor(color) {
            if (color && color[0] === '#') {
                return color;
            } else {
                return '#000000';
            }
        },
        isContentCorrected: function isContentCorrected(content) {
            return content && content[0] !== '#';
        },
        setObjColor: function setObjColor(color) {
            this.template.objects[this.active_object].color = color;
        },
        showPreview: function showPreview() {
            this.is_playing = false;
            this.checkElementsVisibility(0);
            this.video.load();
        },
        isEmptyTimeEnd: function isEmptyTimeEnd(value) {
            return value === "" || value === null || value === undefined;
        },
        normalizeTimeEnd: function normalizeTimeEnd(value) {
            if (this.isEmptyTimeEnd(value)) {
                return "";
            }
            var parsed = parseFloat(value);
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(parsed) ? parsed : "";
        },
        isElementVisibleAt: function isElementVisibleAt(element, currentTime) {
            if (currentTime === 0) {
                return true;
            }

            var start = parseFloat(element.time_start);
            if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(start)) {
                start = 0;
            }

            if (this.isEmptyTimeEnd(element.time_end)) {
                return start < currentTime;
            }

            var end = parseFloat(element.time_end);
            if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(end)) {
                return start < currentTime;
            }

            return start < currentTime && end > currentTime;
        },
        checkElementsVisibility: function checkElementsVisibility(currentTime) {
            var self = this;
            var time = parseFloat(currentTime);
            if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(time)) {
                time = 0;
            }

            var elements = [self.template.texts, self.template.objects, self.template.frames];
            for (var o = 0; o < elements.length; o++) {
                var element = elements[o];
                if (!element) {
                    continue;
                }

                for (var i = 0; i < element.length; i++) {
                    if (!element[i]) {
                        continue;
                    }

                    self.$set(element[i], 'is_visible', self.isElementVisibleAt(element[i], time) ? 1 : 0);
                }
            }
        },
        stopVisibilityLoop: function stopVisibilityLoop() {
            if (this.visibilityRaf) {
                cancelAnimationFrame(this.visibilityRaf);
                this.visibilityRaf = null;
            }
        },
        startVisibilityLoop: function startVisibilityLoop() {
            var self = this;

            this.stopVisibilityLoop();

            var tick = function tick() {
                if (!self.is_playing) {
                    self.visibilityRaf = null;
                    return;
                }

                if (self.video) {
                    self.checkElementsVisibility(self.video.currentTime);
                }

                self.visibilityRaf = requestAnimationFrame(tick);
            };

            this.visibilityRaf = requestAnimationFrame(tick);
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.$hostname + '/admin/templates/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                    var _this2 = this;

                    var data, _loop, i, _i, ratio, _loop2, _i2, _i3, _loop3, _i5;

                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    data = response.data;

                                    _loop = function _loop(i) {

                                        var text = _.find(self.fonts, function (f) {
                                            return f.name === data.templates[0].texts[i].font_name;
                                        });
                                        if (!text) {
                                            //alert('Шрифт ' + data.templates[0].texts[i].font_name + ' не найден. Пожалуйста, замените на другой.');
                                        }

                                        data.templates[0].texts[i].is_visible = 1;
                                        if (data.templates[0].texts[i].time_start === undefined) {
                                            data.templates[0].texts[i].time_start = 0;
                                        }
                                        if (self.isEmptyTimeEnd(data.templates[0].texts[i].time_end)) {
                                            data.templates[0].texts[i].time_end = "";
                                        }

                                        if (!data.templates[0].texts[i].direction) {
                                            data.templates[0].texts[i].direction = "normal";
                                        }

                                        if (!data.templates[0].texts[i].animation_type) {
                                            data.templates[0].texts[i].animation_type = 0;
                                            data.templates[0].texts[i].animation_duration = 0;
                                        }

                                        if (!data.templates[0].texts[i].shadow_blur) {
                                            data.templates[0].texts[i].shadow_blur = 0;
                                        }

                                        if (!data.templates[0].texts[i].shadow_alpha) {
                                            data.templates[0].texts[i].shadow_alpha = 0;
                                        }

                                        if (!data.templates[0].texts[i].shadow_distance) {
                                            data.templates[0].texts[i].shadow_distance = 0;
                                        }

                                        if (!data.templates[0].texts[i].shadow_color) {
                                            data.templates[0].texts[i].shadow_color = '#ffffff';
                                        }

                                        if (!data.templates[0].texts[i].stroke_size) {
                                            data.templates[0].texts[i].stroke_size = 0;
                                        }

                                        if (!data.templates[0].texts[i].stroke_size) {
                                            data.templates[0].texts[i].stroke_color = '#000000';
                                        }

                                        if (!data.templates[0].texts[i].is_text_brush) {
                                            data.templates[0].texts[i].text_brush_data = [];
                                        }

                                        if (!data.templates[0].texts[i].bg_alpha) {
                                            data.templates[0].texts[i].bg_alpha = 1;
                                        }

                                        if (!data.templates[0].texts[i].is_animated) {
                                            data.templates[0].texts[i].is_animated = 0;
                                        }
                                    };

                                    for (i = 0; i < data.templates[0].texts.length; i++) {
                                        _loop(i);
                                    }

                                    for (i = 0; i < data.templates[0].objects.length; i++) {
                                        data.templates[0].objects[i].is_visible = 1;
                                        if (data.templates[0].objects[i].time_start === undefined || data.templates[0].objects[i].time_start === null) {
                                            data.templates[0].objects[i].time_start = 0;
                                        }
                                        if (self.isEmptyTimeEnd(data.templates[0].objects[i].time_end)) {
                                            data.templates[0].objects[i].time_end = "";
                                        }

                                        if (!data.templates[0].objects[i].animation_type) {
                                            data.templates[0].objects[i].animation_type = 0;
                                            data.templates[0].objects[i].animation_duration = 0;
                                        }

                                        if (!data.templates[0].objects[i].shadow_blur) {
                                            data.templates[0].objects[i].shadow_blur = 0;
                                        }

                                        if (!data.templates[0].objects[i].shadow_alpha) {
                                            data.templates[0].objects[i].shadow_alpha = 0;
                                        }

                                        if (!data.templates[0].objects[i].shadow_distance) {
                                            data.templates[0].objects[i].shadow_distance = 0;
                                        }

                                        if (!data.templates[0].objects[i].shadow_color) {
                                            data.templates[0].objects[i].shadow_color = '#ffffff';
                                        }

                                        if (!data.templates[0].objects[i].is_animated) {
                                            data.templates[0].objects[i].is_animated = 0;
                                        }
                                    }

                                    if (!data.templates[0].frames) {
                                        data.templates[0].frames = [];
                                    }

                                    for (_i = 0; _i < data.templates[0].frames.length; _i++) {
                                        data.templates[0].frames[_i].is_visible = 1;
                                        if (data.templates[0].frames[_i].time_start === undefined || data.templates[0].frames[_i].time_start === null) {
                                            data.templates[0].frames[_i].time_start = 0;
                                        }
                                        if (self.isEmptyTimeEnd(data.templates[0].frames[_i].time_end)) {
                                            data.templates[0].frames[_i].time_end = "";
                                        }
                                        if (!data.templates[0].frames[_i].rawData) {
                                            data.templates[0].frames[_i].rawData = {
                                                original_w: 1080,
                                                w: 540,
                                                x: 0,
                                                y: 0
                                            };
                                        }
                                    }

                                    self.template = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data.templates[0]));

                                    self.template.parts.forEach(function (p) {
                                        self.client_parts.push({
                                            duration: p.duration,
                                            speed: p.speed ? p.speed : "1.0",
                                            effect_type: p.effect_type ? p.effect_type : 0,
                                            effect_values: p.effect_values ? p.effect_values : { x: 0.5, y: 0.5 },
                                            collage_type: p.collage_type ? self.convertCollageTypeToNewFormat(p.collage_type) : 0,
                                            content_type: p.content_type ? p.content_type : 0,
                                            content: p.content ? p.content : null,
                                            content_full: p.content_full ? p.content_full : null,
                                            frame: p.frame ? p.frame : 0,
                                            start_time: p.start_time ? p.start_time : 0,
                                            cutout_animation_type: p.cutout_animation_type ? p.cutout_animation_type : 0,
                                            cutout_animation_duration: p.cutout_animation_duration ? p.cutout_animation_duration : 0,
                                            cutout_start_time: p.cutout_start_time ? p.cutout_start_time : 0,
                                            cutout_scale: p.cutout_scale ? p.cutout_scale : 0,
                                            cutout_x: p.cutout_x ? p.cutout_x : 0.5,
                                            cutout_y: p.cutout_y ? p.cutout_y : 0.5,
                                            cutout_only: p.cutout_only ? p.cutout_only : 0
                                        });
                                    });

                                    if (self.client_parts.length) {
                                        self.setVisiblePartCount(self.client_parts.length);
                                    }

                                    if (self.template.release_date) {
                                        self.template.release_time = moment(self.template.release_date, moment.DATETIME_LOCAL_MS).format('HH:mm');
                                        self.template.release_date = moment(self.template.release_date, moment.DATETIME_LOCAL_MS).format('YYYY-MM-DD');
                                    } else {
                                        self.template.release_time = '12:00';
                                    }

                                    if (self.template.realVideoDuration) {
                                        self.realVideoDuration = self.template.realVideoDuration;
                                    }

                                    if (self.template.realAudioDuration) {
                                        self.realAudioDuration = self.template.realAudioDuration;
                                    }

                                    if (self.template.song_insta) {
                                        self.template.song_insta = 'https://www.instagram.com/reels/audio/' + self.template.song_insta;
                                    }

                                    if (self.template.song_tiktok) {
                                        self.template.song_tiktok = 'https://vm.tiktok.com/' + self.template.song_tiktok;
                                    }

                                    if (self.template.effects) {
                                        self.effect = self.template.effects.split(':')[0];
                                        self.effect_intensity = self.template.effects.split(':')[1];
                                    } else {
                                        self.effect = "";
                                        self.effect_intensity = 100;
                                    }

                                    if (self.template.filters) {
                                        self.filter = self.template.filters.split(':')[0];
                                        self.filter_intensity = self.template.filters.split(':')[1];
                                    } else {
                                        self.filter = "";
                                        self.filter_intensity = 100;
                                    }

                                    ratio = parseInt(self.template.ratio);

                                    if (ratio > 1) {
                                        self.heightCanvas = ratio === 2 ? 202.5 : ratio === 3 ? 72 : 640;
                                    }

                                    if (!(self.template.objects.length < 1)) {
                                        _context2.next = 23;
                                        break;
                                    }

                                    self.template.objects = [];
                                    self.object_positions = [];
                                    _context2.next = 33;
                                    break;

                                case 23:

                                    if (self.template.texts.length < 1) {
                                        self.is_text_active = true;
                                        self.active_text = 0;
                                        self.active_type = 'object';
                                    }

                                    self.object_positions = [];

                                    _loop2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _loop2(_i2) {
                                        var dataSource, size;
                                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _loop2$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:

                                                        self.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                                                        if (!(self.template.objects[_i2].id.indexOf('.svg') > -1)) {
                                                            _context.next = 8;
                                                            break;
                                                        }

                                                        _context.next = 4;
                                                        return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(self.$hostname + '/admin/services/graphics/svg/source', {
                                                            'params': {
                                                                url: self.graphicsUrl + self.template.objects[_i2].id
                                                            },
                                                            'headers': {
                                                                'Authorization': 'Bearer ' + localStorage.getItem('token')
                                                            }
                                                        });

                                                    case 4:
                                                        dataSource = _context.sent;


                                                        self.template.objects[_i2].source = dataSource.data;

                                                        _context.next = 20;
                                                        break;

                                                    case 8:
                                                        if (!(self.isGifSrc(self.template.objects[_i2].id) || !self.template.objects[_i2].dimensions)) {
                                                            _context.next = 19;
                                                            break;
                                                        }

                                                        _context.prev = 9;
                                                        _context.next = 12;
                                                        return self.loadRasterGraphic(self.template.objects[_i2].id);

                                                    case 12:
                                                        size = _context.sent;

                                                        if (size && !self.template.objects[_i2].dimensions) {
                                                            self.$set(self.template.objects[_i2], 'dimensions', size);
                                                        }
                                                        _context.next = 19;
                                                        break;

                                                    case 16:
                                                        _context.prev = 16;
                                                        _context.t0 = _context['catch'](9);

                                                        console.log(_context.t0);

                                                    case 19:
                                                        self.template.objects[_i2].source = "Image";

                                                    case 20:

                                                        self.textWaiting = true;

                                                        self.template.objects[_i2].is_visible = 1;
                                                        self.$nextTick(function () {
                                                            self.applyObjectContainerPosition(_i2);

                                                            self.video = self.$refs.videoContainer;

                                                            self.video.addEventListener("playing", function () {
                                                                self.is_playing = true;
                                                            });

                                                            self.video.addEventListener("timeupdate", function () {
                                                                self.checkElementsVisibility(self.video.currentTime);
                                                            });

                                                            self.video.addEventListener("pause", function () {
                                                                self.is_playing = false;
                                                            });

                                                            self.textWaiting = false;
                                                        });

                                                    case 23:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _loop2, _this2, [[9, 16]]);
                                    });
                                    _i2 = 0;

                                case 27:
                                    if (!(_i2 < self.template.objects.length)) {
                                        _context2.next = 32;
                                        break;
                                    }

                                    return _context2.delegateYield(_loop2(_i2), 't0', 29);

                                case 29:
                                    _i2++;
                                    _context2.next = 27;
                                    break;

                                case 32:

                                    self.$nextTick(function () {
                                        self.applyAllObjectContainerPositions();
                                    });

                                case 33:

                                    if ((self.template.frames || []).length > 0) {
                                        self.frame_positions = [];

                                        for (_i3 = 0; _i3 < self.template.frames.length; _i3++) {
                                            self.frame_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(self.default_positions)));
                                        }

                                        if (self.template.texts.length < 1 && self.template.objects.length < 1) {
                                            self.is_text_active = true;
                                            self.active_frame = 0;
                                            self.active_type = 'frame';
                                        }

                                        setTimeout(function () {
                                            for (var _i4 = 0; _i4 < self.template.frames.length; _i4++) {
                                                self.applyFrameContainerPosition(_i4);
                                            }

                                            self.video = self.$refs.videoContainer;
                                            if (self.video && !self.video._overlayWatchersBound) {
                                                self.video._overlayWatchersBound = true;
                                                self.video.addEventListener("playing", function () {
                                                    self.is_playing = true;
                                                });
                                                self.video.addEventListener("timeupdate", function () {
                                                    self.checkElementsVisibility(self.video.currentTime);
                                                });
                                                self.video.addEventListener("pause", function () {
                                                    self.is_playing = false;
                                                });
                                            }
                                        }, 1000);
                                    }

                                    if (self.template.texts.length > 0) {

                                        self.is_text_active = true;
                                        self.active_text = 0;
                                        self.active_type = 'text';

                                        _loop3 = function _loop3(_i5) {
                                            self.positions.push(self.default_positions);

                                            if (!self.template.texts[_i5].angle) {
                                                self.template.texts[_i5].angle = 0;
                                            }

                                            self.textWaiting = true;

                                            setTimeout(function () {

                                                if (self.$refs.draggableContainer[_i5].clientHeight < 1) {
                                                    console.log('2275');
                                                    location.reload();
                                                }
                                                var centerX = self.template.texts[_i5].position_x * 360 - self.$refs.draggableContainer[_i5].clientWidth / 2;
                                                var centerY = self.template.texts[_i5].position_y * self.heightCanvas - self.$refs.draggableContainer[_i5].clientHeight / 2;

                                                self.$refs.draggableContainer[_i5].style.left = centerX + 'px';
                                                self.$refs.draggableContainer[_i5].style.top = centerY + 'px';

                                                self.video = self.$refs.videoContainer;

                                                self.video.addEventListener("playing", function () {
                                                    //console.log('play ' + self.video.currentTime);

                                                    self.is_playing = true;
                                                });

                                                self.video.addEventListener("timeupdate", function () {
                                                    self.checkElementsVisibility(self.video.currentTime);
                                                });

                                                self.video.addEventListener("pause", function () {
                                                    //console.log('pause ' + self.video.currentTime);

                                                    self.is_playing = false;
                                                });

                                                self.textWaiting = false;
                                            }, 1000);
                                        };

                                        for (_i5 = 0; _i5 < self.template.texts.length; _i5++) {
                                            _loop3(_i5);
                                        }
                                    }

                                    self.tags = response.data.tags;
                                    self.template.tags = self.template.tags ? JSON.parse(self.template.tags) : [];

                                    self.refreshTags();
                                    self.captureUnsavedSnapshot();

                                case 39:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee, this);
                }));

                return function (_x6) {
                    return _ref.apply(this, arguments);
                };
            }()).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        getResources: function getResources() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.$hostname + '/admin/resources/', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.server_effects = response.data.effects;
                self.server_graphics = response.data.graphics;
                self.server_filters = response.data.filters;
                self.server_fonts = response.data.fonts;
                self.server_frames = response.data.frames;

                if (!self.active_object_category && self.server_graphics.length) {
                    self.active_object_category = self.server_graphics[0].name;
                }

                self.appendFonts();
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        appendFonts: function appendFonts() {

            var newStyle = document.createElement('style');
            for (var i = 0; i < this.server_fonts.length; i++) {
                var font = this.server_fonts[i];

                newStyle.appendChild(document.createTextNode('\n                    @font-face {\n                      font-family: \'' + font.name + '\';\n                      src: url(\'/static/fonts/' + font.src + '\');\n                    }\n                    '));

                this.fonts.push({
                    params: '\'' + font.name + '\', sans-serif;',
                    code: font.name,
                    name: font.name
                });
            }

            document.head.appendChild(newStyle);
        },
        showSVGModal: function showSVGModal() {
            this.is_object_changing = false;
            this.show_svg_modal = true;
        },
        showFramesModal: function showFramesModal() {
            this.is_frame_changing = false;
            this.show_frames_modal = true;
        },
        closeSVGModal: function closeSVGModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_svg_modal = false;
                this.is_object_changing = false;
            }
        },
        closeFramesModal: function closeFramesModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_frames_modal = false;
                this.is_frame_changing = false;
            }
        },
        //'888'
        showCollageModal: function showCollageModal(index) {
            this.active_part_index = index;

            var part = this.client_parts[index];
            if (part.collage_type === 'custom') {
                this.active_collage_category = 'Custom';
                if (part.frame && part.frame.rawData) {
                    this.custom_collage_rawData = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(part.frame.rawData));
                } else {
                    this.custom_collage_rawData = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.default_custom_collage_rawData));
                }
            } else {
                if (part.collage_type && part.collage_type !== 0) {
                    this.active_collage_category = part.collage_type.toString().split(';')[0].split('_')[0];
                }
                this.custom_collage_rawData = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.default_custom_collage_rawData));
            }

            this.show_collage_modal = true;
        },
        closeCollageModal: function closeCollageModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_collage_modal = false;
            }
        },
        save: function save() {
            var _this3 = this;

            var self = this;

            this.commitVideoCount();
            this.calculateFrames();

            var template = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.template));
            template.parts = self.partsForSave();

            if (!this.validatePartDurations()) {
                return false;
            }

            if (template.type < 0 && Math.abs(this.sumParts - this.template.duration) > 0) {

                var notification = {
                    template: '<span><b>\u0414\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u043E\u0432 \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0439 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C\u044E \u0432\u0438\u0434\u0435\u043E</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                return false;
            }

            // if (Math.abs(this.realAudioDuration.toFixed(2) - this.realVideoDuration.toFixed(2)) > 0) {
            //
            //     const notification = {
            //         template: `<span><b>Длительность загруженного видео не совпадает с длительностью загруженного аудио</b></span>`
            //     };
            //
            //     self.$notifications.notify(
            //         {
            //             component: notification,
            //             icon: 'nc-icon nc-simple-remove',
            //             horizontalAlign: 'right',
            //             verticalAlign: 'top',
            //             type: 'danger'
            //         })
            //
            //     return false;
            // }

            if (template.type < 0 && Math.abs(this.sumParts - this.realVideoDuration.toFixed(2)) > 0) {

                var _notification = {
                    template: '<span><b>\u0423\u043A\u0430\u0437\u0430\u043D\u043D\u0430\u044F \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0432\u0438\u0434\u0435\u043E \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0439 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C\u044E, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u043E\u0439 \u0438\u0437 \u0432\u0438\u0434\u0435\u043E</b></span>'
                };

                self.$notifications.notify({
                    component: _notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                return false;
            }

            if (template.song_insta) {
                var regex = /(\d{14,22})/gi;
                var match = regex.exec(template.song_insta);

                var reelId = match ? match[0] : null;
                template.song_insta = reelId;

                if (!reelId) {
                    var _notification2 = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 Reels Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification2,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (template.song_tiktok) {
                var parts = template.song_tiktok.split('/');

                if (parts.length > 3 && parts[3].length > 5) {
                    template.song_tiktok = parts[3];
                } else {

                    var _notification3 = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 TikTok Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification3,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (this.video) {
                this.showPreview();
            }

            self.waiting = true;

            setTimeout(function () {

                if (_this3.is_text_active) {

                    for (var i = 0; i < self.template.texts.length; i++) {

                        var activeText = template.texts[i];

                        if (activeText.position_x !== 0.5) {
                            var centerX = _this3.$refs.draggableContainer[i].offsetLeft + _this3.$refs.draggableContainer[i].clientWidth / 2;

                            activeText.position_x = parseFloat((centerX / 360).toFixed(4));
                        }

                        if (activeText.position_y !== 0.5) {
                            var centerY = _this3.$refs.draggableContainer[i].offsetTop + _this3.$refs.draggableContainer[i].clientHeight / 2;

                            activeText.position_y = parseFloat((centerY / _this3.heightCanvas).toFixed(4));
                        }

                        activeText.letter_spacing = activeText.letter_spacing == "" ? 0 : activeText.letter_spacing;
                        activeText.line_spacing = activeText.line_spacing == "" ? 0 : activeText.line_spacing;
                        activeText.angle = activeText.angle == "" ? 0 : activeText.angle;
                        activeText.z_index = activeText.z_index == "" ? 0 : activeText.z_index;

                        activeText.position_x = parseFloat(activeText.position_x);
                        activeText.position_y = parseFloat(activeText.position_y);
                        activeText.font_size = parseFloat(activeText.font_size);
                        activeText.alpha = parseFloat(activeText.alpha);
                        activeText.bg_alpha = parseFloat(activeText.bg_alpha);
                        activeText.letter_spacing = parseFloat(activeText.letter_spacing);
                        activeText.line_spacing = parseFloat(activeText.line_spacing);
                        activeText.time_start = parseFloat(activeText.time_start);
                        activeText.shadow_distance = parseFloat(activeText.shadow_distance);
                        activeText.shadow_alpha = parseFloat(activeText.shadow_alpha);
                        activeText.shadow_blur = parseInt(activeText.shadow_blur);
                        activeText.animation_type = parseInt(activeText.animation_type);
                        activeText.animation_duration = parseFloat(activeText.animation_duration);
                        activeText.is_animated = parseInt(activeText.is_animated);
                        activeText.angle = parseInt(activeText.angle);
                        activeText.z_index = parseInt(activeText.z_index);
                        activeText.time_end = self.normalizeTimeEnd(activeText.time_end);

                        activeText.text_brush_data = activeText.is_text_brush ? activeText.text_brush_data : [];

                        template.texts[i] = activeText;
                    }

                    for (var _i6 = 0; _i6 < self.template.objects.length; _i6++) {

                        var activeObj = template.objects[_i6];

                        activeObj.position_x = parseFloat(activeObj.position_x);
                        activeObj.position_y = parseFloat(activeObj.position_y);

                        activeObj.scale = parseFloat(activeObj.scale);
                        activeObj.alpha = parseFloat(activeObj.alpha);
                        activeObj.time_start = parseFloat(activeObj.time_start);
                        activeObj.animation_type = parseInt(activeObj.animation_type);
                        activeObj.shadow_alpha = parseFloat(activeObj.shadow_alpha);
                        activeObj.shadow_distance = parseFloat(activeObj.shadow_distance);
                        activeObj.shadow_blur = parseInt(activeObj.shadow_blur);
                        activeObj.animation_duration = parseFloat(activeObj.animation_duration);
                        activeObj.is_animated = parseInt(activeObj.is_animated);
                        activeObj.angle = activeObj.angle == "" ? 0 : parseInt(activeObj.angle);
                        activeObj.z_index = activeObj.z_index == "" ? 0 : parseInt(activeObj.z_index);
                        activeObj.time_end = self.normalizeTimeEnd(activeObj.time_end);

                        delete activeObj.source;

                        template.objects[_i6] = activeObj;
                    }

                    for (var _i7 = 0; _i7 < (template.frames || []).length; _i7++) {
                        var activeFrame = template.frames[_i7];

                        activeFrame.alpha = parseFloat(activeFrame.alpha);
                        activeFrame.angle = parseInt(activeFrame.angle);
                        activeFrame.z_index = parseInt(activeFrame.z_index);
                        activeFrame.time_start = parseFloat(activeFrame.time_start);
                        activeFrame.time_end = self.normalizeTimeEnd(activeFrame.time_end);

                        template.frames[_i7] = activeFrame;
                    }
                } else {
                    template.texts = [];
                    template.objects = [];
                    template.frames = [];
                }

                if (!template.is_copyrighted) {
                    template.song_insta = "";
                    template.song_tiktok = "";
                }

                if (_this3.effect) {
                    template.effects = _this3.effect + ":" + _this3.effect_intensity;
                } else {
                    template.effects = "";
                }
                if (_this3.filter) {
                    template.filters = _this3.filter + ":" + _this3.filter_intensity;
                } else {
                    template.filters = "";
                }

                template.release_date = template.release_date + ' ' + template.release_time + ':00';

                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(_this3.$hostname + '/admin/templates/' + _this3.id + '/update', template, {
                    'headers': {
                        'Authorization': 'Bearer ' + _this3.token
                    }
                }).then(function (response) {
                    var notification = {
                        template: '<span><b>\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.waiting = false;
                    self.captureUnsavedSnapshot();

                    //                    self.$router.push('/templates');
                }).catch(function (error) {
                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;
                });
            }, 200);
        },
        remove: function remove() {
            var self = this;

            if (confirm("Внимание! Подтверждение удаления шаблона: " + self.id)) {
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.$hostname + '/admin/templates/' + this.id + '/delete', this.template, {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                }).then(function (response) {
                    var notification = {
                        template: '<span><b>\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.allowUnsavedLeave = true;
                    self.$router.push('/templates');
                }).catch(function (error) {

                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
                });
            }
        },
        clickContentFileButton: function clickContentFileButton(index) {
            var ref = _.get(this.$refs, 'contentFileInput_' + index);
            ref[0].click();
        },
        uploadFile: function uploadFile(event, type, index) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(response.data));

                if (data.file_type !== 'content') {
                    self.template[data.file_type] = data.url;
                    self.template[data.file_type + '_full'] = data.url_full;
                    self.template[data.file_type + '_size'] = data.filesize;

                    if (data.file_type === 'src') {
                        self.realVideoDuration = data.duration ? data.duration : null;
                    }

                    if (data.file_type === 'audio') {
                        self.realAudioDuration = data.duration ? data.duration : null;
                    }
                    if (self.video) {
                        self.showPreview();
                    }
                } else {
                    self.client_parts[index].content = data.url;
                    self.client_parts[index].content_full = data.url_full;
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        dragMouseDown: function dragMouseDown(event) {
            event.preventDefault();

            var path = event.composedPath ? event.composedPath() : event.path;
            var id = null;
            _.each(path, function (p) {
                if (p.className === 'draggable-container') {
                    id = p.id;
                }
            });

            if (!id) {
                return;
            }

            this.preview_drag_start = { x: event.clientX, y: event.clientY };
            this.preview_drag_moved = false;

            if (id.indexOf('o') === 0) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'object';

                this.object_positions[this.draggable_index].clientX = event.clientX;
                this.object_positions[this.draggable_index].clientY = event.clientY;
                this.$refs.draggableContainer2[this.draggable_index].style.opacity = '0.6';

                document.onmousemove = this.objectDrag;
                document.onmouseup = this.closeDragObject;
            } else if (id.indexOf('f') === 0) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'frame';

                if (!this.frame_positions[this.draggable_index]) {
                    this.$set(this.frame_positions, this.draggable_index, JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.default_positions)));
                }

                this.frame_positions[this.draggable_index].clientX = event.clientX;
                this.frame_positions[this.draggable_index].clientY = event.clientY;
                this.$refs.draggableContainer3[this.draggable_index].style.opacity = '0.6';

                document.onmousemove = this.frameDrag;
                document.onmouseup = this.closeDragFrame;
            } else {
                this.draggable_index = id;
                this.draggable_type = 'text';

                this.positions[this.draggable_index].clientX = event.clientX;
                this.positions[this.draggable_index].clientY = event.clientY;
                this.$refs.draggableContainer[this.draggable_index].style.opacity = '0.6';

                document.onmousemove = this.textDrag;
                document.onmouseup = this.closeDragText;
            }
        },
        markPreviewDragIfMoved: function markPreviewDragIfMoved(event) {
            if (this.preview_drag_moved || !this.preview_drag_start) {
                return;
            }

            var dx = event.clientX - this.preview_drag_start.x;
            var dy = event.clientY - this.preview_drag_start.y;
            if (dx * dx + dy * dy > 0) {
                this.preview_drag_moved = true;
            }
        },
        selectPreviewIfClicked: function selectPreviewIfClicked(type) {
            if (this.preview_drag_moved || this.draggable_index == null) {
                return;
            }

            var index = parseInt(this.draggable_index);
            if (type === 'text') {
                this.selectText(index);
            } else if (type === 'object') {
                this.selectObject(index);
            } else if (type === 'frame') {
                this.selectFrame(index);
            }
        },
        textDrag: function textDrag(event) {
            event.preventDefault();
            this.markPreviewDragIfMoved(event);

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX;
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY;
            this.positions[this.draggable_index].clientX = event.clientX;
            this.positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer[this.draggable_index].style.top = this.$refs.draggableContainer[this.draggable_index].offsetTop - this.positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer[this.draggable_index].style.left = this.$refs.draggableContainer[this.draggable_index].offsetLeft - this.positions[this.draggable_index].movementX + 'px';

            var centerX = this.$refs.draggableContainer[this.draggable_index].offsetLeft + this.$refs.draggableContainer[this.draggable_index].clientWidth / 2;
            var centerY = this.$refs.draggableContainer[this.draggable_index].offsetTop + this.$refs.draggableContainer[this.draggable_index].clientHeight / 2;

            this.template.texts[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.texts[this.draggable_index].position_y = parseFloat((centerY / this.heightCanvas).toFixed(4));
        },
        closeDragText: function closeDragText() {
            document.onmouseup = null;
            document.onmousemove = null;

            if (this.draggable_index != null && this.$refs.draggableContainer[this.draggable_index]) {
                this.$refs.draggableContainer[this.draggable_index].style.opacity = '';
            }

            this.selectPreviewIfClicked('text');
            this.draggable_index = null;

            return false;
        },

        objectDrag: function objectDrag(event) {
            event.preventDefault();
            this.markPreviewDragIfMoved(event);

            this.object_positions[this.draggable_index].movementX = this.object_positions[this.draggable_index].clientX - event.clientX;
            this.object_positions[this.draggable_index].movementY = this.object_positions[this.draggable_index].clientY - event.clientY;
            this.object_positions[this.draggable_index].clientX = event.clientX;
            this.object_positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer2[this.draggable_index].style.top = this.$refs.draggableContainer2[this.draggable_index].offsetTop - this.object_positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer2[this.draggable_index].style.left = this.$refs.draggableContainer2[this.draggable_index].offsetLeft - this.object_positions[this.draggable_index].movementX + 'px';

            this.syncObjectModelFromElement(this.draggable_index);
        },
        closeDragObject: function closeDragObject() {
            document.onmouseup = null;
            document.onmousemove = null;

            if (this.draggable_index != null && this.$refs.draggableContainer2[this.draggable_index]) {
                this.$refs.draggableContainer2[this.draggable_index].style.opacity = '';
            }

            this.selectPreviewIfClicked('object');
            this.draggable_index = null;

            return false;
        },

        frameDrag: function frameDrag(event) {
            event.preventDefault();
            this.markPreviewDragIfMoved(event);

            this.frame_positions[this.draggable_index].movementX = this.frame_positions[this.draggable_index].clientX - event.clientX;
            this.frame_positions[this.draggable_index].movementY = this.frame_positions[this.draggable_index].clientY - event.clientY;
            this.frame_positions[this.draggable_index].clientX = event.clientX;
            this.frame_positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer3[this.draggable_index].style.top = this.$refs.draggableContainer3[this.draggable_index].offsetTop - this.frame_positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer3[this.draggable_index].style.left = this.$refs.draggableContainer3[this.draggable_index].offsetLeft - this.frame_positions[this.draggable_index].movementX + 'px';

            this.updateFramePositionFromDom(this.draggable_index);
        },
        closeDragFrame: function closeDragFrame() {
            document.onmouseup = null;
            document.onmousemove = null;

            if (this.draggable_index != null && this.$refs.draggableContainer3[this.draggable_index]) {
                this.$refs.draggableContainer3[this.draggable_index].style.opacity = '';
            }

            this.selectPreviewIfClicked('frame');
            this.draggable_index = null;

            return false;
        },
        renderCollagePart: function renderCollagePart(collageType, partIndex) {
            if (!collageType) {
                return;
            }

            if (collageType === 'custom') {
                var frame = this.client_parts[partIndex] && this.client_parts[partIndex].frame;
                return this.renderCustomCollageFrame(frame, 0.7);
            }

            var layout = collageType.split(';');
            var category = layout[0].split('_')[0];
            var collageId = layout[0];
            var partId = parseInt(layout[1]);
            var collages = _.find(this.collages, function (c) {
                return c.name === category;
            });
            var collage = _.find(collages.data, function (c) {
                return c.id === collageId;
            });

            return this.renderCollage(collage, 0.7, partId - 1);
        },
        renderCustomCollageFrame: function renderCustomCollageFrame(frame) {
            var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            if (!frame) {
                return '';
            }

            var left = parseFloat(frame.x) * 108 * scale;
            var top = parseFloat(frame.y) * 192 * scale;
            var width = parseFloat(frame.w) * 108 * scale;
            var height = parseFloat(frame.h) * 192 * scale;
            var rtl = (parseFloat(frame.b_tl) || 0) * width;
            var rtr = (parseFloat(frame.b_tr) || 0) * width;
            var rbr = (parseFloat(frame.b_br) || 0) * width;
            var rbl = (parseFloat(frame.b_bl) || 0) * width;

            var containerStyle = "position:relative;" + ('width:' + 108 * scale + 'px;height:' + 192 * scale + 'px;') + "background:#f7f7f7;overflow:hidden;" + "border: 1px solid #000;" + "box-shadow:0 6px 20px rgba(0,0,0,.08);";

            var frameStyle = "position:absolute;" + ('left:' + left + 'px;top:' + top + 'px;') + ('width:' + width + 'px;height:' + height + 'px;') + "background:#BAE1FF;" + ('border-radius:' + rtl + 'px ' + rtr + 'px ' + rbr + 'px ' + rbl + 'px;overflow:hidden;') + "display:flex;align-items:center;justify-content:center;" + "color:rgba(0,0,0,.5);" + "font:600 12px sans-serif;";

            return '<div style="' + containerStyle + '"><div class="collage-item-part diagonal-lines" style="' + frameStyle + '">1</div></div>';
        },
        renderCollage: function renderCollage(layout) {
            var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var partId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


            var palette = ["#FFDFBA", "#FFFFBA", "#BAFFC9", "#BAE1FF", "#D7C4F3", "#C1F0F6", "#FAD6A5", "#F7C5CC", "#C9E4DE"];

            var containerStyle = "position:relative;" + ('width:' + 108 * scale + 'px;height:' + 192 * scale + 'px;') + "background:#f7f7f7;overflow:hidden;" + ('border: 1px solid ' + (partId === null && this.previous_collage_id === layout.id ? 'red' : '#000') + ';') + "box-shadow:0 6px 20px rgba(0,0,0,.08);";

            var html = '<div style="' + containerStyle + '">';

            for (var i = 0; i < layout.frames.length; i++) {
                var f = layout.frames[i];

                var left = f.x * 108 * scale;
                var top = f.y * 192 * scale;
                var width = f.width * 108 * scale;
                var height = f.height * 192 * scale;

                var color = palette[i % palette.length];

                var radiusStyle = "0px";
                if (f.crop && f.crop.type === "roundedCorner") {
                    var v = f.crop.value;
                    if (v < 0) v = 0;
                    if (v > 1) v = 1;
                    radiusStyle = v * Math.min(width, height) / 2 + "px";
                }

                var frameStyle = "position:absolute;" + "left:" + left + "px;top:" + top + "px;" + "width:" + width + "px;height:" + height + "px;" + "background:" + color + ";" + "border-radius:" + radiusStyle + ";overflow:hidden;" + "display:flex;align-items:center;justify-content:center;" + "color:rgba(0,0,0,.5);" + "font:600 12px sans-serif;";

                var params = layout.id + ';' + (i + 1) + ';' + f.x + ';' + f.y + ';' + f.width + ';' + f.height;

                html += '\n                          <div\n                            data-params="' + params + '"\n                            class="collage-item-part ' + (partId === i ? 'diagonal-lines' : '') + '"\n                            style="' + frameStyle + '"\n                          >\n                            ' + (i + 1) + '\n                          </div>\n                        ';
            }

            html += "</div>";
            return html;
        }
    }
});

/***/ }),

/***/ "4TJk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4WDn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4pBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("PBKA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5cca518_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("EW1A");
function injectStyle (ssrContext) {
  __webpack_require__("IiAE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5cca518"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5cca518_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32ce65de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("/Bd9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32ce65de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5JS7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5P5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'sort', 'object_count', 'status', ''],
            data: [],
            status: localStorage.getItem('gcat_status') ? localStorage.getItem('gcat_status') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/graphic/categories/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/graphics/categories', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
                localStorage.setItem('graphics-categories', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-graphics-category',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('graphic/categories') < 1) {
            localStorage.setItem('gcat_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "5Pe2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            font: {
                status: 0,
                name: null,
                src: null,
                src_full: null,
                is_premium: 0,
                category_id: null,
                sort: 1
            },
            locales: [],
            categories: []
        };
    },

    created: function created() {
        this.getCategories();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/fonts');
        },
        getCategories: function getCategories() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/fonts/categories', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.categories = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var font = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.font));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/fonts/create', font, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0428\u0440\u0438\u0444\u0442 \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/fonts');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.font.src = data.url;
                self.font.src_full = data.url_full;
                self.font.src_size = data.filesize;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }
    }
});

/***/ }),

/***/ "5VL1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreatePostCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            category: {
                status: 0,
                translations: [],
                sort: 1,
                ratio: 1
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/post/categories');
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var category = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.category));

            category.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/posts/categories/create', category, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/post/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }
    }
});

/***/ }),

/***/ "641v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6TJk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6deb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6t5d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7707":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "78V2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"preview-page"},[_c('div',{staticClass:"preview-layout"},[_c('div',{staticClass:"card preview-sidebar"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('label',{staticClass:"preview-dev-toggle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showInactive),expression:"showInactive"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showInactive)?_vm._i(_vm.showInactive,null)>-1:(_vm.showInactive)},on:{"change":function($event){var $$a=_vm.showInactive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showInactive=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showInactive=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showInactive=$$c}}}}),_vm._v("\n                        Показать скрытые\n                    ")]),_vm._v(" "),_c('div',{staticClass:"preview-sidebar-title"},[_vm._v("Категории")]),_vm._v(" "),_c('div',{staticClass:"preview-sidebar-list"},[_c('draggable',{on:{"start":_vm.onCategoriesDragStart,"end":_vm.onCategoriesDragEnd,"change":_vm.onCategoriesReorder},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},[_c('transition-group',_vm._l((_vm.data),function(element){return _c('div',{key:element.id,staticClass:"category-list",class:{ active: _vm.isSelectedCategory(element.id), 'is-inactive': _vm.isCategoryInactive(element.status) },on:{"click":function($event){return _vm.selectCategory(element.id)}}},[_c('span',{staticClass:"category-list-row"},[_c('span',{staticClass:"category-list-name"},[_vm._v(_vm._s(element.name))]),_vm._v(" "),(_vm.isCategoryInactive(element.status))?_c('span',{staticClass:"category-off"},[_vm._v("Скрыта")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"category-list-count"},[_vm._v(_vm._s(element.items ? element.items.length : element.items_count))])])])}),0)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"card preview-main"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-area"},[(_vm.selectedCategory)?_c('div',[_c('p',{staticClass:"category-name"},[_vm._v("\n                                "+_vm._s(_vm.selectedCategory.name)+"\n                                "),_c('span',{staticClass:"category-count"},[_vm._v("("+_vm._s(_vm.visibleItems.length)+")")]),_vm._v(" "),(_vm.isCategoryInactive(_vm.selectedCategory.status))?_c('span',{staticClass:"category-off-note"},[_vm._v("\n                                    Категория не отображается в приложении\n                                ")]):_vm._e()]),_vm._v(" "),(_vm.visibleItems.length > 0)?_c('div',{key:_vm.selectedCategory.id,staticClass:"items-grid"},[_c('draggable',{on:{"start":_vm.onItemsDragStart,"end":_vm.onItemsDragEnd,"change":function($event){return _vm.onItemsReorder(_vm.selectedCategory)}},model:{value:(_vm.visibleItems),callback:function ($$v) {_vm.visibleItems=$$v},expression:"visibleItems"}},_vm._l((_vm.visibleItems),function(item){return _c('div',{key:item.id,staticClass:"inline-div",on:{"click":function($event){$event.preventDefault();return _vm.openItem(item.id)}}},[_c('div',{staticClass:"card-item"},[_c('img',{staticClass:"card-media",attrs:{"src":item.src_full,"loading":"lazy","alt":""}}),_vm._v(" "),_c('span',{staticClass:"item-badge is-id"},[_vm._v("ID "+_vm._s(item.id))]),_vm._v(" "),(_vm.isInactive(item.status))?_c('span',{staticClass:"item-badge is-dev"},[_vm._v("Скрыт")]):_vm._e()])])}),0)],1):_c('p',{staticClass:"preview-empty"},[_vm._v(_vm._s(_vm.emptyLabel))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"preview-main-footer"},[_c('button',{staticClass:"btn btn-success btn-fill btn-save",attrs:{"type":"submit","disabled":!_vm.hasUnsavedOrder},on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[_vm._v("\n                                Сохранить\n                            ")])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7SdG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__ = __webpack_require__("3Q3N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d00f7cbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__ = __webpack_require__("J6wH");
function injectStyle (ssrContext) {
  __webpack_require__("GhUe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d00f7cbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Vht":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MusicCategories_vue__ = __webpack_require__("BD//");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e16190a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MusicCategories_vue__ = __webpack_require__("BUUk");
function injectStyle (ssrContext) {
  __webpack_require__("4WDn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8e16190a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MusicCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e16190a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MusicCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7XHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Финансы")]),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('fg-input',{attrs:{"type":"date","label":"Начальная дата","placeholder":""},on:{"input":function($event){return _vm.saveFilters('fi_date_start', _vm.start_date)}},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('fg-input',{attrs:{"type":"date","label":"Конечная дата","placeholder":""},on:{"input":function($event){return _vm.saveFilters('fi_date_end', _vm.end_date)}},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"is-premium-filter"}},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category_id),expression:"category_id"}],staticClass:"form-control",attrs:{"aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.category_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.getSubcategories()}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"is-premium-filter"}},[_vm._v("Подкатегория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.subcategory_id),expression:"subcategory_id"}],staticClass:"form-control",attrs:{"aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.subcategory_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('fi_subcategory', _vm.subcategory_id)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.subcategories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"is-premium-filter"}},[_vm._v("Проект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.project_id),expression:"project_id"}],staticClass:"form-control",attrs:{"multiple":"","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.project_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.projects),function(p){return _c('option',{domProps:{"value":p.id}},[_vm._v(_vm._s(p.name))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить запись\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'date')?_c('span',[_vm._v("Дата")]):(column === 'description')?_c('span',[_vm._v("Описание")]):(column === 'category_id')?_c('span',[_vm._v("Категория")]):(column === 'subcategory_id')?_c('span',[_vm._v("Подкатегория")]):(column === 'project_id')?_c('span',[_vm._v("Проект")]):(column === 'amount')?_c('span',[_vm._v("Сумма, $")]):_c('span')])})})],2),_vm._v(" "),_c('tbody',[_vm._l((_vm.data),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm._f("toEasyDate")(item.date)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.category_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.subcategory_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.project_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.amount)))]),_vm._v(" "),_c('td',[_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])])])])}),_vm._v(" "),_c('tr',{staticClass:"summary"},[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.summary)))]),_vm._v(" "),_c('td')])],2)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7lmx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7mcY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Albums_vue__ = __webpack_require__("vwmR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb6c8e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Albums_vue__ = __webpack_require__("HrH9");
function injectStyle (ssrContext) {
  __webpack_require__("nwib")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fb6c8e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Albums_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb6c8e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Albums_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7szl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        var self = this;

        var token = localStorage.getItem('token');

        axios.get(this.$hostname + '/admin/effects/categories/', {
            'params': {},
            'headers': {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (response) {
            self.loading = false;
            self.categories = response.data;

            self.get();
        }).catch(function (error) {
            self.loading = false;
            console.log(error);
        });
    },
    data: function data() {
        return {
            columns: ['id', 'category', 'name', 'preview_src', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('effr_status') ? localStorage.getItem('effr_status') : "",
            categoryId: localStorage.getItem('effr_category') ? localStorage.getItem('effr_category') : "",
            categories: [],
            loading: false,
            limit: 10,
            offset: parseInt(localStorage.getItem('effr_active_offset')) || 0
        };
    },

    computed: {
        effectsUrl: function effectsUrl() {
            return this.$effectsUrl;
        }
    },
    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            localStorage.setItem('effr_active_offset', "0");
            this.offset = 0;

            this.get();
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('effr_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('effr_active_offset', parseInt(this.offset));
            }
        },
        add: function add() {
            this.$router.push('/effects/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');
            //this.loading = true;

            axios.get(this.$hostname + '/admin/effects/', {
                'params': {
                    limit: self.limit,
                    offset: self.offset,
                    status: this.status,
                    categoryId: this.categoryId
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-effect',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('effects') < 1) {
            localStorage.setItem('effr_category', "");
            localStorage.setItem('effr_status', "");
            localStorage.setItem('effr_active_offset', "0");
        }
        next();
    }
});

/***/ }),

/***/ "7x4E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("5Pe2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5102c1be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("Za8t");
function injectStyle (ssrContext) {
  __webpack_require__("kZs8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5102c1be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5102c1be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "81Wq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.getAlbums();
    },
    data: function data() {
        return {
            columns: ['id', 'album', 'is_free', 'src_full', 'image_src_full', 'artist', 'title', 'sort', 'status', ''],
            data: [],
            albums: [],
            album: localStorage.getItem('music_album') ? localStorage.getItem('music_album') : "",
            status: localStorage.getItem('music_status') ? localStorage.getItem('music_status') : "",
            loading: false,
            limit: 10,
            tracksCount: "",
            offset: parseInt(localStorage.getItem('music_active_offset')) || 0,
            stats: {
                freeTracksCount: 0,
                premiumTracksCount: 0,
                averageTracksCount: 0,
                averageFreeCount: 0,
                averagePremiumCount: 0
            }
        };
    },

    filters: {
        secondsToTime: function secondsToTime(value) {
            if (value) {
                return Math.floor(value / 60).toString() + ':' + (value % 60).toString();
            } else {
                return '';
            }
        }
    },
    methods: {
        init: function init() {},
        filter: function filter() {
            localStorage.setItem('music_active_offset', "0");
            this.offset = 0;
            this.get();
        },
        add: function add() {
            this.$router.push('/new-music/create');
        },
        getAlbums: function getAlbums() {
            var self = this;

            var token = localStorage.getItem('token');

            axios.get(this.$hostname + '/admin/music/categories/', {
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.albums = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.get();
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/music/', {
                'params': {
                    status: this.status,
                    album: this.album,
                    limit: this.limit,
                    offset: this.offset
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                var data = response.data;
                self.loading = false;

                self.data = data.tracks;
                self.tracksCount = data.count;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('music_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('music_active_offset', parseInt(this.offset));
            }
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-music',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('new-music') < 1) {
            localStorage.setItem('music_active_offset', "0");
            localStorage.setItem('music_album', "");
            localStorage.setItem('music_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "8QNM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.model)?_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.category_id),expression:"model.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.getSubcategories()}]}},_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Подкатегория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.subcategory_id),expression:"model.subcategory_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "subcategory_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.subcategories),function(s){return _c('option',{domProps:{"value":s.id}},[_vm._v(_vm._s(s.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Проект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.project_id),expression:"model.project_id"}],staticClass:"form-control",attrs:{"multiple":"","id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.projects),function(p){return _c('option',{domProps:{"value":p.id}},[_vm._v(_vm._s(p.name))])}),0)]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Описание","placeholder":""},model:{value:(_vm.model.description),callback:function ($$v) {_vm.$set(_vm.model, "description", $$v)},expression:"model.description"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сумма","placeholder":""},model:{value:(_vm.model.amount),callback:function ($$v) {_vm.$set(_vm.model, "amount", $$v)},expression:"model.amount"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"date","label":"Дата","placeholder":""},model:{value:(_vm.model.date),callback:function ($$v) {_vm.$set(_vm.model, "date", $$v)},expression:"model.date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.model.project_id || !_vm.model.amount || !_vm.model.category_id || !_vm.model.subcategory_id || !_vm.model.date},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8SBY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8bB9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8bZa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("buDd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_288260fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("FU+P");
function injectStyle (ssrContext) {
  __webpack_require__("6TJk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-288260fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_288260fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8xqZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("evl4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ea66246_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("Wq76");
function injectStyle (ssrContext) {
  __webpack_require__("tTt6")
  __webpack_require__("xVco")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ea66246"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ea66246_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "947H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "94d2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Проект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.project_id),expression:"task.project_id"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.task, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("My Feed")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Muse")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Aura")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Swipe")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Wallpapers")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("Nola")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Премиум")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.is_premium),expression:"task.is_premium"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.task, "is_premium", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Премиум")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не премиум")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Версия")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.version),expression:"task.version"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.task, "version", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("Все")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"ID рассылки","placeholder":""},model:{value:(_vm.task.push_payload.id),callback:function ($$v) {_vm.$set(_vm.task.push_payload, "id", $$v)},expression:"task.push_payload.id"}}),_vm._v(" "),(_vm.task.project_id == 9)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип пуша")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.push_payload.type),expression:"task.push_payload.type"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.task.push_payload, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Offer")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Paywall")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Reels Maker")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Carousel")])])]):_vm._e(),_vm._v(" "),(_vm.task.project_id == 9)?_c('fg-input',{attrs:{"type":"text","label":"ID шаблона","placeholder":""},model:{value:(_vm.task.push_payload.template_id),callback:function ($$v) {_vm.$set(_vm.task.push_payload, "template_id", $$v)},expression:"task.push_payload.template_id"}}):_vm._e(),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Токен (оставить пустым, чтобы отправить всем пользователям)","placeholder":""},model:{value:(_vm.task.token),callback:function ($$v) {_vm.$set(_vm.task, "token", $$v)},expression:"task.token"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"date","label":"Дата отправки (дата пользователя, когда ему придет пуш)","placeholder":""},model:{value:(_vm.client_release_date),callback:function ($$v) {_vm.client_release_date=$$v},expression:"client_release_date"}}),_vm._v(" "),(_vm.client_release_date && _vm.client_release_date.indexOf('null') < 0)?_c('fg-input',{attrs:{"type":"time","label":"Время отправки (время пользователя, когда ему придет пуш)","placeholder":""},model:{value:(_vm.client_release_time),callback:function ($$v) {_vm.client_release_time=$$v},expression:"client_release_time"}}):_vm._e()],1)]),_vm._v(" "),(_vm.locales[0])?_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.locales[0].title && !_vm.locales[0].text},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.task)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content locale-section"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"locale-block"},[_vm._v(_vm._s(itm.code))]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Тайтл","placeholder":""},model:{value:(_vm.locales[index].title),callback:function ($$v) {_vm.$set(_vm.locales[index], "title", $$v)},expression:"locales[index].title"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Текст","placeholder":""},model:{value:(_vm.locales[index].text),callback:function ($$v) {_vm.$set(_vm.locales[index], "text", $$v)},expression:"locales[index].text"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9RUc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Категории")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('pc_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить категорию\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'name')?_c('span',[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активна")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активна")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9WEk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[(_vm.object)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.is_premium),expression:"object.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.object.is_premium)?_vm._i(_vm.object.is_premium,null)>-1:(_vm.object.is_premium)},on:{"change":function($event){var $$a=_vm.object.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.object, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.object, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.object, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.category_id),expression:"object.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return (c.id !== 999)?_c('option',{domProps:{"value":c.id}},[_vm._v("\n                                            "+_vm._s(c.name)+"\n                                        ")]):_vm._e()}),0)]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название","placeholder":""},model:{value:(_vm.object.name),callback:function ($$v) {_vm.$set(_vm.object, "name", $$v)},expression:"object.name"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Метод наложения")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.params.mode),expression:"object.params.mode"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object.params, "mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Normal")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Add")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Multiply")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Screen")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Overlay")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Lighten")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("HardLight")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("SoftLight")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Прозрачность по умолчанию (от 1 до 0)","placeholder":""},model:{value:(_vm.object.params.opacity),callback:function ($$v) {_vm.$set(_vm.object.params, "opacity", $$v)},expression:"object.params.opacity"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Максимальная прозрачность (по умолчанию 1)","placeholder":""},model:{value:(_vm.object.params.max_opacity),callback:function ($$v) {_vm.$set(_vm.object.params, "max_opacity", $$v)},expression:"object.params.max_opacity"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.object.sort),callback:function ($$v) {_vm.$set(_vm.object, "sort", $$v)},expression:"object.sort"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Эффект: "),(_vm.object.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.object.src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]):(_vm.object.src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.object.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"device-block device1",attrs:{"src":_vm.object.src_full},on:{"click":function($event){$event.preventDefault();return _vm.openResource(_vm.object.src_full)}}}),_vm._v(" "),_c('div',[_c('input',{ref:"srcFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.srcFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('h4',{staticClass:"card-title",staticStyle:{"margin-top":"30px"},attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Превью (jpg): "),(_vm.object.preview_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.object.preview_src_size >= 0.1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.object.preview_src_size)+"Mb")]):(_vm.object.preview_src_size >= 0.05)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.object.preview_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.object.preview_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.object.preview_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"device-block device1",attrs:{"src":_vm.object.preview_src_full},on:{"click":function($event){$event.preventDefault();return _vm.openResource(_vm.object.preview_src_full)}}}),_vm._v(" "),_c('div',[_c('input',{ref:"previewSrcFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'preview_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.previewSrcFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"btn btn-danger btn-fill float-left btn-save",on:{"click":function($event){return _vm.remove()}}},[_vm._v("\n                                Удалить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.sort || !_vm.object.category_id || !_vm.object.src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9gRq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fullcalendar_vue__ = __webpack_require__("XcIV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fullcalendar_daygrid__ = __webpack_require__("BUKW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fullcalendar_interaction__ = __webpack_require__("1WWl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__("M4fF");
var axios = __webpack_require__("mtWM");






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a,
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
        FullCalendar: __WEBPACK_IMPORTED_MODULE_2__fullcalendar_vue__["a" /* default */]

    },
    created: function created() {
        this.get();
    },
    computed: {
        calendar: function calendar() {
            return this.$refs.fullCalendar.getApi();
        }
    },
    data: function data() {
        return {
            data: [],
            calendarOptions: {
                themeSystem: 'bootstrap',
                plugins: [__WEBPACK_IMPORTED_MODULE_3__fullcalendar_daygrid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__fullcalendar_interaction__["a" /* default */]],
                initialView: 'dayGridMonth',
                aspectRatio: 2,
                locale: 'Ru',
                buttonText: {
                    today: 'Сегодня'
                },
                eventClick: this.handleEventClick,
                dateClick: this.handleDateClick,
                eventContent: this.renderEventContent,
                renderEvent: this.renderEventContent,
                firstDay: 1,
                fixedWeekCount: false,
                events: []
            },
            activeId: null,
            role: parseInt(localStorage.getItem('role')) || 0,
            activeVideo: "",
            status: "1",
            waiting: false
        };
    },

    methods: {
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            self.waiting = true;

            axios.get(this.$hostname + '/admin/templates/calendar', {
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.waiting = false;
                self.data = response.data.templates;

                for (var i = 0; i < self.data.length; i++) {
                    var t = self.data[i];

                    self.calendar.addEvent({
                        id: t.id,
                        title: t.id,
                        start: t.release_date_history,
                        preview_url: t.src_full
                    });
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        renderEventContent: function renderEventContent(eventInfo) {
            var arrayOfDomNodes = [];

            var videoWrap = document.createElement('p');
            videoWrap.setAttribute('style', 'margin: 0; width: 100%;cursor: pointer;');

            videoWrap.innerHTML = '<p style="font-size: 30px; display: block; margin: 0 auto; width: 100px"><span style="color: black; font-weight: 700 !important;\n' + ' vertical-align:middle;">ID: ' + eventInfo.event.id + '</span></p>';

            arrayOfDomNodes = [videoWrap];

            return { domNodes: arrayOfDomNodes };
        },
        renderEvent: function renderEvent(eventInfo) {
            console.log(eventInfo);
        },
        handleEventClick: function handleEventClick(arg) {
            this.activeId = arg.event.id;
            this.activeVideo = arg.event.extendedProps.preview_url;
        },
        openTemplate: function openTemplate(arg) {
            this.$router.push({
                name: 'edit-template',
                params: { id: this.activeId }
            });
        },
        closeVideo: function closeVideo() {
            this.activeId = null;
            this.activeVideo = "";
        },
        handleDateClick: function handleDateClick(arg) {
            return;
            var calendarApi = this.calendar;
            calendarApi.addEvent({
                id: 3,
                title: 'Meeting',
                start: '2024-04-01T14:30:00',
                image_url: '/static/img/premium.png'
            });
        }
    }
});

/***/ }),

/***/ "9wf4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AYP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                            Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Фрейм: "),(_vm.object.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.object.src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]):(_vm.object.src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.object.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),(_vm.object.src_full)?_c('img',{staticClass:"device-block device1",attrs:{"id":"preview-img","src":_vm.object.src_full},on:{"click":function($event){$event.preventDefault();return _vm.openResource(_vm.object.src_full)}}}):_vm._e(),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'object_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),(_vm.object.src_full)?_c('div',{staticClass:"col-md-8"},[_c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6",staticStyle:{"background":"#C9D5DF"}},[_c('div',{staticClass:"img-wrap"},[_c('img',{ref:"img",staticClass:"frame",attrs:{"id":"frame-img","src":_vm.object.src_full,"alt":""}}),_vm._v(" "),_vm._l((_vm.object.params),function(pa,index){return (pa.w && pa.h)?_c('div',{staticClass:"frame-layouts",attrs:{"id":("pa" + index)},domProps:{"innerHTML":_vm._s(_vm.layout_html(index))},on:{"click":function($event){return _vm.selectLayout(index)}}}):_vm._e()})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Layouts\n                                ")]),_vm._v(" "),_c('form',[(_vm.object)?_c('div',{staticClass:"texts-buttons"},[_vm._l((_vm.object.layouts),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_layout },attrs:{"type":"button"},on:{"click":function($event){return _vm.selectLayout(index)}}},[_vm._v("Layout "+_vm._s(index + 1)+"\n                                        ")])}),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill",attrs:{"type":"button"},on:{"click":function($event){return _vm.addLayout()}}},[_vm._v("+\n                                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill",attrs:{"type":"button"},on:{"click":function($event){return _vm.save()}}},[_vm._v("Обновить\n                                        ")])],2):_vm._e(),_vm._v(" "),_vm._l((_vm.object.params),function(rawData,index){return _c('div',{staticClass:"row frame-params",class:{ 'active' : index === _vm.active_layout }},[_c('div',{staticClass:"col-md-12"},[_c('code',[_vm._v("\"x\": "+_vm._s(_vm.object.layouts[index].x)+",")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("\"y\": "+_vm._s(_vm.object.layouts[index].y)+",")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("\"w\": "+_vm._s(_vm.object.layouts[index].w)+",")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("\"h\": "+_vm._s(_vm.object.layouts[index].h))]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Ширина фрейма в Figma","placeholder":""},model:{value:(rawData.original_w),callback:function ($$v) {_vm.$set(rawData, "original_w", $$v)},expression:"rawData.original_w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Высота фрейма в Figma","placeholder":""},model:{value:(rawData.original_h),callback:function ($$v) {_vm.$set(rawData, "original_h", $$v)},expression:"rawData.original_h"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Ширина редактируемой области","placeholder":""},model:{value:(rawData.w),callback:function ($$v) {_vm.$set(rawData, "w", $$v)},expression:"rawData.w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Высота редактируемой области","placeholder":""},model:{value:(rawData.h),callback:function ($$v) {_vm.$set(rawData, "h", $$v)},expression:"rawData.h"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ сверху","placeholder":""},model:{value:(rawData.y),callback:function ($$v) {_vm.$set(rawData, "y", $$v)},expression:"rawData.y"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ слева","placeholder":""},model:{value:(rawData.x),callback:function ($$v) {_vm.$set(rawData, "x", $$v)},expression:"rawData.x"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Радиус верхний левый","placeholder":""},model:{value:(rawData.b_tl),callback:function ($$v) {_vm.$set(rawData, "b_tl", $$v)},expression:"rawData.b_tl"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус верхний правый","placeholder":""},model:{value:(rawData.b_tr),callback:function ($$v) {_vm.$set(rawData, "b_tr", $$v)},expression:"rawData.b_tr"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус нижний левый","placeholder":""},model:{value:(rawData.b_bl),callback:function ($$v) {_vm.$set(rawData, "b_bl", $$v)},expression:"rawData.b_bl"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус нижний правый","placeholder":""},model:{value:(rawData.b_br),callback:function ($$v) {_vm.$set(rawData, "b_br", $$v)},expression:"rawData.b_br"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeLayout(_vm.active_layout)}}},[_vm._v("Удалить layout\n                                            ")])],1)])})],2)])])])],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Alek":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AtX6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Templates_vue__ = __webpack_require__("Eavv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53245a47_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Templates_vue__ = __webpack_require__("MWUD");
function injectStyle (ssrContext) {
  __webpack_require__("lvPc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53245a47"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Templates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53245a47_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Templates_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AuOr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B21k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("OjML");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a23e12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("EvFy");
function injectStyle (ssrContext) {
  __webpack_require__("Alek")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61a23e12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a23e12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BChI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("UYPH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d1e238_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("SRNb");
function injectStyle (ssrContext) {
  __webpack_require__("Cu9F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74d1e238"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d1e238_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BD//":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('mc_status') ? localStorage.getItem('mc_status') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/music/categories/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/music/categories/', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;

                self.loading = false;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-music-category',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('music/categories') < 1) {
            localStorage.setItem('mc_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "BPtL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.category_id),expression:"model.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.getSubcategories()}]}},_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Подкатегория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.subcategory_id),expression:"model.subcategory_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "subcategory_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.subcategories),function(s){return _c('option',{domProps:{"value":s.id}},[_vm._v(_vm._s(s.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Проект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.project_id),expression:"model.project_id"}],staticClass:"form-control",attrs:{"multiple":"","id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.projects),function(p){return _c('option',{domProps:{"value":p.id}},[_vm._v(_vm._s(p.name))])}),0)]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Описание","placeholder":""},model:{value:(_vm.model.description),callback:function ($$v) {_vm.$set(_vm.model, "description", $$v)},expression:"model.description"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сумма","placeholder":""},model:{value:(_vm.model.amount),callback:function ($$v) {_vm.$set(_vm.model, "amount", $$v)},expression:"model.amount"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"date","label":"Дата","placeholder":""},model:{value:(_vm.model.date),callback:function ($$v) {_vm.$set(_vm.model, "date", $$v)},expression:"model.date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.model.project_id || !_vm.model.amount || !_vm.model.category_id || !_vm.model.subcategory_id || !_vm.model.date},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BUUk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Категории музыки")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('mc_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить альбом\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'status')?_c('span',[_vm._v("статус")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',{class:{'main-categories' : item['id'] < 3}},[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'name')?_c('span',[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === 'image_src_full')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[_c('div',{staticClass:"device-block device1",style:({ backgroundImage: 'url(' + item[column] + ')' })})]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активен")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активен")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BoeW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Категории эффектов")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('gr_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить категорию\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):(column === 'color')?_c('span',[_vm._v("цвет фона")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'name')?_c('span',[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === 'color')?_c('span',{staticClass:"color-block",style:({ backgroundColor: '' + item[column] + '' }),on:{"click":function($event){return _vm.edit(item['id'])}}}):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активна")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активна")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CBL3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CHFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            object: {
                status: 0,
                object_count: 0,
                translations: [],
                sort: 1
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/effect/categories');
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var object = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.object));

            object.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            if (object.color[0] !== '#') {
                object.color = '#' + object.color;
            }

            if (object.color.length < 7) {
                var notification = {
                    template: '<span><b>\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0446\u0432\u0435\u0442\u0430 \u0444\u043E\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                return false;
            }

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/effects/categories/create', object, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/effect/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }
    }
});

/***/ }),

/***/ "CPmk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            object: null,
            categories: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.getCategories();
    },
    computed: {
        effectsUrl: function effectsUrl() {
            return this.$effectsUrl;
        }
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/effects');
        },
        getCategories: function getCategories() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/effects/categories', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.categories = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.get(self.id);
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/effects/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.object = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
                self.object.params = JSON.parse(self.object.params);
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var effect = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.object));
            effect.params.mode = parseInt(effect.params.mode);
            effect.params.opacity = parseFloat(effect.params.opacity);
            effect.params.max_opacity = parseFloat(effect.params.max_opacity);

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/effects/' + this.id + '/update', effect, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u042D\u0444\u0444\u0435\u043A\u0442 \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        remove: function remove() {
            var self = this;

            if (confirm("Подтверждение удаления эффекта")) {

                self.waiting = true;

                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/effects/' + this.id + '/remove', {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                }).then(function (response) {

                    var notification = {
                        template: '<span><b>\u042D\u0444\u0444\u0435\u043A\u0442 \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.waiting = false;

                    self.$router.push('/effects');
                }).catch(function (error) {
                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;
                });
            }
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.object[type] = data.url;
                self.object[type + '_full'] = data.url_full;
                self.object[type + '_size'] = data.filesize;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        openResource: function openResource(url) {
            window.open(url, "_blank");
        }

    }
});

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarLink_vue__ = __webpack_require__("7SdG");



var SidebarStore = {
    showSidebar: false,
    sidebarLinks: [{
        name: 'Dashboard',
        icon: 'ti-panel',
        path: '/admin/overview'
    }],
    displaySidebar: function displaySidebar(value) {
        this.showSidebar = value;
    }
};

var SidebarPlugin = {
    install: function install(Vue) {
        Vue.mixin({
            data: function data() {
                return {
                    sidebarStore: SidebarStore
                };
            }
        });

        Object.defineProperty(Vue.prototype, '$sidebar', {
            get: function get() {
                return this.$root.sidebarStore;
            }
        });
        Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
        Vue.component('sidebar-link', __WEBPACK_IMPORTED_MODULE_1__SidebarLink_vue__["a" /* default */]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "Cu9F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DUIh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("4SD2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_677d4540_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("W3Ar");
function injectStyle (ssrContext) {
  __webpack_require__("AuOr")
  __webpack_require__("Wld7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-677d4540"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_677d4540_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DbLt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.is_premium),expression:"track.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.track.is_premium)?_vm._i(_vm.track.is_premium,null)>-1:(_vm.track.is_premium)},on:{"change":function($event){var $$a=_vm.track.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.track, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.track, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.track, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trendy-control"}},[_vm._v("Популярное")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.is_trendy),expression:"track.is_trendy"}],staticClass:"form-check-inline",attrs:{"id":"trendy-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.track.is_trendy)?_vm._i(_vm.track.is_trendy,null)>-1:(_vm.track.is_trendy)},on:{"change":function($event){var $$a=_vm.track.is_trendy,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.track, "is_trendy", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.track, "is_trendy", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.track, "is_trendy", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Альбом")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.album_id),expression:"track.album_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.track, "album_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.albums),function(a){return (a.id !== 999)?_c('option',{domProps:{"value":a.id}},[_vm._v(_vm._s(a.name))]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.status),expression:"track.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.track, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Артист","placeholder":""},model:{value:(_vm.track.artist),callback:function ($$v) {_vm.$set(_vm.track, "artist", $$v)},expression:"track.artist"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название","placeholder":""},model:{value:(_vm.track.title),callback:function ($$v) {_vm.$set(_vm.track, "title", $$v)},expression:"track.title"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Длительность","readonly":"","placeholder":""},model:{value:(_vm.track.duration),callback:function ($$v) {_vm.$set(_vm.track, "duration", $$v)},expression:"track.duration"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.track.sort),callback:function ($$v) {_vm.$set(_vm.track, "sort", $$v)},expression:"track.sort"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Фон: "),(_vm.track.image_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.track.image_src_size >= 0.3)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.track.image_src_size)+"Mb")]):(_vm.track.image_src_size >= 0.2)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.track.image_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.track.image_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.track.image_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'image_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Аудио: "),(_vm.track.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.track.src_size >= 4)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]):(_vm.track.src_size >= 2)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.track.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"audioFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"audio/mp3"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.audioFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.track.album_id || !_vm.track.sort || !_vm.track.title || !_vm.track.artist || !_vm.track.src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DomV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DuvD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("uzar");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a5d0ba2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("TMFv");
function injectStyle (ssrContext) {
  __webpack_require__("5JS7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a5d0ba2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a5d0ba2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EGO2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("100 Awesome Nucleo Icons")]),_vm._v(" "),_c('p',{staticClass:"card-category"},[_vm._v("Handcrafted by our friends from "),_c('a',{attrs:{"target":"_blank","href":"https://nucleoapp.com/?ref=1712"}},[_vm._v("NucleoApp")])])]),_vm._v(" "),_c('div',{staticClass:"all-icons"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-air-baloon"}),_vm._v(" "),_c('p',[_vm._v("nc-air-baloon")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-album-2"}),_vm._v(" "),_c('p',[_vm._v("nc-album-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-alien-33"}),_vm._v(" "),_c('p',[_vm._v("nc-alien-33")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-align-center"}),_vm._v(" "),_c('p',[_vm._v("nc-align-center")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-align-left-2"}),_vm._v(" "),_c('p',[_vm._v("nc-align-left-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-ambulance"}),_vm._v(" "),_c('p',[_vm._v("nc-ambulance")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-android"}),_vm._v(" "),_c('p',[_vm._v("nc-android")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-app"}),_vm._v(" "),_c('p',[_vm._v("nc-app")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-apple"}),_vm._v(" "),_c('p',[_vm._v("nc-apple")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-atom"}),_vm._v(" "),_c('p',[_vm._v("nc-atom")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-attach-87"}),_vm._v(" "),_c('p',[_vm._v("nc-attach-87")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-audio-92"}),_vm._v(" "),_c('p',[_vm._v("nc-audio-92")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-backpack"}),_vm._v(" "),_c('p',[_vm._v("nc-backpack")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-badge"}),_vm._v(" "),_c('p',[_vm._v("nc-badge")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bag"}),_vm._v(" "),_c('p',[_vm._v("nc-bag")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bank"}),_vm._v(" "),_c('p',[_vm._v("nc-bank")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-battery-81"}),_vm._v(" "),_c('p',[_vm._v("nc-battery-81")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bell-55"}),_vm._v(" "),_c('p',[_vm._v("nc-bell-55")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bold"}),_vm._v(" "),_c('p',[_vm._v("nc-bold")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bulb-63"}),_vm._v(" "),_c('p',[_vm._v("nc-bulb-63")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bullet-list-67"}),_vm._v(" "),_c('p',[_vm._v("nc-bullet-list-67")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bus-front-12"}),_vm._v(" "),_c('p',[_vm._v("nc-bus-front-12")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-button-pause"}),_vm._v(" "),_c('p',[_vm._v("nc-button-pause")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-button-play"}),_vm._v(" "),_c('p',[_vm._v("nc-button-play")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-button-power"}),_vm._v(" "),_c('p',[_vm._v("nc-button-power")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-camera-20"}),_vm._v(" "),_c('p',[_vm._v("nc-camera-20")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-caps-small"}),_vm._v(" "),_c('p',[_vm._v("nc-caps-small")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cart-simple"}),_vm._v(" "),_c('p',[_vm._v("nc-cart-simple")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cctv"}),_vm._v(" "),_c('p',[_vm._v("nc-cctv")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart-bar-32"}),_vm._v(" "),_c('p',[_vm._v("nc-chart-bar-32")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart-pie-35"}),_vm._v(" "),_c('p',[_vm._v("nc-chart-pie-35")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart-pie-36"}),_vm._v(" "),_c('p',[_vm._v("nc-chart-pie-36")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart"}),_vm._v(" "),_c('p',[_vm._v("nc-chart")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chat-round"}),_vm._v(" "),_c('p',[_vm._v("nc-chat-round")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-check-2"}),_vm._v(" "),_c('p',[_vm._v("nc-check-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-circle-09"}),_vm._v(" "),_c('p',[_vm._v("nc-circle-09")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-circle"}),_vm._v(" "),_c('p',[_vm._v("nc-circle")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cloud-download-93"}),_vm._v(" "),_c('p',[_vm._v("nc-cloud-download-93")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cloud-upload-94"}),_vm._v(" "),_c('p',[_vm._v("nc-cloud-upload-94")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-compass-05"}),_vm._v(" "),_c('p',[_vm._v("nc-compass-05")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-controller-modern"}),_vm._v(" "),_c('p',[_vm._v("nc-controller-modern")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-credit-card"}),_vm._v(" "),_c('p',[_vm._v("nc-credit-card")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-delivery-fast"}),_vm._v(" "),_c('p',[_vm._v("nc-delivery-fast")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-email-83"}),_vm._v(" "),_c('p',[_vm._v("nc-email-83")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-email-85"}),_vm._v(" "),_c('p',[_vm._v("nc-email-85")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-explore-2"}),_vm._v(" "),_c('p',[_vm._v("nc-explore-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-fav-remove"}),_vm._v(" "),_c('p',[_vm._v("nc-fav-remove")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-favourite-28"}),_vm._v(" "),_c('p',[_vm._v("nc-favourite-28")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-globe-2"}),_vm._v(" "),_c('p',[_vm._v("nc-globe-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-grid-45"}),_vm._v(" "),_c('p',[_vm._v("nc-grid-45")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-headphones-2"}),_vm._v(" "),_c('p',[_vm._v("nc-headphones-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-html5"}),_vm._v(" "),_c('p',[_vm._v("nc-html5")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-istanbul"}),_vm._v(" "),_c('p',[_vm._v("nc-istanbul")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-key-25"}),_vm._v(" "),_c('p',[_vm._v("nc-key-25")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-layers-3"}),_vm._v(" "),_c('p',[_vm._v("nc-layers-3")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-light-3"}),_vm._v(" "),_c('p',[_vm._v("nc-light-3")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-lock-circle-open"}),_vm._v(" "),_c('p',[_vm._v("nc-lock-circle-open")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-map-big"}),_vm._v(" "),_c('p',[_vm._v("nc-map-big")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-mobile"}),_vm._v(" "),_c('p',[_vm._v("nc-mobile")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-money-coins"}),_vm._v(" "),_c('p',[_vm._v("nc-money-coins")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-note-03"}),_vm._v(" "),_c('p',[_vm._v("nc-note-03")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-notes"}),_vm._v(" "),_c('p',[_vm._v("nc-notes")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-notification-70"}),_vm._v(" "),_c('p',[_vm._v("nc-notification-70")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-palette"}),_vm._v(" "),_c('p',[_vm._v("nc-palette")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-paper-2"}),_vm._v(" "),_c('p',[_vm._v("nc-paper-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-pin-3"}),_vm._v(" "),_c('p',[_vm._v("nc-pin-3")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-planet"}),_vm._v(" "),_c('p',[_vm._v("nc-planet")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-preferences-circle-rotate"}),_vm._v(" "),_c('p',[_vm._v("nc-preferences-circle-rotate")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-puzzle-10"}),_vm._v(" "),_c('p',[_vm._v("nc-puzzle-10")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-quote"}),_vm._v(" "),_c('p',[_vm._v("nc-quote")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-refresh-02"}),_vm._v(" "),_c('p',[_vm._v("nc-refresh-02")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-ruler-pencil"}),_vm._v(" "),_c('p',[_vm._v("nc-ruler-pencil")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-satisfied"}),_vm._v(" "),_c('p',[_vm._v("nc-satisfied")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-scissors"}),_vm._v(" "),_c('p',[_vm._v("nc-scissors")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-send"}),_vm._v(" "),_c('p',[_vm._v("nc-send")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-settings-90"}),_vm._v(" "),_c('p',[_vm._v("nc-settings-90")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-settings-gear-64"}),_vm._v(" "),_c('p',[_vm._v("nc-settings-gear-64")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-settings-tool-66"}),_vm._v(" "),_c('p',[_vm._v("nc-settings-tool-66")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-simple-add"}),_vm._v(" "),_c('p',[_vm._v("nc-simple-add")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-simple-delete"}),_vm._v(" "),_c('p',[_vm._v("nc-simple-delete")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-simple-remove"}),_vm._v(" "),_c('p',[_vm._v("nc-simple-remove")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-single-02"}),_vm._v(" "),_c('p',[_vm._v("nc-single-02")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-single-copy-04"}),_vm._v(" "),_c('p',[_vm._v("nc-single-copy-04")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-spaceship"}),_vm._v(" "),_c('p',[_vm._v("nc-spaceship")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-square-pin"}),_vm._v(" "),_c('p',[_vm._v("nc-square-pin")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-down"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-down")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-left"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-left")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-right"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-right")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-up"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-up")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-sun-fog-29"}),_vm._v(" "),_c('p',[_vm._v("nc-sun-fog-29")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-support-17"}),_vm._v(" "),_c('p',[_vm._v("nc-support-17")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tablet-2"}),_vm._v(" "),_c('p',[_vm._v("nc-tablet-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tag-content"}),_vm._v(" "),_c('p',[_vm._v("nc-tag-content")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tap-01"}),_vm._v(" "),_c('p',[_vm._v("nc-tap-01")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-time-alarm"}),_vm._v(" "),_c('p',[_vm._v("nc-time-alarm")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tv-2"}),_vm._v(" "),_c('p',[_vm._v("nc-tv-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-umbrella-13"}),_vm._v(" "),_c('p',[_vm._v("nc-umbrella-13")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-vector"}),_vm._v(" "),_c('p',[_vm._v("nc-vector")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-watch-time"}),_vm._v(" "),_c('p',[_vm._v("nc-watch-time")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-zoom-split"}),_vm._v(" "),_c('p',[_vm._v("nc-zoom-split")])])])])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ERMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_mixins_replaceGraphicSize__ = __webpack_require__("g69p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_mixins_gifGraphic__ = __webpack_require__("pJH4");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _ = __webpack_require__("M4fF");

var moment = __webpack_require__("PJh5");





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditCategory',
    mixins: [__WEBPACK_IMPORTED_MODULE_6_src_mixins_replaceGraphicSize__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_src_mixins_gifGraphic__["a" /* default */]],
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            showP: false,
            token: localStorage.getItem('token'),
            template: null,
            activeVideo: '',
            waiting: false,
            interval: null,
            lock_waiting: false,
            is_playing: false,
            show_svg_modal: false,
            show_collage_modal: false,
            is_object_changing: false,
            video: null,
            categories: JSON.parse(localStorage.getItem('categories')),
            sizes: JSON.parse(localStorage.getItem('sizes')),
            compression: false,
            preview: null,
            source: null,
            client_parts: [],
            is_text_active: false,
            active_text: 0,
            active_object: 0,
            draggable_index: 0,
            draggable_type: null,
            active_type: 'text',
            server_effects: [],
            server_graphics: [],
            server_filters: [],
            server_fonts: [],
            active_object_category: 'Arrows',
            active_collage_category: '2',
            default_text: {
                text: 'Default text',
                font_name: 'SF Pro',
                font_size: 30,
                text_color: "#ffffff",
                letter_spacing: 0,
                line_spacing: 0,
                alpha: 1,
                text_align: 'center',
                background_color: 'transparent',
                position_x: 0.49,
                position_y: 0.49,
                is_text_brush: 0,
                text_brush_data: [],
                z_index: 1,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
                direction: 'normal',
                animation_type: 0,
                animation_duration: 0,
                shadow_blur: 0,
                shadow_alpha: 0,
                shadow_color: '#ffffff',
                stroke_size: 0,
                stroke_color: '#000000'
            },
            default_object: {
                id: "b-330x298.svg",
                scale: 1,
                source: '<span>SVG</span>',
                color: '#ffffff',
                alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                time_start: 0,
                animation_type: 0,
                animation_duration: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
                shadow_color: '#ffffff',
                shadow_alpha: 0,
                shadow_blur: 0
            },
            texts: [],
            objects: [],
            colors: ["#FFFFFF", "#000000", "#F9F7F4", "#FAF5ED", "#F2E8DD", "#F4E4DD", "#D9BEBD", "#C5AEB6", "#E3C2D2", "#F1E0EF", "#D5C9E9", "#C8ACE0", "#E06E97", "#E64F3C", "#AB613E", "#B97959", "#D99056", "#E8BF88", "#EDD8AB", "#FAE389", "#F5C154", "#B78C3A", "#585B3B", "#7B7C41", "#BBB595", "#DFE7DA", "#C0DED3", "#B4C5C9", "#C9D9F0", "#4E63EC", "#4F5E8D", "#725B6E", "#F0F0F0", "#D9D9D9", "#616161", "#3C3C3C"],
            fonts: [{
                params: "'SF Pro', sans-serif;",
                code: "SF Pro",
                name: "SF Pro"
            }],
            animation_types: [{
                id: 0,
                name: "-"
            }, {
                id: 1,
                name: "Fade"
            }, {
                id: 4,
                name: "Zoom In"
            }, {
                id: 18,
                name: "Zoom Out"
            }, {
                id: 6,
                name: "Reveal ↓"
            }, {
                id: 7,
                name: "Reveal ↑"
            }, {
                id: 8,
                name: "Reveal →"
            }, {
                id: 9,
                name: "Reveal ←"
            }, {
                id: 10,
                name: "Float ↓"
            }, {
                id: 11,
                name: "Float ↑"
            }, {
                id: 12,
                name: "Float →"
            }, {
                id: 13,
                name: "Float ←"
            }, {
                id: 14,
                name: "Typewriter"
            }, {
                id: 15,
                name: "Typewriter Fade In"
            }, {
                id: 16,
                name: "Typewriter By Word"
            }, {
                id: 17,
                name: "Typewriter By Word Fade In"
            }],
            effect_types: [{
                id: 0,
                name: "-"
            }, {
                id: 1,
                name: "Zoom in"
            }, {
                id: 2,
                name: "Zoom out"
            }],
            content_types: [{
                id: 0,
                name: "Любой"
            }, {
                id: 1,
                name: "Фото"
            }, {
                id: 2,
                name: "Видео"
            }],
            text_aligns: [{
                name: "center"
            }, {
                name: "start"
            }, {
                name: "end"
            }],
            default_positions: {
                clientX: undefined,
                clientY: undefined,
                movementX: 0,
                movementY: 0
            },
            positions: [],
            object_positions: [],
            collages: [{
                name: '2',
                data: [{
                    id: '2_1',
                    frames: [{ x: 0, y: 0, width: 1.0, height: 0.5 }, { x: 0, y: 0.5, width: 1.0, height: 0.5 }]
                }, {
                    id: '2_2',
                    frames: [{ x: 0, y: 0, width: 1.0, height: 0.491 }, { x: 0, y: 0.509, width: 1.0, height: 0.491 }]
                }, {
                    id: '2_3',
                    frames: [{ x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474 }, { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474 }]
                }, {
                    id: '2_4',
                    frames: [{ x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '2_5',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 1.0 }, { x: 0.5, y: 0, width: 0.5, height: 1.0 }]
                }, {
                    id: '2_6',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.315 }, { x: 0, y: 0.315, width: 1, height: 0.685 }]
                }, {
                    id: '2_7',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.685 }, { x: 0, y: 0.685, width: 1, height: 0.315 }]
                }, {
                    id: '2_8',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: '2_9',
                    frames: [{ x: 0.2375, y: 0.1223, width: 0.532, height: 0.3647 }, { x: 0.2375, y: 0.5133, width: 0.532, height: 0.3647 }]
                }]
            }, {
                name: '3',
                data: [{
                    id: "3_1",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3334 }, { x: 0, y: 0.6667, width: 1, height: 0.3333 }]
                }, {
                    id: "3_2",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.326783 }, { x: 0, y: 0.336758, width: 1, height: 0.326783 }, { x: 0, y: 0.673216, width: 1, height: 0.326783 }]
                }, {
                    id: "3_3",
                    frames: [{ x: 0.028, y: 0.015625, width: 0.944, height: 0.3125 }, { x: 0.028, y: 0.34375, width: 0.944, height: 0.3125 }, { x: 0.028, y: 0.671875, width: 0.944, height: 0.3125 }]
                }, {
                    id: "3_4",
                    frames: [{
                        x: 0.028,
                        y: 0.015625,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }, {
                        x: 0.028,
                        y: 0.34375,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }, {
                        x: 0.028,
                        y: 0.671875,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }]
                }, {
                    id: "3_5",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6667, width: 0.5, height: 0.3333 }]
                }, {
                    id: "3_6",
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 1 }, { x: 0.3333, y: 0, width: 0.3333, height: 1 }, { x: 0.6667, y: 0, width: 0.3333, height: 1 }]
                }, {
                    id: "3_7",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_8",
                    frames: [{ x: 0, y: 0.5, width: 1, height: 0.5 }, { x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_9",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_10",
                    frames: [{ x: 0.0648, y: 0.064, width: 0.4815, height: 0.28125 }, { x: 0.0648, y: 0.35925, width: 0.4815, height: 0.28125 }, { x: 0.0648, y: 0.6564, width: 0.4815, height: 0.28125 }]
                }]
            }, {
                name: '4',
                data: [{
                    id: "4_1",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.25 }, { x: 0, y: 0.25, width: 1, height: 0.25 }, { x: 0, y: 0.5, width: 1, height: 0.25 }, { x: 0, y: 0.75, width: 1, height: 0.25 }]
                }, {
                    id: "4_2",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.24267 }, { x: 0, y: 0.25264333, width: 1, height: 0.24267 }, { x: 0, y: 0.50498666, width: 1, height: 0.24267 }, { x: 0, y: 0.75733, width: 1, height: 0.24267 }]
                }, {
                    id: "4_3",
                    frames: [{ x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875 }]
                }, {
                    id: "4_4",
                    frames: [{ x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }]
                }, {
                    id: "4_5",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "4_6",
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.4948 }, { x: 0.50925, y: 0, width: 0.49075, height: 0.4948 }, { x: 0, y: 0.5052, width: 0.49075, height: 0.4948 }, { x: 0.50925, y: 0.5052, width: 0.49075, height: 0.4948 }]
                }, {
                    id: "4_7",
                    frames: [{ x: 0.0315, y: 0.017708, width: 0.45925, height: 0.410417 }, { x: 0.50925, y: 0.017708, width: 0.45927, height: 0.410417 }, { x: 0.0315, y: 0.438542, width: 0.45927, height: 0.410417 }, { x: 0.50925, y: 0.438542, width: 0.45927, height: 0.410417 }]
                }, {
                    id: "4_8",
                    frames: [{ x: 0.0407, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.5213, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.0407, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.5213, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }]
                }, {
                    id: "4_9",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.5 }, { x: 0, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 }]
                }, {
                    id: "4_10",
                    frames: [{ x: 0.01852, y: 0.010717, width: 0.96296, height: 0.48381425 }, { x: 0.01852, y: 0.50546875, width: 0.30864, height: 0.48411425 }, { x: 0.34568, y: 0.50546875, width: 0.30864, height: 0.48411425 }, { x: 0.67284, y: 0.50546875, width: 0.30864, height: 0.48411425 }]
                }, {
                    id: "4_11",
                    frames: [{ x: 0.01852, y: 0.010417, width: 0.400926, height: 0.4843745 }, { x: 0.437966, y: 0.010417, width: 0.543514, height: 0.4843745 }, { x: 0.01852, y: 0.5052085, width: 0.543514, height: 0.4843745 }, { x: 0.580554, y: 0.5052085, width: 0.400926, height: 0.4843745 }]
                }, {
                    id: "4_12",
                    frames: [{ x: 0, y: 0, width: 0.49074, height: 0.4895829967 }, { x: 0.50926, y: 0, width: 0.49074, height: 0.4895829967 }, { x: 0, y: 0.4999996633, width: 1, height: 0.2447917 }, { x: 0, y: 0.7552083, width: 1, height: 0.2447917 }]
                }]
            }, {
                name: '5',
                data: [{
                    id: '5_1',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.2 }, { x: 0, y: 0.2, width: 1, height: 0.2 }, { x: 0, y: 0.4, width: 1, height: 0.2 }, { x: 0, y: 0.6, width: 1, height: 0.2 }, { x: 0, y: 0.8, width: 1, height: 0.2 }]
                }, {
                    id: '5_2',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.1875 }, { x: 0, y: 0.203125, width: 1, height: 0.1875 }, { x: 0, y: 0.40625, width: 1, height: 0.1875 }, { x: 0, y: 0.609375, width: 1, height: 0.1875 }, { x: 0, y: 0.8125, width: 1, height: 0.1875 }]
                }, {
                    id: '5_3',
                    frames: [{ x: 0.028, y: 0.015825, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095 }]
                }, {
                    id: '5_4',
                    frames: [{ x: 0.028, y: 0.015825, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '5_5',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.5, height: 0.3334 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '5_6',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 1 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0.3333, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0, width: 0.3334, height: 1 }]
                }, {
                    id: '5_7',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.6666, y: 0, width: 0.3334, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3333 }, { x: 0, y: 0.6666, width: 1, height: 0.3334 }]
                }, {
                    id: '5_8',
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.4947915 }, { x: 0, y: 0.5052085, width: 0.49075, height: 0.4947915 }, { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.33710567, width: 0.49075, height: 0.32608867 }, { x: 0.50927, y: 0.67361134, width: 0.49075, height: 0.32638867 }]
                }, {
                    id: '5_9',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '5_11',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 }]
                }]
            }, {
                name: '6',
                data: [{
                    id: '6_1',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.16697 }, { x: 0, y: 0.16637, width: 1, height: 0.16697 }, { x: 0, y: 0.33304, width: 1, height: 0.16697 }, { x: 0, y: 0.49971, width: 1, height: 0.16697 }, { x: 0, y: 0.66638, width: 1, height: 0.16696 }, { x: 0, y: 0.83304, width: 1, height: 0.16696 }]
                }, {
                    id: '6_2',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.15798583 }, { x: 0, y: 0.16790283, width: 1, height: 0.15798583 }, { x: 0, y: 0.33680566, width: 1, height: 0.15798583 }, { x: 0, y: 0.50520849, width: 1, height: 0.15798583 }, { x: 0, y: 0.67361132, width: 1, height: 0.15798583 }, { x: 0, y: 0.84201415, width: 1, height: 0.15798583 }]
                }, {
                    id: '6_3',
                    frames: [{ x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152 }]
                }, {
                    id: '6_4',
                    frames: [{ x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '6_14',
                    frames: [{ x: 0, y: 0, width: 0.1667, height: 1 }, { x: 0.1667, y: 0, width: 0.1666, height: 1 }, { x: 0.3333, y: 0, width: 0.1667, height: 1 }, { x: 0.5, y: 0, width: 0.1667, height: 1 }, { x: 0.6667, y: 0, width: 0.1666, height: 1 }, { x: 0.8333, y: 0, width: 0.1667, height: 1 }]
                }, {
                    id: '6_5',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0.6666, width: 0.3333, height: 0.3334 }]
                }, {
                    id: '6_6',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.5, height: 0.3334 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '6_7',
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0, y: 0.33685567, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.33685567, width: 0.49075, height: 0.32638867 }, { x: 0, y: 0.67321134, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.67321134, width: 0.49075, height: 0.32638867 }]
                }, {
                    id: '6_8',
                    frames: [{ x: 0, y: 0, width: 0.369444, height: 0.25 }, { x: 0, y: 0.25, width: 0.369444, height: 0.25 }, { x: 0.369444, y: 0, width: 0.630556, height: 0.5 }, { x: 0, y: 0.5, width: 0.630556, height: 0.5 }, { x: 0.630556, y: 0.5, width: 0.369444, height: 0.25 }, { x: 0.630556, y: 0.75, width: 0.369444, height: 0.25 }]
                }, {
                    id: '6_9',
                    frames: [{ x: 0, y: 0, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.2526175, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.505235, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.7578525, width: 0.369444, height: 0.2421475 }, { x: 0.387964, y: 0, width: 0.612036, height: 0.4947915 }, { x: 0.387964, y: 0.505235, width: 0.612036, height: 0.4947915 }]
                }, {
                    id: '6_10',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.65833 }, { x: 0, y: 0.65833, width: 0.3333, height: 0.34167 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.34167 }, { x: 0.3333, y: 0.34167, width: 0.3333, height: 0.65833 }, { x: 0.6666, y: 0, width: 0.3334, height: 0.65833 }, { x: 0.6666, y: 0.65833, width: 0.3334, height: 0.34167 }]
                }, {
                    id: '6_11',
                    frames: [{ x: 0, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0.33950667, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0.67851334, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0, y: 0.33685867, width: 0.32098667, height: 0.32638867 }, { x: 0, y: 0.67321734, width: 0.32098667, height: 0.32638867 }, { x: 0.33950667, y: 0.33685867, width: 0.66049333, height: 0.66314133 }]
                }, {
                    id: '6_12',
                    frames: [{ x: 0, y: 0, width: 0.68611, height: 0.3333 }, { x: 0.68611, y: 0, width: 0.31389, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.31389, height: 0.3333 }, { x: 0.31389, y: 0.3333, width: 0.68611, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.68611, height: 0.3334 }, { x: 0.68611, y: 0.6666, width: 0.31389, height: 0.3334 }]
                }, {
                    id: '6_13',
                    frames: [{ x: 0.084185, y: 0.14375, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.14375, width: 0.391667, height: 0.22013867 }, { x: 0.084185, y: 0.38993067, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.38993067, width: 0.391667, height: 0.22013867 }, { x: 0.084185, y: 0.63611134, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.63611134, width: 0.391667, height: 0.22013867 }]
                }]
            }, {
                name: '9',
                data: [{
                    id: '9_1',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.6666, y: 0, width: 0.3333, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.3333, height: 0.3334 }, { x: 0.3333, y: 0.3333, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0.3333, width: 0.3333, height: 0.3334 }, { x: 0, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0.6666, width: 0.3333, height: 0.3334 }]
                }]
            }, {
                name: '10',
                data: [{
                    id: '10_1',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.2 }, { x: 0.5, y: 0, width: 0.5, height: 0.2 }, { x: 0, y: 0.2, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.2, width: 0.5, height: 0.2 }, { x: 0, y: 0.4, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.4, width: 0.5, height: 0.2 }, { x: 0, y: 0.6, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.6, width: 0.5, height: 0.2 }, { x: 0, y: 0.8, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.8, width: 0.5, height: 0.2 }]
                }, {
                    id: '10_2',
                    frames: [{ x: 0, y: 0, width: 0.2, height: 0.5 }, { x: 0, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.2, y: 0, width: 0.2, height: 0.5 }, { x: 0.2, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.4, y: 0, width: 0.2, height: 0.5 }, { x: 0.4, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.6, y: 0, width: 0.2, height: 0.5 }, { x: 0.6, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.8, y: 0, width: 0.2, height: 0.5 }, { x: 0.8, y: 0.5, width: 0.2, height: 0.5 }]
                }]
            }, {
                name: '12',
                data: [{
                    id: '12_1',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0, width: 0.3333, height: 0.25 }, { x: 0, y: 0.25, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0.25, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0.25, width: 0.3333, height: 0.25 }, { x: 0, y: 0.5, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0.5, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0.5, width: 0.3333, height: 0.25 }, { x: 0, y: 0.75, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0.75, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0.75, width: 0.3333, height: 0.25 }]
                }, {
                    name: '20',
                    data: [{
                        id: '20_1',
                        frames: [{ x: 0, y: 0, width: 0.25, height: 0.2 }, { x: 0.25, y: 0, width: 0.25, height: 0.2 }, { x: 0.5, y: 0, width: 0.25, height: 0.2 }, { x: 0.75, y: 0, width: 0.25, height: 0.2 }, { x: 0, y: 0.2, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.2, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.2, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.2, width: 0.25, height: 0.2 }, { x: 0, y: 0.4, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.4, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.4, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.4, width: 0.25, height: 0.2 }, { x: 0, y: 0.6, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.6, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.6, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.6, width: 0.25, height: 0.2 }, { x: 0, y: 0.8, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.8, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.8, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.8, width: 0.25, height: 0.2 }]
                    }]
                }]
            }]
        };
    },

    watch: {
        is_playing: function is_playing(val) {
            if (val) {
                this.startInterval();
            } else {
                clearInterval(this.interval);
            }
        }
    },
    created: function created() {
        var self = this;
        self.id = this.$route.params.id;

        self.getResources();

        self.get(self.id);
    },
    computed: {
        graphicsUrl: function graphicsUrl() {
            return this.$graphicsUrl;
        },
        sumParts: function sumParts() {
            var sum = 0;
            _.map(this.client_parts, function (p) {
                if (!p.cutout_only) {
                    var duration = parseFloat(p.duration);
                    duration = isNaN(duration) ? 0 : duration;

                    // Collages block
                    if (p.collage_type !== 0) {
                        var startTime = parseFloat(p.start_time);
                        startTime = isNaN(startTime) ? 0 : startTime;

                        var collageDuration = startTime + duration;
                        duration = sum > collageDuration ? 0 : collageDuration - sum;
                    }

                    sum += duration;
                }
            });

            return sum.toFixed(2);
        },
        sortedFonts: function sortedFonts() {
            return _.sortBy(this.fonts, function (f) {
                return f.name;
            });
        },
        versions: function versions() {
            var result = [];
            var start = 9.0 * 10;
            var end = this.$endVersion * 10;

            for (var i = start; i <= end; i++) {
                result.push((i / 10).toFixed(1));
            }

            return result;
        }
    },
    methods: {
        text_html: function text_html(index) {
            var textModel = this.template.texts[index];
            var text = _.find(this.fonts, function (f) {
                return f.name === textModel.font_name;
            });

            if (!text) {
                alert('Шрифт ' + textModel.font_name + ' не найден. Пожалуйста, замените на другой.');

                text = _.first(this.fonts);
            }

            var line_height = parseFloat(textModel.font_size) + parseFloat(textModel.line_spacing);
            var alpha = textModel.alpha;

            var direction = '';
            if (textModel.direction === 'vertical') {
                direction = '  writing-mode: vertical-rl;\n' + '  text-orientation: upright;\n';
            }

            var offset = 4 / 88 * textModel.font_size;
            var blur = 0.29 * textModel.font_size / 88 * textModel.shadow_blur;
            var shadow = 'text-shadow: ' + offset + 'px ' + offset + 'px ' + blur + 'px ' + textModel.shadow_color + this.convertAlphaToHex(textModel.shadow_alpha) + ';';

            return '<span style="color: ' + textModel.text_color + '; ' + 'background-color: ' + textModel.background_color + '; ' + 'font-size: ' + textModel.font_size + 'px; ' + 'letter-spacing: ' + textModel.letter_spacing + 'px; ' + 'opacity: ' + alpha + '; ' + 'line-height: ' + line_height + 'px; ' + 'transform: rotate( ' + textModel.angle + 'deg); ' + 'display: block;' + 'border: 1px solid white;' + 'padding: 5px;' + direction + shadow + 'text-align: ' + textModel.text_align + '; ' + 'z-index: ' + textModel.z_index + '; ' + 'font-family:' + text.params + ';">' + textModel.text + '</span>';
        },
        object_html: function object_html(index) {
            return this.renderSvgObjectHtml(this.template.objects[index]);
        },
        image_html: function image_html(index) {
            var objectModel = this.template.objects[index];

            if (!objectModel.source || !objectModel.dimensions) {
                return "";
            }

            var width = objectModel.dimensions.width;
            var height = objectModel.dimensions.height;

            width = width * parseFloat(objectModel.scale);
            height = height * parseFloat(objectModel.scale);

            var img = '<img src="' + this.objectPlayerSrc(objectModel) + '">';

            var style = ' style="width: ' + width + 'px; height: ' + height + 'px; opacity: ' + objectModel.alpha + '; padding: 0px; transform: rotate(' + objectModel.angle + 'deg); z-index: ' + objectModel.z_index + '; display: block;"';

            img = this.insertAt(img, style, 5);

            return img;
        },

        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        goBack: function goBack() {
            window.history.back();
        },
        getResources: function getResources() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/resources/', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.server_effects = response.data.effects;
                self.server_graphics = response.data.graphics;
                self.server_filters = response.data.filters;
                self.server_fonts = response.data.fonts;

                self.appendFonts();
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        insertAt: function insertAt(str, sub, pos) {
            return '' + str.slice(0, pos) + sub + str.slice(pos);
        },
        formatStartTime: function formatStartTime(event, index, object) {
            this.client_parts[index][object] = this.client_parts[index][object].replace(',', '.');
        },
        formatDuration: function formatDuration(event, index) {
            this.client_parts[index].duration = this.client_parts[index].duration.replace(',', '.');
        },
        formatSpeed: function formatSpeed(event, index) {
            this.client_parts[index].speed = this.client_parts[index].speed.replace(',', '.');
        },
        formatVideoDuration: function formatVideoDuration(event, index) {
            this.template.duration = this.template.duration.replace(',', '.');
        },
        addText: function addText() {
            var copy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var self = this;

            // if copied
            if (copy !== false) {
                var copiedText = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.template.texts[self.active_text]));
                copiedText.text = 'Default text';

                self.template.texts.push(copiedText);

                var positions = self.positions[self.active_text];
                positions.clientX = positions.clientX ? positions.clientX + 5 : positions.clientX;
                positions.clientY = positions.clientY ? positions.clientY + 5 : positions.clientY;
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(positions)));

                setTimeout(function () {

                    self.$refs.draggableContainer[self.template.texts.length - 1].style.left = self.$refs.draggableContainer[self.active_text].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = self.$refs.draggableContainer[self.active_text].offsetTop + 5 + 'px';

                    self.active_text = self.template.texts.length - 1;
                    self.active_type = 'text';

                    //console.log(self.$refs.draggableContainer[self.template.texts.length - 1].style.left);
                }, 100);
            } else {
                self.template.texts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_text)));
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                self.active_text = self.template.texts.length - 1;
                self.active_type = 'text';
            }
        },
        addObject: function addObject(object) {
            var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            // if copied
            if (copy !== false) {
                var copiedObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.template.objects[self.active_object]));

                self.template.objects.push(copiedObject);
                self.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.object_positions[self.active_object])));

                setTimeout(function () {

                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.left = self.$refs.draggableContainer2[self.active_object].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.top = self.$refs.draggableContainer2[self.active_object].offsetTop + 5 + 'px';

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object';
                }, 100);
            } else {
                self.placeGraphicObject(object);
            }

            self.active_object_category = 'Arrows';
        },
        changeObject: function changeObject() {
            this.is_object_changing = true;
            this.show_svg_modal = true;
        },
        addCollage: function addCollage(e) {
            // 888
            var data = e.target.dataset.params;
            var params = data.split(';');
            var id = params[0];
            var part = params[1];
            var x = params[2];
            var y = params[3];
            var w = params[4];
            var h = params[5];

            this.client_parts[this.active_part_index].collage_type = id + ';' + part;
            this.client_parts[this.active_part_index].frame = {
                x: parseFloat(x),
                y: parseFloat(y),
                w: parseFloat(w),
                h: parseFloat(h)
            };

            this.previous_collage_id = id;

            this.show_collage_modal = false;
        },
        convertCollageTypeToNewFormat: function convertCollageTypeToNewFormat(oldType) {

            if (oldType.toString().indexOf('_') > 0) return oldType;

            var oldTypeName = _.find(this.collage_types, function (c) {
                return c.id === parseInt(oldType);
            }).name;
            var oldCategory = oldTypeName.split('/');
            var collageCategory = parseInt(oldCategory[1]) === 6 ? 6 : 1;

            return oldCategory[1] + '_' + collageCategory + ';' + oldCategory[0];
        },
        convertAlphaToHex: function convertAlphaToHex(alpha) {
            if (alpha < 0.08) return '00';
            return Math.floor(alpha * 255).toString(16);
        },
        selectText: function selectText(text) {
            this.active_text = text;
            this.active_type = 'text';
        },
        selectObject: function selectObject(object) {
            this.active_object = object;
            this.active_type = 'object';
        },
        selectObjectCategory: function selectObjectCategory(category) {
            this.active_object_category = category;
        },
        selectCollageCategory: function selectCollageCategory(category) {
            this.active_collage_category = category;
        },
        removeCollageFromPart: function removeCollageFromPart(index) {
            var self = this;

            if (confirm("Подтверждение удаления коллажа")) {
                self.client_parts[index].collage_type = 0;
                self.client_parts[index].frame = null;

                console.log(self.client_parts[index]);
            }
        },
        removeText: function removeText(index) {
            var self = this;

            if (self.template.texts.length < 2) {
                var notification = {
                    template: '<span><b>\u0414\u043B\u044F \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u0442\u0435\u043A\u0441\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0447\u0435\u043A\u0431\u043E\u043A\u0441 "\u041D\u0430\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430"</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'warning'
                });

                return;
            }

            if (confirm("Подтверждение удаления текста: " + self.template.texts[index].text)) {
                self.active_text = 0;
                self.active_type = 'text';

                self.template.texts = self.template.texts.filter(function (t, i) {
                    return i !== index;
                });
            }
        },
        removeObject: function removeObject(index) {
            var self = this;

            if (self.template.objects.length < 2) {
                var notification = {
                    template: '<span><b>\u0414\u043B\u044F \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0447\u0435\u043A\u0431\u043E\u043A\u0441 "\u041D\u0430\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430"</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'warning'
                });

                return;
            }

            if (confirm("Подтверждение удаления объекта")) {
                self.active_object = 0;
                self.active_type = 'object';

                self.template.objects = self.template.objects.filter(function (t, i) {
                    return i !== index;
                });
            }
        },
        toggleText: function toggleText() {
            var self = this;

            if (self.is_text_active) {
                self.template.texts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_text)));
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                setTimeout(function () {
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = '0px';
                }, 500);
            } else {
                self.template.texts = [];
                self.positions = [];
            }
        },
        toggleBackground: function toggleBackground() {
            if (this.template.texts[this.active_text].background_color === 'transparent') {
                this.setColor('#FFFFFF', 'background');
            } else {
                this.setColor('transparent', 'background');
            }
        },

        setTextPosition: function setTextPosition(x, y) {

            x = parseFloat(x);
            y = parseFloat(y);

            if (x) {
                this.template.texts[this.active_text].position_x = x;

                var centerX = 0.5 * 360 - this.$refs.draggableContainer[this.active_text].clientWidth / 2;

                this.$refs.draggableContainer[this.active_text].style.left = centerX + 'px';
            }

            if (y) {
                this.template.texts[this.active_text].position_y = y;

                var centerY = 0.5 * 640 - this.$refs.draggableContainer[this.active_text].clientHeight / 2;

                this.$refs.draggableContainer[this.active_text].style.top = centerY + 'px';
            }
        },
        setObjectPosition: function setObjectPosition(x, y) {
            if (x) {
                this.template.objects[this.active_object].position_x = x;

                var centerX = 0.5 * 360 - this.$refs.draggableContainer2[this.active_object].clientWidth / 2;

                this.$refs.draggableContainer2[this.active_object].style.left = centerX + 'px';
            }

            if (y) {
                this.template.objects[this.active_object].position_y = y;

                var centerY = 0.5 * 640 - this.$refs.draggableContainer2[this.active_object].clientHeight / 2;

                this.$refs.draggableContainer2[this.active_object].style.top = centerY + 'px';
            }
        },
        changeContentType: function changeContentType(index, type) {
            this.client_parts[index].content = type === 2 ? '#000000' : null;
        },
        changeEffectType: function changeEffectType(index, type) {

            if (type === 0) {
                return;
            }

            var from = 1;
            var to = 0.85;
            if (type === 2) {
                from = 0.85;
                to = 1;
            }

            this.client_parts[index].effect_values = {
                from: from,
                to: to,
                x: 0.5,
                y: 0.5
            };
        },
        changeEffectPosition: function changeEffectPosition(event, index) {
            var offsetX = void 0;
            var offsetY = void 0;

            if (event.target.className !== 'effect-preview') {
                var parent = event.target.parentElement;
                if (parent.className !== 'effect-preview') {
                    parent = parent.parentElement;
                } else {}

                offsetX = 0;
                offsetY = 0;
            } else {
                offsetX = event.offsetX < 0 ? 0 : event.offsetX;
                offsetY = event.offsetY < 0 ? 0 : event.offsetY;
            }

            this.client_parts[index].effect_values.x = (offsetX / 50).toFixed(2);
            if (this.client_parts[index].effect_values.x > 1) {
                this.client_parts[index].effect_values.x = 1;
            }

            this.client_parts[index].effect_values.y = (offsetY / 89).toFixed(2);
            if (this.client_parts[index].effect_values.y > 1) {
                this.client_parts[index].effect_values.y = 1;
            }
        },
        setColor: function setColor(color, type) {
            if (type === 'color') {
                this.template.texts[this.active_text].text_color = color;
            }

            if (type === 'background') {
                this.template.texts[this.active_text].background_color = color;
            }
        },
        setObjColor: function setObjColor(color) {
            this.template.objects[this.active_object].color = color;
        },
        changeVideoCount: function changeVideoCount(value) {
            var self = this;
            var oldParts = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.client_parts));

            if (isNaN(parseInt(value))) {
                return oldParts;
            }

            var newParts = [];
            for (var i = 0; i < value; i++) {
                newParts.push({
                    duration: '',
                    speed: '1.0',
                    effect_type: 0,
                    content_type: 0,
                    effect_values: { x: 0.5, y: 0.5 },
                    collage_type: 0,
                    frame: 0,
                    start_time: 0
                });
            }

            for (var _i = 0; _i < oldParts.length; _i++) {
                for (var j = 0; j < newParts.length; j++) {
                    if (_i === j) {
                        newParts[j] = oldParts[_i];
                    }
                }
            }

            this.client_parts = newParts;
        },

        showPreview: function showPreview() {
            this.is_playing = false;
            this.checkElementsVisibility(0);
            this.video.load();
        },
        checkElementsVisibility: function checkElementsVisibility(currentTime) {
            var self = this;

            var elements = [self.template.texts, self.template.objects];
            for (var o = 0; o < elements.length; o++) {

                var element = elements[o];
                for (var i = 0; i < element.length; i++) {
                    if (currentTime === 0) {
                        element[i].is_visible = 1;
                    } else {
                        if (parseFloat(element[i].time_start) < currentTime && parseFloat(element[i].time_end) > currentTime) {
                            element[i].is_visible = 1;
                        } else if (parseFloat(element[i].time_start) < currentTime && element[i].time_end === "") {
                            element[i].is_visible = 1;
                        } else {
                            element[i].is_visible = 0;
                        }
                    }
                }
            }
        },
        startInterval: function startInterval() {
            var self = this;

            this.interval = setInterval(function () {
                self.checkElementsVisibility(self.video.currentTime);
                if (self.template.duration && self.video.currentTime >= self.template.duration) {
                    self.video.load();
                }
            }, 30);
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/created/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                    var _this = this;

                    var data, i, _i2, _loop, _i3, _loop2, _i4;

                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    data = response.data;


                                    for (i = 0; i < data.templates[0].texts.length; i++) {
                                        data.templates[0].texts[i].is_visible = 1;
                                        if (data.templates[0].texts[i].time_start === undefined) {
                                            data.templates[0].texts[i].time_start = 0;
                                        }
                                        if (data.templates[0].texts[i].time_end === undefined) {
                                            data.templates[0].texts[i].time_end = "";
                                        }

                                        if (!data.templates[0].texts[i].direction) {
                                            data.templates[0].texts[i].direction = "normal";
                                        }

                                        if (!data.templates[0].texts[i].animation_type) {
                                            data.templates[0].texts[i].animation_type = 0;
                                            data.templates[0].texts[i].animation_duration = 0;
                                        }

                                        if (!data.templates[0].texts[i].shadow_blur) {
                                            data.templates[0].texts[i].shadow_blur = 0;
                                        }

                                        if (!data.templates[0].texts[i].shadow_alpha) {
                                            data.templates[0].texts[i].shadow_alpha = 0;
                                        }

                                        if (!data.templates[0].texts[i].shadow_color) {
                                            data.templates[0].texts[i].shadow_color = '#ffffff';
                                        }

                                        if (!data.templates[0].texts[i].stroke_size) {
                                            data.templates[0].texts[i].stroke_size = 0;
                                        }

                                        if (!data.templates[0].texts[i].stroke_size) {
                                            data.templates[0].texts[i].stroke_color = '#000000';
                                        }

                                        if (!data.templates[0].texts[i].is_text_brush) {
                                            data.templates[0].texts[i].text_brush_data = [];
                                        }
                                    }

                                    for (_i2 = 0; _i2 < data.templates[0].objects.length; _i2++) {
                                        if (!data.templates[0].objects[_i2].animation_type) {
                                            data.templates[0].objects[_i2].animation_type = 0;
                                            data.templates[0].objects[_i2].animation_duration = 0;
                                        }

                                        if (!data.templates[0].objects[_i2].shadow_blur) {
                                            data.templates[0].objects[_i2].shadow_blur = 0;
                                        }

                                        if (!data.templates[0].objects[_i2].shadow_alpha) {
                                            data.templates[0].objects[_i2].shadow_alpha = 0;
                                        }

                                        if (!data.templates[0].objects[_i2].shadow_color) {
                                            data.templates[0].objects[_i2].shadow_color = '#ffffff';
                                        }
                                    }

                                    self.template = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data.templates[0]));

                                    self.template.parts.forEach(function (p) {
                                        self.client_parts.push({
                                            duration: p.duration,
                                            speed: p.speed ? p.speed : "1.0",
                                            effect_type: p.effect_type ? p.effect_type : 0,
                                            content_type: p.content_type ? p.content_type : 0,
                                            effect_values: p.effect_values ? p.effect_values : { x: 0.5, y: 0.5 },
                                            collage_type: p.collage_type ? p.collage_type : 0,
                                            frame: p.frame ? p.frame : 0,
                                            start_time: p.start_time ? p.start_time : 0
                                        });
                                    });

                                    if (self.template.release_date) {
                                        self.template.release_time = moment(self.template.release_date, moment.DATETIME_LOCAL_MS).format('HH:mm');
                                        self.template.release_date = moment(self.template.release_date, moment.DATETIME_LOCAL_MS).format('YYYY-MM-DD');
                                    } else {
                                        self.template.release_time = '12:00';
                                    }

                                    if (self.template.song_insta) {
                                        self.template.song_insta = 'https://www.instagram.com/reels/audio/' + self.template.song_insta;
                                    }

                                    if (self.template.song_tiktok) {
                                        self.template.song_tiktok = 'https://vm.tiktok.com/' + self.template.song_tiktok;
                                    }

                                    if (!(self.template.objects.length < 1)) {
                                        _context2.next = 13;
                                        break;
                                    }

                                    self.template.objects = [];
                                    self.object_positions = [];
                                    _context2.next = 20;
                                    break;

                                case 13:
                                    _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _loop(_i3) {
                                        var dataSource, size;
                                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _loop$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:

                                                        self.object_positions.push(self.default_positions);

                                                        if (!(self.template.objects[_i3].id.indexOf('.svg') > -1)) {
                                                            _context.next = 8;
                                                            break;
                                                        }

                                                        _context.next = 4;
                                                        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(self.$hostname + '/admin/services/graphics/svg/source', {
                                                            'params': {
                                                                url: self.graphicsUrl + self.template.objects[_i3].id
                                                            },
                                                            'headers': {
                                                                'Authorization': 'Bearer ' + localStorage.getItem('token')
                                                            }
                                                        });

                                                    case 4:
                                                        dataSource = _context.sent;


                                                        self.template.objects[_i3].source = dataSource.data;

                                                        _context.next = 14;
                                                        break;

                                                    case 8:
                                                        self.template.objects[_i3].source = "Image";

                                                        if (!self.isGifSrc(self.template.objects[_i3].id)) {
                                                            _context.next = 14;
                                                            break;
                                                        }

                                                        _context.next = 12;
                                                        return self.loadRasterGraphic(self.template.objects[_i3].id);

                                                    case 12:
                                                        size = _context.sent;

                                                        if (size && !self.template.objects[_i3].dimensions) {
                                                            self.$set(self.template.objects[_i3], 'dimensions', size);
                                                        }

                                                    case 14:

                                                        setTimeout(function () {

                                                            self.template.objects[_i3].is_visible = 1;

                                                            var centerX = self.template.objects[_i3].position_x * 360 - self.$refs.draggableContainer2[_i3].clientWidth / 2;
                                                            var centerY = self.template.objects[_i3].position_y * 640 - self.$refs.draggableContainer2[_i3].clientHeight / 2;

                                                            self.$refs.draggableContainer2[_i3].style.left = centerX + 'px';
                                                            self.$refs.draggableContainer2[_i3].style.top = centerY + 'px';

                                                            self.video = self.$refs.videoContainer;

                                                            self.video.addEventListener("playing", function () {
                                                                //console.log('play ' + self.video.currentTime);

                                                                self.is_playing = true;
                                                            });

                                                            self.video.addEventListener("timeupdate", function () {
                                                                self.checkElementsVisibility(self.video.currentTime);
                                                            });

                                                            self.video.addEventListener("pause", function () {
                                                                //console.log('pause ' + self.video.currentTime);

                                                                self.is_playing = false;
                                                            });
                                                        }, 500);

                                                    case 15:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _loop, _this);
                                    });
                                    _i3 = 0;

                                case 15:
                                    if (!(_i3 < self.template.objects.length)) {
                                        _context2.next = 20;
                                        break;
                                    }

                                    return _context2.delegateYield(_loop(_i3), 't0', 17);

                                case 17:
                                    _i3++;
                                    _context2.next = 15;
                                    break;

                                case 20:

                                    if (self.template.texts.length > 0) {

                                        self.is_text_active = true;
                                        self.active_text = 0;
                                        self.active_type = 'text';

                                        _loop2 = function _loop2(_i4) {
                                            self.positions.push(self.default_positions);

                                            if (!self.template.texts[_i4].angle) {
                                                self.template.texts[_i4].angle = 0;
                                            }

                                            setTimeout(function () {

                                                var centerX = self.template.texts[_i4].position_x * 360 - self.$refs.draggableContainer[_i4].clientWidth / 2;
                                                var centerY = self.template.texts[_i4].position_y * 640 - self.$refs.draggableContainer[_i4].clientHeight / 2;

                                                self.$refs.draggableContainer[_i4].style.left = centerX + 'px';
                                                self.$refs.draggableContainer[_i4].style.top = centerY + 'px';

                                                self.video = self.$refs.videoContainer;

                                                self.video.addEventListener("playing", function () {
                                                    //console.log('play ' + self.video.currentTime);

                                                    self.is_playing = true;
                                                });

                                                self.video.addEventListener("timeupdate", function () {
                                                    self.checkElementsVisibility(self.video.currentTime);
                                                });

                                                self.video.addEventListener("pause", function () {
                                                    //console.log('pause ' + self.video.currentTime);

                                                    self.is_playing = false;
                                                });
                                            }, 500);
                                        };

                                        for (_i4 = 0; _i4 < self.template.texts.length; _i4++) {
                                            _loop2(_i4);
                                        }
                                    }

                                case 21:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee, this);
                }));

                return function (_x3) {
                    return _ref.apply(this, arguments);
                };
            }()).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        appendFonts: function appendFonts() {

            var newStyle = document.createElement('style');
            for (var i = 0; i < this.server_fonts.length; i++) {
                var font = this.server_fonts[i];

                newStyle.appendChild(document.createTextNode('\n                    @font-face {\n                      font-family: \'' + font.name + '\';\n                      src: url(\'/static/fonts/' + font.src + '\');\n                    }\n                    '));

                this.fonts.push({
                    params: '\'' + font.name + '\', sans-serif;',
                    code: font.name,
                    name: font.name
                });
            }

            document.head.appendChild(newStyle);
        },
        showSVGModal: function showSVGModal() {
            this.show_svg_modal = true;
        },
        closeSVGModal: function closeSVGModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_svg_modal = false;
                this.is_object_changing = false;
                this.active_object_category = 'Arrows';
            }
        },
        // 888
        showCollageModal: function showCollageModal(index) {
            this.active_part_index = index;
            this.show_collage_modal = true;
        },
        closeCollageModal: function closeCollageModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_collage_modal = false;
            }
        },
        save: function save() {
            var _this2 = this;

            var self = this;

            var template = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.template));
            template.parts = self.client_parts;

            for (var i = 0; i < template.parts.length; i++) {
                if (template.parts[i].duration === null || template.parts[i].speed === null) {
                    var notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u043E\u0432 \u0432\u0438\u0434\u0435\u043E</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (template.song_insta) {
                var regex = /(\d{14,22})/gi;
                var match = regex.exec(template.song_insta);

                var reelId = match ? match[0] : null;
                template.song_insta = reelId;

                if (!reelId) {
                    var _notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 Reels Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (template.song_tiktok) {
                var parts = template.song_tiktok.split('/');

                if (parts.length > 3 && parts[3].length > 5) {
                    template.song_tiktok = parts[3];
                } else {

                    var _notification2 = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 TikTok Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification2,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (Math.abs(self.sumParts - template.duration) > 0.05) {

                var _notification3 = {
                    template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u043E\u0432 \u0432\u0438\u0434\u0435\u043E</b></span>'
                };

                self.$notifications.notify({
                    component: _notification3,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                return false;
            }

            if (this.video) {
                this.video.load();
            }

            self.waiting = true;
            //console.log(self.template.texts);
            //return false;
            setTimeout(function () {

                if (_this2.is_text_active) {

                    for (var _i5 = 0; _i5 < self.template.texts.length; _i5++) {

                        var activeText = template.texts[_i5];

                        if (activeText.position_x !== 0.5) {
                            var centerX = _this2.$refs.draggableContainer[_i5].offsetLeft + _this2.$refs.draggableContainer[_i5].clientWidth / 2;

                            activeText.position_x = parseFloat((centerX / 360).toFixed(4));
                        }

                        if (activeText.position_y !== 0.5) {
                            var centerY = _this2.$refs.draggableContainer[_i5].offsetTop + _this2.$refs.draggableContainer[_i5].clientHeight / 2;

                            activeText.position_y = parseFloat((centerY / 640).toFixed(4));
                        }

                        activeText.letter_spacing = activeText.letter_spacing == "" ? 0 : activeText.letter_spacing;
                        activeText.line_spacing = activeText.line_spacing == "" ? 0 : activeText.line_spacing;
                        activeText.angle = activeText.angle == "" ? 0 : activeText.angle;
                        activeText.z_index = activeText.z_index == "" ? 0 : activeText.z_index;

                        activeText.font_size = parseFloat(activeText.font_size);
                        activeText.alpha = parseFloat(activeText.alpha);
                        activeText.letter_spacing = parseFloat(activeText.letter_spacing);
                        activeText.line_spacing = parseFloat(activeText.line_spacing);
                        activeText.time_start = parseFloat(activeText.time_start);
                        activeText.shadow_alpha = parseFloat(activeText.shadow_alpha);
                        activeText.shadow_blur = parseInt(activeText.shadow_blur);
                        activeText.animation_type = parseInt(activeText.animation_type);
                        activeText.animation_duration = parseFloat(activeText.animation_duration);
                        activeText.angle = parseInt(activeText.angle);
                        activeText.z_index = parseInt(activeText.z_index);
                        activeText.time_end = activeText.time_end === "" ? "" : parseFloat(activeText.time_end);

                        activeText.text_brush_data = activeText.is_text_brush ? activeText.text_brush_data : [];

                        template.texts[_i5] = activeText;
                    }

                    for (var _i6 = 0; _i6 < self.template.objects.length; _i6++) {

                        var activeObj = template.objects[_i6];

                        activeObj.position_x = parseFloat(activeObj.position_x);
                        activeObj.position_y = parseFloat(activeObj.position_y);

                        activeObj.scale = parseFloat(activeObj.scale);
                        activeObj.alpha = parseFloat(activeObj.alpha);
                        activeObj.time_start = parseFloat(activeObj.time_start);
                        activeObj.animation_type = parseInt(activeObj.animation_type);
                        activeObj.animation_duration = parseFloat(activeObj.animation_duration);
                        activeObj.angle = activeObj.angle == "" ? 0 : parseInt(activeObj.angle);
                        activeObj.z_index = activeObj.z_index == "" ? 0 : parseInt(activeObj.z_index);
                        activeObj.time_end = activeObj.time_end === "" ? "" : parseFloat(activeObj.time_end);

                        delete activeObj.source;

                        template.objects[_i6] = activeObj;
                    }
                } else {
                    template.texts = [];
                    template.objects = [];
                }

                if (!template.is_copyrighted) {
                    template.song_insta = "";
                    template.song_tiktok = "";
                }

                template.release_date = template.release_date + ' ' + template.release_time + ':00';

                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this2.$hostname + '/admin/created/' + _this2.id + '/update', template, {
                    'headers': {
                        'Authorization': 'Bearer ' + _this2.token
                    }
                }).then(function (response) {
                    var notification = {
                        template: '<span><b>\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.waiting = false;

                    //                    self.$router.push('/templates');
                }).catch(function (error) {
                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;
                });
            }, 200);
        },
        remove: function remove() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$hostname + '/admin/created/' + this.id + '/delete', this.template, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {
                var notification = {
                    template: '<span><b>\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0431\u044B\u043B\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u043E</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/memories');
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data));

                self.template[data.file_type] = data.url;
                self.template[data.file_type + '_full'] = data.url_full;
                self.template[data.file_type + '_size'] = data.filesize;

                if (self.video) {
                    self.showPreview();
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        dragMouseDown: function dragMouseDown(event) {
            event.preventDefault();

            var path = event.composedPath ? event.composedPath() : event.path;
            var id = null;
            _.each(path, function (p) {
                if (p.className === 'draggable-container') {
                    id = p.id;
                }
            });

            if (!id) {
                return;
            }

            if (id.indexOf('o') > -1) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'object';

                this.object_positions[this.draggable_index].clientX = event.clientX;
                this.object_positions[this.draggable_index].clientY = event.clientY;

                document.onmousemove = this.objectDrag;
                document.onmouseup = this.closeDragObject;
            } else {
                this.draggable_index = id;
                this.draggable_type = 'text';

                this.positions[this.draggable_index].clientX = event.clientX;
                this.positions[this.draggable_index].clientY = event.clientY;

                document.onmousemove = this.textDrag;
                document.onmouseup = this.closeDragText;
            }
        },
        textDrag: function textDrag(event) {
            event.preventDefault();

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX;
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY;
            this.positions[this.draggable_index].clientX = event.clientX;
            this.positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer[this.draggable_index].style.top = this.$refs.draggableContainer[this.draggable_index].offsetTop - this.positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer[this.draggable_index].style.left = this.$refs.draggableContainer[this.draggable_index].offsetLeft - this.positions[this.draggable_index].movementX + 'px';

            var centerX = this.$refs.draggableContainer[this.draggable_index].offsetLeft + this.$refs.draggableContainer[this.draggable_index].clientWidth / 2;
            var centerY = this.$refs.draggableContainer[this.draggable_index].offsetTop + this.$refs.draggableContainer[this.draggable_index].clientHeight / 2;

            this.template.texts[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.texts[this.draggable_index].position_y = parseFloat((centerY / 640).toFixed(4));
        },
        closeDragText: function closeDragText() {
            document.onmouseup = null;
            document.onmousemove = null;

            this.draggable_index = null;

            return false;
        },

        objectDrag: function objectDrag(event) {
            event.preventDefault();

            this.object_positions[this.draggable_index].movementX = this.object_positions[this.draggable_index].clientX - event.clientX;
            this.object_positions[this.draggable_index].movementY = this.object_positions[this.draggable_index].clientY - event.clientY;
            this.object_positions[this.draggable_index].clientX = event.clientX;
            this.object_positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer2[this.draggable_index].style.top = this.$refs.draggableContainer2[this.draggable_index].offsetTop - this.object_positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer2[this.draggable_index].style.left = this.$refs.draggableContainer2[this.draggable_index].offsetLeft - this.object_positions[this.draggable_index].movementX + 'px';

            this.syncObjectModelFromElement(this.draggable_index);
        },
        closeDragObject: function closeDragObject() {
            document.onmouseup = null;
            document.onmousemove = null;

            this.draggable_index = null;

            return false;
        },
        renderCollagePart: function renderCollagePart(index) {
            var layout = index.split(';');

            if (index) {
                var category = layout[0].split('_')[0];
                var collageId = layout[0];
                var partId = parseInt(layout[1]);
                var collages = _.find(this.collages, function (c) {
                    return c.name === category;
                });
                var collage = _.find(collages.data, function (c) {
                    return c.id === collageId;
                });

                return this.renderCollage(collage, 0.7, partId - 1);
            }
        },
        renderCollage: function renderCollage(layout) {
            var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var partId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


            var palette = ["#FFDFBA", "#FFFFBA", "#BAFFC9", "#BAE1FF", "#D7C4F3", "#C1F0F6", "#FAD6A5", "#F7C5CC", "#C9E4DE"];

            var containerStyle = "position:relative;" + ('width:' + 108 * scale + 'px;height:' + 192 * scale + 'px;') + "background:#f7f7f7;overflow:hidden;" + ('border: 1px solid ' + (partId === null && this.previous_collage_id === layout.id ? 'red' : '#000') + ';') + "box-shadow:0 6px 20px rgba(0,0,0,.08);";

            var html = '<div style="' + containerStyle + '">';

            for (var i = 0; i < layout.frames.length; i++) {
                var f = layout.frames[i];

                var left = f.x * 108 * scale;
                var top = f.y * 192 * scale;
                var width = f.width * 108 * scale;
                var height = f.height * 192 * scale;

                var color = palette[i % palette.length];

                var radiusStyle = "0px";
                if (f.crop && f.crop.type === "roundedCorner") {
                    var v = f.crop.value;
                    if (v < 0) v = 0;
                    if (v > 1) v = 1;
                    radiusStyle = v * Math.min(width, height) / 2 + "px";
                }

                var frameStyle = "position:absolute;" + "left:" + left + "px;top:" + top + "px;" + "width:" + width + "px;height:" + height + "px;" + "background:" + color + ";" + "border-radius:" + radiusStyle + ";overflow:hidden;" + "display:flex;align-items:center;justify-content:center;" + "color:rgba(0,0,0,.5);" + "font:600 12px sans-serif;";

                var params = layout.id + ';' + (i + 1) + ';' + f.x + ';' + f.y + ';' + f.width + ';' + f.height;

                html += '\n                          <div\n                            data-params="' + params + '"\n                            class="collage-item-part ' + (partId === i ? 'diagonal-lines' : '') + '"\n                            style="' + frameStyle + '"\n                          >\n                            ' + (i + 1) + '\n                          </div>\n                        ';
            }

            html += "</div>";
            return html;
        }
    }
});

/***/ }),

/***/ "EW1A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-component"},[_c('div',{staticClass:"full-page section-image",attrs:{"data-color":"black"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-offset-3 col-md-6 ml-auto mr-auto form-login"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"card card-login"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"card-body",class:{ shake: _vm.loginError }},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Пароль"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-warning btn-wd",on:{"click":function($event){return _vm.login(_vm.username, _vm.password)}}},[_vm._v("Войти")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer ml-auto mr-auto"})])])])])]),_vm._v(" "),_c('div',{staticClass:"full-page-background",style:({ backgroundImage: 'url(' + _vm.splash + ')' })})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EZIe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_mixins_previewPage__ = __webpack_require__("LToN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__("M4fF");
var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1_src_mixins_previewPage__["a" /* default */]],
    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a
    },
    created: function created() {
        this.get();
    },
    data: function data() {
        return {
            data: [],
            activeVideo: "",
            waiting: false,
            categoryId: 998,
            categories: [],
            role: parseInt(localStorage.getItem('role')) || 0,
            // only admins have the save button, so only they are asked about unsaved order
            canSaveOrder: (parseInt(localStorage.getItem('role')) || 0) === 302,
            activeId: null,
            templateOrders: [],
            categoryOrderDirty: false,
            dragGuard: false,
            categoryDragGuard: false,
            showDev: true
        };
    },

    computed: {
        hasUnsavedOrder: function hasUnsavedOrder() {
            return this.templateOrders.length > 0 || this.categoryOrderDirty;
        },
        selectedCategory: function selectedCategory() {
            var categoryId = parseInt(this.categoryId, 10);
            return _.find(this.data, function (category) {
                return parseInt(category.id, 10) === categoryId;
            }) || null;
        },
        templatesCountLabel: function templatesCountLabel() {
            var count = this.visibleTemplates.length;
            return count + ' ' + this.pluralize(count, 'шаблон', 'шаблона', 'шаблонов');
        },
        visibleTemplates: {
            get: function get() {
                var category = this.selectedCategory;
                if (!category || !category.templates) {
                    return [];
                }
                if (this.showDev) {
                    return category.templates;
                }
                var self = this;
                return _.filter(category.templates, function (template) {
                    return !self.isDev(template.status);
                });
            },
            set: function set(templates) {
                var category = this.selectedCategory;
                if (!category) {
                    return;
                }
                if (this.showDev) {
                    category.templates = templates;
                    return;
                }
                var self = this;
                var queue = templates.slice();
                category.templates = _.map(category.templates, function (template) {
                    if (self.isDev(template.status)) {
                        return template;
                    }
                    return queue.length ? queue.shift() : template;
                });
            }
        }
    },
    methods: {
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            self.waiting = true;

            axios.get(this.$hostname + '/admin/templates/preview', {
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.waiting = false;
                self.templateOrders = [];
                self.categoryOrderDirty = false;
                self.data = response.data;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        save: function save() {
            var self = this;

            var token = localStorage.getItem('token');

            self.waiting = true;

            axios.post(this.$hostname + '/admin/templates/preview/resort', {
                categoryIds: this.categoryOrderDirty ? _.map(this.data, 'id') : [],
                templateOrders: this.templateOrders
            }, {
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function () {
                self.templateOrders = [];
                self.categoryOrderDirty = false;
                self.get();
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        onTemplatesDragStart: function onTemplatesDragStart() {
            this.dragGuard = true;
        },
        onTemplatesDragEnd: function onTemplatesDragEnd() {
            var _this = this;

            setTimeout(function () {
                _this.dragGuard = false;
            }, 150);
        },
        onCategoriesDragStart: function onCategoriesDragStart() {
            this.categoryDragGuard = true;
        },
        onCategoriesDragEnd: function onCategoriesDragEnd() {
            var _this2 = this;

            setTimeout(function () {
                _this2.categoryDragGuard = false;
            }, 150);
        },
        onCategoriesReorder: function onCategoriesReorder() {
            this.categoryOrderDirty = true;
        },
        isSelectedCategory: function isSelectedCategory(id) {
            return parseInt(id, 10) === parseInt(this.categoryId, 10);
        },
        pluralize: function pluralize(count, one, few, many) {
            var mod10 = Math.abs(count) % 10;
            var mod100 = Math.abs(count) % 100;

            if (mod100 > 10 && mod100 < 20) {
                return many;
            }

            if (mod10 === 1) {
                return one;
            }

            if (mod10 >= 2 && mod10 <= 4) {
                return few;
            }

            return many;
        },
        selectCategory: function selectCategory(id) {
            if (this.categoryDragGuard) {
                return;
            }
            this.categoryId = id;
        },
        onTemplatesReorder: function onTemplatesReorder(category) {
            if (!category || !category.templates) {
                return;
            }

            var categoryId = parseInt(category.id, 10);
            var ids = _.map(category.templates, 'id');
            this.templateOrders = _.filter(this.templateOrders, function (order) {
                return parseInt(order.categoryId, 10) !== categoryId;
            });
            this.templateOrders.push({
                categoryId: categoryId,
                ids: ids
            });
            this.syncOtherCategoryOrders(categoryId, ids);
        },
        syncOtherCategoryOrders: function syncOtherCategoryOrders(sourceCategoryId, orderedIds) {
            var subset = {};
            _.forEach(orderedIds, function (id) {
                subset[id] = true;
            });

            _.forEach(this.data, function (category) {
                if (parseInt(category.id, 10) === sourceCategoryId || !category.templates || !category.templates.length) {
                    return;
                }

                var byId = {};
                _.forEach(category.templates, function (template) {
                    byId[template.id] = template;
                });

                var queue = [];
                _.forEach(orderedIds, function (id) {
                    if (byId[id]) {
                        queue.push(byId[id]);
                    }
                });

                if (!queue.length) {
                    return;
                }

                category.templates = _.map(category.templates, function (template) {
                    if (!subset[template.id]) {
                        return template;
                    }
                    return queue.length ? queue.shift() : template;
                });
            });
        },
        getTemplateSrc: function getTemplateSrc(src) {
            return src;
        },
        getTemplateType: function getTemplateType() {
            return 'video/mp4';
        },
        isVideo: function isVideo(url) {
            return url && url.indexOf('.mp4') > -1;
        },
        isDev: function isDev(status) {
            return parseInt(status, 10) === 0;
        },
        isFree: function isFree(isPremium) {
            return parseInt(isPremium, 10) !== 1;
        },
        openVideo: function openVideo(src, id) {
            if (this.dragGuard) {
                return;
            }
            this.activeId = id;
            this.activeVideo = src;
        },
        openTemplate: function openTemplate(arg) {
            this.$router.push({
                name: 'edit-template',
                params: { id: this.activeId }
            });
        },
        closeVideo: function closeVideo() {
            this.activeId = null;
            this.activeVideo = "";
        }
    }
});

/***/ }),

/***/ "Eavv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_collection__ = __webpack_require__("v89g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_collection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_collection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _ = __webpack_require__("M4fF");
var axios = __webpack_require__("mtWM");
var moment = __webpack_require__("PJh5");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        var self = this;

        var token = localStorage.getItem('token');

        axios.get(this.$hostname + '/admin/categories/', {
            'params': {},
            'headers': {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (response) {
            self.loading = false;
            self.categories = response.data;
            localStorage.setItem('categories', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

            self.get();
        }).catch(function (error) {
            self.loading = false;
            console.log(error);
        });
    },
    data: function data() {
        return {
            columns: ['id', 'category', 'is_trending_music', 'preview_src_full', 'videos', 'duration', 'sort', 'use_count', 'status', ''],
            data: [],
            tags: [],
            role: parseInt(localStorage.getItem('role')) || 0,
            categoryId: localStorage.getItem('tt_category') ? localStorage.getItem('tt_category') : "",
            status: localStorage.getItem('tt_status') ? localStorage.getItem('tt_status') : "",
            isTrendy: localStorage.getItem('tt_is_trendy') ? localStorage.getItem('tt_is_trendy') : "",
            isCopyrighted: localStorage.getItem('tt_is_copyrighted') ? localStorage.getItem('tt_is_copyrighted') : "",
            isNew: localStorage.getItem('tt_is_new') ? localStorage.getItem('tt_is_new') : "",
            categories: [],
            filteredId: null,
            activeVideo: "",
            songId: null,
            limit: 10,
            sortBy: localStorage.getItem('tt_sort_by') ? localStorage.getItem('tt_sort_by') : "id",
            offset: parseInt(localStorage.getItem('tt_active_offset')) || 0,
            stats: {
                templatesCount: 0,
                freeTemplatesCount: 0,
                premiumTemplatesCount: 0
            },
            tag_ids: localStorage.getItem('tt_tag_ids') ? JSON.parse(localStorage.getItem('tt_tag_ids')) : null
        };
    },

    filters: {
        toEasyDate: function toEasyDate(value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY HH:mm');
            } else {
                return '';
            }
        },
        toShortText: function toShortText(value) {
            if (value) {
                return value.length > 10 ? value.substr(0, 10) + '...' : value.substr(0, 10);
            } else {
                return '';
            }
        }
    },
    methods: {
        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        isFree: function isFree(isPremium) {
            return parseInt(isPremium, 10) !== 1;
        },
        resetStatsCount: function resetStatsCount() {
            this.stats = {
                templatesCount: 0,
                freeTemplatesCount: 0,
                premiumTemplatesCount: 0,
                averageTemplateCount: 0,
                averageFreeCount: 0,
                averagePremiumCount: 0
            };
        },
        add: function add() {
            this.$router.push('/templates/create');
        },
        filter: function filter() {
            localStorage.setItem('tt_active_offset', "0");
            this.offset = 0;
            this.get();
        },
        edit: function edit(id) {
            if (this.role === 2) {
                return false;
            }
            //localStorage.setItem('w_last_opened_id', parseInt(id));
            this.$router.push({
                name: 'edit-template',
                params: { id: id }
            });
        },
        openNewTab: function openNewTab(id) {
            if (this.role === 2) {
                return false;
            }
            var routeData = this.$router.resolve({
                name: 'edit-template',
                params: { id: id }
            });

            window.open(routeData.href, '_blank');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            var categoryId = this.categoryId === null ? '' : this.categoryId;
            var status = this.status === null ? '' : this.status;
            var isTrendy = this.isTrendy === null ? '' : this.isTrendy;
            var isCopyrighted = this.isCopyrighted === null ? '' : this.isCopyrighted;
            var isNew = this.isNew === null ? '' : this.isNew;
            var filteredId = this.filteredId === null ? '' : this.filteredId;
            var songId = this.songId === null ? '' : this.songId;
            var fullTagIds = this.tag_ids === null ? '' : this.tag_ids;

            var tagIds = [];
            _.map(fullTagIds, function (t) {
                tagIds.push(t.id);
            });

            self.resetStatsCount();

            axios.get(this.$hostname + '/admin/templates', {
                'params': {
                    categoryId: categoryId,
                    status: status,
                    isTrendy: isTrendy,
                    isCopyrighted: isCopyrighted,
                    isNew: isNew,
                    limit: self.limit,
                    offset: self.offset,
                    filteredId: filteredId,
                    songName: songId,
                    tagIds: tagIds,
                    sortBy: self.sortBy
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                var data = response.data;

                self.data = data.templates;

                self.tags = data.tags;

                self.stats.templatesCount = data.templates_count;
                self.stats.premiumTemplatesCount = data.premium_count;
                self.stats.freeTemplatesCount = data.templates_count - data.premium_count;
            }).catch(function (error) {
                console.log(error);
            });
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('tt_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('tt_active_offset', parseInt(this.offset));
            }
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        },
        saveSort: function saveSort(name, value) {
            localStorage.setItem(name, value);
        },
        openVideo: function openVideo(src) {
            if (this.role === 2) {
                this.activeVideo = src;
            }
        },
        closeVideo: function closeVideo() {
            this.activeVideo = "";
        },
        addTag: function addTag(tags) {
            this.tag_ids = tags;
            localStorage.setItem('tt_tag_ids', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tag_ids));
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('templates') < 1) {
            localStorage.setItem('tt_active_offset', "0");
            localStorage.setItem('tt_category', "");
            localStorage.setItem('tt_status', "");
            localStorage.setItem('tt_is_trendy', "");
            localStorage.setItem('tt_is_new', "");
            localStorage.setItem('tt_is_copyrighted', "");
            localStorage.setItem('tt_tag_ids', null);
            localStorage.setItem('tt_sort_by', "id");
        }
        next();
    }
});

/***/ }),

/***/ "Ejjt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('frcat_status') ? localStorage.getItem('frcat_status') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/frame/categories/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/frames/categories', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
                localStorage.setItem('frames-categories', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-frames-category',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('frame/categories') < 1) {
            localStorage.setItem('frcat_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "En8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[(_vm.object)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-usage",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.openUsage.apply(null, arguments)}}},[_vm._v("\n                            Где используется этот стикер\n                        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.is_premium),expression:"object.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.object.is_premium)?_vm._i(_vm.object.is_premium,null)>-1:(_vm.object.is_premium)},on:{"change":function($event){var $$a=_vm.object.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.object, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.object, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.object, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.category_id),expression:"object.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return (c.id !== 999)?_c('option',{domProps:{"value":c.id}},[_vm._v("\n                                            "+_vm._s(c.name)+"\n                                        ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Доступно для редактирования")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.no_color),expression:"object.no_color"}],staticClass:"form-control",attrs:{"id":"status-control","disabled":!_vm.isSvgSrc(_vm.object.src),"aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "no_color", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Доступно")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Не доступно")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Src","placeholder":""},model:{value:(_vm.object.src),callback:function ($$v) {_vm.$set(_vm.object, "src", $$v)},expression:"object.src"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.object.sort),callback:function ($$v) {_vm.$set(_vm.object, "sort", $$v)},expression:"object.sort"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Стикер: "),(_vm.object.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.object.src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]):(_vm.object.src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.object.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"device-block device1",attrs:{"src":_vm.object.src_full},on:{"click":function($event){$event.preventDefault();return _vm.openResource(_vm.object.src_full)}}}),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":".gif,.svg,.png,.jpg,.jpeg,.webp,image/gif,image/svg+xml,image/png,image/jpeg,image/webp"},on:{"change":function($event){return _vm.uploadFile($event, 'object_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"btn btn-danger btn-fill float-left btn-save",on:{"click":function($event){return _vm.remove()}}},[_vm._v("\n                                Удалить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.sort || !_vm.object.category_id || !_vm.object.src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)]):_vm._e()]),_vm._v(" "),(_vm.show_usage_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeUsage}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Где используется этот стикер")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-close-modal",attrs:{"type":"button"},on:{"click":_vm.closeUsage}},[_vm._v("\n                        Закрыть\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.usage_loading)?_c('div',{staticClass:"usage-loader"}):_vm._e(),_vm._v(" "),(!_vm.usage_loading && !_vm.usage.templates.length && !_vm.usage.carousels.length)?_c('div',{staticClass:"usage-empty"},[_vm._v("\n                        Этот стикер нигде не используется\n                    ")]):_vm._e(),_vm._v(" "),(!_vm.usage_loading && _vm.usage.templates.length)?_c('div',[_c('h5',{staticClass:"usage-section-title"},[_vm._v("Шаблоны "),_c('span',[_vm._v(_vm._s(_vm.usage.templates.length))])]),_vm._v(" "),_c('div',{staticClass:"usage-grid"},_vm._l((_vm.usage.templates),function(item){return _c('div',{key:'t-' + item.id,staticClass:"usage-card",on:{"click":function($event){return _vm.openTemplate(item.id)}}},[_c('div',{staticClass:"usage-preview"},[(_vm.isVideo(item.preview_src_full))?_c('video',{attrs:{"muted":"","loop":"","autoplay":"","playsinline":"","src":item.preview_src_full},domProps:{"muted":true}}):(item.preview_src_full)?_c('img',{attrs:{"src":item.preview_src_full,"alt":""}}):_c('div',{staticClass:"usage-preview-empty"},[_vm._v("нет превью")])]),_vm._v(" "),_c('div',{staticClass:"usage-meta"},[_c('div',{staticClass:"usage-id"},[_vm._v("#"+_vm._s(item.id))]),_vm._v(" "),_c('div',{staticClass:"usage-category"},[_vm._v(_vm._s(item.category))]),_vm._v(" "),(item.release_date)?_c('div',{staticClass:"usage-status text-primary"},[_vm._v("Запланировано")]):(item.status === 1)?_c('div',{staticClass:"usage-status text-success"},[_vm._v("Опубликовано")]):_c('div',{staticClass:"usage-status text-warning"},[_vm._v("Ожидает")])])])}),0)]):_vm._e(),_vm._v(" "),(!_vm.usage_loading && _vm.usage.carousels.length)?_c('div',[_c('h5',{staticClass:"usage-section-title"},[_vm._v("Карусели "),_c('span',[_vm._v(_vm._s(_vm.usage.carousels.length))])]),_vm._v(" "),_c('div',{staticClass:"usage-grid"},_vm._l((_vm.usage.carousels),function(item){return _c('div',{key:'c-' + item.id,staticClass:"usage-card",on:{"click":function($event){return _vm.openCarousel(item.id)}}},[_c('div',{staticClass:"usage-preview",class:{ 'is-square': item.ratio == 4 }},[(item.preview_src_full)?_c('img',{attrs:{"src":item.preview_src_full,"alt":""}}):_c('div',{staticClass:"usage-preview-empty"},[_vm._v("нет превью")])]),_vm._v(" "),_c('div',{staticClass:"usage-meta"},[_c('div',{staticClass:"usage-id"},[_vm._v("#"+_vm._s(item.id))]),_vm._v(" "),_c('div',{staticClass:"usage-category"},[_vm._v(_vm._s(item.category))]),_vm._v(" "),(item.status === 1)?_c('div',{staticClass:"usage-status text-success"},[_vm._v("Активен")]):_c('div',{staticClass:"usage-status text-warning"},[_vm._v("Не активен")]),_vm._v(" "),(item.parts && item.parts.length)?_c('div',{staticClass:"usage-parts"},[_vm._v("\n                                        слайды: "+_vm._s(item.parts.join(', '))+"\n                                    ")]):_vm._e()])])}),0)]):_vm._e()])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EuQ/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EvFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.status),expression:"category.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Формат")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.ratio),expression:"category.ratio"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "ratio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("4:5")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("1:1")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.category.sort),callback:function ($$v) {_vm.$set(_vm.category, "sort", $$v)},expression:"category.sort"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.category.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FU+P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.album.status),expression:"album.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.album, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.album.sort),callback:function ($$v) {_vm.$set(_vm.album, "sort", $$v)},expression:"album.sort"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.album.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.album)?_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fzuf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G0RX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('drop-down',[_c('template',{slot:"title"},[_c('i',{staticClass:"fa fa-globe"}),_vm._v(" "),_c('b',{staticClass:"caret"}),_vm._v(" "),_c('span',{staticClass:"notification"},[_vm._v("5 Notifications")])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 1")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 2")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 3")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 4")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Another notification")])],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('drop-down',{attrs:{"title":"Dropdown"}},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Action")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Another action")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Something")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Something else here")]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Separated link")])]),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_c('i',{staticClass:"nc-icon nc-zoom-split hidden-lg-up"}),_vm._v(" "),_c('span',{staticClass:"d-lg-none"},[_vm._v("Search")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#pablo"}},[_c('span',{staticClass:"no-icon"},[_vm._v("Выйти")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G5Vj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostsCategories_vue__ = __webpack_require__("pUmS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd557e4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostsCategories_vue__ = __webpack_require__("9RUc");
function injectStyle (ssrContext) {
  __webpack_require__("4TJk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd557e4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostsCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd557e4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostsCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GUFv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GhUe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GlkW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gxik":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Категории фреймов")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('gr_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'name')?_c('span',[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активна")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активна")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HINT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HrH9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Альбомы")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('a_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить альбом\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'image_src_full')?_c('span',[_vm._v("фон")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):(column === 'tracks_number')?_c('span',[_vm._v("количество треков")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'name')?_c('span',[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === 'image_src_full')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[_c('div',{staticClass:"device-block device1",style:({ backgroundImage: 'url(' + item[column] + ')' })})]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активен")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активен")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hxpz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.data)?_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Календарь публикаций")]),_vm._v(" "),_c('FullCalendar',{ref:"fullCalendar",attrs:{"options":_vm.calendarOptions}})],1):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.activeVideo)?_c('div',{staticClass:"video-bg",on:{"click":function($event){$event.preventDefault();return _vm.closeVideo()}}}):_vm._e(),_vm._v(" "),(_vm.activeVideo)?_c('div',{attrs:{"id":"player"}},[_c('video',{staticStyle:{"max-width":"100%"},attrs:{"onloadstart":"this.volume=0.1","controls":"","autoplay":"","id":"video_player"}},[_c('source',{attrs:{"src":_vm.activeVideo}})]),_vm._v(" "),(_vm.role === 302)?_c('button',{staticClass:"btn btn-fill btn-close btn-default",class:{ 'active-state': _vm.activeVideo },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.openTemplate()}}},[_vm._v("\n            Редактировать\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-close",class:{ 'active-state': _vm.activeVideo },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.closeVideo()}}},[_vm._v("\n            Закрыть\n        ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I94V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"preview-page"},[_c('div',{staticClass:"preview-layout"},[_c('div',{staticClass:"card preview-sidebar"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('label',{staticClass:"preview-dev-toggle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showDev),expression:"showDev"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showDev)?_vm._i(_vm.showDev,null)>-1:(_vm.showDev)},on:{"change":function($event){var $$a=_vm.showDev,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showDev=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showDev=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showDev=$$c}}}}),_vm._v("\n                        Показать dev шаблоны\n                    ")]),_vm._v(" "),_c('div',{staticClass:"preview-sidebar-title"},[_vm._v("Категории")]),_vm._v(" "),_c('div',{staticClass:"preview-sidebar-list"},_vm._l((_vm.data),function(element){return _c('div',{key:element.id,staticClass:"category-list",class:{ active: _vm.isSelectedCategory(element.id) },on:{"click":function($event){return _vm.selectCategory(element.id)}}},[_c('span',{staticClass:"category-list-name"},[_vm._v(_vm._s(element.name))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"card preview-main"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-area"},[(_vm.selectedCategory)?_c('div',[_c('p',{staticClass:"category-name"},[_vm._v("\n                                "+_vm._s(_vm.selectedCategory.name)+"\n                                "),_c('span',{staticClass:"category-count"},[_vm._v("("+_vm._s(_vm.visiblePosts.length)+")")])]),_vm._v(" "),(_vm.visiblePosts.length > 0)?_c('div',{key:_vm.selectedCategory.id,staticClass:"templates-grid"},[_c('draggable',{on:{"start":_vm.onPostsDragStart,"end":_vm.onPostsDragEnd,"change":function($event){return _vm.onPostsReorder(_vm.selectedCategory)}},model:{value:(_vm.visiblePosts),callback:function ($$v) {_vm.visiblePosts=$$v},expression:"visiblePosts"}},_vm._l((_vm.visiblePosts),function(post){return _c('div',{key:post.id,staticClass:"inline-div",on:{"click":function($event){$event.preventDefault();_vm.openPreview(_vm.previewMedia(post), post.id)}}},[_c('div',{staticClass:"card-template",class:_vm.cardRatioClass(post.ratio),style:(_vm.previewImage(post)
                                                ? { 'background-image': 'url(' + _vm.previewImage(post) + ')' }
                                                : {})},[(_vm.cardVideoSrc(post))?_c('video',{key:'v-' + post.id,attrs:{"muted":"","loop":"","autoplay":"","playsinline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.cardVideoSrc(post),"type":_vm.getTemplateType()}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"template-badge is-id"},[_vm._v("ID "+_vm._s(post.id))]),_vm._v(" "),(_vm.isDev(post.status))?_c('span',{staticClass:"template-badge is-dev"},[_vm._v("DEV")]):_vm._e(),_vm._v(" "),(_vm.isStories(post.ratio))?_c('span',{staticClass:"template-badge is-stories"},[_vm._v("сторис")]):_vm._e(),_vm._v(" "),(_vm.isFree(post.is_premium))?_c('span',{staticClass:"template-badge is-free"},[_vm._v("free")]):_vm._e()])])}),0)],1):_c('p',{staticClass:"preview-empty"},[_vm._v(_vm._s(_vm.emptyListLabel))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"preview-main-footer"},[(_vm.role === 302)?_c('button',{staticClass:"btn btn-success btn-fill btn-save",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[_vm._v("\n                                Сохранить\n                            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.activePreview)?_c('div',{staticClass:"video-bg",on:{"click":function($event){$event.preventDefault();return _vm.closePreview()}}}):_vm._e(),_vm._v(" "),(_vm.activePreview)?_c('div',{attrs:{"id":"player"}},[(_vm.isVideo(_vm.activePreview))?_c('video',{staticStyle:{"max-width":"100%"},attrs:{"onloadstart":"this.volume=0.1","controls":"","autoplay":"","id":"video_player"}},[_c('source',{attrs:{"src":_vm.activePreview}})]):_c('img',{staticClass:"preview-lightbox-image",attrs:{"src":_vm.activePreview,"alt":""}}),_vm._v(" "),(_vm.role === 302)?_c('button',{staticClass:"btn btn-fill btn-close btn-default",class:{ 'active-state': _vm.activePreview },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.openPost()}}},[_vm._v("\n                                Редактировать\n                            ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-close",class:{ 'active-state': _vm.activePreview },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.closePreview()}}},[_vm._v("\n                                Закрыть\n                            ")])]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IA/J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IRFK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IZnu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("ERMs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47a07e7b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("VH3l");
function injectStyle (ssrContext) {
  __webpack_require__("1mif")
  __webpack_require__("TJGk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47a07e7b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47a07e7b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IiAE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ImUk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iqy4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Пуш-рассылки")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('pp_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("В процессе")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Отправлено")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Создать рассылку\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'id')?_c('span',[_vm._v("id")]):(column === 'project_id')?_c('span',{staticStyle:{"width":"82px","display":"block"}},[_vm._v("проект")]):(column === 'locale')?_c('span',[_vm._v("локали")]):(column === 'title')?_c('span',[_vm._v("тайтл")]):(column === 'text')?_c('span',[_vm._v("текст")]):(column === 'push_code')?_c('span',[_vm._v("код пуша")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'created_at')?_c('span',[_vm._v("дата создания")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === '')?_c('span',[_c('img',{staticClass:"remove-icon",attrs:{"src":"/static/img/delete.png"},on:{"click":function($event){return _vm.removeTask(item['id'])}}})]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"st text-warning"},[_vm._v("В процессе")]):_vm._e(),_vm._v(" "),(item[column] === 2)?_c('span',{staticClass:"st text-success"},[_vm._v("Отправлено")]):_vm._e()]):(column === 'project_id')?_c('span',[(item[column] === 2)?_c('span',{staticClass:"text-info"},[_vm._v("My Feed")]):(item[column] === 9)?_c('span',{staticClass:"text-info"},[_vm._v("Muse")]):(item[column] === 10)?_c('span',{staticClass:"text-info"},[_vm._v("Aura")]):(item[column] === 11)?_c('span',{staticClass:"text-info"},[_vm._v("Swipe")]):(item[column] === 12)?_c('span',{staticClass:"text-info"},[_vm._v("Wallpapers")]):(item[column] === 13)?_c('span',{staticClass:"text-info"},[_vm._v("Nola")]):_vm._e()]):(column === 'created_at')?_c('span',[_vm._v("\n                                            "+_vm._s(_vm._f("toEasyDate")(item[column]))+"\n                                          ")]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IuHN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J6wH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",attrs:{"tag":"li"},nativeOn:{"click":function($event){return _vm.hideSidebar.apply(null, arguments)}}},'component',_vm.$attrs,false),[_c('a',{staticClass:"nav-link"},[_vm._t("default",function(){return [(_vm.link.icon)?_c('i',{class:_vm.link.icon}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JFZj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("vxzy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_522871a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("y13M");
function injectStyle (ssrContext) {
  __webpack_require__("tTNm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-522871a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_522871a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JM/w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JRly":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JWN9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateTag',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            tag: {
                status: 0,
                templates: 0,
                translations: [],
                sort: 1
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/tags');
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var tag = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tag));

            tag.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/tags/create', tag, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0422\u0435\u0433 \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/tags');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }
    }
});

/***/ }),

/***/ "JlLP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Посты")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryId),expression:"categoryId"}],staticClass:"form-control",attrs:{"id":"category-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('posts_category', _vm.categoryId)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('posts_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Формат")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ratio),expression:"ratio"}],staticClass:"form-control",attrs:{"id":"ratio-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ratio=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('posts_ratio', _vm.ratio)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("4:5")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("4:3")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("9:16")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("1:1")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Поиск по ID","placeholder":""},model:{value:(_vm.filteredId),callback:function ($$v) {_vm.filteredId=$$v},expression:"filteredId"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'category')?_c('span',[_vm._v("категория")]):(column === 'is_trendy')?_c('span',[_vm._v("тренд")]):(column === 'ratio')?_c('span',[_vm._v("формат")]):(column === 'preview_src_full')?_c('span',[_vm._v("обложка")]):(column === 'status')?_c('span',[_vm._v("статус")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'preview_src_full')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[_c('img',{staticClass:"device-block device1",class:{
                                                     'device1-tall': item.ratio == 3,
                                                     'device1-wide': item.ratio == 2,
                                                     'device1-square': item.ratio == 4
                                                 },attrs:{"src":("" + (item[column]))}})]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")]),_vm._v(" "),_c('img',{staticClass:"new-tab",attrs:{"src":"/static/img/new-tab.png"},on:{"click":function($event){return _vm.openNewTab(item['id'])}}}),_vm._v(" "),_c('img',{staticClass:"new-tab",attrs:{"src":"/static/img/copy.png"},on:{"click":function($event){return _vm.duplicate(item['id'])}}})]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активен")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активен")]):_vm._e()]):(column === 'is_trendy')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-purple"},[_vm._v("Тренд")]):_vm._e()]):(column === 'ratio')?_c('span',[(item[column] == 1)?_c('span',[_vm._v("4:5")]):(item[column] == 2)?_c('span',[_vm._v("4:3")]):(item[column] == 3)?_c('span',[_vm._v("9:16")]):(item[column] == 4)?_c('span',[_vm._v("1:1")]):_c('span',[_vm._v(_vm._s(item[column]))])]):(column === 'category_id')?_c('span',[(item[column] === 1)?_c('span',[_vm._v("Пост")]):_vm._e(),_vm._v(" "),(item[column] === 2)?_c('span',[_vm._v("Карусель")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JniN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__("qg9l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61b563a7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__("1bPL");
function injectStyle (ssrContext) {
  __webpack_require__("zrYM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61b563a7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61b563a7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jqgy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_mixins_previewBackLink__ = __webpack_require__("dHGc");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");



/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_5_src_mixins_previewBackLink__["a" /* default */]],
    name: 'EditAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            object: null,
            originalStatus: null,
            categories: [],
            show_usage_modal: false,
            usage_loading: false,
            usage: {
                templates: [],
                carousels: []
            }
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.getCategories();
    },
    computed: {
        graphicsUrl: function graphicsUrl() {
            return this.$graphicsUrl;
        }
    },
    methods: {
        // back to the preview if the page was opened from it, otherwise to the list
        goBack: function goBack() {
            this.leaveTo('/graphics');
        },
        isSvgSrc: function isSvgSrc(src) {
            if (!src || typeof src !== 'string') {
                return false;
            }

            return (/\.svg$/i.test(src.split('?')[0])
            );
        },
        isVideo: function isVideo(url) {
            return url && url.indexOf('.mp4') > -1;
        },
        pluralize: function pluralize(n, one, few, many) {
            var num = Math.abs(parseInt(n, 10)) || 0;
            var mod100 = num % 100;
            var mod10 = num % 10;

            if (mod100 > 10 && mod100 < 20) {
                return many;
            }

            if (mod10 === 1) {
                return one;
            }

            if (mod10 >= 2 && mod10 <= 4) {
                return few;
            }

            return many;
        },
        usageCountText: function usageCountText(templates, carousels) {
            return templates + ' ' + this.pluralize(templates, 'шаблоне', 'шаблонах', 'шаблонах') + ' \u0438 ' + carousels + ' ' + this.pluralize(carousels, 'карусели', 'каруселях', 'каруселях');
        },
        updatedCountText: function updatedCountText(templates, carousels) {
            return '\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u043E: ' + templates + ' ' + this.pluralize(templates, 'шаблон', 'шаблона', 'шаблонов') + ', ' + carousels + ' ' + this.pluralize(carousels, 'карусель', 'карусели', 'каруселей');
        },
        openUsage: function openUsage() {
            var self = this;

            self.show_usage_modal = true;
            self.usage_loading = true;
            self.usage = {
                templates: [],
                carousels: []
            };

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/graphics/' + this.id + '/usage', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {
                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data)) || {};
                self.usage = {
                    templates: data.templates || [],
                    carousels: data.carousels || []
                };
                self.usage_loading = false;
            }).catch(function (error) {
                self.usage_loading = false;
                self.show_usage_modal = false;

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        closeUsage: function closeUsage() {
            this.show_usage_modal = false;
        },
        openTemplate: function openTemplate(id) {
            var routeData = this.$router.resolve({
                name: 'edit-template',
                params: { id: id }
            });

            window.open(routeData.href, '_blank');
        },
        openCarousel: function openCarousel(id) {
            var routeData = this.$router.resolve({
                name: 'edit-post',
                params: { id: id }
            });

            window.open(routeData.href, '_blank');
        },
        getCategories: function getCategories() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/graphics/categories', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.categories = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data));

                self.get(self.id);
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/graphics/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.object = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data));
                self.originalStatus = self.object.status;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        fetchUsageCounts: function fetchUsageCounts() {
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/graphics/' + this.id + '/usage', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {
                var usage = response.data || {};

                return {
                    templates: (usage.templates || []).length,
                    carousels: (usage.carousels || []).length
                };
            });
        },
        confirmIfUsed: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(usedActionText, emptyConfirmText) {
                var counts;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.fetchUsageCounts();

                            case 2:
                                counts = _context.sent;

                                if (!(counts.templates > 0 || counts.carousels > 0)) {
                                    _context.next = 5;
                                    break;
                                }

                                return _context.abrupt('return', confirm('\u042D\u0442\u043E\u0442 \u0441\u0442\u0438\u043A\u0435\u0440 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0432 ' + this.usageCountText(counts.templates, counts.carousels) + '. ' + usedActionText));

                            case 5:
                                if (!emptyConfirmText) {
                                    _context.next = 7;
                                    break;
                                }

                                return _context.abrupt('return', confirm(emptyConfirmText));

                            case 7:
                                return _context.abrupt('return', true);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function confirmIfUsed(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return confirmIfUsed;
        }(),
        notifyError: function notifyError(message) {
            var notification = {
                template: '<span><b>' + message + '</b></span>'
            };

            this.$notifications.notify({
                component: notification,
                icon: 'nc-icon nc-simple-remove',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'danger'
            });
        },
        save: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var self, statusDeactivated, confirmed, graphic;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                self = this;
                                statusDeactivated = parseInt(this.originalStatus, 10) === 1 && parseInt(this.object.status, 10) === 0;

                                if (!statusDeactivated) {
                                    _context2.next = 18;
                                    break;
                                }

                                self.waiting = true;

                                _context2.prev = 4;
                                _context2.next = 7;
                                return this.confirmIfUsed('При сохранении этот объект пропадет из этих шаблонов. Продолжить?');

                            case 7:
                                confirmed = _context2.sent;

                                self.waiting = false;

                                if (confirmed) {
                                    _context2.next = 11;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 11:
                                _context2.next = 18;
                                break;

                            case 13:
                                _context2.prev = 13;
                                _context2.t0 = _context2['catch'](4);

                                self.waiting = false;
                                this.notifyError(_context2.t0.response && _context2.t0.response.data && _context2.t0.response.data.message ? _context2.t0.response.data.message : 'Не удалось проверить использования стикера');
                                return _context2.abrupt('return');

                            case 18:
                                graphic = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.object));


                                self.waiting = true;

                                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$hostname + '/admin/graphics/' + this.id + '/update', graphic, {
                                    'headers': {
                                        'Authorization': 'Bearer ' + this.token
                                    }
                                }).then(function (response) {

                                    var data = response.data || {};
                                    self.originalStatus = graphic.status;

                                    if (data.src) {
                                        self.object.src = data.src;
                                        self.object.src_full = self.graphicsUrl + data.src;
                                    }

                                    var message = 'Стикер был успешно обновлён';

                                    if (data.usages) {
                                        message += '. ' + self.updatedCountText(data.usages.templates, data.usages.carousels);
                                    }

                                    var notification = {
                                        template: '<span><b>' + message + '</b></span>'
                                    };

                                    self.$notifications.notify({
                                        component: notification,
                                        icon: 'nc-icon nc-explore-2',
                                        horizontalAlign: 'right',
                                        verticalAlign: 'top',
                                        type: 'info'
                                    });

                                    self.waiting = false;
                                }).catch(function (error) {
                                    var notification = {
                                        template: '<span><b>' + error.response.data.message + '</b></span>'
                                    };

                                    self.$notifications.notify({
                                        component: notification,
                                        icon: 'nc-icon nc-simple-remove',
                                        horizontalAlign: 'right',
                                        verticalAlign: 'top',
                                        type: 'danger'
                                    });

                                    self.waiting = false;
                                });

                            case 21:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[4, 13]]);
            }));

            function save() {
                return _ref2.apply(this, arguments);
            }

            return save;
        }(),
        remove: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var self, confirmed;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                self = this;


                                self.waiting = true;

                                _context3.prev = 2;
                                _context3.next = 5;
                                return this.confirmIfUsed('При удалении этот объект пропадет из этих шаблонов. Продолжить?', 'Подтверждение удаления стикера');

                            case 5:
                                confirmed = _context3.sent;

                                self.waiting = false;

                                if (confirmed) {
                                    _context3.next = 9;
                                    break;
                                }

                                return _context3.abrupt('return');

                            case 9:
                                _context3.next = 16;
                                break;

                            case 11:
                                _context3.prev = 11;
                                _context3.t0 = _context3['catch'](2);

                                self.waiting = false;
                                this.notifyError(_context3.t0.response && _context3.t0.response.data && _context3.t0.response.data.message ? _context3.t0.response.data.message : 'Не удалось проверить использования стикера');
                                return _context3.abrupt('return');

                            case 16:

                                self.waiting = true;

                                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/graphics/' + this.id + '/remove', {
                                    'headers': {
                                        'Authorization': 'Bearer ' + this.token
                                    }
                                }).then(function (response) {

                                    var notification = {
                                        template: '<span><b>\u0421\u0442\u0438\u043A\u0435\u0440 \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0451\u043D</b></span>'
                                    };

                                    self.$notifications.notify({
                                        component: notification,
                                        icon: 'nc-icon nc-explore-2',
                                        horizontalAlign: 'right',
                                        verticalAlign: 'top',
                                        type: 'info'
                                    });

                                    self.waiting = false;

                                    self.leaveTo('/graphics');
                                }).catch(function (error) {
                                    var notification = {
                                        template: '<span><b>' + error.response.data.message + '</b></span>'
                                    };

                                    self.$notifications.notify({
                                        component: notification,
                                        icon: 'nc-icon nc-simple-remove',
                                        horizontalAlign: 'right',
                                        verticalAlign: 'top',
                                        type: 'danger'
                                    });

                                    self.waiting = false;
                                });

                            case 18:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[2, 11]]);
            }));

            function remove() {
                return _ref3.apply(this, arguments);
            }

            return remove;
        }(),
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();
            var file = event.target.files[0];

            self.waiting = true;

            if (file && !self.isSvgSrc(file.name)) {
                self.object.no_color = 1;
            }

            formData.append('file', file);

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data));

                self.object.src = data.url;
                self.object.src_full = data.url_full;
                self.object.src_size = data.filesize;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        openResource: function openResource(url) {
            window.open(url, "_blank");
        }

    }
});

/***/ }),

/***/ "K7qa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KGJ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KR/T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'templates', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('tags_status') ? localStorage.getItem('tags_status') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/tags/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/tags/', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
                localStorage.setItem('tags', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-tag',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('tags') < 1) {
            localStorage.setItem('tags_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "KUyq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("qnwY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_191c2142_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("Ptqe");
function injectStyle (ssrContext) {
  __webpack_require__("JRly")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-191c2142"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_191c2142_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KVG2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("CPmk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f676940_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("9WEk");
function injectStyle (ssrContext) {
  __webpack_require__("U4tR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f676940"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f676940_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ky1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.object.sort),callback:function ($$v) {_vm.$set(_vm.object, "sort", $$v)},expression:"object.sort"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L8vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                            Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.is_premium),expression:"object.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.object.is_premium)?_vm._i(_vm.object.is_premium,null)>-1:(_vm.object.is_premium)},on:{"change":function($event){var $$a=_vm.object.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.object, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.object, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.object, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.category_id),expression:"object.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return (c.id !== 999)?_c('option',{domProps:{"value":c.id}},[_vm._v("\n                                                "+_vm._s(c.name)+"\n                                            ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип наложения layout")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.type),expression:"object.type"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Над фреймом")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Под фреймом")])])]),_vm._v(" "),_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Фрейм: "),(_vm.object.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.object.src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]):(_vm.object.src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.object.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),(_vm.object.src_full)?_c('img',{staticClass:"device-block device1",attrs:{"id":"preview-img","src":_vm.object.src_full},on:{"click":function($event){$event.preventDefault();return _vm.openResource(_vm.object.src_full)}}}):_vm._e(),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'object_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.category_id || !_vm.object.src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                    Сохранить\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"btn btn-delete btn-danger btn-fill float-right btn-save",on:{"click":function($event){return _vm.remove()}}},[_vm._v("\n                                    Удалить\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),(_vm.object.src_full)?_c('div',{staticClass:"col-md-8"},[_c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6",staticStyle:{"background":"#C9D5DF"}},[_c('div',{staticClass:"img-wrap"},[_c('img',{ref:"img",staticClass:"frame",attrs:{"id":"frame-img","src":_vm.object.src_full,"alt":""}}),_vm._v(" "),_vm._l((_vm.object.params),function(pa,index){return (pa.w && pa.h)?_c('div',{staticClass:"frame-layouts",attrs:{"id":("pa" + index)},domProps:{"innerHTML":_vm._s(_vm.layout_html(index))},on:{"click":function($event){return _vm.selectLayout(index)}}}):_vm._e()})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Layouts\n                                ")]),_vm._v(" "),_c('form',[(_vm.object)?_c('div',{staticClass:"texts-buttons"},[_vm._l((_vm.object.layouts),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_layout },attrs:{"type":"button"},on:{"click":function($event){return _vm.selectLayout(index)}}},[_vm._v("Layout "+_vm._s(index + 1)+"\n                                        ")])}),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill",attrs:{"type":"button"},on:{"click":function($event){return _vm.addLayout()}}},[_vm._v("+\n                                        ")])],2):_vm._e(),_vm._v(" "),_vm._l((_vm.object.params),function(rawData,index){return _c('div',{staticClass:"row frame-params",class:{ 'active' : index === _vm.active_layout }},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Ширина фрейма в Figma","placeholder":""},model:{value:(rawData.original_w),callback:function ($$v) {_vm.$set(rawData, "original_w", $$v)},expression:"rawData.original_w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Высота фрейма в Figma","placeholder":""},model:{value:(rawData.original_h),callback:function ($$v) {_vm.$set(rawData, "original_h", $$v)},expression:"rawData.original_h"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Ширина редактируемой области","placeholder":""},model:{value:(rawData.w),callback:function ($$v) {_vm.$set(rawData, "w", $$v)},expression:"rawData.w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Высота редактируемой области","placeholder":""},model:{value:(rawData.h),callback:function ($$v) {_vm.$set(rawData, "h", $$v)},expression:"rawData.h"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ сверху","placeholder":""},model:{value:(rawData.y),callback:function ($$v) {_vm.$set(rawData, "y", $$v)},expression:"rawData.y"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ слева","placeholder":""},model:{value:(rawData.x),callback:function ($$v) {_vm.$set(rawData, "x", $$v)},expression:"rawData.x"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Радиус верхний левый","placeholder":""},model:{value:(rawData.b_tl),callback:function ($$v) {_vm.$set(rawData, "b_tl", $$v)},expression:"rawData.b_tl"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус верхний правый","placeholder":""},model:{value:(rawData.b_tr),callback:function ($$v) {_vm.$set(rawData, "b_tr", $$v)},expression:"rawData.b_tr"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус нижний левый","placeholder":""},model:{value:(rawData.b_bl),callback:function ($$v) {_vm.$set(rawData, "b_bl", $$v)},expression:"rawData.b_bl"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус нижний правый","placeholder":""},model:{value:(rawData.b_br),callback:function ($$v) {_vm.$set(rawData, "b_br", $$v)},expression:"rawData.b_br"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeLayout(_vm.active_layout)}}},[_vm._v("Удалить layout\n                                            ")])],1)])})],2)])])])],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LToN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__unsavedLeaveGuard__ = __webpack_require__("WSC3");


// Common parts of the preview pages (drag-and-drop order of categories and items).
// A page provides a `hasUnsavedOrder` computed; `canSaveOrder` is false for users without the save button.
/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__unsavedLeaveGuard__["a" /* default */]],
    data: function data() {
        return {
            canSaveOrder: true
        };
    },

    methods: {
        hasUnsavedChanges: function hasUnsavedChanges() {
            return this.canSaveOrder && !!this.hasUnsavedOrder;
        },
        isCategoryInactive: function isCategoryInactive(status) {
            // the app shows only categories with status = 1
            return parseInt(status, 10) !== 1;
        }
    }
});

/***/ }),

/***/ "Lehl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_mixins_previewPage__ = __webpack_require__("LToN");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__("M4fF");
var axios = __webpack_require__("mtWM");



// Scroll position of the preview, kept while an item is open in the edit page,
// so "back" returns to the same place. Lives in memory only.
var pendingScroll = null;

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2_src_mixins_previewPage__["a" /* default */]],
    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
    },
    props: {
        // api prefix: /admin/{resource}/preview
        resource: {
            type: String,
            required: true
        },
        editRoute: {
            type: String,
            required: true
        },
        emptyLabel: {
            type: String,
            default: 'Пусто'
        }
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        // the edit page opened from the preview carries its address in ?back
        if (!pendingScroll || pendingScroll.path !== to.fullPath || from.query.back !== to.fullPath) {
            pendingScroll = null;
        }
        next();
    },
    created: function created() {
        this.scrollToRestore = pendingScroll ? pendingScroll.top : null;
        pendingScroll = null;
        this.get();
    },
    data: function data() {
        return {
            data: [],
            waiting: false,
            categoryId: parseInt(this.$route.query.category, 10) || null,
            itemOrders: [],
            categoryOrderDirty: false,
            dragGuard: false,
            categoryDragGuard: false,
            showInactive: true
        };
    },

    computed: {
        selectedCategory: function selectedCategory() {
            var categoryId = parseInt(this.categoryId, 10);
            return _.find(this.data, function (category) {
                return parseInt(category.id, 10) === categoryId;
            }) || null;
        },
        hasUnsavedOrder: function hasUnsavedOrder() {
            return this.itemOrders.length > 0 || this.categoryOrderDirty;
        },
        visibleItems: {
            get: function get() {
                var category = this.selectedCategory;
                if (!category || !category.items) {
                    return [];
                }
                if (this.showInactive) {
                    return category.items;
                }
                var self = this;
                return _.filter(category.items, function (item) {
                    return !self.isInactive(item.status);
                });
            },
            set: function set(items) {
                var category = this.selectedCategory;
                if (!category) {
                    return;
                }
                if (this.showInactive) {
                    category.items = items;
                    return;
                }
                var self = this;
                var queue = items.slice();
                category.items = _.map(category.items, function (item) {
                    if (self.isInactive(item.status)) {
                        return item;
                    }
                    return queue.length ? queue.shift() : item;
                });
            }
        }
    },
    watch: {
        categoryId: function categoryId(id) {
            this.loadItems(this.selectedCategory);
            if (!id || parseInt(this.$route.query.category, 10) === parseInt(id, 10)) {
                return;
            }
            this.$router.replace({ query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query, { category: String(id) }) });
        }
    },
    methods: {
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            self.waiting = true;

            axios.get(this.$hostname + '/admin/' + this.resource + '/preview', {
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.waiting = false;
                self.itemOrders = [];
                self.categoryOrderDirty = false;
                // items are loaded per category when it is opened
                self.data = _.map(response.data || [], function (category) {
                    category.items = null;
                    return category;
                });
                var selectedExists = _.some(self.data, function (category) {
                    return parseInt(category.id, 10) === parseInt(self.categoryId, 10);
                });
                if (!selectedExists && self.data.length) {
                    self.categoryId = self.data[0].id;
                } else {
                    self.loadItems(self.selectedCategory);
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        save: function save() {
            var self = this;

            var token = localStorage.getItem('token');

            self.waiting = true;

            axios.post(this.$hostname + '/admin/' + this.resource + '/preview/resort', {
                categoryIds: this.categoryOrderDirty ? _.map(this.data, 'id') : [],
                itemOrders: this.itemOrders
            }, {
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function () {
                self.itemOrders = [];
                self.categoryOrderDirty = false;
                self.get();
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        onItemsDragStart: function onItemsDragStart() {
            this.dragGuard = true;
        },
        onItemsDragEnd: function onItemsDragEnd() {
            var _this = this;

            setTimeout(function () {
                _this.dragGuard = false;
            }, 150);
        },
        onCategoriesDragStart: function onCategoriesDragStart() {
            this.categoryDragGuard = true;
        },
        onCategoriesDragEnd: function onCategoriesDragEnd() {
            var _this2 = this;

            setTimeout(function () {
                _this2.categoryDragGuard = false;
            }, 150);
        },
        onCategoriesReorder: function onCategoriesReorder() {
            this.categoryOrderDirty = true;
        },
        isSelectedCategory: function isSelectedCategory(id) {
            return parseInt(id, 10) === parseInt(this.categoryId, 10);
        },
        selectCategory: function selectCategory(id) {
            if (this.categoryDragGuard) {
                return;
            }
            this.categoryId = id;
        },
        loadItems: function loadItems(category) {
            if (!category || category.items || category.itemsLoading) {
                return;
            }
            var self = this;

            var token = localStorage.getItem('token');

            category.itemsLoading = true;
            self.waiting = true;

            axios.get(this.$hostname + '/admin/' + this.resource + '/preview/items', {
                'params': {
                    categoryId: category.id
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                category.itemsLoading = false;
                category.items = response.data || [];
                self.waiting = false;
                self.restoreScroll();
            }).catch(function (error) {
                category.itemsLoading = false;
                self.waiting = false;
                console.log(error);
            });
        },
        scrollContainer: function scrollContainer() {
            return document.querySelector('.main-panel');
        },
        restoreScroll: function restoreScroll() {
            var _this3 = this;

            var top = this.scrollToRestore;
            this.scrollToRestore = null;
            if (top === null || top === undefined) {
                return;
            }
            this.$nextTick(function () {
                var container = _this3.scrollContainer();
                if (container) {
                    container.scrollTop = top;
                }
            });
        },
        onItemsReorder: function onItemsReorder(category) {
            if (!category || !category.items) {
                return;
            }

            var categoryId = parseInt(category.id, 10);
            this.itemOrders = _.filter(this.itemOrders, function (order) {
                return parseInt(order.categoryId, 10) !== categoryId;
            });
            this.itemOrders.push({
                categoryId: categoryId,
                ids: _.map(category.items, 'id')
            });
        },
        isInactive: function isInactive(status) {
            return parseInt(status, 10) === 0;
        },
        openItem: function openItem(id) {
            if (this.dragGuard) {
                return;
            }
            var container = this.scrollContainer();
            pendingScroll = { path: this.$route.fullPath, top: container ? container.scrollTop : 0 };
            this.$router.push({
                name: this.editRoute,
                params: { id: id },
                query: { back: this.$route.fullPath }
            });
        }
    }
});

/***/ }),

/***/ "M+AW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            track: null,
            albums: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.getAlbums();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/templates');
        },
        getAlbums: function getAlbums() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/albums', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.albums = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.get(self.id);
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/tracks/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.track = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(self.locales, function (l) {

                    var tModel = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(self.album.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var track = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.track));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/tracks/' + this.id + '/update', track, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0422\u0440\u0435\u043A \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/tracks');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            var needID3 = type === 'src';

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type,
                    needID3: needID3
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.track[data.file_type] = data.url;
                self.track[data.file_type + '_full'] = data.url_full;
                self.track[data.file_type + '_size'] = data.filesize;

                if (needID3 && data.duration) {
                    data.duration = Math.floor(data.duration);

                    var minutes = Math.floor(data.duration / 60).toString();
                    var seconds = data.duration % 60 < 10 ? '0' + (data.duration % 60).toString() : (data.duration % 60).toString();
                    self.track.duration = minutes + ':' + seconds;
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }

    }
});

/***/ }),

/***/ "M2Iw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.object.sort),callback:function ($$v) {_vm.$set(_vm.object, "sort", $$v)},expression:"object.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Цвет фона (начинается с #)","placeholder":""},model:{value:(_vm.object.color),callback:function ($$v) {_vm.$set(_vm.object, "color", $$v)},expression:"object.color"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54ea3888_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("z6Gw");
function injectStyle (ssrContext) {
  __webpack_require__("tN2X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54ea3888_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MDnB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        DropDown: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Dropdown_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "MEcK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Frames_vue__ = __webpack_require__("abEj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0591582f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Frames_vue__ = __webpack_require__("tO0E");
function injectStyle (ssrContext) {
  __webpack_require__("WUb1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0591582f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Frames_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0591582f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Frames_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MFnH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"li",staticClass:"dropdown nav-item",class:{show: _vm.isOpen},attrs:{"aria-haspopup":"true","aria-expanded":_vm.isOpen},on:{"click":_vm.toggleDropDown}},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"data-toggle":"dropdown"}},[_vm._t("title",function(){return [_c('i',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"no-icon"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('b',{staticClass:"caret"})]})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"dropdown-menu"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MWUD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Шаблоны")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row stats-block mt10"},[_c('span',[_vm._v("Количество шаблонов: "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.stats.templatesCount))]),_vm._v(" ("),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.stats.premiumTemplatesCount))]),_vm._v(" - premium, "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.stats.freeTemplatesCount))]),_vm._v(" - free) ")])]),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryId),expression:"categoryId"}],staticClass:"form-control",attrs:{"id":"category-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('tt_category', _vm.categoryId)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('tt_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Опубликовано")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ожидает")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Запланировано")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Copyrighted")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.isCopyrighted),expression:"isCopyrighted"}],staticClass:"form-control",attrs:{"id":"trendy-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.isCopyrighted=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('tt_is_copyrighted', _vm.isCopyrighted)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Free")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Copyrighted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("New")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.isNew),expression:"isNew"}],staticClass:"form-control",attrs:{"id":"trendy-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.isNew=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('tt_is_new', _vm.isNew)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("New")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Теги")]),_vm._v(" "),_c('vue-multiselect',{attrs:{"searchable":false,"label":"name","track-by":"id","options":_vm.tags,"multiple":true,"taggable":true},on:{"input":_vm.addTag},model:{value:(_vm.tag_ids),callback:function ($$v) {_vm.tag_ids=$$v},expression:"tag_ids"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Поиск по ID","placeholder":""},model:{value:(_vm.filteredId),callback:function ($$v) {_vm.filteredId=$$v},expression:"filteredId"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Поиск по песне","placeholder":""},model:{value:(_vm.songId),callback:function ($$v) {_vm.songId=$$v},expression:"songId"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),(_vm.role === 302)?_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить шаблон\n                                ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Сортировка")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortBy),expression:"sortBy"}],staticClass:"form-control",attrs:{"id":"sort-by","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sortBy=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveSort('tt_sort_by', _vm.sortBy)}]}},[_c('option',{attrs:{"value":"id","selected":""}},[_vm._v("По умолчанию")]),_vm._v(" "),_c('option',{attrs:{"value":"use_count"}},[_vm._v("По популярности")]),_vm._v(">\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Сортировать\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                            След.\n                        ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                            Пред.\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'preview_src_full')?_c('span',[_vm._v("превью")]):(column === 'counter')?_c('span',[_vm._v("экспорт")]):(column === 'category')?_c('span',[_vm._v("категория")]):(column === 'is_trending_music')?_c('span',[_vm._v("тренд")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'videos')?_c('span',[_vm._v("количество видео")]):(column === 'duration')?_c('span',[_vm._v("длительность, сек.")]):(column === 'use_count')?_c('span',[_vm._v("использования")]):(column === 'release_date')?_c('span',[_vm._v("дата публикации")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'preview_src_full')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[(!_vm.isVideo(item[column]))?_c('div',{staticClass:"device-block device1",style:({ backgroundImage: 'url(' + item[column] + ')' })},[(_vm.isFree(item['is_premium']))?_c('span',{staticClass:"free-badge"},[_vm._v("free")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isVideo(item[column]))?_c('div',{staticClass:"device-block device1",on:{"click":function($event){$event.preventDefault();return _vm.openVideo(item['src_full'])}}},[_c('video',{key:item[column],staticStyle:{"max-width":"100%","cursor":"pointer"},attrs:{"muted":"","loop":"","autoplay":"","playsinline":"","id":"video_player"},domProps:{"muted":true}},[_c('source',{attrs:{"src":item[column]}})]),_vm._v(" "),(_vm.isFree(item['is_premium']))?_c('span',{staticClass:"free-badge"},[_vm._v("free")]):_vm._e()]):_vm._e()]):(column === 'color'  && item[column])?_c('span',{staticClass:"color-block",style:({ backgroundColor: '#' + item[column] })}):(column === 'color_group' && item[column])?_c('span',{staticClass:"color-block",style:({ backgroundColor: '#' + item[column] })}):(column === '')?_c('span',[(_vm.role === 302)?_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"new-tab",attrs:{"src":"/static/img/new-tab.png"},on:{"click":function($event){return _vm.openNewTab(item['id'])}}})]):(column === 'status')?_c('span',[(item['release_date'])?_c('span',{staticClass:"font-weight-bold text-primary"},[_vm._v("Запланировано")]):(item[column] === 1)?_c('span',{staticClass:"font-weight-bold text-success"},[_vm._v("Опубликовано")]):(item[column] === 0)?_c('span',{staticClass:"font-weight-bold text-warning"},[_vm._v("Ожидает")]):_vm._e()]):(column === 'is_trending_music')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-purple"},[_vm._v("Тренд")]):_vm._e()]):(column === 'release_date')?_c('span',{},[_vm._v("\n                                            "+_vm._s(_vm._f("toEasyDate")(item[column]))+"\n                                        ")]):(column === 'duration')?_c('span',{},[_c('span',[_vm._v(_vm._s(item[column]))])]):(column === 'type')?_c('span',[(item[column] === 2)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/live.png"}}):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.activeVideo)?_c('div',{staticClass:"video-bg",on:{"click":function($event){$event.preventDefault();return _vm.closeVideo()}}}):_vm._e(),_vm._v(" "),(_vm.activeVideo)?_c('div',{attrs:{"id":"player"}},[_c('video',{staticStyle:{"max-width":"100%"},attrs:{"onloadstart":"this.volume=0.1","controls":"","autoplay":"","id":"video_player"}},[_c('source',{attrs:{"src":_vm.activeVideo}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-close",class:{ 'active-state': _vm.activeVideo },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.closeVideo()}}},[_vm._v("\n                    Закрыть\n                ")])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MWya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'sort', 'color', 'status', ''],
            data: [],
            status: localStorage.getItem('ecat_status') ? localStorage.getItem('ecat_status') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/effect/categories/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/effects/categories', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
                localStorage.setItem('effects-categories', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-effects-category',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('effect/categories') < 1) {
            localStorage.setItem('ecat_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3ce4880_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("NTbq");
function injectStyle (ssrContext) {
  __webpack_require__("Qf8J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3ce4880_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarLink_vue__ = __webpack_require__("7SdG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        SidebarLink: __WEBPACK_IMPORTED_MODULE_0__SidebarLink_vue__["a" /* default */]
    },
    props: {
        title: {
            type: String,
            default: 'MUSE'
        },
        backgroundColor: {
            type: String,
            default: 'black',
            validator: function validator(value) {
                var acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black'];
                return acceptedValues.indexOf(value) !== -1;
            }
        },
        backgroundImage: {
            type: String,
            default: '/static/img/muse1.jpg'
        },
        activeColor: {
            type: String,
            default: 'success',
            validator: function validator(value) {
                var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
                return acceptedValues.indexOf(value) !== -1;
            }
        },
        sidebarLinks: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        autoClose: {
            type: Boolean,
            default: true
        }
    },
    provide: function provide() {
        return {
            autoClose: this.autoClose
        };
    },

    computed: {
        sidebarStyle: function sidebarStyle() {
            return {
                backgroundImage: 'url(' + this.backgroundImage + ')'
            };
        }
    }
});

/***/ }),

/***/ "NAs0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logs_vue__ = __webpack_require__("oMSU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49bb861e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logs_vue__ = __webpack_require__("eJV/");
function injectStyle (ssrContext) {
  __webpack_require__("miwB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49bb861e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49bb861e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__light_bootstrap_main__ = __webpack_require__("28ys");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes_routes__ = __webpack_require__("T1vP");





// LightBootstrap plugin


// router setup

// plugin setup
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4__light_bootstrap_main__["a" /* default */]);

// configure router
var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_5__routes_routes__["a" /* default */], // short for routes: routes
    linkActiveClass: 'nav-item active',
    mode: 'hash'
});

function nextFactory(context, middleware, index) {
    var subsequentMiddleware = middleware[index];

    if (!subsequentMiddleware) {
        return context.next;
    }

    return function () {
        context.next.apply(context, arguments);

        var nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, context, { next: nextMiddleware }));
    };
}

router.beforeEach(function (to, from, next) {
    if (to.meta.middleware) {
        var middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

        var context = {
            from: from,
            next: next,
            router: router,
            to: to
        };

        var nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, context, { next: nextMiddleware }));
    }

    return next();
});

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$hostname = "https://templates.bigrowth.io";
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$storeVersion = 11;
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$endVersion = 10.5;
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$graphicsUrl = 'https://muse.fra1.digitaloceanspaces.com/graphics/';
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$effectsUrl = 'https://muse.fra1.digitaloceanspaces.com/effects/';
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$fontsUrl = 'https://muse.fra1.digitaloceanspaces.com/fonts/';
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$framesUrl = 'https://muse.fra1.digitaloceanspaces.com/frames/';

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
    el: '#app',
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_3__App_vue__["a" /* default */]);
    },
    router: router
});

/***/ }),

/***/ "NOA/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NSrd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
        this.getCategories();
    },
    data: function data() {
        return {
            columns: ['id', 'category', 'name', 'status', ''],
            categoryId: localStorage.getItem('fonts_category') ? localStorage.getItem('fonts_category') : "",
            token: localStorage.getItem('token'),
            data: [],
            categories: [],
            limit: 200,
            offset: parseInt(localStorage.getItem('fonts_offset')) || 0,
            status: localStorage.getItem('fonts_status') ? localStorage.getItem('fonts_status') : "",
            loading: false,
            filteredName: null
        };
    },

    methods: {
        getCategories: function getCategories() {
            var self = this;

            axios.get(this.$hostname + '/admin/fonts/categories', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.categories = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/fonts/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');
            var categoryId = this.categoryId === null ? '' : this.categoryId;
            var filteredName = this.filteredName === null ? '' : this.filteredName;

            //this.loading = true;

            axios.get(this.$hostname + '/admin/fonts/', {
                'params': {
                    status: this.status,
                    limit: this.limit,
                    offset: this.offset,
                    categoryId: categoryId,
                    filteredName: filteredName
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-font',
                params: { id: id }
            });
        },
        openNewTab: function openNewTab(id) {
            if (this.role === 2) {
                return false;
            }
            var routeData = this.$router.resolve({
                name: 'edit-font',
                params: { id: id }
            });

            window.open(routeData.href, '_blank');
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('fonts_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('fonts_offset', parseInt(this.offset));
            }
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('fonts') < 1) {
            localStorage.setItem('fonts_status', "");
            localStorage.setItem('fonts_offset', "");
            localStorage.setItem('fonts_category', "");
        }
        next();
    }
});

/***/ }),

/***/ "NTbq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            with\n            "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n            bigrowth team.\n        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NWP3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("blLA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273fa118_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("DbLt");
function injectStyle (ssrContext) {
  __webpack_require__("/ANq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-273fa118"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273fa118_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ned/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("5VL1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d8ab0f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("dP4F");
function injectStyle (ssrContext) {
  __webpack_require__("rXY7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05d8ab0f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d8ab0f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O6yf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.status),expression:"category.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Формат")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.ratio),expression:"category.ratio"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "ratio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Обычный")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Горизонтальный (16:9, 5:1 и тд)")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.category.sort),callback:function ($$v) {_vm.$set(_vm.category, "sort", $$v)},expression:"category.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество шаблонов в категории","placeholder":"","readonly":""},model:{value:(_vm.category.templates),callback:function ($$v) {_vm.$set(_vm.category, "templates", $$v)},expression:"category.templates"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.category.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O9iy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tags_vue__ = __webpack_require__("KR/T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75da16b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tags_vue__ = __webpack_require__("bXML");
function injectStyle (ssrContext) {
  __webpack_require__("GUFv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75da16b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75da16b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OVJ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("3R5Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f28bbf2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("w4xd");
function injectStyle (ssrContext) {
  __webpack_require__("lChS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f28bbf2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f28bbf2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OjML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditPostCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            category: null,
            locales: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/post/categories');
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/posts/categories/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.category = data.category;
                self.locales = data.locales;

                _.map(self.locales, function (l) {

                    var tModel = _.find(self.category.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var category = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.category));

            category.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/posts/categories/' + this.id + '/update', category, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }

    }
});

/***/ }),

/***/ "OmYT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc32231e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("YuFu");
function injectStyle (ssrContext) {
  __webpack_require__("ufGv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc32231e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OprI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("TiXa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_176063a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("T9aZ");
function injectStyle (ssrContext) {
  __webpack_require__("yUUj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-176063a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_176063a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OrYA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tracks_vue__ = __webpack_require__("dePQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be81c218_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tracks_vue__ = __webpack_require__("hGmM");
function injectStyle (ssrContext) {
  __webpack_require__("YUca")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-be81c218"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tracks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be81c218_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tracks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P+tE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// The editor's layers bar (ref "layersBar") and canvas preview stick to the top of the screen while scrolling down.
// The bar's height changes as layers are added, so the preview's sticky offset follows it.
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            layersBarHeight: 0
        };
    },
    mounted: function mounted() {
        this.observeLayersBar();
    },
    updated: function updated() {
        this.observeLayersBar();
    },
    beforeDestroy: function beforeDestroy() {
        if (this.layersBarObserver) {
            this.layersBarObserver.disconnect();
        }
    },

    methods: {
        observeLayersBar: function observeLayersBar() {
            var _this = this;

            var bar = this.$refs.layersBar;
            if (bar === this.observedLayersBar || typeof ResizeObserver === 'undefined') {
                return;
            }
            if (!this.layersBarObserver) {
                this.layersBarObserver = new ResizeObserver(function () {
                    _this.layersBarHeight = _this.observedLayersBar ? _this.observedLayersBar.offsetHeight : 0;
                });
            }
            this.layersBarObserver.disconnect();
            this.observedLayersBar = bar;
            if (bar) {
                this.layersBarObserver.observe(bar);
            } else {
                this.layersBarHeight = 0;
            }
        }
    }
});

/***/ }),

/***/ "P/+h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Memories")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('ctt_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Опубликовано")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ожидает")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Copyrighted")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.isCopyrighted),expression:"isCopyrighted"}],staticClass:"form-control",attrs:{"id":"trendy-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.isCopyrighted=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('ctt_is_copyrighted', _vm.isCopyrighted)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Free")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Copyrighted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("New")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.isNew),expression:"isNew"}],staticClass:"form-control",attrs:{"id":"trendy-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.isNew=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('ctt_is_new', _vm.isNew)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("New")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),(_vm.role === 302)?_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить шаблон\n                                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'preview_src_full')?_c('span',[_vm._v("превью")]):(column === 'counter')?_c('span',[_vm._v("экспорт")]):(column === 'category')?_c('span',[_vm._v("категория")]):(column === 'push_type')?_c('span',[_vm._v("тип")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'videos')?_c('span',[_vm._v("количество видео")]):(column === 'duration')?_c('span',[_vm._v("длительность, сек.")]):(column === 'release_date')?_c('span',[_vm._v("дата публикации")]):(column === 'is_premium')?_c('span',[_vm._v("премиум")]):(column === 'is_trendy')?_c('span',[_vm._v("популярное")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'preview_src_full')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[(!_vm.isVideo(item[column]))?_c('div',{staticClass:"device-block device1",style:({ backgroundImage: 'url(' + item[column] + ')' })}):_vm._e(),_vm._v(" "),(_vm.isVideo(item[column]))?_c('div',{staticClass:"device-block device1"},[_c('video',{key:item[column],staticStyle:{"max-width":"100%","cursor":"pointer"},attrs:{"muted":"","loop":"","autoplay":"","playsinline":"","id":"video_player"},domProps:{"muted":true}},[_c('source',{attrs:{"src":item[column]}})])]):_vm._e()]):(column === 'color'  && item[column])?_c('span',{staticClass:"color-block",style:({ backgroundColor: '#' + item[column] })}):(column === 'color_group' && item[column])?_c('span',{staticClass:"color-block",style:({ backgroundColor: '#' + item[column] })}):(column === 'name')?_c('span',[(_vm.role === 302)?_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))]):_vm._e()]):(column === '')?_c('span',[(_vm.role === 302)?_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")]):_vm._e()]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Опубликовано")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Ожидает")]):_vm._e()]):(column === 'push_type')?_c('span',[(item[column] !== 0)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/push.png"}}):_vm._e()]):(column === 'release_date')?_c('span',{},[_vm._v("\n                                            "+_vm._s(_vm._f("toEasyDate")(item[column]))+"\n                                        ")]):(column === 'duration')?_c('span',{},[_c('span',[_vm._v(_vm._s(item[column]))])]):(column === 'is_premium')?_c('span',[(item[column] === 1)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/premium.png"}}):_vm._e()]):(column === 'is_trendy')?_c('span',{staticClass:"emodji"},[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("🖤")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"}):_vm._e()]):(column === 'type')?_c('span',[(item[column] === 2)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/live.png"}}):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P827":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Finance_vue__ = __webpack_require__("Vg8q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e01317ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Finance_vue__ = __webpack_require__("7XHD");
function injectStyle (ssrContext) {
  __webpack_require__("e3EN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e01317ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Finance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e01317ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Finance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P9to":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Стикеры")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryId),expression:"categoryId"}],staticClass:"form-control",attrs:{"id":"category-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('gr_category', _vm.categoryId)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('gr_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Поиск по ID","placeholder":""},model:{value:(_vm.filteredId),callback:function ($$v) {_vm.filteredId=$$v},expression:"filteredId"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Поиск по src","placeholder":""},model:{value:(_vm.filteredSrc),callback:function ($$v) {_vm.filteredSrc=$$v},expression:"filteredSrc"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить стикер\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'category')?_c('span',[_vm._v("категория")]):(column === 'src_full')?_c('span',[_vm._v("стикер")]):(column === 'no_color')?_c('span',[_vm._v("доступно для редактирования")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'src')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[_c('img',{staticClass:"device-block device1",attrs:{"src":("" + _vm.graphicsUrl + (item[column]))}})]):(column === 'no_color')?_c('span',[(item[column] !== 1)?_c('img',{staticClass:"no-color",attrs:{"src":"/static/img/ok.png"}}):_vm._e()]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")]),_vm._v(" "),_c('img',{staticClass:"new-tab",attrs:{"src":"/static/img/new-tab.png"},on:{"click":function($event){return _vm.openNewTab(item['id'])}}})]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активен")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активен")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PAcX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("TRiL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b35028a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("8QNM");
function injectStyle (ssrContext) {
  __webpack_require__("V+6M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b35028a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b35028a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PBKA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Login',
    data: function data() {
        return {
            categories: [],
            username: 'admin',
            password: '',
            loginError: false,
            //splash: '/static/img/backgrounds/' + Math.floor((Math.random() * (5 - 1) + 1)).toString() + '.jpg'
            splash: '/static/img/backgrounds/3.jpg'
        };
    },

    created: function created() {
        if (localStorage.getItem('token')) {
            this.$router.push('/templates');
        }
        document.getElementsByTagName("html")[0].style.height = "100vh";
    },
    methods: {
        login: function login(_login, password) {
            var self = this;
            self.loginError = false;

            axios.post(this.$hostname + '/admin/auth', {
                login: _login,
                password: password
            }).then(function (response) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('role', parseInt(response.data.role));
                localStorage.setItem('new-auth-2', "0811");

                self.$router.push('/templates');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.loginError = true;

                // self.$notifications.notify(
                //     {
                //         component: notification,
                //         icon: 'nc-icon nc-simple-remove',
                //         horizontalAlign: 'right',
                //         verticalAlign: 'top',
                //         type: 'danger'
                //     })
            });
        }
    }
});

/***/ }),

/***/ "PWOe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TABS = [{ name: 'preview-templates', label: 'Шаблоны', admin: false }, { name: 'preview-carousels', label: 'Карусели', admin: true }, { name: 'preview-stories', label: 'Сторис', admin: true }, { name: 'preview-graphics', label: 'Стикеры', admin: true }, { name: 'preview-frames', label: 'Фреймы', admin: true }];

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            role: parseInt(localStorage.getItem('role')) || 0
        };
    },

    computed: {
        tabs: function tabs() {
            var isAdmin = this.role === 302;
            return TABS.filter(function (tab) {
                return isAdmin || !tab.admin;
            });
        }
    }
});

/***/ }),

/***/ "PfAX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[(_vm.album)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.album.status),expression:"album.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.album, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.album.sort),callback:function ($$v) {_vm.$set(_vm.album, "sort", $$v)},expression:"album.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество треков в альбоме","placeholder":"","readonly":""},model:{value:(_vm.album.tracks_number),callback:function ($$v) {_vm.$set(_vm.album, "tracks_number", $$v)},expression:"album.tracks_number"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Фон: "),(_vm.album.image_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.album.image_src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.album.image_src_size)+"Mb")]):(_vm.album.image_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.album.image_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.album.image_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.album.image_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.album.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.album)?_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pfth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'templates', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('c_status') ? localStorage.getItem('c_status') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/categories/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/categories/', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
                localStorage.setItem('categories', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-category',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('categories') < 1) {
            localStorage.setItem('c_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "Ptqe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.category_id),expression:"object.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return (c.id !== 999)?_c('option',{domProps:{"value":c.id}},[_vm._v("\n                                            "+_vm._s(c.name)+"\n                                        ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип контента")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.type),expression:"object.type"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Категория")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("По свойству")])])]),_vm._v(" "),(_vm.object.type == 2)?_c('fg-input',{attrs:{"type":"text","label":"Свойство","placeholder":""},model:{value:(_vm.object.params.by_property),callback:function ($$v) {_vm.$set(_vm.object.params, "by_property", $$v)},expression:"object.params.by_property"}}):_vm._e(),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке).\n                                          <br>Discover = <b>100</b>; Created by AI = <b>80</b>; Reels = <b>50</b>; TikTok = <b>40</b>;","placeholder":""},model:{value:(_vm.object.sort),callback:function ($$v) {_vm.$set(_vm.object, "sort", $$v)},expression:"object.sort"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.sort || !_vm.object.type || (!_vm.object.category_id && !_vm.object.params.by_property)},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QDyf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'card'
});

/***/ }),

/***/ "QQSj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.album.status),expression:"album.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.album, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.album.sort),callback:function ($$v) {_vm.$set(_vm.album, "sort", $$v)},expression:"album.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество треков в альбоме","placeholder":"","readonly":""},model:{value:(_vm.album.tracks_number),callback:function ($$v) {_vm.$set(_vm.album, "tracks_number", $$v)},expression:"album.tracks_number"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Фон: "),(_vm.album.image_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.album.image_src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.album.image_src_size)+"Mb")]):(_vm.album.image_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.album.image_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.album.image_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.album.image_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.album.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.album)?_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qf8J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qkg6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'l-table',
    props: {
        columns: Array,
        data: Array
    },
    methods: {
        hasValue: function hasValue(item, column) {
            return item[column.toLowerCase()] !== 'undefined';
        },
        itemValue: function itemValue(item, column) {
            return item[column.toLowerCase()];
        }
    }
});

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cfc0341_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("2zcV");
function injectStyle (ssrContext) {
  __webpack_require__("fPBy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cfc0341"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cfc0341_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rfjl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewHub_vue__ = __webpack_require__("PWOe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b4ff3b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewHub_vue__ = __webpack_require__("hz6b");
function injectStyle (ssrContext) {
  __webpack_require__("YsF+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31b4ff3b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewHub_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b4ff3b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewHub_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rfq/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SRNb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.object.sort),callback:function ($$v) {_vm.$set(_vm.object, "sort", $$v)},expression:"object.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество объектов в категории","placeholder":"","readonly":""},model:{value:(_vm.object.object_count),callback:function ($$v) {_vm.$set(_vm.object, "object_count", $$v)},expression:"object.object_count"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Sczw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SeyF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateEffect',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            object: {
                status: 0,
                category_id: 0,
                name: null,
                src: null,
                src_full: null,
                preview_src: null,
                preview_src_full: null,
                is_premium: 0,
                sort: 1,
                params: {
                    mode: 0,
                    opacity: 1,
                    max_opacity: null
                }
            },
            categories: []
        };
    },

    created: function created() {
        this.getCategories();
    },
    computed: {
        graphicsUrl: function graphicsUrl() {
            return this.$graphicsUrl;
        }
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/effects');
        },
        getCategories: function getCategories() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/effects/categories', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {
                self.categories = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var object = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.object));
            object.params.mode = parseInt(object.params.mode);
            object.params.opacity = parseFloat(object.params.opacity);
            object.params.max_opacity = parseFloat(object.params.max_opacity);

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/effects/create', object, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u042D\u0444\u0444\u0435\u043A\u0442 \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                //self.$router.push('/effects');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.object[type] = data.url;
                self.object[type + '_full'] = data.url_full;
                self.object[type + '_size'] = data.filesize;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        openResource: function openResource(url) {
            window.open(url, "_blank");
        }
    }
});

/***/ }),

/***/ "SvCM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.object.sort),callback:function ($$v) {_vm.$set(_vm.object, "sort", $$v)},expression:"object.sort"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Login_vue__ = __webpack_require__("4pBi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Categories_vue__ = __webpack_require__("+iwA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Category_Create_vue__ = __webpack_require__("OprI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Category_Edit_vue__ = __webpack_require__("ndI3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Templates_vue__ = __webpack_require__("AtX6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Template_Create_vue__ = __webpack_require__("x//Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Template_Edit_vue__ = __webpack_require__("DUIh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Memories_vue__ = __webpack_require__("lnxJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Memories_Create_vue__ = __webpack_require__("/8N7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Memories_Edit_vue__ = __webpack_require__("IZnu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Tags_vue__ = __webpack_require__("O9iy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Tag_Create_vue__ = __webpack_require__("/nKp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Tag_Edit_vue__ = __webpack_require__("UMcj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Tabs_vue__ = __webpack_require__("1D72");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Tab_Create_vue__ = __webpack_require__("JFZj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Tab_Edit_vue__ = __webpack_require__("KUyq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Albums_vue__ = __webpack_require__("7mcY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Albums_Create_vue__ = __webpack_require__("ZDeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Albums_Edit_vue__ = __webpack_require__("wR3j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Tracks_vue__ = __webpack_require__("OrYA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Tracks_Create_vue__ = __webpack_require__("NWP3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Tracks_Edit_vue__ = __webpack_require__("lroX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Reports_vue__ = __webpack_require__("JniN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Reports_Create_vue__ = __webpack_require__("DuvD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_PreviewHub_vue__ = __webpack_require__("Rfjl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Preview_vue__ = __webpack_require__("2R7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_PostsPreview_vue__ = __webpack_require__("2cU8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_PostsPreviewNola_vue__ = __webpack_require__("/ERI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Icons_vue__ = __webpack_require__("U7xI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_Logs_vue__ = __webpack_require__("NAs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_Finance_vue__ = __webpack_require__("P827");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_Push_vue__ = __webpack_require__("okzn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Push_Create_vue__ = __webpack_require__("eKw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_components_Dashboard_Views_Finance_Create_vue__ = __webpack_require__("hyCC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_components_Dashboard_Views_Finance_Edit_vue__ = __webpack_require__("PAcX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_components_Dashboard_Views_Calendar_vue__ = __webpack_require__("nm/p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_src_components_Dashboard_Views_Fonts_vue__ = __webpack_require__("caEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_src_components_Dashboard_Views_Fonts_Create_vue__ = __webpack_require__("7x4E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_src_components_Dashboard_Views_Fonts_Edit_vue__ = __webpack_require__("Vt8W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_src_components_Dashboard_Views_FontsCategories_vue__ = __webpack_require__("k7vH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_src_components_Dashboard_Views_FontsCategories_Create_vue__ = __webpack_require__("yFli");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_src_components_Dashboard_Views_FontsCategories_Edit_vue__ = __webpack_require__("sNwX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_src_components_Dashboard_Views_GraphicsCategories_vue__ = __webpack_require__("jP93");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_src_components_Dashboard_Views_GraphicsCategories_Create_vue__ = __webpack_require__("/Ffv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_src_components_Dashboard_Views_GraphicsCategories_Edit_vue__ = __webpack_require__("BChI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_src_components_Dashboard_Views_Graphics_vue__ = __webpack_require__("sFCw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_src_components_Dashboard_Views_Graphics_Create_vue__ = __webpack_require__("frD+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_src_components_Dashboard_Views_Graphics_Edit_vue__ = __webpack_require__("4PKd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_src_components_Dashboard_Views_FramesCategories_vue__ = __webpack_require__("s980");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_src_components_Dashboard_Views_FramesCategories_Create_vue__ = __webpack_require__("jwN2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_src_components_Dashboard_Views_FramesCategories_Edit_vue__ = __webpack_require__("owed");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_src_components_Dashboard_Views_Frames_vue__ = __webpack_require__("MEcK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_src_components_Dashboard_Views_ResourcePreview_vue__ = __webpack_require__("xvC0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_src_components_Dashboard_Views_Calc_vue__ = __webpack_require__("oKnG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_src_components_Dashboard_Views_Frames_Create_vue__ = __webpack_require__("bV1C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_src_components_Dashboard_Views_Frames_Edit_vue__ = __webpack_require__("OVJ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_src_components_Dashboard_Views_EffectsCategories_vue__ = __webpack_require__("ZpEE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_src_components_Dashboard_Views_EffectsCategories_Create_vue__ = __webpack_require__("sO3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_src_components_Dashboard_Views_EffectsCategories_Edit_vue__ = __webpack_require__("Ydh+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_src_components_Dashboard_Views_Effects_vue__ = __webpack_require__("Y0gd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_src_components_Dashboard_Views_Effects_Create_vue__ = __webpack_require__("aSXu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_src_components_Dashboard_Views_Effects_Edit_vue__ = __webpack_require__("KVG2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_src_components_Dashboard_Views_MusicCategories_vue__ = __webpack_require__("7Vht");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_src_components_Dashboard_Views_MusicCategories_Create_vue__ = __webpack_require__("8bZa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_src_components_Dashboard_Views_MusicCategories_Edit_vue__ = __webpack_require__("yeRO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_src_components_Dashboard_Views_Music_vue__ = __webpack_require__("4EL8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_src_components_Dashboard_Views_Music_Create_vue__ = __webpack_require__("TT+3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_src_components_Dashboard_Views_Music_Edit_vue__ = __webpack_require__("qMsu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_src_components_Dashboard_Views_Posts_vue__ = __webpack_require__("fMfY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_src_components_Dashboard_Views_Posts_Edit_vue__ = __webpack_require__("8xqZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_src_components_Dashboard_Views_PostsCategories_vue__ = __webpack_require__("G5Vj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_src_components_Dashboard_Views_PostsCategories_Create_vue__ = __webpack_require__("Ned/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_src_components_Dashboard_Views_PostsCategories_Edit_vue__ = __webpack_require__("B21k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__middleware_Auth__ = __webpack_require__("X1HV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__middleware_Viewer__ = __webpack_require__("WiDG");

// GeneralViews


// Admin pages












































































var routes = [{
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Login_vue__["a" /* default */]
}, {
    path: '/',
    redirect: "/templates",
    component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
    children: [{
        path: 'categories',
        name: 'Categories',
        component: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Categories_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'categories/create',
        name: 'create-category',
        component: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Category_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'categories/:id',
        name: 'edit-category',
        component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Category_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'templates',
        name: 'Templates',
        component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Templates_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_76__middleware_Viewer__["a" /* default */]]
        }
    }, {
        path: 'templates/create',
        name: 'create-template',
        component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Template_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'templates/:id',
        name: 'edit-template',
        component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Template_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'memories',
        name: 'Memories',
        component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Memories_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_76__middleware_Viewer__["a" /* default */]]
        }
    }, {
        path: 'memories/create',
        name: 'create-for-you',
        component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Memories_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'memories/:id',
        name: 'edit-for-you',
        component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Memories_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'tags',
        name: 'Tags',
        component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Tags_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'tags/create',
        name: 'create-tag',
        component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Tag_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'tags/:id',
        name: 'edit-tag',
        component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Tag_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'preview',
        component: __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_PreviewHub_vue__["a" /* default */],
        children: [{
            path: '',
            name: 'Preview',
            redirect: { name: 'preview-templates' }
        }, {
            path: 'templates',
            name: 'preview-templates',
            component: __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Preview_vue__["a" /* default */],
            meta: {
                middleware: [__WEBPACK_IMPORTED_MODULE_76__middleware_Viewer__["a" /* default */]]
            }
        }, {
            path: 'carousels',
            name: 'preview-carousels',
            component: __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_PostsPreview_vue__["a" /* default */],
            props: { type: 'carousel' },
            meta: {
                middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
            }
        }, {
            path: 'stories',
            name: 'preview-stories',
            component: __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_PostsPreview_vue__["a" /* default */],
            props: { type: 'stories' },
            meta: {
                middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
            }
        }, {
            path: 'frames',
            name: 'preview-frames',
            component: __WEBPACK_IMPORTED_MODULE_54_src_components_Dashboard_Views_ResourcePreview_vue__["a" /* default */],
            props: { resource: 'frames', editRoute: 'edit-frame', emptyLabel: 'Нет фреймов' },
            meta: {
                middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
            }
        }, {
            path: 'graphics',
            name: 'preview-graphics',
            component: __WEBPACK_IMPORTED_MODULE_54_src_components_Dashboard_Views_ResourcePreview_vue__["a" /* default */],
            props: { resource: 'graphics', editRoute: 'edit-graphic', emptyLabel: 'Нет стикеров' },
            meta: {
                middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
            }
        }]
    }, {
        path: 'car-preview',
        redirect: { name: 'preview-carousels' }
    }, {
        path: 'nola-preview',
        name: 'PreviewNola',
        component: __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_PostsPreviewNola_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'albums',
        name: 'Albums',
        component: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Albums_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'albums/create',
        name: 'create-album',
        component: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Albums_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'albums/:id',
        name: 'edit-album',
        component: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Albums_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'tracks',
        name: 'Tracks',
        component: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Tracks_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'tracks/create',
        name: 'create-track',
        component: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Tracks_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'tracks/:id',
        name: 'edit-track',
        component: __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Tracks_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'reports',
        name: 'reports',
        component: __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Reports_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'reports/create',
        name: 'create-report',
        component: __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Reports_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'finance',
        name: 'finance',
        component: __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_Finance_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'push-tasks',
        name: 'push-tasks',
        component: __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_Push_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'push-tasks/create',
        name: 'create-push-tasks',
        component: __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Push_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'finance/create',
        name: 'create-finance',
        component: __WEBPACK_IMPORTED_MODULE_35_src_components_Dashboard_Views_Finance_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'finance/:id',
        name: 'edit-finance',
        component: __WEBPACK_IMPORTED_MODULE_36_src_components_Dashboard_Views_Finance_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'logs',
        name: 'logs',
        component: __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_Logs_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_76__middleware_Viewer__["a" /* default */]]
        }
    }, {
        path: 'calendar',
        name: 'Calendar',
        component: __WEBPACK_IMPORTED_MODULE_37_src_components_Dashboard_Views_Calendar_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_76__middleware_Viewer__["a" /* default */]]
        }
    }, {
        path: 'tabs',
        name: 'Tabs',
        component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Tabs_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'tabs/create',
        name: 'create-tab',
        component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Tab_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'tabs/:id',
        name: 'edit-tab',
        component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Tab_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'fonts',
        name: 'Fonts',
        component: __WEBPACK_IMPORTED_MODULE_38_src_components_Dashboard_Views_Fonts_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'fonts/create',
        name: 'create-font',
        component: __WEBPACK_IMPORTED_MODULE_39_src_components_Dashboard_Views_Fonts_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'fonts/:id',
        name: 'edit-font',
        component: __WEBPACK_IMPORTED_MODULE_40_src_components_Dashboard_Views_Fonts_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'font/categories',
        name: 'fonts-categories',
        component: __WEBPACK_IMPORTED_MODULE_41_src_components_Dashboard_Views_FontsCategories_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'font/categories/create',
        name: 'create-fonts-category',
        component: __WEBPACK_IMPORTED_MODULE_42_src_components_Dashboard_Views_FontsCategories_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'font/categories/:id',
        name: 'edit-fonts-category',
        component: __WEBPACK_IMPORTED_MODULE_43_src_components_Dashboard_Views_FontsCategories_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'graphic/categories',
        name: 'graphics-categories',
        component: __WEBPACK_IMPORTED_MODULE_44_src_components_Dashboard_Views_GraphicsCategories_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'graphic/categories/create',
        name: 'create-graphics-category',
        component: __WEBPACK_IMPORTED_MODULE_45_src_components_Dashboard_Views_GraphicsCategories_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'graphic/categories/:id',
        name: 'edit-graphics-category',
        component: __WEBPACK_IMPORTED_MODULE_46_src_components_Dashboard_Views_GraphicsCategories_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'graphics',
        name: 'graphics',
        component: __WEBPACK_IMPORTED_MODULE_47_src_components_Dashboard_Views_Graphics_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'graphics/create',
        name: 'create-graphic',
        component: __WEBPACK_IMPORTED_MODULE_48_src_components_Dashboard_Views_Graphics_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'graphics/:id',
        name: 'edit-graphic',
        component: __WEBPACK_IMPORTED_MODULE_49_src_components_Dashboard_Views_Graphics_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'frame/categories',
        name: 'frames-categories',
        component: __WEBPACK_IMPORTED_MODULE_50_src_components_Dashboard_Views_FramesCategories_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'frame/categories/create',
        name: 'create-frames-category',
        component: __WEBPACK_IMPORTED_MODULE_51_src_components_Dashboard_Views_FramesCategories_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'frame/categories/:id',
        name: 'edit-frames-category',
        component: __WEBPACK_IMPORTED_MODULE_52_src_components_Dashboard_Views_FramesCategories_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'calc',
        name: 'calc',
        component: __WEBPACK_IMPORTED_MODULE_55_src_components_Dashboard_Views_Calc_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'frames',
        name: 'frames',
        component: __WEBPACK_IMPORTED_MODULE_53_src_components_Dashboard_Views_Frames_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'frames/create',
        name: 'create-frame',
        component: __WEBPACK_IMPORTED_MODULE_56_src_components_Dashboard_Views_Frames_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'frames/:id',
        name: 'edit-frame',
        component: __WEBPACK_IMPORTED_MODULE_57_src_components_Dashboard_Views_Frames_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'effect/categories',
        name: 'effects-categories',
        component: __WEBPACK_IMPORTED_MODULE_58_src_components_Dashboard_Views_EffectsCategories_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'effect/categories/create',
        name: 'create-effects-category',
        component: __WEBPACK_IMPORTED_MODULE_59_src_components_Dashboard_Views_EffectsCategories_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'effect/categories/:id',
        name: 'edit-effects-category',
        component: __WEBPACK_IMPORTED_MODULE_60_src_components_Dashboard_Views_EffectsCategories_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'effects',
        name: 'effects',
        component: __WEBPACK_IMPORTED_MODULE_61_src_components_Dashboard_Views_Effects_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'effects/create',
        name: 'create-effect',
        component: __WEBPACK_IMPORTED_MODULE_62_src_components_Dashboard_Views_Effects_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'effects/:id',
        name: 'edit-effect',
        component: __WEBPACK_IMPORTED_MODULE_63_src_components_Dashboard_Views_Effects_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'music/categories',
        name: 'music-categories',
        component: __WEBPACK_IMPORTED_MODULE_64_src_components_Dashboard_Views_MusicCategories_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'music/categories/create',
        name: 'create-music-category',
        component: __WEBPACK_IMPORTED_MODULE_65_src_components_Dashboard_Views_MusicCategories_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'music/categories/:id',
        name: 'edit-music-category',
        component: __WEBPACK_IMPORTED_MODULE_66_src_components_Dashboard_Views_MusicCategories_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'new-music',
        name: 'music',
        component: __WEBPACK_IMPORTED_MODULE_67_src_components_Dashboard_Views_Music_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'new-music/create',
        name: 'create-music',
        component: __WEBPACK_IMPORTED_MODULE_68_src_components_Dashboard_Views_Music_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'new-music/:id',
        name: 'edit-music',
        component: __WEBPACK_IMPORTED_MODULE_69_src_components_Dashboard_Views_Music_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'posts',
        name: 'posts',
        component: __WEBPACK_IMPORTED_MODULE_70_src_components_Dashboard_Views_Posts_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'posts/:id',
        name: 'edit-post',
        component: __WEBPACK_IMPORTED_MODULE_71_src_components_Dashboard_Views_Posts_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'post/categories',
        name: 'posts-categories',
        component: __WEBPACK_IMPORTED_MODULE_72_src_components_Dashboard_Views_PostsCategories_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'post/categories/create',
        name: 'create-posts-category',
        component: __WEBPACK_IMPORTED_MODULE_73_src_components_Dashboard_Views_PostsCategories_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'post/categories/:id',
        name: 'edit-posts-category',
        component: __WEBPACK_IMPORTED_MODULE_74_src_components_Dashboard_Views_PostsCategories_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_75__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'icons',
        name: 'Icons',
        component: __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Icons_vue__["a" /* default */]
        // meta: {
        //     middleware: [Auth]
        // },
    }]
}, { path: '*', component: __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__["a" /* default */] }];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "T9aZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.status),expression:"category.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Формат")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.ratio),expression:"category.ratio"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "ratio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Обычный")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Горизонтальный (16:9, 5:1 и тд)")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.category.sort),callback:function ($$v) {_vm.$set(_vm.category, "sort", $$v)},expression:"category.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество шаблонов в категории","placeholder":"","readonly":""},model:{value:(_vm.category.templates),callback:function ($$v) {_vm.$set(_vm.category, "templates", $$v)},expression:"category.templates"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.category.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "THFC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_mixins_previewPage__ = __webpack_require__("LToN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__("M4fF");
var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1_src_mixins_previewPage__["a" /* default */]],
    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a
    },
    created: function created() {
        this.get();
    },
    data: function data() {
        return {
            data: [],
            activePreview: "",
            waiting: false,
            categoryId: null,
            role: parseInt(localStorage.getItem('role')) || 0,
            activeId: null,
            postOrders: [],
            dragGuard: false,
            showDev: true
        };
    },

    computed: {
        hasUnsavedOrder: function hasUnsavedOrder() {
            return this.postOrders.length > 0;
        },
        selectedCategory: function selectedCategory() {
            var categoryId = parseInt(this.categoryId, 10);
            return _.find(this.data, function (category) {
                return parseInt(category.id, 10) === categoryId;
            }) || null;
        },
        emptyListLabel: function emptyListLabel() {
            return 'Нет каруселей и сторис';
        },
        visiblePosts: {
            get: function get() {
                var category = this.selectedCategory;
                if (!category || !category.posts) {
                    return [];
                }
                if (this.showDev) {
                    return category.posts;
                }
                var self = this;
                return _.filter(category.posts, function (post) {
                    return !self.isDev(post.status);
                });
            },
            set: function set(posts) {
                var category = this.selectedCategory;
                if (!category) {
                    return;
                }
                if (this.showDev) {
                    category.posts = posts;
                    return;
                }
                var self = this;
                var queue = posts.slice();
                category.posts = _.map(category.posts, function (post) {
                    if (self.isDev(post.status)) {
                        return post;
                    }
                    return queue.length ? queue.shift() : post;
                });
            }
        }
    },
    methods: {
        get: function get() {
            var self = this;
            var token = localStorage.getItem('token');

            self.waiting = true;

            axios.get(this.$hostname + '/admin/posts/preview-nola', {
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.waiting = false;
                self.postOrders = [];
                self.data = response.data || [];
                var selectedExists = _.some(self.data, function (category) {
                    return parseInt(category.id, 10) === parseInt(self.categoryId, 10);
                });
                if (!selectedExists && self.data.length) {
                    self.categoryId = self.data[0].id;
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        save: function save() {
            var self = this;

            var token = localStorage.getItem('token');

            self.waiting = true;

            axios.post(this.$hostname + '/admin/posts/preview-nola/resort', {
                postOrders: this.postOrders
            }, {
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function () {
                self.postOrders = [];
                self.get();
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        onPostsDragStart: function onPostsDragStart() {
            this.dragGuard = true;
        },
        onPostsDragEnd: function onPostsDragEnd() {
            var _this = this;

            setTimeout(function () {
                _this.dragGuard = false;
            }, 150);
        },
        isSelectedCategory: function isSelectedCategory(id) {
            return parseInt(id, 10) === parseInt(this.categoryId, 10);
        },
        selectCategory: function selectCategory(id) {
            this.categoryId = id;
        },
        onPostsReorder: function onPostsReorder(category) {
            if (!category || !category.posts) {
                return;
            }

            var categoryId = parseInt(category.id, 10);
            var ids = _.map(category.posts, 'id');
            this.postOrders = _.filter(this.postOrders, function (order) {
                return parseInt(order.categoryId, 10) !== categoryId;
            });
            this.postOrders.push({
                categoryId: categoryId,
                ids: ids
            });
            this.syncOtherCategoryOrders(categoryId, ids);
        },
        syncOtherCategoryOrders: function syncOtherCategoryOrders(sourceCategoryId, orderedIds) {
            var subset = {};
            _.forEach(orderedIds, function (id) {
                subset[id] = true;
            });

            _.forEach(this.data, function (category) {
                if (parseInt(category.id, 10) === sourceCategoryId || !category.posts || !category.posts.length) {
                    return;
                }

                var byId = {};
                _.forEach(category.posts, function (post) {
                    byId[post.id] = post;
                });

                var queue = [];
                _.forEach(orderedIds, function (id) {
                    if (byId[id]) {
                        queue.push(byId[id]);
                    }
                });

                if (!queue.length) {
                    return;
                }

                category.posts = _.map(category.posts, function (post) {
                    if (!subset[post.id]) {
                        return post;
                    }
                    return queue.length ? queue.shift() : post;
                });
            });
        },
        cardRatioClass: function cardRatioClass(ratio) {
            var value = parseInt(ratio, 10);
            if (value === 2) {
                return 'is-wide';
            }
            if (value === 3) {
                return 'is-tall';
            }
            if (value === 4) {
                return 'is-square';
            }
            return 'is-portrait';
        },
        getTemplateType: function getTemplateType() {
            return 'video/mp4';
        },
        isVideo: function isVideo(url) {
            return url && url.indexOf('.mp4') > -1;
        },
        previewImage: function previewImage(post) {
            if (post.preview_src_full && !this.isVideo(post.preview_src_full)) {
                return post.preview_src_full;
            }
            return null;
        },
        cardVideoSrc: function cardVideoSrc(post) {
            if (post.video_src_full) {
                return post.video_src_full;
            }
            if (this.isVideo(post.preview_src_full)) {
                return post.preview_src_full;
            }
            return null;
        },
        previewMedia: function previewMedia(post) {
            return this.cardVideoSrc(post) || this.previewImage(post) || '';
        },
        isDev: function isDev(status) {
            return parseInt(status, 10) === 0;
        },
        isStories: function isStories(ratio) {
            return parseInt(ratio, 10) === 3;
        },
        isFree: function isFree(isPremium) {
            return parseInt(isPremium, 10) !== 1;
        },
        openPreview: function openPreview(src, id) {
            if (this.dragGuard) {
                return;
            }
            this.activeId = id;
            this.activePreview = src;
        },
        openPost: function openPost() {
            this.$router.push({
                name: 'edit-post',
                params: { id: this.activeId }
            });
        },
        closePreview: function closePreview() {
            this.activeId = null;
            this.activePreview = "";
        }
    }
});

/***/ }),

/***/ "TJGk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TMFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v("\n                        - Новый отчет")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 buttons-block"},[_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Отчет все страны и регионы (один файл, txt): "),(_vm.data.reports_src)?_c('span',[_c('span',{staticClass:"inline-link"},[_c('a',{attrs:{"href":_vm.data.reports_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"reportsFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'reports_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.reportsFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Курсы валют (csv): "),(_vm.data.rates_src)?_c('span',[_c('span',{staticClass:"inline-link"},[_c('a',{attrs:{"href":_vm.data.rates_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"ratesFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'rates_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.ratesFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),(_vm.data.revenue > 0)?_c('div',{staticClass:"col-md-4"},[_c('div',[_vm._v("My Feed: "+_vm._s(_vm.data.revenue_0)+" $")]),_vm._v(" "),_c('div',[_vm._v("Muse: "+_vm._s(_vm.data.revenue_1)+" $")]),_vm._v(" "),_c('div',[_vm._v("Wallpapers: "+_vm._s(_vm.data.revenue_2)+" $")]),_vm._v(" "),_c('div',[_vm._v("Imagine: "+_vm._s(_vm.data.revenue_3)+" $")]),_vm._v(" "),_c('div',[_vm._v("Framy: "+_vm._s(_vm.data.revenue_4)+" $")]),_vm._v(" "),_c('div',[_vm._v("---")]),_vm._v(" "),_c('div',[_vm._v("Общий доход: "+_vm._s(_vm.data.revenue)+" $")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.data.reports_src || !_vm.data.rates_src},on:{"click":function($event){$event.preventDefault();return _vm.upload.apply(null, arguments)}}},[_vm._v("\n                                Загрузить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MobileMenu_vue__ = __webpack_require__("0AsC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        TopNavbar: __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__["a" /* default */],
        ContentFooter: __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__["a" /* default */],
        DashboardContent: __WEBPACK_IMPORTED_MODULE_2__Content_vue__["a" /* default */],
        MobileMenu: __WEBPACK_IMPORTED_MODULE_3__MobileMenu_vue__["a" /* default */]
    },
    data: function data() {
        return {
            role: parseInt(localStorage.getItem('role')) || 0
        };
    },

    methods: {
        toggleSidebar: function toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false);
            }
        },

        resetOffsets: function resetOffsets() {
            localStorage.setItem('w_active_offset', 0);
        }
    }
});

/***/ }),

/***/ "TRiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            model: null,
            categories: [],
            subcategories: [],
            projects: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.getSettings();
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        getSubcategories: function getSubcategories() {
            var _this = this;

            if (!this.model.category_id) {
                return;
            }

            this.subcategories = this.categories.find(function (c) {
                return c.id === _this.model.category_id;
            }).subcategories;
        },

        getSettings: function getSettings() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/finance/settings', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.settings));

                self.categories = data.categories;
                self.projects = data.projects;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/finance/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
                self.model.project_id = JSON.parse(self.model.project_id);
                self.model.date = self.model.date.split('T')[0];

                self.getSubcategories();
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/finance/' + this.id + '/update', model, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0417\u0430\u043F\u0438\u0441\u044C \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/finance');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        }
    }
});

/***/ }),

/***/ "TS8z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"preview-page"},[_c('div',{staticClass:"preview-layout"},[_c('div',{staticClass:"card preview-sidebar"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('label',{staticClass:"preview-dev-toggle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showDev),expression:"showDev"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showDev)?_vm._i(_vm.showDev,null)>-1:(_vm.showDev)},on:{"change":function($event){var $$a=_vm.showDev,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showDev=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showDev=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showDev=$$c}}}}),_vm._v("\n                        Показать dev шаблоны\n                    ")]),_vm._v(" "),_c('div',{staticClass:"preview-sidebar-title"},[_vm._v("Категории")]),_vm._v(" "),_c('div',{staticClass:"preview-sidebar-list"},[_c('draggable',{on:{"start":_vm.onCategoriesDragStart,"end":_vm.onCategoriesDragEnd,"change":_vm.onCategoriesReorder},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},[_c('transition-group',_vm._l((_vm.data),function(element){return _c('div',{key:element.id,staticClass:"category-list",class:{ active: _vm.isSelectedCategory(element.id) },on:{"click":function($event){return _vm.selectCategory(element.id)}}},[_c('span',{staticClass:"category-list-row"},[_c('span',{staticClass:"category-list-name"},[_vm._v(_vm._s(element.name))]),_vm._v(" "),(_vm.isCategoryInactive(element.status))?_c('span',{staticClass:"category-off"},[_vm._v("Скрыта")]):_vm._e()])])}),0)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"card preview-main"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-area"},[(_vm.selectedCategory)?_c('div',[_c('p',{staticClass:"category-name"},[_vm._v("\n                                "+_vm._s(_vm.selectedCategory.name)+"\n                                "),_c('span',{staticClass:"category-count"},[_vm._v("("+_vm._s(_vm.visiblePosts.length)+")")]),_vm._v(" "),(_vm.isCategoryInactive(_vm.selectedCategory.status))?_c('span',{staticClass:"category-off-note"},[_vm._v("\n                                    Категория не отображается в приложении\n                                ")]):_vm._e()]),_vm._v(" "),(_vm.visiblePosts.length > 0)?_c('div',{key:_vm.selectedCategory.id,staticClass:"templates-grid"},[_c('draggable',{on:{"start":_vm.onPostsDragStart,"end":_vm.onPostsDragEnd,"change":function($event){return _vm.onPostsReorder(_vm.selectedCategory)}},model:{value:(_vm.visiblePosts),callback:function ($$v) {_vm.visiblePosts=$$v},expression:"visiblePosts"}},_vm._l((_vm.visiblePosts),function(post){return _c('div',{key:post.id,staticClass:"inline-div",on:{"click":function($event){$event.preventDefault();_vm.openPreview(_vm.previewMedia(post), post.id)}}},[_c('div',{staticClass:"card-template",class:[_vm.cardRatioClass(post.ratio), { 'has-media': !!_vm.previewMedia(post) }]},[(_vm.cardVideoSrc(post))?_c('video',{key:'v-' + post.id,staticClass:"card-media",attrs:{"muted":"","loop":"","autoplay":"","playsinline":"","poster":_vm.previewImage(post) || undefined},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.cardVideoSrc(post),"type":_vm.getTemplateType()}})]):(_vm.previewImage(post))?_c('img',{staticClass:"card-media",attrs:{"src":_vm.previewImage(post),"alt":""}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"template-badge is-id"},[_vm._v("ID "+_vm._s(post.id))]),_vm._v(" "),(_vm.isDev(post.status))?_c('span',{staticClass:"template-badge is-dev"},[_vm._v("DEV")]):_vm._e(),_vm._v(" "),(_vm.isFree(post.is_premium))?_c('span',{staticClass:"template-badge is-free"},[_vm._v("free")]):_vm._e()])])}),0)],1):_c('p',{staticClass:"preview-empty"},[_vm._v(_vm._s(_vm.emptyListLabel))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"preview-main-footer"},[(_vm.role === 302)?_c('button',{staticClass:"btn btn-success btn-fill btn-save",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[_vm._v("\n                                Сохранить\n                            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.activePreview)?_c('div',{staticClass:"video-bg",on:{"click":function($event){$event.preventDefault();return _vm.closePreview()}}}):_vm._e(),_vm._v(" "),(_vm.activePreview)?_c('div',{attrs:{"id":"player"}},[(_vm.isVideo(_vm.activePreview))?_c('video',{staticStyle:{"max-width":"100%"},attrs:{"onloadstart":"this.volume=0.1","controls":"","autoplay":"","id":"video_player"}},[_c('source',{attrs:{"src":_vm.activePreview}})]):_c('img',{staticClass:"preview-lightbox-image",attrs:{"src":_vm.activePreview,"alt":""}}),_vm._v(" "),(_vm.role === 302)?_c('button',{staticClass:"btn btn-fill btn-close btn-default",class:{ 'active-state': _vm.activePreview },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.openPost()}}},[_vm._v("\n                                Редактировать\n                            ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-close",class:{ 'active-state': _vm.activePreview },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.closePreview()}}},[_vm._v("\n                                Закрыть\n                            ")])]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TT+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("eKbS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd942b96_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("w5Qj");
function injectStyle (ssrContext) {
  __webpack_require__("VV7b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cd942b96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd942b96_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TiXa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            category: {
                status: 0,
                templates: 0,
                translations: [],
                sort: 1,
                ratio: 1
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/categories');
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var category = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.category));

            category.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/categories/create', category, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }
    }
});

/***/ }),

/***/ "Tov1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        var self = this;

        var token = localStorage.getItem('token');

        axios.get(this.$hostname + '/admin/posts/categories/', {
            'params': {},
            'headers': {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (response) {
            self.loading = false;
            self.categories = response.data;

            self.get();
        }).catch(function (error) {
            self.loading = false;
            console.log(error);
        });
    },
    data: function data() {
        return {
            columns: ['id', 'category', 'ratio', 'is_trendy', 'preview_src_full', 'sort', 'status', ''],
            token: localStorage.getItem('token'),
            data: [],
            status: localStorage.getItem('posts_status') ? localStorage.getItem('posts_status') : "",
            categoryId: localStorage.getItem('posts_category') ? localStorage.getItem('posts_category') : "",
            ratio: localStorage.getItem('posts_ratio') ? localStorage.getItem('posts_ratio') : "",
            filteredId: null,
            categories: [],
            loading: false,
            limit: 30,
            offset: parseInt(localStorage.getItem('posts_active_offset')) || 0
        };
    },

    computed: {
        graphicsUrl: function graphicsUrl() {
            return this.$graphicsUrl;
        }
    },
    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            localStorage.setItem('posts_active_offset', "0");
            this.offset = 0;

            this.get();
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('posts_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('posts_active_offset', parseInt(this.offset));
            }
        },
        add: function add() {

            var self = this;

            axios.post(this.$hostname + '/admin/posts/create', null, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.$router.push({
                    name: 'edit-post',
                    params: { id: response.data.id }
                });
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        duplicate: function duplicate(id) {

            var self = this;

            if (confirm('\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0434\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043A\u0430\u0440\u0443\u0441\u0435\u043B\u0438: ' + id)) {
                axios.post(this.$hostname + '/admin/posts/duplicate', { id: id }, {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                }).then(function (response) {

                    self.$router.push({
                        name: 'edit-post',
                        params: { id: response.data.id }
                    });
                }).catch(function (error) {
                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
                });
            }
        },
        openNewTab: function openNewTab(id) {
            if (this.role === 2) {
                return false;
            }
            var routeData = this.$router.resolve({
                name: 'edit-post',
                params: { id: id }
            });

            window.open(routeData.href, '_blank');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');
            //this.loading = true;

            var filteredId = this.filteredId === null ? '' : this.filteredId;

            axios.get(this.$hostname + '/admin/posts/', {
                'params': {
                    limit: self.limit,
                    offset: self.offset,
                    status: this.status,
                    categoryId: this.categoryId,
                    ratio: this.ratio,
                    filteredId: filteredId
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;

                self.loading = false;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-post',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('posts') < 1) {
            localStorage.setItem('posts_category', "");
            localStorage.setItem('posts_status', "");
            localStorage.setItem('posts_ratio', "");
            localStorage.setItem('posts_active_offset', "0");
        }
        next();
    }
});

/***/ }),

/***/ "U4tR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U6AA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand-lg"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"collapse navbar-collapse justify-content-end"},[_c('ul',{staticClass:"navbar-nav ml-auto"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",on:{"click":function($event){return _vm.logout()}}},[_vm._v("\n                        Выйти\n                    ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U72P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "U7xI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__ = __webpack_require__("U72P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ef38f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__ = __webpack_require__("EGO2");
function injectStyle (ssrContext) {
  __webpack_require__("ct9D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ef38f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UEX8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UMcj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("uZPb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_406788a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("lQ71");
function injectStyle (ssrContext) {
  __webpack_require__("9wf4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-406788a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_406788a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UQTq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UYPH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            object: null,
            locales: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/graphic/categories');
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/graphics/categories/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.object = data.category;
                self.locales = data.locales;

                _.map(self.locales, function (l) {

                    var tModel = _.find(self.object.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var object = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.object));

            object.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/graphics/categories/' + this.id + '/update', object, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                //self.$router.push('/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }

    }
});

/***/ }),

/***/ "V+6M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VH3l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                            Общая информация")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.template)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"text","label":"Название шаблона","placeholder":""},model:{value:(_vm.template.name),callback:function ($$v) {_vm.$set(_vm.template, "name", $$v)},expression:"template.name"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип шаблона")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.type),expression:"template.type"}],staticClass:"form-control",attrs:{"id":"type-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("1. По дате: прошлая неделя")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2. По дате: прошлый месяц")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3. По дате: текущий месяц")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4. По дате: прошлый год")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5. По дате: текущий год")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("6. По дате: прошлые выходные")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("7. По дате: будние дни на прошлой неделе")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("8. По дате: Лето")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("9. По дате: Осень")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10. По дате: Зима")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("11. По дате: Весна")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("12. По дате: Лето прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("13. По дате: Осень прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("14. По дате: Зима прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15. По дате: Весна прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("16. По местоположению: Путешествие")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("17. По местоположению: Дом")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("18. One day of my life")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("19. Recently")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20. Day of my life with date")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("21. Spring Camera Roll")]),_vm._v(" "),_c('option',{attrs:{"value":"22"}},[_vm._v("22. Spring Recap")]),_vm._v(" "),_c('option',{attrs:{"value":"23"}},[_vm._v("23. По дате: за последние 6 месяцев")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.status),expression:"template.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Опубликовано")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ожидает")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимированный тип шаблона")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.format_type),expression:"template.format_type"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "format_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Обычный")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Slide 2 кусочка (справа-налево)")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Slide 3 кусочка (справа-налево)")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Slide 2 кусочка (снизу-вверх)")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Slide 3 кусочка (снизу-вверх)")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Slide слева вниз, справа вверх")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Разъезжается центральный кадр")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Slide 2 кусочка (слева-направо)")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Slide 3 кусочка (слева-направо)")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Slide 2 кусочка (сверху-вниз)")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Slide 3 кусочка (сверху-вниз)")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Разъезжается первый кадр")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Появляются по очереди 3 кусочка и уезжают вверх")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("Cutout (смешанный)")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("14")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("16")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("17")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("18")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("19")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Минимальная версия")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.v),expression:"template.v"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "v", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Все версии")]),_vm._v(" "),_vm._l((_vm.versions),function(version){return _c('option',{key:version,domProps:{"value":version}},[_vm._v("\n                                                "+_vm._s(version)+"\n                                            ")])})],2)]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.template.sort),callback:function ($$v) {_vm.$set(_vm.template, "sort", $$v)},expression:"template.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название трека","placeholder":""},model:{value:(_vm.template.song),callback:function ($$v) {_vm.$set(_vm.template, "song", $$v)},expression:"template.song"}}),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на Reels audio","placeholder":""},model:{value:(_vm.template.song_insta),callback:function ($$v) {_vm.$set(_vm.template, "song_insta", $$v)},expression:"template.song_insta"}}):_vm._e(),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на TikTok audio","placeholder":""},model:{value:(_vm.template.song_tiktok),callback:function ($$v) {_vm.$set(_vm.template, "song_tiktok", $$v)},expression:"template.song_tiktok"}}):_vm._e(),_vm._v(" "),_c('fg-input',{attrs:{"type":"date","label":"Дата публикации (формат ДД.ММ.ГГГГ)","placeholder":""},model:{value:(_vm.template.release_date),callback:function ($$v) {_vm.$set(_vm.template, "release_date", $$v)},expression:"template.release_date"}}),_vm._v(" "),(_vm.template.release_date)?_c('fg-input',{attrs:{"type":"time","label":"Время публикации (формат HH:MM)","placeholder":""},model:{value:(_vm.template.release_time),callback:function ($$v) {_vm.$set(_vm.template, "release_time", $$v)},expression:"template.release_time"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 checkbox-block"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_premium),expression:"template.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_premium)?_vm._i(_vm.template.is_premium,null)>-1:(_vm.template.is_premium)},on:{"change":function($event){var $$a=_vm.template.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"new-control"}},[_vm._v("Новое")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_new),expression:"template.is_new"}],staticClass:"form-check-inline",attrs:{"id":"new-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_new)?_vm._i(_vm.template.is_new,null)>-1:(_vm.template.is_new)},on:{"change":function($event){var $$a=_vm.template.is_new,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_new", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_new", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_new", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"copyrighted-control"}},[_vm._v("Copyrighted-музыка")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_copyrighted),expression:"template.is_copyrighted"}],staticClass:"form-check-inline",attrs:{"id":"copyrighted-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_copyrighted)?_vm._i(_vm.template.is_copyrighted,null)>-1:(_vm.template.is_copyrighted)},on:{"change":function($event){var $$a=_vm.template.is_copyrighted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_copyrighted", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_copyrighted", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_copyrighted", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"text-control"}},[_vm._v("Наложение\n                                            текста/объекта")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.is_text_active),expression:"is_text_active"}],staticClass:"form-check-inline",attrs:{"id":"text-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.is_text_active)?_vm._i(_vm.is_text_active,null)>-1:(_vm.is_text_active)},on:{"change":[function($event){var $$a=_vm.is_text_active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.is_text_active=$$a.concat([$$v]))}else{$$i>-1&&(_vm.is_text_active=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.is_text_active=$$c}},function($event){return _vm.toggleText()}]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"margin-top"},[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                            Видео: "),(_vm.template.preview_src_full)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.preview_src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):(_vm.template.preview_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.preview_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"previewFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'preview_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.previewFileInput.click()}}},[_vm._v("\n                                                Загрузить\n                                            ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                            Аудио: "),(_vm.template.audio_full)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.audio_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):(_vm.template.audio_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.audio_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"audioFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"audio/mp3"},on:{"change":function($event){return _vm.uploadFile($event, 'audio')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.audioFileInput.click()}}},[_vm._v("\n                                                Загрузить\n                                            ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.template.videos || !_vm.template.type || !_vm.template.name
                                        || !_vm.template.song || !_vm.template.audio || !_vm.template.preview_src
                                        || (_vm.template.is_copyrighted === true && (!_vm.template.song_insta && !_vm.template.song_tiktok))},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                    Сохранить\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()]),_vm._v(" "),(_vm.show_collage_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeCollageModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.collages),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill collage-category",class:{ 'active' : t.name === _vm.active_collage_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectCollageCategory(t.name)}}},[_vm._v("\n                                            "+_vm._s(t.name)+"\n                                        ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return _vm._l((_vm.collages),function(t,index){return _c('div',_vm._l((t.data),function(c,index){return (t.name === _vm.active_collage_category)?_c('div',{staticClass:"collage-item"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.renderCollage(c))},on:{"click":_vm.addCollage}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeCollageModal}},[_vm._v("\n                                            Закрыть\n                                        ")])]})],2)])])]):_vm._e(),_vm._v(" "),_c('card',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_text_active),expression:"is_text_active"}]},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                            Текст")]),_vm._v(" "),(_vm.is_text_active)?_c('div',{staticClass:"texts-buttons"},[_vm._l((_vm.template.texts),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_text && _vm.active_type === 'text'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectText(index)}}},[_vm._v(_vm._s(t.text)+"\n                                "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.template.objects),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_object && _vm.active_type === 'object'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObject(index)}}},[_c('img',{staticClass:"button-preview",style:({ backgroundImage: 'url(\'' + _vm.objectPlayerSrc(t) + '\')' }),attrs:{"alt":""}}),_vm._v(" "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.active_type === 'text' ? _vm.addText(_vm.active_text) : _vm.addObject(null, _vm.active_object)}}},[_vm._v("\n                                Копировать\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.addText()}}},[_vm._v("Добавить текст\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showSVGModal()}}},[_vm._v("Добавить объект\n                            ")])],2):_vm._e(),_vm._v(" "),(_vm.show_svg_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeSVGModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.server_graphics),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : t.name === _vm.active_object_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObjectCategory(t.name)}}},[_vm._v("\n                                                "+_vm._s(t.name)+"\n                                            ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return _vm._l((_vm.server_graphics),function(t,index){return _c('div',_vm._l((t.data),function(c,index){return (t.name === _vm.active_object_category)?_c('div',{staticClass:"object-item",on:{"click":function($event){return _vm.addObject(c)}}},[_c('img',{staticClass:"image",attrs:{"src":("" + _vm.graphicsUrl + (c.src))}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeSVGModal}},[_vm._v("\n                                                Закрыть\n                                            ")])]})],2)])])]):_vm._e(),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.is_text_active && _vm.active_type === 'text')?_c('div',{staticClass:"col-md-4 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Текст")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text),expression:"template.texts[active_text].text"}],staticClass:"text-area",domProps:{"value":(_vm.template.texts[_vm.active_text].text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления текста (0 - c начала)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_start),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_start", $$v)},expression:"template.texts[active_text].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_end),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_end", $$v)},expression:"template.texts[active_text].time_end"}})],1)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер шрифта: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].font_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"5","max":"200","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].font_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "font_size", $$v)},expression:"template.texts[active_text].font_size"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Шрифт")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].font_name),expression:"template.texts[active_text].font_name"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "font_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.sortedFonts),function(f){return _c('option',{domProps:{"value":f.name}},[_vm._v(_vm._s(f.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"control1"}},[_vm._v("По центру по\n                                            горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control1","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_x == 0.5},on:{"change":function($event){return _vm.setTextPosition(0.5, null)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Position X","placeholder":""},on:{"input":function (val) { return _vm.setTextPosition(val, null); }},model:{value:(_vm.template.texts[_vm.active_text].position_x),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "position_x", $$v)},expression:"template.texts[active_text].position_x"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"control2"}},[_vm._v("По центру по\n                                            вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control2","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_y == 0.5},on:{"change":function($event){return _vm.setTextPosition(null, 0.5)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Position Y","placeholder":""},on:{"input":function (val) { return _vm.setTextPosition(null, val); }},model:{value:(_vm.template.texts[_vm.active_text].position_y),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "position_y", $$v)},expression:"template.texts[active_text].position_y"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control1"}},[_vm._v("Text brush")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].is_text_brush),expression:"template.texts[active_text].is_text_brush"}],staticClass:"form-check-inline",attrs:{"id":"control1","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.texts[_vm.active_text].is_text_brush)?_vm._i(_vm.template.texts[_vm.active_text].is_text_brush,null)>-1:(_vm.template.texts[_vm.active_text].is_text_brush)},on:{"change":function($event){var $$a=_vm.template.texts[_vm.active_text].is_text_brush,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template.texts[_vm.active_text], "is_text_brush", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template.texts[_vm.active_text], "is_text_brush", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template.texts[_vm.active_text], "is_text_brush", $$c)}}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.template.texts[_vm.active_text].is_text_brush)?_c('label',{staticClass:"control-label"},[_vm._v("Text brush data")]):_vm._e(),_vm._v(" "),(_vm.template.texts[_vm.active_text].is_text_brush)?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_brush_data),expression:"template.texts[active_text].text_brush_data"}],staticClass:"text-area",domProps:{"value":(_vm.template.texts[_vm.active_text].text_brush_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text_brush_data", $event.target.value)}}}):_vm._e()]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот текста (градусы)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].angle),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "angle", $$v)},expression:"template.texts[active_text].angle"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межбуквенный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].letter_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "letter_spacing", $$v)},expression:"template.texts[active_text].letter_spacing"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межстрочный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].line_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "line_spacing", $$v)},expression:"template.texts[active_text].line_spacing"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет текста: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].text_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_color),expression:"template.texts[active_text].text_color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].text_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.texts[_vm.active_text].text_color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'color')}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет фона:\n                                            "),(_vm.template.texts[_vm.active_text].background_color === 'transparent')?_c('span',{staticClass:"param-span"},[_vm._v("Прозрачный")]):_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].background_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].background_color),expression:"template.texts[active_text].background_color"},{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "background_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"background-control"}},[_vm._v("Прозрачный")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"background-control","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].background_color === 'transparent'},on:{"change":function($event){return _vm.toggleBackground()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.texts[_vm.active_text].background_color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'background')}}})}),0)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "alpha", $$v)},expression:"template.texts[active_text].alpha"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Направление текста")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].direction),expression:"template.texts[active_text].direction"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "direction", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"normal"}},[_vm._v("normal")]),_vm._v(" "),_c('option',{attrs:{"value":"vertical"}},[_vm._v("vertical")]),_vm._v(" "),_c('option',{attrs:{"value":"round"}},[_vm._v("round")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].animation_type),expression:"template.texts[active_text].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name)+"\n                                            ")])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].animation_duration)+" сек")])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"20","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "animation_duration", $$v)},expression:"template.texts[active_text].animation_duration"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Выравнивание "),_c('br'),_vm._v("(если больше одной строки)")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_align),expression:"template.texts[active_text].text_align"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "text_align", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.text_aligns),function(ta){return _c('option',{domProps:{"value":ta.name}},[_vm._v(_vm._s(ta.name)+"\n                                            ")])}),0)]),_vm._v(" "),_c('label',{attrs:{"for":"shadow-color"}},[_vm._v("Цвет тени:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].shadow_color),expression:"template.texts[active_text].shadow_color"}],attrs:{"type":"color","id":"shadow-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "shadow_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Радиус размытия тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_blur))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_blur),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_blur", $$v)},expression:"template.texts[active_text].shadow_blur"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_alpha", $$v)},expression:"template.texts[active_text].shadow_alpha"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер обводки: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].stroke_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].stroke_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "stroke_size", $$v)},expression:"template.texts[active_text].stroke_size"}}),_vm._v(" "),_c('label',{attrs:{"for":"stroke-color"}},[_vm._v("Цвет обводки:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].stroke_color),expression:"template.texts[active_text].stroke_color"}],attrs:{"type":"color","id":"stroke-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].stroke_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "stroke_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].z_index),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "z_index", $$v)},expression:"template.texts[active_text].z_index"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeText(_vm.active_text)}}},[_vm._v("Удалить текст\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),(_vm.is_text_active && _vm.active_type === 'object')?_c('div',{staticClass:"col-md-4 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Объект")]),_vm._v(" "),_c('img',{staticClass:"object-preview",attrs:{"alt":"","src":_vm.objectPlayerSrc(_vm.template.objects[_vm.active_object])},on:{"click":function($event){return _vm.changeObject()}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления объекта (0 - c начала)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_start),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_start", $$v)},expression:"template.objects[active_object].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_end),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_end", $$v)},expression:"template.objects[active_object].time_end"}})],1)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].scale))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0.03","max":"5","step":"0.005","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].scale),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "scale", $$v)},expression:"template.objects[active_object].scale"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control3"}},[_vm._v("По центру по\n                                            горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control3","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_x == 0.5},on:{"change":function($event){return _vm.setObjectPosition(0.5, null)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control4"}},[_vm._v("По центру по\n                                            вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control4","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_y == 0.5},on:{"change":function($event){return _vm.setObjectPosition(null, 0.5)}}})]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот объекта (градусы)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].angle),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "angle", $$v)},expression:"template.objects[active_object].angle"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].id.indexOf('nocolor') < 0 && !_vm.isGifSrc(_vm.template.objects[_vm.active_object].id)),expression:"template.objects[active_object].id.indexOf('nocolor') < 0 && !isGifSrc(template.objects[active_object].id)"}],staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].color),expression:"template.objects[active_object].color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.objects[_vm.active_object].color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.objects[_vm.active_object], "color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.objects[_vm.active_object].color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setObjColor(c)}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].animation_type),expression:"template.objects[active_object].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.objects[_vm.active_object], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name)+"\n                                            ")])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].animation_duration))])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"20","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "animation_duration", $$v)},expression:"template.objects[active_object].animation_duration"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].alpha),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "alpha", $$v)},expression:"template.objects[active_object].alpha"}}),_vm._v(" "),_c('label',{attrs:{"for":"shadow-color"}},[_vm._v("Цвет тени:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].shadow_color),expression:"template.objects[active_object].shadow_color"}],attrs:{"type":"color","id":"shadow-color"},domProps:{"value":(_vm.template.objects[_vm.active_object].shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.objects[_vm.active_object], "shadow_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Радиус размытия тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].shadow_blur))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].shadow_blur),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "shadow_blur", $$v)},expression:"template.objects[active_object].shadow_blur"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].shadow_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].shadow_alpha),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "shadow_alpha", $$v)},expression:"template.objects[active_object].shadow_alpha"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].z_index),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "z_index", $$v)},expression:"template.objects[active_object].z_index"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeObject(_vm.active_object)}}},[_vm._v("Удалить объект\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[(_vm.template)?_c('div',{attrs:{"id":"preview-container"}},[_c('div',{attrs:{"id":"player"}},[_c('video',{ref:"videoContainer",staticStyle:{"max-width":"100%","cursor":"pointer"},attrs:{"controls":"","disablepictureinpicture":"","muted":"","controlsList":"nofullscreen nodownload noremoteplayback noplaybackrate","playsinline":"","id":"video_player"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.template.preview_src_full}})]),_vm._v(" "),_vm._l((_vm.template.texts),function(tt,index){return (tt.font_size)?_c('div',{ref:"draggableContainer",refInFor:true,staticClass:"draggable-container",attrs:{"id":("" + index)}},[(_vm.fonts.length > 1)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header",domProps:{"innerHTML":_vm._s(_vm.text_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e()]):_vm._e()}),_vm._v(" "),_vm._l((_vm.template.objects),function(tt,index){return (tt.scale)?_c('div',{ref:"draggableContainer2",refInFor:true,staticClass:"draggable-container",attrs:{"id":("o" + index)}},[(tt.id.indexOf('.svg') > 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header nospace",domProps:{"innerHTML":_vm._s(_vm.object_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e(),_vm._v(" "),(tt.id.indexOf('.svg') < 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header nospace",domProps:{"innerHTML":_vm._s(_vm.image_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e()]):_vm._e()})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-toggle",class:{ 'active-state': _vm.template.src_full },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.showPreview()}}},[_vm._v("\n                                            Показать превью\n                                        ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Параметры видео")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.template)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Длительность, сек.","placeholder":""},on:{"input":function($event){return _vm.formatVideoDuration($event)}},model:{value:(_vm.template.duration),callback:function ($$v) {_vm.$set(_vm.template, "duration", $$v)},expression:"template.duration"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество фрагментов","placeholder":""},on:{"input":_vm.changeVideoCount},model:{value:(_vm.template.videos),callback:function ($$v) {_vm.$set(_vm.template, "videos", $$v)},expression:"template.videos"}}),_vm._v(" "),_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Фрагменты "),_c('br'),_vm._v("(длительность:\n                                        "),(Math.abs(_vm.sumParts - _vm.template.duration) > 0.05)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.sumParts))]):_c('span',[_vm._v(_vm._s(_vm.sumParts))]),_vm._v("):\n                                    ")]),_vm._v(" "),_vm._l((_vm.client_parts),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('span',{staticClass:"block-number"},[_vm._v(_vm._s(index + 1)+".")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Длительн.","placeholder":""},on:{"input":function($event){return _vm.formatDuration($event, index)}},model:{value:(_vm.client_parts[index].duration),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "duration", $$v)},expression:"client_parts[index].duration"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Скорость","placeholder":""},on:{"input":function($event){return _vm.formatSpeed($event, index)}},model:{value:(_vm.client_parts[index].speed),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "speed", $$v)},expression:"client_parts[index].speed"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Эффект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].effect_type),expression:"client_parts[index].effect_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "effect_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeEffectType(index, _vm.client_parts[index].effect_type)}]}},_vm._l((_vm.effect_types),function(e){return _c('option',{domProps:{"value":e.id}},[_vm._v("\n                                                                "+_vm._s(e.name)+"\n                                                            ")])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row",class:{ bordered: _vm.client_parts[index].effect_type === 0 }},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-text btn-fill active control-btn collage-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showCollageModal(index)}}},[_vm._v("Коллаж +\n                                                        ")])])]),_vm._v(" "),(_vm.client_parts[index].collage_type)?_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Время начала","placeholder":""},on:{"input":function($event){return _vm.formatStartTime($event, index, 'start_time')}},model:{value:(_vm.client_parts[index].start_time),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "start_time", $$v)},expression:"client_parts[index].start_time"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип контента")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].content_type),expression:"client_parts[index].content_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "content_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.content_types),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v("\n                                                                "+_vm._s(c.name)+"\n                                                            ")])}),0)])])]),_vm._v(" "),(_vm.client_parts[index].collage_type)?_c('div',{staticClass:"row bordered"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"collage-preview",domProps:{"innerHTML":_vm._s(_vm.renderCollagePart(_vm.client_parts[index].collage_type))},on:{"click":function($event){return _vm.showCollageModal(index)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-danger btn-fill btn-delete-collage",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removeCollageFromPart(index)}}},[_vm._v("Удалить коллаж\n                                                    ")])])]):_vm._e(),_vm._v(" "),((_vm.client_parts[index].effect_type === 1 || _vm.client_parts[index].effect_type === 2) && _vm.client_parts[index].effect_values)?_c('div',{staticClass:"row bordered"},[_c('div',{staticClass:"effect-values"},[_vm._v("\n                                                    "+_vm._s(_vm.effect_types[_vm.client_parts[index].effect_type].name)+" - Параметры\n                                                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"effect-preview",on:{"click":function($event){return _vm.changeEffectPosition($event, index)}}},[_c('span',{staticClass:"effect-area",style:({'top': _vm.client_parts[index].effect_values.y * 87 - 15 + 'px',
                                                                        'left': _vm.client_parts[index].effect_values.x * 48 - 15 + 'px'})},[_c('span',{staticClass:"effect-center"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"#" + String(index + 1) + " - Начальное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.from),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "from", $$v)},expression:"client_parts[index].effect_values.from"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"#" + String(index + 1) + " - Конечное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.to),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "to", $$v)},expression:"client_parts[index].effect_values.to"}})],1)]):_vm._e()])])})],2)])]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VV7b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VXPv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            track: {},
            model: {
                date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().utc().format('YYYY-MM-DD'),
                description: '',
                amount: '',
                category_id: 1,
                subcategory_id: 1,
                project_id: [1]
            },
            categories: [],
            subcategories: [],
            projects: []
        };
    },

    created: function created() {
        this.getSettings();
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        getSubcategories: function getSubcategories() {
            var _this = this;

            this.model.subcategory_id = 1;
            this.subcategories = this.categories.find(function (c) {
                return c.id === _this.model.category_id;
            }).subcategories;
        },

        getSettings: function getSettings() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/finance/settings', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.settings));

                self.categories = data.categories;
                self.projects = data.projects;

                self.getSubcategories();
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/tracks/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.track = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(self.locales, function (l) {

                    var tModel = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(self.album.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/finance/create', model, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0417\u0430\u043F\u0438\u0441\u044C \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/finance');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        }
    }
});

/***/ }),

/***/ "Vcpj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            category: null,
            locales: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/categories');
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/categories/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.category = data.category;
                self.locales = data.locales;

                _.map(self.locales, function (l) {

                    var tModel = _.find(self.category.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var category = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.category));

            category.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/categories/' + this.id + '/update', category, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }

    }
});

/***/ }),

/***/ "Vg8q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");
var moment = __webpack_require__("PJh5");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            columns: ['date', 'description', 'category_id', 'subcategory_id', 'project_id', 'amount', ''],
            data: [],
            summary: 0,
            type: "",
            start_date: localStorage.getItem('fi_date_start') ? localStorage.getItem('fi_date_start') : moment().startOf('month').format('YYYY-MM-DD'),
            end_date: localStorage.getItem('fi_date_end') ? localStorage.getItem('fi_date_end') : moment().utc().format('YYYY-MM-DD'),
            category_id: localStorage.getItem('fi_category') ? localStorage.getItem('fi_category') : "",
            subcategory_id: localStorage.getItem('fi_subcategory') ? localStorage.getItem('fi_subcategory') : "",
            project_id: [],
            loading: false,
            categories: [],
            subcategories: [],
            projects: []
        };
    },

    filters: {
        toEasyDate: function toEasyDate(value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY');
            } else {
                return '';
            }
        },
        toMoneyFormat: function toMoneyFormat(value) {
            if (value) {
                return Intl.NumberFormat().format(value);
            } else {
                return '';
            }
        }
    },
    created: function created() {
        this.get();
    },
    methods: {
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/finance/create');
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-finance',
                params: { id: id }
            });
        },
        getSubcategories: function getSubcategories() {
            var _this = this;

            this.saveFilters('fi_category', this.category_id);

            if (this.category_id === "") {
                this.subcategory_id = "";
                return this.subcategories = [];
            }
            this.subcategory_id = "";
            this.subcategories = this.categories.find(function (c) {
                return c.id === parseInt(_this.category_id);
            }).subcategories;
        },

        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            var dateStart = this.start_date === null ? '' : this.start_date;
            var dateEnd = this.end_date === null ? '' : this.end_date;

            this.loading = true;

            axios.get(this.$hostname + '/admin/finance/', {
                'params': {
                    date_start: dateStart,
                    date_end: dateEnd,
                    category_id: this.category_id,
                    subcategory_id: this.subcategory_id,
                    project_id: this.project_id
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.loading = false;

                self.data = response.data.finance;
                self.categories = response.data.settings.categories;
                self.projects = response.data.settings.projects;
                self.summary = response.data.summary;

                self.getSubcategories();
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('finance') < 1) {
            localStorage.setItem('fi_date_start', "");
            localStorage.setItem('fi_date_end', "");
            localStorage.setItem('fi_category', "");
            localStorage.setItem('fi_subcategory', "");
            localStorage.setItem('fi_project', "");
        }
        next();
    }
});

/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "VpPE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vt8W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("rdED");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71fabeec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("wk3R");
function injectStyle (ssrContext) {
  __webpack_require__("VpPE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71fabeec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71fabeec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VtWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Категории стикеров")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('gr_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить категорию\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):(column === 'object_count')?_c('span',[_vm._v("количество объектов")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'name')?_c('span',[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активна")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активна")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W3Ar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                            Общая информация")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.template)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.category_id),expression:"template.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return (c.id !== 999)?_c('option',{domProps:{"value":c.id}},[_vm._v("\n                                                "+_vm._s(c.name)+"\n                                            ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.status),expression:"template.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Опубликовано")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ожидает")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип шаблона")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.type),expression:"template.type"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Обычный")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Slide 2 кусочка (справа-налево)")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Slide 3 кусочка (справа-налево)")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Slide 2 кусочка (снизу-вверх)")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Slide 3 кусочка (снизу-вверх)")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Slide слева вниз, справа вверх")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Разъезжается центральный кадр")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Slide 2 кусочка (слева-направо)")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Slide 3 кусочка (слева-направо)")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Slide 2 кусочка (сверху-вниз)")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Slide 3 кусочка (сверху-вниз)")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Разъезжается первый кадр")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Появляются по очереди 3 кусочка и уезжают вверх")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("Cutout (смешанный)")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("Slide 1 кусочек (справа-налево)")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("Slide 1 кусочек (слева-направо)")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("Slide 1 кусочек (снизу-вверх)")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("Slide 1 кусочек (сверху-вниз)")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("Съезжается первый кадр")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("19")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Формат")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.ratio),expression:"template.ratio"}],staticClass:"form-control",attrs:{"id":"ratio-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "ratio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeRatioType()}]}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Обычный")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Горизонтальный (16:9)")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Горизонтальный (5:1)")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Минимальная версия")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.v),expression:"template.v"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "v", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Все версии")]),_vm._v(" "),_vm._l((_vm.versions),function(version){return _c('option',{key:version,domProps:{"value":version}},[_vm._v("\n                                                "+_vm._s(version)+"\n                                            ")])})],2)]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.template.sort),callback:function ($$v) {_vm.$set(_vm.template, "sort", $$v)},expression:"template.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название трека","placeholder":""},model:{value:(_vm.template.song),callback:function ($$v) {_vm.$set(_vm.template, "song", $$v)},expression:"template.song"}}),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на Reels audio","placeholder":""},model:{value:(_vm.template.song_insta),callback:function ($$v) {_vm.$set(_vm.template, "song_insta", $$v)},expression:"template.song_insta"}}):_vm._e(),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на TikTok audio","placeholder":""},model:{value:(_vm.template.song_tiktok),callback:function ($$v) {_vm.$set(_vm.template, "song_tiktok", $$v)},expression:"template.song_tiktok"}}):_vm._e(),_vm._v(" "),_c('fg-input',{attrs:{"type":"date","label":"Дата публикации (формат ДД.ММ.ГГГГ)","placeholder":""},model:{value:(_vm.template.release_date),callback:function ($$v) {_vm.$set(_vm.template, "release_date", $$v)},expression:"template.release_date"}}),_vm._v(" "),(_vm.template.release_date)?_c('fg-input',{attrs:{"type":"time","label":"Время публикации (формат HH:MM)","placeholder":""},model:{value:(_vm.template.release_time),callback:function ($$v) {_vm.$set(_vm.template, "release_time", $$v)},expression:"template.release_time"}}):_vm._e(),_vm._v(" "),_c('div',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                            Теги:\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',{staticClass:"d-none"},[_vm._v(_vm._s(_vm.template.tags))]),_vm._v(" "),_c('div',{staticClass:"tags-set"},_vm._l((_vm.tags),function(t){return _c('div',{class:{ 'active' : t.active },on:{"click":function($event){return _vm.toggleTag(t)}}},[_vm._v(_vm._s(t.name))])}),0)])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 checkbox-block"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_premium),expression:"template.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_premium)?_vm._i(_vm.template.is_premium,null)>-1:(_vm.template.is_premium)},on:{"change":function($event){var $$a=_vm.template.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trendy-control"}},[_vm._v("Популярное")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_trendy),expression:"template.is_trendy"}],staticClass:"form-check-inline",attrs:{"id":"trendy-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_trendy)?_vm._i(_vm.template.is_trendy,null)>-1:(_vm.template.is_trendy)},on:{"change":function($event){var $$a=_vm.template.is_trendy,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_trendy", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_trendy", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_trendy", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"new-control"}},[_vm._v("Новое")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_new),expression:"template.is_new"}],staticClass:"form-check-inline",attrs:{"id":"new-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_new)?_vm._i(_vm.template.is_new,null)>-1:(_vm.template.is_new)},on:{"change":function($event){var $$a=_vm.template.is_new,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_new", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_new", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_new", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trending-music-control"}},[_vm._v("Трендовая\n                                                    музыка")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_trending_music),expression:"template.is_trending_music"}],staticClass:"form-check-inline",attrs:{"id":"trending-music-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_trending_music)?_vm._i(_vm.template.is_trending_music,null)>-1:(_vm.template.is_trending_music)},on:{"change":function($event){var $$a=_vm.template.is_trending_music,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_trending_music", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_trending_music", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_trending_music", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"collage-control"}},[_vm._v("Коллаж")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_collage),expression:"template.is_collage"}],staticClass:"form-check-inline",attrs:{"id":"collage-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_collage)?_vm._i(_vm.template.is_collage,null)>-1:(_vm.template.is_collage)},on:{"change":function($event){var $$a=_vm.template.is_collage,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_collage", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_collage", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_collage", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"copyrighted-control"}},[_vm._v("Copyrighted-музыка")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_copyrighted),expression:"template.is_copyrighted"}],staticClass:"form-check-inline",attrs:{"id":"copyrighted-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_copyrighted)?_vm._i(_vm.template.is_copyrighted,null)>-1:(_vm.template.is_copyrighted)},on:{"change":function($event){var $$a=_vm.template.is_copyrighted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_copyrighted", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_copyrighted", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_copyrighted", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"stories-control"}},[_vm._v("Stories")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_stories),expression:"template.is_stories"}],staticClass:"form-check-inline",attrs:{"id":"stories-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_stories)?_vm._i(_vm.template.is_stories,null)>-1:(_vm.template.is_stories)},on:{"change":function($event){var $$a=_vm.template.is_stories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_stories", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_stories", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_stories", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"cut-out-control"}},[_vm._v("Cutout")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_cut_out),expression:"template.is_cut_out"}],staticClass:"form-check-inline",attrs:{"id":"cut-out-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_cut_out)?_vm._i(_vm.template.is_cut_out,null)>-1:(_vm.template.is_cut_out)},on:{"change":function($event){var $$a=_vm.template.is_cut_out,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_cut_out", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_cut_out", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_cut_out", $$c)}}}})]),_vm._v(" "),(_vm.template.is_cut_out)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"cut-out-control"}},[_vm._v("Paper Cutout")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_paper_cut_out),expression:"template.is_paper_cut_out"}],staticClass:"form-check-inline",attrs:{"id":"cut-out-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_paper_cut_out)?_vm._i(_vm.template.is_paper_cut_out,null)>-1:(_vm.template.is_paper_cut_out)},on:{"change":function($event){var $$a=_vm.template.is_paper_cut_out,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_paper_cut_out", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_paper_cut_out", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_paper_cut_out", $$c)}}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"text-control"}},[_vm._v("Наложение\n                                                    текста/объекта")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.is_text_active),expression:"is_text_active"}],staticClass:"form-check-inline",attrs:{"id":"text-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.is_text_active)?_vm._i(_vm.is_text_active,null)>-1:(_vm.is_text_active)},on:{"change":[function($event){var $$a=_vm.is_text_active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.is_text_active=$$a.concat([$$v]))}else{$$i>-1&&(_vm.is_text_active=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.is_text_active=$$c}},function($event){return _vm.toggleText()}]}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет фона: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.background))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.background),expression:"template.background"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.background)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template, "background", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Эффект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.effect),expression:"effect"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.effect=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("-")]),_vm._v(" "),_vm._l((_vm.server_effects),function(se){return _c('option',{domProps:{"value":se.name}},[_vm._v("\n                                                        "+_vm._s(se.name)+"\n                                                    ")])})],2)]),_vm._v(" "),(_vm.effect)?_c('label',{staticClass:"control-label"},[_vm._v("Интенсивность эффекта: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.effect_intensity))])]):_vm._e(),_vm._v(" "),(_vm.effect)?_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.effect_intensity),callback:function ($$v) {_vm.effect_intensity=$$v},expression:"effect_intensity"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Фильтр")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("-")]),_vm._v(" "),_vm._l((_vm.server_filters),function(sf){return _c('option',{domProps:{"value":sf.name}},[_vm._v("\n                                                        "+_vm._s(sf.name)+"\n                                                    ")])})],2)]),_vm._v(" "),(_vm.filter)?_c('label',{staticClass:"control-label"},[_vm._v("Интенсивность фильтра: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.filter_intensity))])]):_vm._e(),_vm._v(" "),(_vm.filter)?_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.filter_intensity),callback:function ($$v) {_vm.filter_intensity=$$v},expression:"filter_intensity"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                                    Видео: "),(_vm.template.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.src_size >= 4)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]):(_vm.template.src_size >= 3)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"videoFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.videoFileInput.click()}}},[_vm._v("\n                                                        Загрузить\n                                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                                    Превью: "),(_vm.template.preview_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.preview_src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):(_vm.template.preview_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.preview_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"previewFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'preview_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.previewFileInput.click()}}},[_vm._v("\n                                                        Загрузить\n                                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                                    Аудио: "),(_vm.template.audio)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.audio_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):(_vm.template.audio_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.audio_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"audioFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"audio/mp3"},on:{"change":function($event){return _vm.uploadFile($event, 'audio')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.audioFileInput.click()}}},[_vm._v("\n                                                        Загрузить\n                                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                                    Обложка (Reels Maker): "),(_vm.template.preview_image)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.preview_image_size >= 0.1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.preview_image_size)+"Mb")]):(_vm.template.preview_image_size >= 0.05)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.preview_image_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.preview_image_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.preview_image_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"previewImageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'preview_image')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.previewImageFileInput.click()}}},[_vm._v("\n                                                        Загрузить\n                                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),(_vm.tags)?_c('div',{staticClass:"row"}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.template.duration || !_vm.template.videos || !_vm.template.category_id || !_vm.template.song
                                        || !_vm.template.src || !_vm.template.preview_src || !_vm.template.audio || !_vm.template.preview_image
                                        || (_vm.template.is_copyrighted == true && (!_vm.template.song_insta && !_vm.template.song_tiktok))},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                    Сохранить\n                                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-fill float-right btn-delete",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.remove.apply(null, arguments)}}},[_vm._v("\n                                    Удалить шаблон\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()]),_vm._v(" "),(_vm.show_collage_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeCollageModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return [_c('button',{staticClass:"btn btn-text btn-fill collage-category",class:{ 'active' : _vm.active_collage_category === 'Custom'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectCollageCategory('Custom')}}},[_vm._v("\n                                            Custom\n                                        ")]),_vm._v(" "),_vm._l((_vm.collages),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill collage-category",class:{ 'active' : t.name === _vm.active_collage_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectCollageCategory(t.name)}}},[_vm._v("\n                                            "+_vm._s(t.name)+"\n                                        ")])})]})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return [(_vm.active_collage_category === 'Custom')?_c('div',{staticClass:"collage-custom-form",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Ширина фрейма в Figma","placeholder":""},model:{value:(_vm.custom_collage_rawData.original_w),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "original_w", $$v)},expression:"custom_collage_rawData.original_w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Высота фрейма в Figma","placeholder":""},model:{value:(_vm.custom_collage_rawData.original_h),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "original_h", $$v)},expression:"custom_collage_rawData.original_h"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Ширина редактируемой области","placeholder":""},model:{value:(_vm.custom_collage_rawData.w),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "w", $$v)},expression:"custom_collage_rawData.w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Высота редактируемой области","placeholder":""},model:{value:(_vm.custom_collage_rawData.h),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "h", $$v)},expression:"custom_collage_rawData.h"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ сверху","placeholder":""},model:{value:(_vm.custom_collage_rawData.y),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "y", $$v)},expression:"custom_collage_rawData.y"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ слева","placeholder":""},model:{value:(_vm.custom_collage_rawData.x),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "x", $$v)},expression:"custom_collage_rawData.x"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Радиус верхний левый","placeholder":""},model:{value:(_vm.custom_collage_rawData.b_tl),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "b_tl", $$v)},expression:"custom_collage_rawData.b_tl"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус верхний правый","placeholder":""},model:{value:(_vm.custom_collage_rawData.b_tr),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "b_tr", $$v)},expression:"custom_collage_rawData.b_tr"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус нижний правый","placeholder":""},model:{value:(_vm.custom_collage_rawData.b_br),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "b_br", $$v)},expression:"custom_collage_rawData.b_br"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус нижний левый","placeholder":""},model:{value:(_vm.custom_collage_rawData.b_bl),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "b_bl", $$v)},expression:"custom_collage_rawData.b_bl"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"button"},on:{"click":_vm.addCustomCollage}},[_vm._v("\n                                                        Применить\n                                                    ")])],1)])]):_c('div',_vm._l((_vm.collages),function(t,index){return _c('div',_vm._l((t.data),function(c,index){return (t.name === _vm.active_collage_category)?_c('div',{staticClass:"collage-item"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.renderCollage(c))},on:{"click":_vm.addCollage}})]):_vm._e()}),0)}),0)]})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer collage-modal-footer"},[_vm._t("footer",function(){return [_c('div',{staticClass:"collage-frame-footer"},[_vm._v(_vm._s(_vm.collageModalFrameText))]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeCollageModal}},[_vm._v("\n                                            Закрыть\n                                        ")])]})],2)])])]):_vm._e(),_vm._v(" "),_c('card',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_text_active),expression:"is_text_active"}]},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                            Текст")]),_vm._v(" "),(_vm.is_text_active)?_c('div',{staticClass:"texts-buttons"},[_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.addText()}}},[_vm._v("Добавить текст\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.addText(false, true)}}},[_vm._v("Добавить tool\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showSVGModal()}}},[_vm._v("Добавить объект\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showFramesModal()}}},[_vm._v("Добавить фрейм\n                            ")])]):_vm._e(),_vm._v(" "),(_vm.is_text_active)?_c('div',{ref:"layersBar",staticClass:"texts-buttons layers-sticky"},[_vm._l((_vm.template.texts),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_text && _vm.active_type === 'text'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectText(index)}}},[_vm._v(_vm._s(t.text)+"\n                                "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.template.objects),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_object && _vm.active_type === 'object'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObject(index)}}},[_c('div',{staticClass:"button-preview",style:({ backgroundImage: 'url(\'' + _vm.objectPlayerSrc(t) + '\')' })}),_vm._v(" "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.template.frames),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_frame && _vm.active_type === 'frame'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectFrame(index)}}},[_c('div',{staticClass:"button-preview",style:({ backgroundImage: 'url(' + _vm.framesUrl + t.src + ')' })})])}),_vm._v(" "),((_vm.active_type === 'text' && _vm.template.texts.length) || (_vm.active_type === 'object' && _vm.template.objects.length) || (_vm.active_type === 'frame' && (_vm.template.frames || []).length))?_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.active_type === 'text' ? _vm.addText(_vm.active_text) : _vm.active_type === 'frame' ? _vm.addFrame(null, _vm.active_frame) : _vm.addObject(null, _vm.active_object)}}},[_vm._v("\n                                Копировать\n                            ")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.show_svg_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeSVGModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.server_graphics),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : t.name === _vm.active_object_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObjectCategory(t.name)}}},[_vm._v("\n                                                "+_vm._s(t.name)+"\n                                            ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return _vm._l((_vm.server_graphics),function(t,index){return _c('div',_vm._l((t.data),function(c,index){return (t.name === _vm.active_object_category)?_c('div',{staticClass:"object-item",on:{"click":function($event){return _vm.addObject(c)}}},[_c('img',{staticClass:"image",attrs:{"src":("" + _vm.graphicsUrl + (c.src))}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeSVGModal}},[_vm._v("\n                                                Закрыть\n                                            ")])]})],2)])])]):_vm._e(),_vm._v(" "),(_vm.show_frames_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeFramesModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.server_frames),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : t.id === _vm.active_frame_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectFrameCategory(t.id)}}},[_vm._v("\n                                                "+_vm._s(t.name)+"\n                                            ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"background":"#C9D5DF"}},[_vm._t("body",function(){return _vm._l((_vm.server_frames),function(t,index){return _c('div',_vm._l((t.data),function(f,index){return (t.id === _vm.active_frame_category)?_c('div',{staticClass:"frame-item",on:{"click":function($event){return _vm.addFrame(f)}}},[_c('img',{staticClass:"image",attrs:{"src":("" + (f.src_full))}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeFramesModal}},[_vm._v("\n                                                Закрыть\n                                            ")])]})],2)])])]):_vm._e(),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.textWaiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.active_type === 'text' && _vm.template && _vm.template.texts.length > 0)?_c('div',{staticClass:"col-md-4 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Текст")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text),expression:"template.texts[active_text].text"}],staticClass:"text-area",domProps:{"value":(_vm.template.texts[_vm.active_text].text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":_vm.template.texts[_vm.active_text].type ? 'Время появления tool (0 - c начала)' : 'Время появления текста (0 - c начала)',"placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_start),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_start", $$v)},expression:"template.texts[active_text].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_end),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_end", $$v)},expression:"template.texts[active_text].time_end"}})],1)]),_vm._v(" "),(_vm.template.texts[_vm.active_text].type)?_c('img',{staticClass:"widget-icon",attrs:{"src":("/static/img/widget" + (_vm.template.texts[_vm.active_text].type) + ".png")}}):_vm._e(),_vm._v(" "),(_vm.template.texts[_vm.active_text].type)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип виджета")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].type),expression:"template.texts[active_text].type"}],staticClass:"form-control",attrs:{"id":"widget-type-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeWidgetType(_vm.active_text, _vm.template.texts[_vm.active_text].type)}]}},_vm._l((_vm.widget_types),function(f){return _c('option',{domProps:{"value":f.id}},[_vm._v(_vm._s(f.name))])}),0)]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер шрифта: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].font_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"5","max":"200","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].font_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "font_size", $$v)},expression:"template.texts[active_text].font_size"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].z_index),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "z_index", $$v)},expression:"template.texts[active_text].z_index"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Шрифт")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].font_name),expression:"template.texts[active_text].font_name"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "font_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.sortedFonts),function(f){return _c('option',{domProps:{"value":f.name}},[_vm._v(_vm._s(f.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"control1"}},[_vm._v("По центру по\n                                            горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control1","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_x == 0.5},on:{"change":function($event){return _vm.setTextPosition(0.5, null)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Position X","placeholder":""},on:{"input":function (val) { return _vm.setTextPosition(val, null); }},model:{value:(_vm.template.texts[_vm.active_text].position_x),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "position_x", $$v)},expression:"template.texts[active_text].position_x"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"control2"}},[_vm._v("По центру по\n                                            вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control2","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_y == 0.5},on:{"change":function($event){return _vm.setTextPosition(null, 0.5)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Position Y","placeholder":""},on:{"input":function (val) { return _vm.setTextPosition(null, val); }},model:{value:(_vm.template.texts[_vm.active_text].position_y),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "position_y", $$v)},expression:"template.texts[active_text].position_y"}})],1),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "alpha", $$v)},expression:"template.texts[active_text].alpha"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control1"}},[_vm._v("Text brush")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].is_text_brush),expression:"template.texts[active_text].is_text_brush"}],staticClass:"form-check-inline",attrs:{"id":"control1","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.texts[_vm.active_text].is_text_brush)?_vm._i(_vm.template.texts[_vm.active_text].is_text_brush,null)>-1:(_vm.template.texts[_vm.active_text].is_text_brush)},on:{"change":function($event){var $$a=_vm.template.texts[_vm.active_text].is_text_brush,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template.texts[_vm.active_text], "is_text_brush", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template.texts[_vm.active_text], "is_text_brush", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template.texts[_vm.active_text], "is_text_brush", $$c)}}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.template.texts[_vm.active_text].is_text_brush)?_c('label',{staticClass:"control-label"},[_vm._v("Text brush data")]):_vm._e(),_vm._v(" "),(_vm.template.texts[_vm.active_text].is_text_brush)?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_brush_data),expression:"template.texts[active_text].text_brush_data"}],staticClass:"text-area",domProps:{"value":(_vm.template.texts[_vm.active_text].text_brush_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text_brush_data", $event.target.value)}}}):_vm._e()]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот текста (градусы)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].angle),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "angle", $$v)},expression:"template.texts[active_text].angle"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межбуквенный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].letter_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "letter_spacing", $$v)},expression:"template.texts[active_text].letter_spacing"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межстрочный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].line_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "line_spacing", $$v)},expression:"template.texts[active_text].line_spacing"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет текста: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].text_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_color),expression:"template.texts[active_text].text_color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].text_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.texts[_vm.active_text].text_color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'color')}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет фона:\n                                            "),(_vm.template.texts[_vm.active_text].background_color === 'transparent')?_c('span',{staticClass:"param-span"},[_vm._v("Прозрачный")]):_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].background_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].background_color),expression:"template.texts[active_text].background_color"},{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "background_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"background-control"}},[_vm._v("Прозрачный")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"background-control","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].background_color === 'transparent'},on:{"change":function($event){return _vm.toggleBackground()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.texts[_vm.active_text].background_color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'background')}}})}),0)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Прозрачность фона: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].bg_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].bg_alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "bg_alpha", $$v)},expression:"template.texts[active_text].bg_alpha"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"animated-control"}},[_vm._v("Анимированный (привязан к кусочку)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].is_animated),expression:"template.texts[active_text].is_animated"}],staticClass:"form-check-inline",attrs:{"true-value":"1","false-value":"0","id":"animated-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.texts[_vm.active_text].is_animated)?_vm._i(_vm.template.texts[_vm.active_text].is_animated,null)>-1:_vm._q(_vm.template.texts[_vm.active_text].is_animated,"1")},on:{"change":function($event){var $$a=_vm.template.texts[_vm.active_text].is_animated,$$el=$event.target,$$c=$$el.checked?("1"):("0");if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template.texts[_vm.active_text], "is_animated", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template.texts[_vm.active_text], "is_animated", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template.texts[_vm.active_text], "is_animated", $$c)}}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Направление текста")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].direction),expression:"template.texts[active_text].direction"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "direction", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"normal"}},[_vm._v("normal")]),_vm._v(" "),_c('option',{attrs:{"value":"vertical"}},[_vm._v("vertical")]),_vm._v(" "),_c('option',{attrs:{"value":"round"}},[_vm._v("round")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].animation_type),expression:"template.texts[active_text].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name)+"\n                                            ")])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].animation_duration))])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"20","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "animation_duration", $$v)},expression:"template.texts[active_text].animation_duration"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Выравнивание "),_c('br'),_vm._v("(если больше одной строки)")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_align),expression:"template.texts[active_text].text_align"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "text_align", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.text_aligns),function(ta){return _c('option',{domProps:{"value":ta.name}},[_vm._v(_vm._s(ta.name)+"\n                                            ")])}),0)]),_vm._v(" "),_c('label',{attrs:{"for":"shadow-color"}},[_vm._v("Цвет тени:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].shadow_color),expression:"template.texts[active_text].shadow_color"}],attrs:{"type":"color","id":"shadow-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "shadow_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Радиус размытия тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_blur))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_blur),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_blur", $$v)},expression:"template.texts[active_text].shadow_blur"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Сдвиг тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_distance))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_distance),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_distance", $$v)},expression:"template.texts[active_text].shadow_distance"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_alpha", $$v)},expression:"template.texts[active_text].shadow_alpha"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер обводки: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].stroke_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].stroke_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "stroke_size", $$v)},expression:"template.texts[active_text].stroke_size"}}),_vm._v(" "),_c('label',{attrs:{"for":"stroke-color"}},[_vm._v("Цвет обводки:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].stroke_color),expression:"template.texts[active_text].stroke_color"}],attrs:{"type":"color","id":"stroke-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].stroke_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "stroke_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeText(_vm.active_text)}}},[_vm._v("Удалить текст\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),(_vm.active_type === 'object' && _vm.template && _vm.template.objects.length > 0)?_c('div',{staticClass:"col-md-4 c-labels"},[_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.changeObject()}}},[_vm._v("Заменить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Объект")]),_vm._v(" "),_c('img',{staticClass:"object-preview",attrs:{"alt":"","src":_vm.objectPlayerSrc(_vm.template.objects[_vm.active_object])},on:{"click":function($event){return _vm.changeObject()}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления объекта (0 - c начала)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_start),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_start", $$v)},expression:"template.objects[active_object].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_end),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_end", $$v)},expression:"template.objects[active_object].time_end"}})],1)]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Размер:","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].scale),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "scale", $$v)},expression:"template.objects[active_object].scale"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0.03","max":"5","step":"0.0001","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].scale),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "scale", $$v)},expression:"template.objects[active_object].scale"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].z_index),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "z_index", $$v)},expression:"template.objects[active_object].z_index"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control3"}},[_vm._v("По центру по\n                                            горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control3","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_x == 0.5},on:{"change":function($event){return _vm.setObjectPosition(0.5, null)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Position X","placeholder":""},on:{"input":function (val) { return _vm.setObjectPosition(val, null); }},model:{value:(_vm.template.objects[_vm.active_object].position_x),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "position_x", $$v)},expression:"template.objects[active_object].position_x"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control4"}},[_vm._v("По центру по\n                                            вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control4","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_y == 0.5},on:{"change":function($event){return _vm.setObjectPosition(null, 0.5)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Position Y","placeholder":""},on:{"input":function (val) { return _vm.setObjectPosition(null, val); }},model:{value:(_vm.template.objects[_vm.active_object].position_y),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "position_y", $$v)},expression:"template.objects[active_object].position_y"}})],1),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот объекта (градусы)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].angle),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "angle", $$v)},expression:"template.objects[active_object].angle"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].id.indexOf('nocolor') < 0 && !_vm.isGifSrc(_vm.template.objects[_vm.active_object].id)),expression:"template.objects[active_object].id.indexOf('nocolor') < 0 && !isGifSrc(template.objects[active_object].id)"}],staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].color),expression:"template.objects[active_object].color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.objects[_vm.active_object].color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.objects[_vm.active_object], "color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.objects[_vm.active_object].color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setObjColor(c)}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"object-animated-control"}},[_vm._v("Анимированный (привязан к кусочку)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].is_animated),expression:"template.objects[active_object].is_animated"}],staticClass:"form-check-inline",attrs:{"true-value":"1","false-value":"0","id":"object-animated-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.objects[_vm.active_object].is_animated)?_vm._i(_vm.template.objects[_vm.active_object].is_animated,null)>-1:_vm._q(_vm.template.objects[_vm.active_object].is_animated,"1")},on:{"change":function($event){var $$a=_vm.template.objects[_vm.active_object].is_animated,$$el=$event.target,$$c=$$el.checked?("1"):("0");if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template.objects[_vm.active_object], "is_animated", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template.objects[_vm.active_object], "is_animated", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template.objects[_vm.active_object], "is_animated", $$c)}}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].animation_type),expression:"template.objects[active_object].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.objects[_vm.active_object], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name)+"\n                                            ")])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].animation_duration))])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"20","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "animation_duration", $$v)},expression:"template.objects[active_object].animation_duration"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].alpha),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "alpha", $$v)},expression:"template.objects[active_object].alpha"}}),_vm._v(" "),_c('label',{attrs:{"for":"shadow-color"}},[_vm._v("Цвет тени:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].shadow_color),expression:"template.objects[active_object].shadow_color"}],attrs:{"type":"color","id":"shadow-color"},domProps:{"value":(_vm.template.objects[_vm.active_object].shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.objects[_vm.active_object], "shadow_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Радиус размытия тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].shadow_blur))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].shadow_blur),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "shadow_blur", $$v)},expression:"template.objects[active_object].shadow_blur"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Сдвиг тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].shadow_distance))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].shadow_distance),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "shadow_distance", $$v)},expression:"template.objects[active_object].shadow_distance"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].shadow_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].shadow_alpha),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "shadow_alpha", $$v)},expression:"template.objects[active_object].shadow_alpha"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Src","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].id),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "id", $$v)},expression:"template.objects[active_object].id"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeObject(_vm.active_object)}}},[_vm._v("Удалить объект\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),(_vm.active_type === 'frame' && _vm.template && _vm.template.frames[_vm.active_frame])?_c('div',{staticClass:"col-md-4 c-labels"},[_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.changeFrame()}}},[_vm._v("Заменить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления фрейма (0 - c начала)","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].time_start),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "time_start", $$v)},expression:"template.frames[active_frame].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].time_end),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "time_end", $$v)},expression:"template.frames[active_frame].time_end"}})],1)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.frames[_vm.active_frame].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].alpha),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "alpha", $$v)},expression:"template.frames[active_frame].alpha"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].z_index),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "z_index", $$v)},expression:"template.frames[active_frame].z_index"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Ширина слайда в Figma","placeholder":""},on:{"input":_vm.onFrameRawDataChange},model:{value:(_vm.template.frames[_vm.active_frame].rawData.original_w),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame].rawData, "original_w", $$v)},expression:"template.frames[active_frame].rawData.original_w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Ширина фрейма","placeholder":""},on:{"input":_vm.onFrameRawDataChange},model:{value:(_vm.template.frames[_vm.active_frame].rawData.w),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame].rawData, "w", $$v)},expression:"template.frames[active_frame].rawData.w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ сверху","placeholder":""},on:{"input":_vm.onFrameRawDataChange},model:{value:(_vm.template.frames[_vm.active_frame].rawData.y),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame].rawData, "y", $$v)},expression:"template.frames[active_frame].rawData.y"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ слева","placeholder":""},on:{"input":_vm.onFrameRawDataChange},model:{value:(_vm.template.frames[_vm.active_frame].rawData.x),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame].rawData, "x", $$v)},expression:"template.frames[active_frame].rawData.x"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот объекта (градусы)","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].angle),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "angle", $$v)},expression:"template.frames[active_frame].angle"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Src","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].src),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "src", $$v)},expression:"template.frames[active_frame].src"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeFrame(_vm.active_frame)}}},[_vm._v("Удалить фрейм\n                                    ")])],1):_vm._e(),_vm._v(" "),(!(_vm.active_type === 'text' && _vm.template && _vm.template.texts.length > 0) &&
                                           !(_vm.active_type === 'object' && _vm.template && _vm.template.objects.length > 0) &&
                                           !(_vm.active_type === 'frame' && _vm.template && _vm.template.frames[_vm.active_frame]))?_c('div',{staticClass:"col-md-4 c-labels"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[(_vm.template)?_c('div',{staticClass:"preview-sticky",style:({ top: _vm.layersBarHeight + 'px' }),attrs:{"id":"preview-container"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.src_full),expression:"template.src_full"}],style:({ height: _vm.heightCanvas + 'px' }),attrs:{"id":"player"}},[(!_vm.isVideo(_vm.template.preview_src_full))?_c('video',{ref:"videoContainer",staticStyle:{"max-width":"100%","cursor":"pointer","border":"1px solid red","position":"relative","z-index":"0"},style:({ height: _vm.heightCanvas + 'px', zIndex: 0 }),attrs:{"controls":"","disablepictureinpicture":"","muted":"","controlsList":"nofullscreen nodownload noremoteplayback noplaybackrate","playsinline":"","id":"video_player","poster":_vm.template.preview_src_full},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.template.src_full}})]):_vm._e(),_vm._v(" "),(_vm.isVideo(_vm.template.preview_src_full))?_c('video',{ref:"videoContainer",staticStyle:{"max-width":"100%","cursor":"pointer","border":"1px solid red","position":"relative","z-index":"0"},style:({ height: _vm.heightCanvas + 'px', zIndex: 0 }),attrs:{"controls":"","disablepictureinpicture":"","muted":"","controlsList":"nofullscreen nodownload noremoteplayback noplaybackrate","playsinline":"","id":"video_player2"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.template.src_full}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.template.texts),function(tt,index){return (tt.font_size)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible !== 0),expression:"tt.is_visible !== 0"}],ref:"draggableContainer",refInFor:true,staticClass:"draggable-container",style:({ zIndex: tt.z_index }),attrs:{"id":("" + index)}},[(_vm.fonts.length > 1)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header",class:{ active: index === _vm.active_text && _vm.active_type === 'text' },domProps:{"innerHTML":_vm._s(_vm.text_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e()]):_vm._e()}),_vm._v(" "),_vm._l((_vm.template.objects),function(tt,index){return (tt.scale)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible !== 0),expression:"tt.is_visible !== 0"}],ref:"draggableContainer2",refInFor:true,staticClass:"draggable-container",style:({ zIndex: tt.z_index }),attrs:{"id":("o" + index)}},[(tt.id.indexOf('.svg') > 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header nospace",class:{ active: index === _vm.active_object && _vm.active_type === 'object' },domProps:{"innerHTML":_vm._s(_vm.object_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e(),_vm._v(" "),(tt.id.indexOf('.svg') < 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header nospace",class:{ active: index === _vm.active_object && _vm.active_type === 'object' },domProps:{"innerHTML":_vm._s(_vm.image_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e()]):_vm._e()}),_vm._v(" "),_vm._l((_vm.template.frames),function(fr,index){return (fr.layouts)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(fr.is_visible !== 0),expression:"fr.is_visible !== 0"}],ref:"draggableContainer3",refInFor:true,staticClass:"draggable-container",style:({ zIndex: fr.z_index }),attrs:{"id":("f" + index)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(fr.is_visible === 1),expression:"fr.is_visible === 1"}],staticClass:"draggable-header nospace",class:{ active: index === _vm.active_frame && _vm.active_type === 'frame' },domProps:{"innerHTML":_vm._s(_vm.frame_html(index))},on:{"mousedown":_vm.dragMouseDown}})]):_vm._e()})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-toggle",class:{ 'active-state': _vm.template.src_full },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.showPreview()}}},[_vm._v("\n                                            Показать превью\n                                        ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[(_vm.template)?_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Параметры видео\n                            "),(_vm.realVideoDuration)?_c('div',{staticClass:"realDuration"},[_vm._v("\n                                Длительность из видео:\n                                "),_c('span',{class:{'bg-danger' : Math.abs(this.sumParts - this.realVideoDuration.toFixed(2)) > 0}},[_vm._v(_vm._s(_vm.realVideoDuration.toFixed(2)))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partsDuration"},[_vm._v("\n                                Длительность фрагментов:\n                            "),_c('span',{class:{'bg-danger' : Math.abs(this.sumParts - this.template.duration) > 0}},[_vm._v(_vm._s(_vm.sumParts))])])]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Длительность, сек.","placeholder":""},on:{"input":function($event){return _vm.formatVideoDuration($event)}},model:{value:(_vm.template.duration),callback:function ($$v) {_vm.$set(_vm.template, "duration", $$v)},expression:"template.duration"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество фрагментов","placeholder":""},on:{"input":_vm.changeVideoCount},nativeOn:{"focusout":function($event){return _vm.commitVideoCount.apply(null, arguments)}},model:{value:(_vm.template.videos),callback:function ($$v) {_vm.$set(_vm.template, "videos", $$v)},expression:"template.videos"}}),_vm._v(" "),_c('div',{staticClass:"form-group paste-durations"},[_c('label',{staticClass:"control-label"},[_vm._v("Вставить длительности из таблицы")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.pastedDurations),expression:"pastedDurations"}],staticClass:"form-control",attrs:{"rows":"5","placeholder":'0.53\n0.23\n0.90\n0.90\n1.13'},domProps:{"value":(_vm.pastedDurations)},on:{"paste":_vm.onPasteDurations,"blur":_vm.applyPastedDurations,"input":function($event){if($event.target.composing){ return; }_vm.pastedDurations=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"paste-durations-hint"},[_vm._v("\n                                            По одному числу в строке. Заголовок и пустые строки пропускаются.\n                                            "),(_vm.pastedDurationsCount)?_c('span',{staticClass:"paste-durations-applied"},[_vm._v("\n                                                Заполнено "+_vm._s(_vm.pastedDurationsCount)+" кусочков\n                                            ")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-sm paste-durations-btn",attrs:{"type":"button"},on:{"click":_vm.applyPastedDurations}},[_vm._v("\n                                            Заполнить\n                                        ")])]),_vm._v(" "),_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Фрагменты\n                                    ")]),_vm._v(" "),_vm._l((_vm.visibleClientParts),function(itm,index){return _c('div',{key:index,staticClass:"content",class:{ 'part-empty-duration': _vm.isPartDurationInvalid(index) }},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"part-actions"},[_c('button',{staticClass:"part-action-btn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.duplicatePart(index)}}},[_vm._v("Дублировать\n                                                ")]),_vm._v(" "),_c('button',{staticClass:"part-action-btn part-action-delete",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removePart(index)}}},[_vm._v("Удалить\n                                                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('span',{staticClass:"block-number"},[_vm._v(_vm._s(index + 1)+".")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3",class:{ 'has-error part-duration-error': _vm.isPartDurationInvalid(index) }},[_c('fg-input',{attrs:{"type":"text","label":"Длительн.","placeholder":""},on:{"input":function($event){return _vm.formatDuration($event, index)}},model:{value:(_vm.client_parts[index].duration),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "duration", $$v)},expression:"client_parts[index].duration"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Скорость","placeholder":""},on:{"input":function($event){return _vm.formatSpeed($event, index)}},model:{value:(_vm.client_parts[index].speed),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "speed", $$v)},expression:"client_parts[index].speed"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Эффект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].effect_type),expression:"client_parts[index].effect_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "effect_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeEffectType(index, _vm.client_parts[index].effect_type)}]}},_vm._l((_vm.effect_types),function(e){return _c('option',{domProps:{"value":e.id}},[_vm._v("\n                                                                "+_vm._s(e.name)+"\n                                                            ")])}),0)])])]),_vm._v(" "),(_vm.template.is_cut_out)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"cut-out-2-control"}},[_vm._v("Cutout-кусочек")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].cutout_only),expression:"client_parts[index].cutout_only"}],staticClass:"form-check-inline",attrs:{"id":"cut-out-2-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.client_parts[index].cutout_only)?_vm._i(_vm.client_parts[index].cutout_only,null)>-1:(_vm.client_parts[index].cutout_only)},on:{"change":function($event){var $$a=_vm.client_parts[index].cutout_only,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.client_parts[index], "cutout_only", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.client_parts[index], "cutout_only", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.client_parts[index], "cutout_only", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип анимации (cutout)")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].cutout_animation_type),expression:"client_parts[index].cutout_animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "cutout_animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(a){return _c('option',{domProps:{"value":a.id}},[_vm._v("\n                                                                "+_vm._s(a.name)+"\n                                                            ")])}),0)])]),_vm._v(" "),(_vm.client_parts[index].cutout_only)?_c('div',{staticClass:"col-md-4",staticStyle:{"padding-right":"15px !important"}},[_c('fg-input',{attrs:{"type":"text","label":"Время появления (cutout)","placeholder":""},on:{"input":function($event){return _vm.formatStartTime($event, index, 'cutout_start_time')}},model:{value:(_vm.client_parts[index].cutout_start_time),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "cutout_start_time", $$v)},expression:"client_parts[index].cutout_start_time"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.template.is_cut_out)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Длительность анимации (cutout): "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.client_parts[index].cutout_animation_duration))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"20","step":"0.1","label":"","placeholder":""},model:{value:(_vm.client_parts[index].cutout_animation_duration),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "cutout_animation_duration", $$v)},expression:"client_parts[index].cutout_animation_duration"}})],1)]):_vm._e(),_vm._v(" "),(_vm.client_parts[index].cutout_only)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"effect-values"},[_vm._v("\n                                                    Позиция (cutout)\n                                                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"cutout-preview",on:{"click":function($event){return _vm.changeCutoutPosition($event, index)}}},[_c('span',{staticClass:"cutout-area",style:({'top': _vm.client_parts[index].cutout_y * 87 - 15 + 'px',
                                                                        'left': _vm.client_parts[index].cutout_x * 48 - 15 + 'px'})},[_c('span',{staticClass:"cutout-center"})])]),_vm._v(" "),_c('span',{staticClass:"cutout-position",staticStyle:{"padding-left":"9px"}},[_vm._v(_vm._s(_vm.client_parts[index].cutout_x))]),_vm._v(" "),_c('span',{staticClass:"cutout-position"},[_vm._v(_vm._s(_vm.client_parts[index].cutout_y))])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[(_vm.template.is_cut_out)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Размер (cutout): "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.client_parts[index].cutout_scale))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"2","step":"0.1","label":"","placeholder":""},model:{value:(_vm.client_parts[index].cutout_scale),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "cutout_scale", $$v)},expression:"client_parts[index].cutout_scale"}})],1)]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",class:{ bordered: _vm.client_parts[index].effect_type === 0 }},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-text btn-fill active control-btn collage-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showCollageModal(index)}}},[_vm._v("Коллаж +\n                                                        ")])])]),_vm._v(" "),(_vm.client_parts[index].collage_type)?_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Время начала","placeholder":""},on:{"input":function($event){return _vm.formatStartTime($event, index, 'start_time')}},model:{value:(_vm.client_parts[index].start_time),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "start_time", $$v)},expression:"client_parts[index].start_time"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4",staticStyle:{"padding-right":"15px !important"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Контент")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].content_type),expression:"client_parts[index].content_type"}],staticClass:"form-control",attrs:{"id":"content-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "content_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeContentType(index, _vm.client_parts[index].content_type)}]}},_vm._l((_vm.content_types),function(e){return _c('option',{domProps:{"value":e.id}},[_vm._v("\n                                                                "+_vm._s(e.name)+"\n                                                            ")])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.client_parts[index].content_type === 1),expression:"client_parts[index].content_type === 1"}],staticClass:"col-md-6 ml9"},[_c('div',[_c('h5',{staticClass:"card-title"},[_vm._v("\n                                                            Контент: "),(_vm.client_parts[index].content)?_c('span',[(_vm.isContentCorrected(_vm.client_parts[index].content))?_c('a',{attrs:{"href":_vm.client_parts[index].content_full,"target":"_blank"}},[_vm._v("(ссылка)")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:("contentFileInput_" + index),refInFor:true,staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'content', index)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.clickContentFileButton(index)}}},[_vm._v("\n                                                                Загрузить\n                                                            ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.client_parts[index].content_type === 2),expression:"client_parts[index].content_type === 2"}],staticClass:"col-md-6 ml9"},[_c('div',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Фон контента: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.getContentColor(_vm.client_parts[index].content)))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].content),expression:"client_parts[index].content"}],attrs:{"type":"color"},domProps:{"value":(_vm.client_parts[index].content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client_parts[index], "content", $event.target.value)}}})])])])]),_vm._v(" "),(_vm.client_parts[index].collage_type)?_c('div',{staticClass:"row bordered"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"collage-preview",domProps:{"innerHTML":_vm._s(_vm.renderCollagePart(_vm.client_parts[index].collage_type, index))},on:{"click":function($event){return _vm.showCollageModal(index)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-danger btn-fill btn-delete-collage",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removeCollageFromPart(index)}}},[_vm._v("Удалить коллаж\n                                                    ")])])]):_vm._e(),_vm._v(" "),((_vm.client_parts[index].effect_type === 1 || _vm.client_parts[index].effect_type === 2) && _vm.client_parts[index].effect_values)?_c('div',{staticClass:"row bordered"},[_c('div',{staticClass:"effect-values"},[_vm._v("\n                                                    "+_vm._s(_vm.effect_types[_vm.client_parts[index].effect_type].name)+" - Параметры\n                                                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"effect-preview",on:{"click":function($event){return _vm.changeEffectPosition($event, index)}}},[_c('span',{staticClass:"effect-area",style:({'top': _vm.client_parts[index].effect_values.y * 87 - 15 + 'px',
                                                                        'left': _vm.client_parts[index].effect_values.x * 48 - 15 + 'px'})},[_c('span',{staticClass:"effect-center"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"Начальное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.from),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "from", $$v)},expression:"client_parts[index].effect_values.from"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"Конечное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.to),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "to", $$v)},expression:"client_parts[index].effect_values.to"}})],1)]):_vm._e()])])})],2)])])]):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WSC3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

function unsavedReplacer(key, value) {
    if (key === 'source' || key === 'is_visible') return undefined;
    return value;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            unsavedSnapshot: null,
            allowUnsavedLeave: false
        };
    },
    created: function created() {
        window.addEventListener('beforeunload', this.onUnsavedBeforeUnload);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('beforeunload', this.onUnsavedBeforeUnload);
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (this.confirmUnsavedLeave()) next();else next(false);
    },

    methods: {
        getUnsavedState: function getUnsavedState() {
            return '';
        },
        stringifyUnsaved: function stringifyUnsaved(data) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data, unsavedReplacer);
        },
        captureUnsavedSnapshot: function captureUnsavedSnapshot() {
            var self = this;
            this.$nextTick(function () {
                self.unsavedSnapshot = self.getUnsavedState();
            });
        },
        hasUnsavedChanges: function hasUnsavedChanges() {
            if (this.allowUnsavedLeave || this.unsavedSnapshot === null) return false;
            return this.getUnsavedState() !== this.unsavedSnapshot;
        },
        confirmUnsavedLeave: function confirmUnsavedLeave() {
            if (!this.hasUnsavedChanges()) return true;
            return window.confirm('Выйти без сохранений?');
        },
        onUnsavedBeforeUnload: function onUnsavedBeforeUnload(e) {
            if (!this.hasUnsavedChanges()) return;
            e.preventDefault();
            e.returnValue = '';
        }
    }
});

/***/ }),

/***/ "WUb1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WiDG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Viewer;
function Viewer(_ref) {
    var next = _ref.next,
        router = _ref.router;

    if (!localStorage.getItem('token') || !localStorage.getItem('new-auth-2')) {
        return router.push({ name: 'login' });
    }

    return next();
}

/***/ }),

/***/ "Wld7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wq76":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                            Общая информация")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.post)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.category_id),expression:"post.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return (c.id !== 999)?_c('option',{domProps:{"value":c.id}},[_vm._v("\n                                                "+_vm._s(c.name)+"\n                                            ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.status),expression:"post.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Опубликовано")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ожидает")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Минимальная версия Muse")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.v),expression:"post.v"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "v", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Все версии")]),_vm._v(" "),_vm._l((_vm.versions),function(version){return _c('option',{key:version,domProps:{"value":version}},[_vm._v("\n                                                "+_vm._s(version)+"\n                                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Минимальная версия Nola")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.v_nola),expression:"post.v_nola"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "v_nola", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Все версии")]),_vm._v(" "),_vm._l((_vm.nolaVersions),function(version){return _c('option',{key:'nola-' + version,domProps:{"value":version}},[_vm._v("\n                                                "+_vm._s(version)+"\n                                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Формат")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.ratio),expression:"post.ratio"}],staticClass:"form-control",attrs:{"id":"ratio-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "ratio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeRatioType()}]}},[_c('option',{attrs:{"value":"1"}},[_vm._v("4:5")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("4:3")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("9:16")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("1:1")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество медиа","value":_vm.calculatedMediaCount,"disabled":""}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.post.sort),callback:function ($$v) {_vm.$set(_vm.post, "sort", $$v)},expression:"post.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка Nola (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.post.sort_nola),callback:function ($$v) {_vm.$set(_vm.post, "sort_nola", $$v)},expression:"post.sort_nola"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 checkbox-block"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.is_premium),expression:"post.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.post.is_premium)?_vm._i(_vm.post.is_premium,null)>-1:(_vm.post.is_premium)},on:{"change":function($event){var $$a=_vm.post.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.post, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.post, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.post, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trendy-control"}},[_vm._v("Популярное")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.is_trendy),expression:"post.is_trendy"}],staticClass:"form-check-inline",attrs:{"id":"trendy-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.post.is_trendy)?_vm._i(_vm.post.is_trendy,null)>-1:(_vm.post.is_trendy)},on:{"change":function($event){var $$a=_vm.post.is_trendy,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.post, "is_trendy", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.post, "is_trendy", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.post, "is_trendy", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"new-control"}},[_vm._v("Новое")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.is_new),expression:"post.is_new"}],staticClass:"form-check-inline",attrs:{"id":"new-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.post.is_new)?_vm._i(_vm.post.is_new,null)>-1:(_vm.post.is_new)},on:{"change":function($event){var $$a=_vm.post.is_new,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.post, "is_new", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.post, "is_new", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.post, "is_new", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет фона: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.post.background))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.background),expression:"post.background"}],attrs:{"type":"color"},domProps:{"value":(_vm.post.background)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "background", $event.target.value)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"","placeholder":""},model:{value:(_vm.post.background),callback:function ($$v) {_vm.$set(_vm.post, "background", $$v)},expression:"post.background"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"margin-top"},[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                                    Превью: "),(_vm.post.preview_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.post.preview_src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.post.preview_src_size)+"Mb")]):(_vm.post.preview_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.post.preview_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.post.preview_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.post.preview_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"preview-img device-block device1",attrs:{"src":_vm.post.preview_src_full},on:{"click":function($event){$event.preventDefault();return _vm.openResource(_vm.post.preview_src_full)}}}),_vm._v(" "),_c('div',[_c('input',{ref:"previewFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'preview_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.previewFileInput.click()}}},[_vm._v("\n                                                        Загрузить\n                                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.post.category_id || !_vm.post.preview_src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                    Сохранить\n                                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-fill float-right btn-delete",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.remove.apply(null, arguments)}}},[_vm._v("\n                                    Удалить шаблон\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"}),_vm._v(" "),(_vm.template)?_c('div',{staticClass:"col-md-12"},[(_vm.show_collage_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeCollageModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.collages),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill collage-category",class:{ 'active' : t.name === _vm.active_collage_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectCollageCategory(t.name)}}},[_vm._v("\n                                            "+_vm._s(t.name)+"\n                                        ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return _vm._l((_vm.collages),function(t,index){return _c('div',_vm._l((t.data),function(c,index){return (t.name === _vm.active_collage_category)?_c('div',{staticClass:"collage-item"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.renderCollage(c))},on:{"click":_vm.addCollage}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeCollageModal}},[_vm._v("\n                                            Закрыть\n                                        ")])]})],2)])])]):_vm._e(),_vm._v(" "),_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                            Настройка шаблона ("+_vm._s(_vm.post.parts.length)+" слайдов)")]),_vm._v(" "),_vm._l((_vm.post.parts),function(p,index){return _c('div',{staticClass:"preview-slide",class:{ 'active' : index === _vm.active_part_index },style:({ backgroundImage: 'url(' + p.src_full + ')', height: _vm.previewSlideHeight + 'px' }),on:{"click":function($event){return _vm.selectPart(index)}}})}),_vm._v(" "),_c('div',{staticClass:"preview-slide add-part",style:({ height: _vm.previewSlideHeight + 'px' }),on:{"click":function($event){return _vm.addPart()}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"row margin-top bordered-block"},[_c('div',{staticClass:"col-md-2"},[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Превью: "),(_vm.template.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]):(_vm.template.src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"srcPreviewFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.srcPreviewFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),(_vm.template.src)?_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"video-preview-control"}},[_vm._v("Видеопревью")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.video_preview),expression:"template.video_preview"}],staticClass:"form-check-inline",attrs:{"id":"video-preview-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.video_preview)?_vm._i(_vm.template.video_preview,null)>-1:(_vm.template.video_preview)},on:{"change":[function($event){var $$a=_vm.template.video_preview,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "video_preview", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "video_preview", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "video_preview", $$c)}},_vm.toggleVideoPreview]}})]):_vm._e(),_vm._v(" "),(_vm.template.src && _vm.template.video_preview)?_c('div',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Видео: "),(_vm.template.video_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.video_src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.video_src_size)+"Mb")]):(_vm.template.video_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.video_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.video_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.video_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('input',{ref:"videoSrcFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"video/*"},on:{"change":function($event){return _vm.uploadFile($event, 'video_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.videoSrcFileInput.click()}}},[_vm._v("\n                                        Загрузить видео\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Номер слайда (от 1 до N)","placeholder":""},on:{"input":_vm.updatePartsOrder},model:{value:(_vm.template.n),callback:function ($$v) {_vm.$set(_vm.template, "n", $$v)},expression:"template.n"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove mt25",attrs:{"type":"button"},on:{"click":function($event){return _vm.removePart()}}},[_vm._v("Удалить слайд\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-text btn-fill active control-btn",staticStyle:{"margin-top":"25px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.copyPart()}}},[_vm._v("Дублировать слайд\n                                ")])])]),_vm._v(" "),(_vm.template)?_c('div',{staticClass:"texts-buttons"},[_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.addLayout()}}},[_vm._v("Добавить layout\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.addText()}}},[_vm._v("Добавить текст\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.addText(false, true)}}},[_vm._v("Добавить tool\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showSVGModal()}}},[_vm._v("Добавить объект\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showFramesModal()}}},[_vm._v("Добавить фрейм\n                            ")])]):_vm._e(),_vm._v(" "),(_vm.template)?_c('div',{ref:"layersBar",staticClass:"texts-buttons layers-sticky"},[_vm._l((_vm.template.layouts),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_layout && _vm.active_type === 'layout'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectLayout(index)}}},[_vm._v("Layout "+_vm._s(index + 1)+"\n                            ")])}),_vm._v(" "),_vm._l((_vm.template.texts),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_text && _vm.active_type === 'text'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectText(index)}}},[_vm._v(_vm._s(t.text)+"\n                                "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.template.objects),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_object && _vm.active_type === 'object'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObject(index)}}},[_c('div',{staticClass:"button-preview",style:({ backgroundImage: 'url(\'' + _vm.objectPlayerSrc(t) + '\')' })}),_vm._v(" "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.template.frames),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_frame && _vm.active_type === 'frame'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectFrame(index)}}},[_c('div',{staticClass:"button-preview",style:({ backgroundImage: 'url(' + _vm.framesUrl + t.src + ')' })})])}),_vm._v(" "),(_vm.active_type === 'text' || _vm.active_type === 'layout' || _vm.active_type === 'object' || _vm.active_type === 'frame')?_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.active_type === 'text' ? _vm.addText(_vm.active_text) : _vm.active_type === 'layout' ? _vm.addLayout(_vm.active_layout) : _vm.active_type === 'frame' ? _vm.addFrame(null, _vm.active_frame) : _vm.addObject(null, _vm.active_object)}}},[_vm._v("\n                                Копировать\n                            ")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.show_svg_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeSVGModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.server_graphics),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : t.name === _vm.active_object_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObjectCategory(t.name)}}},[_vm._v("\n                                                "+_vm._s(t.name)+"\n                                            ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return _vm._l((_vm.server_graphics),function(t,index){return _c('div',_vm._l((t.data),function(c,index){return (t.name === _vm.active_object_category)?_c('div',{staticClass:"object-item",on:{"click":function($event){return _vm.addObject(c)}}},[_c('img',{staticClass:"image",attrs:{"src":("" + _vm.graphicsUrl + (c.src))}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeSVGModal}},[_vm._v("\n                                                Закрыть\n                                            ")])]})],2)])])]):_vm._e(),_vm._v(" "),(_vm.show_frames_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeFramesModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.server_frames),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : t.id === _vm.active_frame_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectFrameCategory(t.id)}}},[_vm._v("\n                                                "+_vm._s(t.name)+"\n                                            ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"background":"#C9D5DF"}},[_vm._t("body",function(){return _vm._l((_vm.server_frames),function(t,index){return _c('div',_vm._l((t.data),function(f,index){return (t.id === _vm.active_frame_category)?_c('div',{staticClass:"frame-item",on:{"click":function($event){return _vm.addFrame(f)}}},[_c('img',{staticClass:"image",attrs:{"src":("" + (f.src_full))}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeFramesModal}},[_vm._v("\n                                                Закрыть\n                                            ")])]})],2)])])]):_vm._e(),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.textWaiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.active_type === 'layout' && _vm.template && _vm.template.layouts[_vm.active_layout])?_c('div',{staticClass:"col-md-3 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.layouts[_vm.active_layout].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].alpha),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout], "alpha", $$v)},expression:"template.layouts[active_layout].alpha"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].z_index),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout], "z_index", $$v)},expression:"template.layouts[active_layout].z_index"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"content-control"}},[_vm._v("Контент")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.layouts[_vm.active_layout].is_content),expression:"template.layouts[active_layout].is_content"}],staticClass:"form-check-inline",attrs:{"id":"content-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.layouts[_vm.active_layout].is_content)?_vm._i(_vm.template.layouts[_vm.active_layout].is_content,null)>-1:(_vm.template.layouts[_vm.active_layout].is_content)},on:{"change":function($event){var $$a=_vm.template.layouts[_vm.active_layout].is_content,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template.layouts[_vm.active_layout], "is_content", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template.layouts[_vm.active_layout], "is_content", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template.layouts[_vm.active_layout], "is_content", $$c)}}}})]),_vm._v(" "),(_vm.template.layouts[_vm.active_layout].is_content)?_c('div',{},[(_vm.template.layouts[_vm.active_layout].co && !_vm.isColor(_vm.template.layouts[_vm.active_layout].co))?_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                            Превью: "),_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.layouts[_vm.active_layout].co_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.layouts[_vm.active_layout].co_size)+"Mb")]):(_vm.template.layouts[_vm.active_layout].co_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.layouts[_vm.active_layout].co_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.layouts[_vm.active_layout].co_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.layouts[_vm.active_layout].co_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]),_vm._v(" "),_c('div',{staticClass:"form-group mt-1"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"content-control"}},[_vm._v("Фон")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.layouts[_vm.active_layout].is_bg),expression:"template.layouts[active_layout].is_bg"}],staticClass:"form-check-inline",attrs:{"id":"content-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.layouts[_vm.active_layout].is_bg)?_vm._i(_vm.template.layouts[_vm.active_layout].is_bg,null)>-1:(_vm.template.layouts[_vm.active_layout].is_bg)},on:{"change":function($event){var $$a=_vm.template.layouts[_vm.active_layout].is_bg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template.layouts[_vm.active_layout], "is_bg", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template.layouts[_vm.active_layout], "is_bg", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template.layouts[_vm.active_layout], "is_bg", $$c)}}}})])]):_vm._e(),_vm._v(" "),_c('div',[_c('input',{ref:"coSrcPreviewFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'co')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.coSrcPreviewFileInput.click()}}},[_vm._v("\n                                                Загрузить\n                                            ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"mt25"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет: "),(_vm.isColor(_vm.template.layouts[_vm.active_layout].co))?_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.getContentColor(_vm.template.layouts[_vm.active_layout].co)))]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.layouts[_vm.active_layout].co),expression:"template.layouts[active_layout].co"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.layouts[_vm.active_layout].co)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.layouts[_vm.active_layout], "co", $event.target.value)}}})])])])]):_vm._e(),_vm._v(" "),_c('fg-input',{staticClass:"mt25",attrs:{"type":"text","label":"Ширина фрейма в Figma","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].rawData.original_w),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout].rawData, "original_w", $$v)},expression:"template.layouts[active_layout].rawData.original_w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Ширина редактируемой области","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].rawData.w),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout].rawData, "w", $$v)},expression:"template.layouts[active_layout].rawData.w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Высота редактируемой области","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].rawData.h),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout].rawData, "h", $$v)},expression:"template.layouts[active_layout].rawData.h"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ сверху","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].rawData.y),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout].rawData, "y", $$v)},expression:"template.layouts[active_layout].rawData.y"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ слева","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].rawData.x),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout].rawData, "x", $$v)},expression:"template.layouts[active_layout].rawData.x"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус верхний левый","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].rawData.b_tl),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout].rawData, "b_tl", $$v)},expression:"template.layouts[active_layout].rawData.b_tl"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус верхний правый","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].rawData.b_tr),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout].rawData, "b_tr", $$v)},expression:"template.layouts[active_layout].rawData.b_tr"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус нижний правый","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].rawData.b_br),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout].rawData, "b_br", $$v)},expression:"template.layouts[active_layout].rawData.b_br"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус нижний правый","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].rawData.b_bl),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout].rawData, "b_bl", $$v)},expression:"template.layouts[active_layout].rawData.b_bl"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот объекта (градусы)","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].angle),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout], "angle", $$v)},expression:"template.layouts[active_layout].angle"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип layout")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.layouts[_vm.active_layout].layout_type),expression:"template.layouts[active_layout].layout_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.layouts[_vm.active_layout], "layout_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.layout_types),function(f){return _c('option',{domProps:{"value":f.id}},[_vm._v(_vm._s(f.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Эффект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.layouts[_vm.active_layout].effect),expression:"template.layouts[active_layout].effect"}],staticClass:"form-control",attrs:{"id":"layout-effect-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.layouts[_vm.active_layout], "effect", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":''}},[_vm._v("-")]),_vm._v(" "),_vm._l((_vm.server_effects),function(se){return _c('option',{domProps:{"value":se.name}},[_vm._v("\n                                                "+_vm._s(se.name)+"\n                                            ")])})],2)]),_vm._v(" "),(_vm.template.layouts[_vm.active_layout].effect)?_c('label',{staticClass:"control-label"},[_vm._v("Интенсивность эффекта: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.layouts[_vm.active_layout].effect_intensity))])]):_vm._e(),_vm._v(" "),(_vm.template.layouts[_vm.active_layout].effect)?_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].effect_intensity),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout], "effect_intensity", $$v)},expression:"template.layouts[active_layout].effect_intensity"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Фильтр")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.layouts[_vm.active_layout].filter),expression:"template.layouts[active_layout].filter"}],staticClass:"form-control",attrs:{"id":"layout-filter-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.layouts[_vm.active_layout], "filter", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":''}},[_vm._v("-")]),_vm._v(" "),_vm._l((_vm.server_filters),function(sf){return _c('option',{domProps:{"value":sf.name}},[_vm._v("\n                                                "+_vm._s(sf.name)+"\n                                            ")])})],2)]),_vm._v(" "),(_vm.template.layouts[_vm.active_layout].filter)?_c('label',{staticClass:"control-label"},[_vm._v("Интенсивность фильтра: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.layouts[_vm.active_layout].filter_intensity))])]):_vm._e(),_vm._v(" "),(_vm.template.layouts[_vm.active_layout].filter)?_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].filter_intensity),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout], "filter_intensity", $$v)},expression:"template.layouts[active_layout].filter_intensity"}}):_vm._e(),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер обводки: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.layouts[_vm.active_layout].stroke_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].stroke_size),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout], "stroke_size", $$v)},expression:"template.layouts[active_layout].stroke_size"}}),_vm._v(" "),_c('label',{attrs:{"for":"stroke-color"}},[_vm._v("Цвет обводки:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.layouts[_vm.active_layout].stroke_color),expression:"template.layouts[active_layout].stroke_color"}],attrs:{"type":"color","id":"stroke-color"},domProps:{"value":(_vm.template.layouts[_vm.active_layout].stroke_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.layouts[_vm.active_layout], "stroke_color", $event.target.value)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"","placeholder":""},model:{value:(_vm.template.layouts[_vm.active_layout].stroke_color),callback:function ($$v) {_vm.$set(_vm.template.layouts[_vm.active_layout], "stroke_color", $$v)},expression:"template.layouts[active_layout].stroke_color"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeLayout(_vm.active_layout)}}},[_vm._v("Удалить layout\n                                    ")])],1):_vm._e(),_vm._v(" "),(_vm.active_type === 'frame' && _vm.template && _vm.template.frames[_vm.active_frame])?_c('div',{staticClass:"col-md-3 c-labels"},[_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.changeFrame()}}},[_vm._v("Заменить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.frames[_vm.active_frame].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].alpha),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "alpha", $$v)},expression:"template.frames[active_frame].alpha"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].z_index),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "z_index", $$v)},expression:"template.frames[active_frame].z_index"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Ширина слайда в Figma","placeholder":""},on:{"input":_vm.onFrameRawDataChange},model:{value:(_vm.template.frames[_vm.active_frame].rawData.original_w),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame].rawData, "original_w", $$v)},expression:"template.frames[active_frame].rawData.original_w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Ширина фрейма","placeholder":""},on:{"input":_vm.onFrameRawDataChange},model:{value:(_vm.template.frames[_vm.active_frame].rawData.w),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame].rawData, "w", $$v)},expression:"template.frames[active_frame].rawData.w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ сверху","placeholder":""},on:{"input":_vm.onFrameRawDataChange},model:{value:(_vm.template.frames[_vm.active_frame].rawData.y),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame].rawData, "y", $$v)},expression:"template.frames[active_frame].rawData.y"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ слева","placeholder":""},on:{"input":_vm.onFrameRawDataChange},model:{value:(_vm.template.frames[_vm.active_frame].rawData.x),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame].rawData, "x", $$v)},expression:"template.frames[active_frame].rawData.x"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот объекта (градусы)","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].angle),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "angle", $$v)},expression:"template.frames[active_frame].angle"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Src","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].src),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "src", $$v)},expression:"template.frames[active_frame].src"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeFrame(_vm.active_frame)}}},[_vm._v("Удалить фрейм\n                                    ")])],1):_vm._e(),_vm._v(" "),(_vm.active_type === 'text' && _vm.template && _vm.template.texts.length > 0)?_c('div',{staticClass:"col-md-3 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Текст")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text),expression:"template.texts[active_text].text"}],staticClass:"text-area",domProps:{"value":(_vm.template.texts[_vm.active_text].text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "alpha", $$v)},expression:"template.texts[active_text].alpha"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].z_index),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "z_index", $$v)},expression:"template.texts[active_text].z_index"}}),_vm._v(" "),(_vm.template.texts[_vm.active_text].type)?_c('img',{staticClass:"widget-icon",attrs:{"src":("/static/img/widget" + (_vm.template.texts[_vm.active_text].type) + ".png")}}):_vm._e(),_vm._v(" "),(_vm.template.texts[_vm.active_text].type)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип виджета")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].type),expression:"template.texts[active_text].type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeWidgetType(_vm.active_text, _vm.template.texts[_vm.active_text].type)}]}},_vm._l((_vm.widget_types),function(f){return _c('option',{domProps:{"value":f.id}},[_vm._v(_vm._s(f.name))])}),0)]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер шрифта: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].font_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"5","max":"200","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].font_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "font_size", $$v)},expression:"template.texts[active_text].font_size"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Шрифт")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].font_name),expression:"template.texts[active_text].font_name"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "font_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.sortedFonts),function(f){return _c('option',{domProps:{"value":f.name}},[_vm._v(_vm._s(f.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"control1"}},[_vm._v("По центру по\n                                            горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control1","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_x == 0.5},on:{"change":function($event){return _vm.setTextPosition(0.5, null)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Position X","placeholder":""},on:{"input":function (val) { return _vm.setTextPosition(val, null); }},model:{value:(_vm.template.texts[_vm.active_text].position_x),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "position_x", $$v)},expression:"template.texts[active_text].position_x"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"control2"}},[_vm._v("По центру по\n                                            вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control2","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_y == 0.5},on:{"change":function($event){return _vm.setTextPosition(null, 0.5)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Position Y","placeholder":""},on:{"input":function (val) { return _vm.setTextPosition(null, val); }},model:{value:(_vm.template.texts[_vm.active_text].position_y),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "position_y", $$v)},expression:"template.texts[active_text].position_y"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control1"}},[_vm._v("Text brush")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].is_text_brush),expression:"template.texts[active_text].is_text_brush"}],staticClass:"form-check-inline",attrs:{"id":"control1","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.texts[_vm.active_text].is_text_brush)?_vm._i(_vm.template.texts[_vm.active_text].is_text_brush,null)>-1:(_vm.template.texts[_vm.active_text].is_text_brush)},on:{"change":function($event){var $$a=_vm.template.texts[_vm.active_text].is_text_brush,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template.texts[_vm.active_text], "is_text_brush", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template.texts[_vm.active_text], "is_text_brush", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template.texts[_vm.active_text], "is_text_brush", $$c)}}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.template.texts[_vm.active_text].is_text_brush)?_c('label',{staticClass:"control-label"},[_vm._v("Text brush data")]):_vm._e(),_vm._v(" "),(_vm.template.texts[_vm.active_text].is_text_brush)?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_brush_data),expression:"template.texts[active_text].text_brush_data"}],staticClass:"text-area",domProps:{"value":(_vm.template.texts[_vm.active_text].text_brush_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text_brush_data", $event.target.value)}}}):_vm._e()]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот текста (градусы)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].angle),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "angle", $$v)},expression:"template.texts[active_text].angle"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межбуквенный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].letter_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "letter_spacing", $$v)},expression:"template.texts[active_text].letter_spacing"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межстрочный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].line_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "line_spacing", $$v)},expression:"template.texts[active_text].line_spacing"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет текста: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].text_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_color),expression:"template.texts[active_text].text_color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].text_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text_color", $event.target.value)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].text_color),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "text_color", $$v)},expression:"template.texts[active_text].text_color"}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.texts[_vm.active_text].text_color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'color')}}})}),0)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет фона:\n                                            "),(_vm.template.texts[_vm.active_text].background_color === 'transparent')?_c('span',{staticClass:"param-span"},[_vm._v("Прозрачный")]):_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].background_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].background_color),expression:"template.texts[active_text].background_color"},{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "background_color", $event.target.value)}}}),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],attrs:{"type":"text","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].background_color),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "background_color", $$v)},expression:"template.texts[active_text].background_color"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"background-control"}},[_vm._v("Прозрачный")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"background-control","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].background_color === 'transparent'},on:{"change":function($event){return _vm.toggleBackground()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.texts[_vm.active_text].background_color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'background')}}})}),0)],1),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Прозрачность фона: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].bg_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].bg_alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "bg_alpha", $$v)},expression:"template.texts[active_text].bg_alpha"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Направление текста")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].direction),expression:"template.texts[active_text].direction"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "direction", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"normal"}},[_vm._v("normal")]),_vm._v(" "),_c('option',{attrs:{"value":"vertical"}},[_vm._v("vertical")]),_vm._v(" "),_c('option',{attrs:{"value":"round"}},[_vm._v("round")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].animation_type),expression:"template.texts[active_text].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name)+"\n                                            ")])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].animation_duration))])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"20","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "animation_duration", $$v)},expression:"template.texts[active_text].animation_duration"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Выравнивание "),_c('br'),_vm._v("(если больше одной строки)")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_align),expression:"template.texts[active_text].text_align"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "text_align", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.text_aligns),function(ta){return _c('option',{domProps:{"value":ta.name}},[_vm._v(_vm._s(ta.name)+"\n                                            ")])}),0)]),_vm._v(" "),_c('label',{attrs:{"for":"shadow-color"}},[_vm._v("Цвет тени:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].shadow_color),expression:"template.texts[active_text].shadow_color"}],attrs:{"type":"color","id":"shadow-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "shadow_color", $event.target.value)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_color),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_color", $$v)},expression:"template.texts[active_text].shadow_color"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Радиус размытия тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_blur))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_blur),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_blur", $$v)},expression:"template.texts[active_text].shadow_blur"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Сдвиг тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_distance))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_distance),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_distance", $$v)},expression:"template.texts[active_text].shadow_distance"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_alpha", $$v)},expression:"template.texts[active_text].shadow_alpha"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер обводки: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].stroke_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].stroke_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "stroke_size", $$v)},expression:"template.texts[active_text].stroke_size"}}),_vm._v(" "),_c('label',{attrs:{"for":"stroke-color"}},[_vm._v("Цвет обводки:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].stroke_color),expression:"template.texts[active_text].stroke_color"}],attrs:{"type":"color","id":"stroke-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].stroke_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "stroke_color", $event.target.value)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].stroke_color),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "stroke_color", $$v)},expression:"template.texts[active_text].stroke_color"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeText(_vm.active_text)}}},[_vm._v("Удалить текст\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),(_vm.active_type === 'object' && _vm.template && _vm.template.objects.length > 0)?_c('div',{staticClass:"col-md-3 c-labels"},[_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.changeObject()}}},[_vm._v("Заменить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Объект")]),_vm._v(" "),_c('img',{staticClass:"object-preview",attrs:{"alt":"","src":_vm.objectPlayerSrc(_vm.template.objects[_vm.active_object])},on:{"click":function($event){return _vm.changeObject()}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].alpha),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "alpha", $$v)},expression:"template.objects[active_object].alpha"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].z_index),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "z_index", $$v)},expression:"template.objects[active_object].z_index"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Размер:","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].scale),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "scale", $$v)},expression:"template.objects[active_object].scale"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0.03","max":"5","step":"0.0001","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].scale),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "scale", $$v)},expression:"template.objects[active_object].scale"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control3"}},[_vm._v("По центру по\n                                            горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control3","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_x == 0.5},on:{"change":function($event){return _vm.setObjectPosition(0.5, null)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Position X","placeholder":""},on:{"input":function (val) { return _vm.setObjectPosition(val, null); }},model:{value:(_vm.template.objects[_vm.active_object].position_x),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "position_x", $$v)},expression:"template.objects[active_object].position_x"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control4"}},[_vm._v("По центру по\n                                            вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control4","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_y == 0.5},on:{"change":function($event){return _vm.setObjectPosition(null, 0.5)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Position Y","placeholder":""},on:{"input":function (val) { return _vm.setObjectPosition(null, val); }},model:{value:(_vm.template.objects[_vm.active_object].position_y),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "position_y", $$v)},expression:"template.objects[active_object].position_y"}})],1),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот объекта (градусы)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].angle),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "angle", $$v)},expression:"template.objects[active_object].angle"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].id.indexOf('nocolor') < 0 && !_vm.isGifSrc(_vm.template.objects[_vm.active_object].id)),expression:"template.objects[active_object].id.indexOf('nocolor') < 0 && !isGifSrc(template.objects[active_object].id)"}],staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].color),expression:"template.objects[active_object].color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.objects[_vm.active_object].color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.objects[_vm.active_object], "color", $event.target.value)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].color),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "color", $$v)},expression:"template.objects[active_object].color"}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.objects[_vm.active_object].color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setObjColor(c)}}})}),0)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].animation_type),expression:"template.objects[active_object].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.objects[_vm.active_object], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name)+"\n                                            ")])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].animation_duration))])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"20","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "animation_duration", $$v)},expression:"template.objects[active_object].animation_duration"}}),_vm._v(" "),_c('label',{attrs:{"for":"shadow-color"}},[_vm._v("Цвет тени:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].shadow_color),expression:"template.objects[active_object].shadow_color"}],attrs:{"type":"color","id":"shadow-color"},domProps:{"value":(_vm.template.objects[_vm.active_object].shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.objects[_vm.active_object], "shadow_color", $event.target.value)}}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].shadow_color),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "shadow_color", $$v)},expression:"template.objects[active_object].shadow_color"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Радиус размытия тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].shadow_blur))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].shadow_blur),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "shadow_blur", $$v)},expression:"template.objects[active_object].shadow_blur"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Сдвиг тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].shadow_distance))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].shadow_distance),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "shadow_distance", $$v)},expression:"template.objects[active_object].shadow_distance"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].shadow_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].shadow_alpha),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "shadow_alpha", $$v)},expression:"template.objects[active_object].shadow_alpha"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Src","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].id),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "id", $$v)},expression:"template.objects[active_object].id"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeObject(_vm.active_object)}}},[_vm._v("Удалить объект\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[(_vm.template)?_c('div',{staticClass:"preview-sticky",style:({ top: _vm.layersBarHeight + 'px' }),attrs:{"id":"preview-container"}},[_c('div',{style:({ height: _vm.heightCanvas + 'px' }),attrs:{"id":"preview-previous"}},[_c('div',{staticClass:"preview-media",style:({ backgroundImage: 'url(' + _vm.template.src_full + ')' })})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.src_full),expression:"template.src_full"}],style:({ height: _vm.heightCanvas + 'px' }),attrs:{"id":"preview"}},[_c('div',{staticClass:"preview-media",style:({ backgroundImage: 'url(' + _vm.template.src_full + ')' })}),_vm._v(" "),_vm._l((_vm.template.layouts),function(la,index){return (la.rawData.w && la.rawData.h && la.rawData.original_w)?_c('div',{attrs:{"id":("l" + index)}},[_c('div',{staticClass:"layout-div",domProps:{"innerHTML":_vm._s(_vm.layout_html(index))},on:{"click":function($event){return _vm.selectLayout(index)}}})]):_vm._e()}),_vm._v(" "),_vm._l((_vm.template.texts),function(tt,index){return (tt.font_size)?_c('div',{ref:"draggableContainer",refInFor:true,staticClass:"draggable-container",style:({ zIndex: tt.z_index }),attrs:{"id":("" + index)}},[(_vm.fonts.length > 1)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header",class:{ active: index === _vm.active_text && _vm.active_type === 'text' },domProps:{"innerHTML":_vm._s(_vm.text_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e()]):_vm._e()}),_vm._v(" "),_vm._l((_vm.template.objects),function(tt,index){return (tt.scale)?_c('div',{ref:"draggableContainer2",refInFor:true,staticClass:"draggable-container",style:({ zIndex: tt.z_index }),attrs:{"id":("o" + index)}},[(tt.id.indexOf('.svg') > 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header nospace",class:{ active: index === _vm.active_object && _vm.active_type === 'object' },domProps:{"innerHTML":_vm._s(_vm.object_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e(),_vm._v(" "),(tt.id.indexOf('.svg') < 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header nospace",class:{ active: index === _vm.active_object && _vm.active_type === 'object' },domProps:{"innerHTML":_vm._s(_vm.image_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e()]):_vm._e()}),_vm._v(" "),_vm._l((_vm.template.frames),function(fr,index){return (fr.layouts)?_c('div',{ref:"draggableContainer3",refInFor:true,staticClass:"draggable-container",style:({ zIndex: fr.z_index }),attrs:{"id":("f" + index)}},[_c('div',{staticClass:"draggable-header nospace",class:{ active: index === _vm.active_frame && _vm.active_type === 'frame' },domProps:{"innerHTML":_vm._s(_vm.frame_html(index))},on:{"mousedown":_vm.dragMouseDown}})]):_vm._e()})],2),_vm._v(" "),_c('button',{staticClass:"btn-layout-highlight",class:{ 'active-state': _vm.show_layout_highlight },attrs:{"type":"button","title":"Отключение видимости лэйаутов в редакторе"},on:{"click":function($event){$event.preventDefault();return _vm.toggleLayoutHighlight.apply(null, arguments)}}},[_c('svg',{attrs:{"viewBox":"0 0 24 24","width":"18","height":"18","aria-hidden":"true"}},[_c('rect',{staticClass:"layer-fill",attrs:{"x":"3","y":"6","width":"12","height":"12","rx":"2","fill":"currentColor","opacity":"0.28"}}),_vm._v(" "),_c('rect',{staticClass:"layer-fill",attrs:{"x":"9","y":"3","width":"12","height":"12","rx":"2","fill":"currentColor","opacity":"0.5"}}),_vm._v(" "),_c('rect',{attrs:{"x":"3","y":"6","width":"12","height":"12","rx":"2","fill":"none","stroke":"currentColor","stroke-width":"1.4"}}),_vm._v(" "),_c('rect',{attrs:{"x":"9","y":"3","width":"12","height":"12","rx":"2","fill":"none","stroke":"currentColor","stroke-width":"1.4"}}),_vm._v(" "),_c('rect',{attrs:{"x":"6","y":"9","width":"12","height":"12","rx":"2","fill":"none","stroke":"currentColor","stroke-width":"1.4"}})])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])],2)],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X1HV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Auth;
function Auth(_ref) {
    var next = _ref.next,
        router = _ref.router;

    if (!localStorage.getItem('token') || !localStorage.getItem('new-auth-2')) {
        return router.push({ name: 'login' });
    }

    var role = localStorage.getItem('role');
    if (!role || parseInt(role) !== 302) {
        return router.push({ name: 'login' });
    }

    return next();
}

/***/ }),

/***/ "XBIO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            object: null,
            locales: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/frame/categories');
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/frames/categories/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.object = data.category;
                self.locales = data.locales;

                _.map(self.locales, function (l) {

                    var tModel = _.find(self.object.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var object = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.object));

            object.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/frames/categories/' + this.id + '/update', object, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                //self.$router.push('/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }

    }
});

/***/ }),

/***/ "XCOI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Музыка")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),(_vm.data)?_c('div',{staticClass:"row stats-block mt10"},[_c('span',[_vm._v("Количество категорий: "),(_vm.tracksCount > 0)?_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.albums.length - 2))]):_vm._e()]),_vm._v(" "),_c('span',[_vm._v("Количество треков: "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.tracksCount))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Альбом")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.album),expression:"album"}],staticClass:"form-control",attrs:{"id":"category-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.album=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('music_album', _vm.album)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.albums),function(a){return _c('option',{domProps:{"value":a.id}},[_vm._v(_vm._s(a.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('music_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить трек\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'album')?_c('span',[_vm._v("альбом")]):(column === 'artist')?_c('span',[_vm._v("артист")]):(column === 'title')?_c('span',[_vm._v("название")]):(column === 'is_premium')?_c('span',[_vm._v("премиум")]):(column === 'is_free')?_c('span',[_vm._v("copyright")]):(column === 'src_full')?_c('span',[_vm._v("трек")]):(column === 'image_src_full')?_c('span',[_vm._v("фон")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'duration')?_c('span',[_vm._v("длительность")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'image_src_full')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[(item[column])?_c('div',{staticClass:"device-block device1",style:({ backgroundImage: 'url(' + item[column] + ')' })}):_vm._e(),_vm._v(" "),(!item[column])?_c('img',{staticClass:"device1",attrs:{"src":"/static/img/track.png"}}):_vm._e()]):(column === 'duration')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'is_free')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-default"},[_vm._v("free")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"}):_vm._e()]):(column === 'src_full')?_c('span',[_c('audio',{attrs:{"src":item[column],"onloadstart":"this.volume=0.5","controls":"controls","controlsList":"nodownload noplaybackrate"}})]):(column === 'is_premium')?_c('span',[(item[column] === 1)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/premium.png"}}):_vm._e()]):(column === 'is_trendy')?_c('span',{staticClass:"emodji"},[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("🖤")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"}):_vm._e()]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активен")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активен")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y0gd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Effects_vue__ = __webpack_require__("7szl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ebd6a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Effects_vue__ = __webpack_require__("2sb2");
function injectStyle (ssrContext) {
  __webpack_require__("7lmx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50ebd6a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Effects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ebd6a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Effects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YCpc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YGHn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            object: {
                status: 0,
                object_count: 0,
                translations: [],
                sort: 1
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/font/categories');
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var object = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.object));

            object.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/fonts/categories/create', object, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/font/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }
    }
});

/***/ }),

/***/ "YUca":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YbGq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            album: null,
            locales: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/albums');
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/albums/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.album = data.album;
                self.locales = data.locales;

                _.map(self.locales, function (l) {

                    var tModel = _.find(self.album.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var album = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.album));

            album.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/albums/' + this.id + '/update', album, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0410\u043B\u044C\u0431\u043E\u043C \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.album.image_src = data.url;
                self.album.image_src_full = data.url_full;
                self.album.image_src_size = data.filesize;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }

    }
});

/***/ }),

/***/ "YbR3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YdHr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ydh+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("q9yi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fbbe91b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("n5E6");
function injectStyle (ssrContext) {
  __webpack_require__("641v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fbbe91b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fbbe91b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Yjxl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YsF+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YuFu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{'input-group': _vm.hasIcon}},[_vm._t("label",function(){return [(_vm.label)?_c('label',{staticClass:"control-label",domProps:{"innerHTML":_vm._s(_vm.label)}}):_vm._e()]}),_vm._v(" "),_vm._t("addonLeft",function(){return [(_vm.addonLeftIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonLeftIcon})]):_vm._e()]}),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control",attrs:{"aria-describedby":"addon-right addon-left"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false)),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("addonRight",function(){return [(_vm.addonRightIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonRightIcon})]):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YyF9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZDeZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("+YzX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41217d5f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("QQSj");
function injectStyle (ssrContext) {
  __webpack_require__("bNZy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41217d5f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41217d5f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73211b65_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("MFnH");
function injectStyle (ssrContext) {
  __webpack_require__("rkeS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73211b65"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73211b65_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Za8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.font.is_premium),expression:"font.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.font.is_premium)?_vm._i(_vm.font.is_premium,null)>-1:(_vm.font.is_premium)},on:{"change":function($event){var $$a=_vm.font.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.font, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.font, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.font, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.font.category_id),expression:"font.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.font, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v("\n                                            "+_vm._s(c.name)+"\n                                        ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.font.status),expression:"font.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.font, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название","placeholder":""},model:{value:(_vm.font.name),callback:function ($$v) {_vm.$set(_vm.font, "name", $$v)},expression:"font.name"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.font.sort),callback:function ($$v) {_vm.$set(_vm.font, "sort", $$v)},expression:"font.sort"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Шрифт: "),(_vm.font.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.font.src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.font.src_size)+"Mb")]):(_vm.font.src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.font.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.font.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.font.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'font')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.font.category_id || !_vm.font.name || !_vm.font.src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zp+p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZpEE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EffectsCategories_vue__ = __webpack_require__("MWya");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02f59691_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EffectsCategories_vue__ = __webpack_require__("BoeW");
function injectStyle (ssrContext) {
  __webpack_require__("6deb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02f59691"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EffectsCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02f59691_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EffectsCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a5f4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.object.sort),callback:function ($$v) {_vm.$set(_vm.object, "sort", $$v)},expression:"object.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество объектов в категории","placeholder":"","readonly":""},model:{value:(_vm.object.object_count),callback:function ($$v) {_vm.$set(_vm.object, "object_count", $$v)},expression:"object.object_count"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aAG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("Qkg6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb59baf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("kgzt");
function injectStyle (ssrContext) {
  __webpack_require__("vqQU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb59baf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aSXu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("SeyF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7863882e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("vcJA");
function injectStyle (ssrContext) {
  __webpack_require__("iK4w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7863882e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7863882e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "abEj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        var self = this;

        var token = localStorage.getItem('token');

        axios.get(this.$hostname + '/admin/frames/categories/', {
            'params': {},
            'headers': {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (response) {
            self.loading = false;
            self.categories = response.data;

            self.get();
        }).catch(function (error) {
            self.loading = false;
            console.log(error);
        });
    },
    data: function data() {
        return {
            columns: ['id', 'category', 'src', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('frr_status') ? localStorage.getItem('frr_status') : "",
            categoryId: localStorage.getItem('frr_category') ? localStorage.getItem('frr_category') : "",
            filteredId: null,
            filteredSrc: null,
            categories: [],
            loading: false,
            limit: 10,
            offset: parseInt(localStorage.getItem('frr_active_offset')) || 0
        };
    },

    computed: {
        graphicsUrl: function graphicsUrl() {
            return this.$graphicsUrl;
        }
    },
    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            localStorage.setItem('frr_active_offset', "0");
            this.offset = 0;

            this.get();
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('frr_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('frr_active_offset', parseInt(this.offset));
            }
        },
        add: function add() {
            this.$router.push('/frames/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');
            var filteredId = this.filteredId === null ? '' : this.filteredId;
            var filteredSrc = this.filteredSrc === null ? '' : this.filteredSrc;
            //this.loading = true;

            axios.get(this.$hostname + '/admin/frames/', {
                'params': {
                    limit: self.limit,
                    offset: self.offset,
                    status: this.status,
                    categoryId: this.categoryId,
                    filteredId: filteredId,
                    filteredSrc: filteredSrc
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-frame',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('frames') < 1) {
            localStorage.setItem('frr_category', "");
            localStorage.setItem('frr_status', "");
            localStorage.setItem('frr_active_offset', "0");
        }
        next();
    }
});

/***/ }),

/***/ "b3fz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'type', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('tabs_status') ? localStorage.getItem('tabs_status') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/tabs/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/tabs/', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
                localStorage.setItem('tabs', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-tab',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('tabs') < 1) {
            localStorage.setItem('tabs_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "bNZy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bV1C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("1c16");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c3eccc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("L8vP");
function injectStyle (ssrContext) {
  __webpack_require__("0n91")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c3eccc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c3eccc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bXML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Теги")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('tags_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить тег\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):(column === 'templates')?_c('span',[_vm._v("количество шаблонов")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'name')?_c('span',[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активен")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активен")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "blLA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            track: {
                status: 0,
                src: null,
                src_full: null,
                image_src: null,
                image_src_full: null,
                sort: 1,
                artist: null,
                title: null,
                duration: null,
                album_id: null,
                is_premium: 1,
                is_trendy: 0
            },
            albums: []
        };
    },

    created: function created() {
        this.getAlbums();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/tracks');
        },
        getAlbums: function getAlbums() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/albums', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.albums = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var track = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.track));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/tracks/create', track, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0422\u0440\u0435\u043A \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/tracks');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            var needID3 = type === 'src';

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type,
                    needID3: needID3
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.track[data.file_type] = data.url;
                self.track[data.file_type + '_full'] = data.url_full;
                self.track[data.file_type + '_size'] = data.filesize;

                if (needID3 && data.duration) {
                    data.duration = Math.floor(data.duration);

                    var minutes = Math.floor(data.duration / 60).toString();
                    var seconds = data.duration % 60 < 10 ? '0' + (data.duration % 60).toString() : (data.duration % 60).toString();
                    self.track.duration = minutes + ':' + seconds;
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }
    }
});

/***/ }),

/***/ "btzk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "buDd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            album: {
                status: 0,
                tracks_number: 0,
                translations: [],
                image_src: null,
                image_src_full: null,
                sort: 1
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/music/categories');
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var album = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.album));

            album.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/music/categories/create', album, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0410\u043B\u044C\u0431\u043E\u043C \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/music/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        }
    }
});

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb6051e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("KGJ+");
function injectStyle (ssrContext) {
  __webpack_require__("IRFK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb6051e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cTXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "caEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fonts_vue__ = __webpack_require__("NSrd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8ba7e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fonts_vue__ = __webpack_require__("2X6/");
function injectStyle (ssrContext) {
  __webpack_require__("NOA/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b8ba7e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fonts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8ba7e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fonts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ct9D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dHGc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Edit pages opened from a preview get its address in ?back.
// Leaving the page returns there: through the browser history when the preview is the previous entry,
// so the browser "Back" button does not lead to the edit page again.
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            cameFromBackPath: false
        };
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.cameFromBackPath = !!from.name && from.fullPath === to.query.back;
        });
    },

    methods: {
        previewBackPath: function previewBackPath() {
            var back = this.$route.query.back;
            if (typeof back === 'string' && back.indexOf('/preview/') === 0) {
                return back;
            }
            return null;
        },
        leaveTo: function leaveTo(listPath) {
            var back = this.previewBackPath();
            if (back && this.cameFromBackPath) {
                this.$router.back();
                return;
            }
            this.$router.push(back || listPath);
        }
    }
});

/***/ }),

/***/ "dP4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.status),expression:"category.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Формат")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.ratio),expression:"category.ratio"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "ratio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("4:5")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("1:1")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.category.sort),callback:function ($$v) {_vm.$set(_vm.category, "sort", $$v)},expression:"category.sort"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.category.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dePQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.getAlbums();
    },
    data: function data() {
        return {
            columns: ['id', 'album', 'src_full', 'image_src_full', 'artist', 'title', 'sort', 'status', ''],
            data: [],
            albums: [],
            album: localStorage.getItem('t_album') ? localStorage.getItem('t_album') : "",
            status: localStorage.getItem('t_status') ? localStorage.getItem('t_status') : "",
            loading: false,
            limit: 10,
            tracksCount: 0,
            offset: parseInt(localStorage.getItem('t_active_offset')) || 0,
            stats: {
                freeTracksCount: 0,
                premiumTracksCount: 0,
                averageTracksCount: 0,
                averageFreeCount: 0,
                averagePremiumCount: 0
            }
        };
    },

    filters: {
        secondsToTime: function secondsToTime(value) {
            if (value) {
                return Math.floor(value / 60).toString() + ':' + (value % 60).toString();
            } else {
                return '';
            }
        }
    },
    methods: {
        init: function init() {},
        filter: function filter() {
            localStorage.setItem('t_active_offset', "0");
            this.offset = 0;
            this.get();
        },
        add: function add() {
            this.$router.push('/tracks/create');
        },
        getAlbums: function getAlbums() {
            var self = this;

            var token = localStorage.getItem('token');

            axios.get(this.$hostname + '/admin/albums', {
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.albums = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.get();
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/tracks/', {
                'params': {
                    status: this.status,
                    album: this.album,
                    limit: this.limit,
                    offset: this.offset
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                var data = response.data;
                self.loading = false;

                self.data = data.tracks;
                self.tracksCount = data.count;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('t_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('t_active_offset', parseInt(this.offset));
            }
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-track',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('tracks') < 1) {
            localStorage.setItem('t_active_offset', "0");
            localStorage.setItem('t_album', "");
            localStorage.setItem('t_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "dhsv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"preview-page"},[_c('div',{staticClass:"preview-layout"},[_c('div',{staticClass:"card preview-sidebar"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('label',{staticClass:"preview-dev-toggle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showDev),expression:"showDev"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showDev)?_vm._i(_vm.showDev,null)>-1:(_vm.showDev)},on:{"change":function($event){var $$a=_vm.showDev,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showDev=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showDev=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showDev=$$c}}}}),_vm._v("\n                        Показать dev шаблоны\n                    ")]),_vm._v(" "),_c('div',{staticClass:"preview-sidebar-title"},[_vm._v("Категории")]),_vm._v(" "),_c('div',{staticClass:"preview-sidebar-list"},[_c('draggable',{on:{"start":_vm.onCategoriesDragStart,"end":_vm.onCategoriesDragEnd,"change":_vm.onCategoriesReorder},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},[_c('transition-group',_vm._l((_vm.data),function(element){return _c('div',{key:element.id,staticClass:"category-list",class:{ active: _vm.isSelectedCategory(element.id) },on:{"click":function($event){return _vm.selectCategory(element.id)}}},[_c('span',{staticClass:"category-list-row"},[_c('span',{staticClass:"category-list-name"},[_vm._v(_vm._s(element.name))]),_vm._v(" "),(_vm.isCategoryInactive(element.status))?_c('span',{staticClass:"category-off"},[_vm._v("Скрыта")]):_vm._e()])])}),0)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"card preview-main"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-area"},[(_vm.selectedCategory)?_c('div',[_c('p',{staticClass:"category-name"},[_vm._v("\n                                "+_vm._s(_vm.selectedCategory.name)+"\n                                "),_c('span',{staticClass:"category-count"},[_vm._v("("+_vm._s(_vm.templatesCountLabel)+")")]),_vm._v(" "),(_vm.isCategoryInactive(_vm.selectedCategory.status))?_c('span',{staticClass:"category-off-note"},[_vm._v("\n                                    Категория не отображается в приложении\n                                ")]):_vm._e()]),_vm._v(" "),(_vm.visibleTemplates.length > 0)?_c('div',{key:_vm.selectedCategory.id,staticClass:"templates-grid"},[_c('draggable',{on:{"start":_vm.onTemplatesDragStart,"end":_vm.onTemplatesDragEnd,"change":function($event){return _vm.onTemplatesReorder(_vm.selectedCategory)}},model:{value:(_vm.visibleTemplates),callback:function ($$v) {_vm.visibleTemplates=$$v},expression:"visibleTemplates"}},_vm._l((_vm.visibleTemplates),function(template){return _c('div',{key:template.id,staticClass:"inline-div",on:{"click":function($event){$event.preventDefault();return _vm.openVideo(template.src_full, template.id)}}},[_c('div',{staticClass:"card-template",style:(!_vm.isVideo(template.preview_src_full)
                                                ? { 'background-image': 'url(' + template.preview_src_full + ')' }
                                                : {})},[(_vm.isVideo(template.preview_src_full))?_c('video',{key:template.id,attrs:{"muted":"","loop":"","autoplay":"","playsinline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.getTemplateSrc(template.preview_src_full),"type":_vm.getTemplateType()}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"template-badge is-count"},[_vm._v(_vm._s(template.use_count))]),_vm._v(" "),_c('span',{staticClass:"template-badge is-id"},[_vm._v("ID "+_vm._s(template.id))]),_vm._v(" "),(_vm.isDev(template.status))?_c('span',{staticClass:"template-badge is-dev"},[_vm._v("DEV")]):_vm._e(),_vm._v(" "),(_vm.isFree(template.is_premium))?_c('span',{staticClass:"template-badge is-free"},[_vm._v("free")]):_vm._e()])])}),0)],1):_c('p',{staticClass:"preview-empty"},[_vm._v("Нет шаблонов")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"preview-main-footer"},[(_vm.role === 302)?_c('button',{staticClass:"btn btn-success btn-fill btn-save",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[_vm._v("\n                                Сохранить\n                            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.activeVideo)?_c('div',{staticClass:"video-bg",on:{"click":function($event){$event.preventDefault();return _vm.closeVideo()}}}):_vm._e(),_vm._v(" "),(_vm.activeVideo)?_c('div',{attrs:{"id":"player"}},[_c('video',{staticStyle:{"max-width":"100%"},attrs:{"onloadstart":"this.volume=0.1","controls":"","autoplay":"","id":"video_player"}},[_c('source',{attrs:{"src":_vm.activeVideo}})]),_vm._v(" "),(_vm.role === 302)?_c('button',{staticClass:"btn btn-fill btn-close btn-default",class:{ 'active-state': _vm.activeVideo },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.openTemplate()}}},[_vm._v("\n                                Редактировать\n                            ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-close",class:{ 'active-state': _vm.activeVideo },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.closeVideo()}}},[_vm._v("\n                                Закрыть\n                            ")])]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "duiC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        var self = this;

        var token = localStorage.getItem('token');

        axios.get(this.$hostname + '/admin/graphics/categories/', {
            'params': {},
            'headers': {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (response) {
            self.loading = false;
            self.categories = response.data;

            self.get();
        }).catch(function (error) {
            self.loading = false;
            console.log(error);
        });
    },
    data: function data() {
        return {
            columns: ['id', 'category', 'src', 'no_color', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('gr_status') ? localStorage.getItem('gr_status') : "",
            categoryId: localStorage.getItem('gr_category') ? localStorage.getItem('gr_category') : "",
            filteredId: null,
            filteredSrc: null,
            categories: [],
            loading: false,
            limit: 10,
            offset: parseInt(localStorage.getItem('gr_active_offset')) || 0
        };
    },

    computed: {
        graphicsUrl: function graphicsUrl() {
            return this.$graphicsUrl;
        }
    },
    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            localStorage.setItem('gr_active_offset', "0");
            this.offset = 0;

            this.get();
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('gr_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('gr_active_offset', parseInt(this.offset));
            }
        },
        add: function add() {
            this.$router.push('/graphics/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');
            var filteredId = this.filteredId === null ? '' : this.filteredId;
            var filteredSrc = this.filteredSrc === null ? '' : this.filteredSrc;
            //this.loading = true;

            axios.get(this.$hostname + '/admin/graphics/', {
                'params': {
                    limit: self.limit,
                    offset: self.offset,
                    status: this.status,
                    categoryId: this.categoryId,
                    filteredId: filteredId,
                    filteredSrc: filteredSrc
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-graphic',
                params: { id: id }
            });
        },
        openNewTab: function openNewTab(id) {
            if (this.role === 2) {
                return false;
            }
            var routeData = this.$router.resolve({
                name: 'edit-graphic',
                params: { id: id }
            });

            window.open(routeData.href, '_blank');
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('graphics') < 1) {
            localStorage.setItem('gr_category', "");
            localStorage.setItem('gr_status', "");
            localStorage.setItem('gr_active_offset', "0");
        }
        next();
    }
});

/***/ }),

/***/ "e3EN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_034effb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("iMRK");
function injectStyle (ssrContext) {
  __webpack_require__("ImUk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_034effb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eJV/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[(_vm.loading)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Логи")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],staticClass:"form-control",attrs:{"id":"type-filter","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.types),function(t){return _c('option',{domProps:{"value":t}},[_vm._v(_vm._s(t))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Поиск по user id","placeholder":""},model:{value:(_vm.userId),callback:function ($$v) {_vm.userId=$$v},expression:"userId"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Поиск по ошибке","placeholder":"11821 / Code: 3"},model:{value:(_vm.summary),callback:function ($$v) {_vm.summary=$$v},expression:"summary"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'user_id')?_c('span',[_vm._v("user ID")]):(column === 'locale')?_c('span',[_vm._v("locale")]):(column === 'version')?_c('span',[_vm._v("version")]):(column === 'file')?_c('span',[_vm._v("file")]):(column === 'created_at')?_c('span',[_vm._v("date")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'created_at')?_c('span',[_vm._v("\n                                            "+_vm._s(_vm._f("toEasyDate")(item[column]))+"\n                                        ")]):(column === 'file')?_c('span',[_c('a',{staticClass:"text-primary",attrs:{"target":"_blank","href":item[column]}},[_vm._v(_vm._s(item[column]))])]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eKbS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            client_parts: [],
            track: {
                status: 0,
                src: null,
                src_full: null,
                image_src: null,
                image_src_full: null,
                sort: 1,
                artist: null,
                title: null,
                duration: null,
                album_id: null,
                is_premium: 1,
                is_trendy: 0,
                parts: [],
                is_free: 0,
                song_insta: "",
                song_tiktok: ""
            },
            albums: [],
            templateIdToCopy: null
        };
    },

    computed: {
        sumParts: function sumParts() {
            var sum = 0;
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(this.track.parts, function (p) {
                if (isNaN(parseFloat(p.duration))) {
                    sum += 0;
                } else {
                    sum += parseFloat(p.duration);
                }
            });

            return sum.toFixed(2);
        }
    },
    created: function created() {
        this.getAlbums();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/new-music');
        },
        getAlbums: function getAlbums() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/music/categories', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.albums = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var track = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.track));

            self.waiting = true;

            if (!!this.track.is_free) {
                track.song_insta = "";
                track.song_tiktok = "";
            }

            if (track.song_insta) {
                var regex = /(\d{14,22})/gi;
                var match = regex.exec(track.song_insta);

                var reelId = match ? match[0] : null;
                track.song_insta = reelId;

                if (!reelId) {
                    var notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 Reels Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;

                    return false;
                }
            }

            if (track.song_tiktok) {
                var parts = track.song_tiktok.split('/');

                if (parts.length > 3 && parts[3].length > 5) {
                    track.song_tiktok = parts[3];
                } else {

                    var _notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 TikTok Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;

                    return false;
                }
            }

            track.artist = track.artist.trim();
            track.title = track.title.trim();

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/music/create', track, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0422\u0440\u0435\u043A \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/new-music');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            var needID3 = type === 'src';

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type,
                    needID3: needID3
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.track[data.file_type] = data.url;
                self.track[data.file_type + '_full'] = data.url_full;
                self.track[data.file_type + '_size'] = data.filesize;

                if (needID3 && data.duration) {
                    self.track.duration = parseFloat(data.duration).toFixed(2);
                    self.track.realAudioDuration = data.duration;
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        getTemplateById: function getTemplateById() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/templates/' + this.templateIdToCopy, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
                var parts = data.templates[0] ? data.templates[0].parts : [];
                self.track.parts = [];
                self.track.count_parts = parts.length;

                for (var i = 0; i < parts.length; i++) {
                    self.track.parts.push({ duration: parseFloat(parts[i].duration) });
                }
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        formatDuration: function formatDuration(event, index) {
            this.track.parts[index].duration = this.track.parts[index].duration.replace(',', '.');
        },
        changeTrackCount: function changeTrackCount(value) {
            var self = this;
            var oldParts = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.track.parts));

            if (isNaN(parseInt(value))) {
                return oldParts;
            }

            var newParts = [];
            for (var i = 0; i < value; i++) {
                newParts.push({
                    duration: ''
                });
            }

            for (var _i = 0; _i < oldParts.length; _i++) {
                for (var j = 0; j < newParts.length; j++) {
                    if (_i === j) {
                        newParts[j] = oldParts[_i];
                    }
                }
            }

            this.track.parts = newParts;
        },

        openResource: function openResource(url) {
            window.open(url, "_blank");
        }
    }
});

/***/ }),

/***/ "eKw4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("rVgw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_823f0314_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("94d2");
function injectStyle (ssrContext) {
  __webpack_require__("qUkk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-823f0314"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_823f0314_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inheritAttrs: false,
    name: 'fg-input',
    props: {
        label: String,
        label2: String,
        value: [String, Number],
        addonRightIcon: String,
        addonLeftIcon: String
    },
    computed: {
        hasIcon: function hasIcon() {
            var _$slots = this.$slots,
                addonRight = _$slots.addonRight,
                addonLeft = _$slots.addonLeft;

            return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
        }
    }
});

/***/ }),

/***/ "ejaj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            track: null,
            albums: [],
            client_parts: [],
            templateIdToCopy: null
        };
    },

    computed: {
        sumParts: function sumParts() {
            var sum = 0;
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.track.parts, function (p) {
                if (isNaN(parseFloat(p.duration))) {
                    sum += 0;
                } else {
                    sum += parseFloat(p.duration);
                }
            });

            return sum.toFixed(2);
        }
    },
    created: function created() {
        this.id = this.$route.params.id;
        this.getAlbums();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/new-music');
        },
        getAlbums: function getAlbums() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/music/categories', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.albums = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.get(self.id);
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/music/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.track = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
                self.track.count_parts = self.track.parts.length;

                if (self.track.song_insta) {
                    self.track.song_insta = 'https://www.instagram.com/reels/audio/' + self.track.song_insta;
                }

                if (self.track.song_tiktok) {
                    self.track.song_tiktok = 'https://vm.tiktok.com/' + self.track.song_tiktok;
                }

                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(self.locales, function (l) {

                    var tModel = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(self.album.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var track = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.track));

            self.waiting = true;

            if (!!this.track.is_free) {
                track.song_insta = "";
                track.song_tiktok = "";
            }

            if (track.song_insta) {
                var regex = /(\d{14,22})/gi;
                var match = regex.exec(track.song_insta);

                var reelId = match ? match[0] : null;
                track.song_insta = reelId;

                if (!reelId) {
                    var notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 Reels Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;

                    return false;
                }
            }

            if (track.song_tiktok) {
                var parts = track.song_tiktok.split('/');

                if (parts.length > 3 && parts[3].length > 5) {
                    track.song_tiktok = parts[3];
                } else {

                    var _notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 TikTok Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;

                    return false;
                }
            }

            track.artist = track.artist.trim();
            track.title = track.title.trim();

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/music/' + this.id + '/update', track, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0422\u0440\u0435\u043A \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/new-music');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            var needID3 = type === 'src';

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type,
                    needID3: needID3
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.track[data.file_type] = data.url;
                self.track[data.file_type + '_full'] = data.url_full;
                self.track[data.file_type + '_size'] = data.filesize;

                if (needID3 && data.duration) {
                    self.track.duration = parseFloat(data.duration).toFixed(2);
                    self.track.realAudioDuration = data.duration;
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        getTemplateById: function getTemplateById() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/templates/' + this.templateIdToCopy, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
                var parts = data.templates[0] ? data.templates[0].parts : [];
                self.track.parts = [];
                self.track.count_parts = parts.length;

                for (var i = 0; i < parts.length; i++) {
                    self.track.parts.push({ duration: parseFloat(parts[i].duration) });
                }
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        formatDuration: function formatDuration(event, index) {
            this.track.parts[index].duration = this.track.parts[index].duration.replace(',', '.');
        },
        changeTrackCount: function changeTrackCount(value) {
            var self = this;
            var oldParts = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.track.parts));

            if (isNaN(parseInt(value))) {
                return oldParts;
            }

            var newParts = [];
            for (var i = 0; i < value; i++) {
                newParts.push({
                    duration: ''
                });
            }

            for (var _i = 0; _i < oldParts.length; _i++) {
                for (var j = 0; j < newParts.length; j++) {
                    if (_i === j) {
                        newParts[j] = oldParts[_i];
                    }
                }
            }

            this.track.parts = newParts;
        },

        openResource: function openResource(url) {
            window.open(url, "_blank");
        }

    }
});

/***/ }),

/***/ "evl4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fullcalendar_core_internal_common__ = __webpack_require__("Ro7l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Graphics_vue__ = __webpack_require__("sFCw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_mixins_unsavedLeaveGuard__ = __webpack_require__("WSC3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_mixins_replaceGraphicSize__ = __webpack_require__("g69p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_mixins_gifGraphic__ = __webpack_require__("pJH4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_mixins_stickyLayers__ = __webpack_require__("P+tE");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _ = __webpack_require__("M4fF");

var moment = __webpack_require__("PJh5");









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditCategory',
    mixins: [__WEBPACK_IMPORTED_MODULE_8_src_mixins_unsavedLeaveGuard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_src_mixins_replaceGraphicSize__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_src_mixins_gifGraphic__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11_src_mixins_stickyLayers__["a" /* default */]],
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            showP: false,
            token: localStorage.getItem('token'),
            template: null,
            post: null,
            parts: [],
            activeVideo: '',
            waiting: false,
            textWaiting: false,
            interval: null,
            lock_waiting: false,
            is_playing: false,
            show_svg_modal: false,
            show_collage_modal: false,
            show_frames_modal: false,
            is_object_changing: false,
            is_frame_changing: false,
            video: null,
            categories: JSON.parse(localStorage.getItem('posts_categories')),
            sizes: JSON.parse(localStorage.getItem('sizes')),
            compression: false,
            preview: null,
            source: null,
            client_parts: [],
            is_text_active: false,
            active_layout: 0,
            show_layout_highlight: true,
            active_text: 0,
            active_object: 0,
            active_frame: 0,
            draggable_index: 0,
            draggable_type: null,
            active_type: 'text',
            realVideoDuration: null,
            realAudioDuration: null,
            effect: "",
            effect_intensity: 100,
            filter: "",
            filter_intensity: 100,
            copiedPartId: null,
            heightCanvas: 450,
            active_object_category: 'Arrows',
            active_frame_category: 1,
            active_collage_category: '2',
            previous_collage_id: null,
            active_part_index: null,
            tags: [],
            server_effects: [],
            server_graphics: [],
            server_filters: [],
            server_fonts: [],
            server_frames: [],
            svg_sources: [],
            default_part: {
                src: null,
                src_full: '/static/img/part_placeholder.jpg',
                src_size: 0,
                video_src: null,
                video_src_full: null,
                video_src_size: 0,
                video_preview: false,
                n: 0,
                texts: [],
                objects: [],
                layouts: [],
                frames: []
            },
            default_layout: {
                is_content: false,
                co: null,
                is_bg: false,
                angle: 0,
                alpha: 1,
                z_index: 0,
                layout_type: 1,
                effect: "",
                effect_intensity: 100,
                filter: "",
                filter_intensity: 100,
                stroke_size: 0,
                stroke_color: '#000000',
                rawData: {
                    original_w: 1080,
                    w: 1080,
                    h: 1350,
                    x: 0,
                    y: 0,
                    b_tl: 0,
                    b_tr: 0,
                    b_br: 0,
                    b_bl: 0
                },
                data: {}
            },
            default_text: {
                text: 'Default text',
                font_name: 'SF Pro',
                font_size: 30,
                text_color: "#000000",
                letter_spacing: 0,
                line_spacing: 0,
                alpha: 1,
                text_align: 'center',
                background_color: 'transparent',
                bg_alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                is_text_brush: 0,
                text_brush_data: [],
                z_index: 1,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
                direction: 'normal',
                shadow_color: '#000000',
                shadow_alpha: 0.16,
                shadow_distance: 0,
                shadow_blur: 10,
                animation_type: 0,
                animation_duration: 0,
                stroke_size: 0,
                stroke_color: '#000000'
            },
            default_object: {
                id: "b-330x298.svg",
                scale: 1,
                source: '<span>SVG</span>',
                color: '#ffffff',
                alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                animation_type: 0,
                animation_duration: 0,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
                shadow_color: '#000000',
                shadow_alpha: 0,
                shadow_distance: 0,
                shadow_blur: 0
            },
            texts: [],
            objects: [],
            colors: ["#FFFFFF", "#000000", "#F9F7F4", "#FAF5ED", "#F2E8DD", "#F4E4DD", "#D9BEBD", "#C5AEB6", "#E3C2D2", "#F1E0EF", "#D5C9E9", "#C8ACE0", "#E06E97", "#E64F3C", "#AB613E", "#B97959", "#D99056", "#E8BF88", "#EDD8AB", "#FAE389", "#F5C154", "#B78C3A", "#585B3B", "#7B7C41", "#BBB595", "#DFE7DA", "#C0DED3", "#B4C5C9", "#C9D9F0", "#4E63EC", "#4F5E8D", "#725B6E", "#F0F0F0", "#D9D9D9", "#616161", "#3C3C3C"],
            fonts: [{
                params: "'SF Pro', sans-serif;",
                code: "SF Pro",
                name: "SF Pro"
            }],
            animation_types: [{
                id: 0,
                name: "-"
            }, {
                id: 1,
                name: "Fade"
            }, {
                id: 4,
                name: "Scale"
            }, {
                id: 6,
                name: "Reveal ↓"
            }, {
                id: 7,
                name: "Reveal ↑"
            }, {
                id: 8,
                name: "Reveal →"
            }, {
                id: 9,
                name: "Reveal ←"
            }, {
                id: 10,
                name: "Float ↓"
            }, {
                id: 11,
                name: "Float ↑"
            }, {
                id: 12,
                name: "Float →"
            }, {
                id: 13,
                name: "Float ←"
            }, {
                id: 14,
                name: "Typewriter"
            }, {
                id: 15,
                name: "Typewriter Fade In"
            }, {
                id: 16,
                name: "Typewriter By Word"
            }],
            effect_types: [{
                id: 0,
                name: "-"
            }, {
                id: 1,
                name: "Zoom in"
            }, {
                id: 2,
                name: "Zoom out"
            }, {
                id: 3,
                name: "Snow"
            }, {
                id: 4,
                name: "VHS"
            }],
            widget_types: [{
                id: 1,
                name: "Message (справа)"
            }, {
                id: 5,
                name: "Message (слева)"
            }, {
                id: 2,
                name: "Time"
            }, {
                id: 3,
                name: "Location"
            }, {
                id: 4,
                name: "Custom tag (снизу)"
            }, {
                id: 6,
                name: "Custom tag (сверху)"
            }, {
                id: 7,
                name: "Selection"
            }],
            layout_types: [{
                id: 1,
                name: "Обычный"
            }, {
                id: 2,
                name: "Overlay"
            }, {
                id: 3,
                name: "Overlay + Удаленный фон"
            }],
            collage_types: [{
                id: 0,
                name: "-",
                params: null
            }, {
                id: 1,
                name: "1/4",
                params: { x: 0, y: 0, w: 0.5, h: 0.5 }
            }, {
                id: 2,
                name: "2/4",
                params: { x: 0.5, y: 0, w: 0.5, h: 0.5 }
            }, {
                id: 3,
                name: "3/4",
                params: { x: 0, y: 0.5, w: 0.5, h: 0.5 }
            }, {
                id: 4,
                name: "4/4",
                params: { x: 0.5, y: 0.5, w: 0.5, h: 0.5 }
            }, {
                id: 5,
                name: "1/3",
                params: { x: 0, y: 0, w: 1, h: 0.3333 }
            }, {
                id: 6,
                name: "2/3",
                params: { x: 0, y: 0.3333, w: 1, h: 0.3333 }
            }, {
                id: 7,
                name: "3/3",
                params: { x: 0, y: 0.6666, w: 1, h: 0.3333 }
            }, {
                id: 8,
                name: "1/2",
                params: { x: 0, y: 0, w: 1, h: 0.5 }
            }, {
                id: 9,
                name: "2/2",
                params: { x: 0, y: 0.5, w: 1, h: 0.5 }
            }, {
                id: 10,
                name: "1/6",
                params: { x: 0, y: 0, w: 0.5, h: 0.3333 }
            }, {
                id: 11,
                name: "2/6",
                params: { x: 0.5, y: 0, w: 0.5, h: 0.3333 }
            }, {
                id: 12,
                name: "3/6",
                params: { x: 0, y: 0.3333, w: 0.5, h: 0.3333 }
            }, {
                id: 13,
                name: "4/6",
                params: { x: 0.5, y: 0.3333, w: 0.5, h: 0.3333 }
            }, {
                id: 14,
                name: "5/6",
                params: { x: 0, y: 0.6666, w: 0.5, h: 0.3333 }
            }, {
                id: 15,
                name: "6/6",
                params: { x: 0.5, y: 0.6666, w: 0.5, h: 0.3333 }
            }],
            content_types: [{
                id: 0,
                name: "Обычный"
            }, {
                id: 1,
                name: "Статика"
            }, {
                id: 2,
                name: "Цвет"
            }],
            text_aligns: [{
                name: "center"
            }, {
                name: "start"
            }, {
                name: "end"
            }],
            default_positions: {
                clientX: undefined,
                clientY: undefined,
                movementX: 0,
                movementY: 0
            },
            positions: [],
            object_positions: [],
            frame_positions: [],
            collages: [{
                name: '2',
                data: [{
                    id: '2_1',
                    frames: [{ x: 0, y: 0, width: 1.0, height: 0.5 }, { x: 0, y: 0.5, width: 1.0, height: 0.5 }]
                }, {
                    id: '2_2',
                    frames: [{ x: 0, y: 0, width: 1.0, height: 0.491 }, { x: 0, y: 0.509, width: 1.0, height: 0.491 }]
                }, {
                    id: '2_3',
                    frames: [{ x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474 }, { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474 }]
                }, {
                    id: '2_4',
                    frames: [{ x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '2_5',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 1.0 }, { x: 0.5, y: 0, width: 0.5, height: 1.0 }]
                }, {
                    id: '2_6',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.315 }, { x: 0, y: 0.315, width: 1, height: 0.685 }]
                }, {
                    id: '2_7',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.685 }, { x: 0, y: 0.685, width: 1, height: 0.315 }]
                }, {
                    id: '2_8',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: '2_9',
                    frames: [{ x: 0.2375, y: 0.1223, width: 0.532, height: 0.3647 }, { x: 0.2375, y: 0.5133, width: 0.532, height: 0.3647 }]
                }]
            }, {
                name: '3',
                data: [{
                    id: "3_1",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3334 }, { x: 0, y: 0.6667, width: 1, height: 0.3333 }]
                }, {
                    id: "3_2",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.326783 }, { x: 0, y: 0.336758, width: 1, height: 0.326783 }, { x: 0, y: 0.673216, width: 1, height: 0.326783 }]
                }, {
                    id: "3_3",
                    frames: [{ x: 0.028, y: 0.015625, width: 0.944, height: 0.3125 }, { x: 0.028, y: 0.34375, width: 0.944, height: 0.3125 }, { x: 0.028, y: 0.671875, width: 0.944, height: 0.3125 }]
                }, {
                    id: "3_4",
                    frames: [{
                        x: 0.028,
                        y: 0.015625,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }, {
                        x: 0.028,
                        y: 0.34375,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }, {
                        x: 0.028,
                        y: 0.671875,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }]
                }, {
                    id: "3_5",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6667, width: 0.5, height: 0.3333 }]
                }, {
                    id: "3_6",
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 1 }, { x: 0.3333, y: 0, width: 0.3333, height: 1 }, { x: 0.6667, y: 0, width: 0.3333, height: 1 }]
                }, {
                    id: "3_7",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_8",
                    frames: [{ x: 0, y: 0.5, width: 1, height: 0.5 }, { x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_9",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_10",
                    frames: [{ x: 0.0648, y: 0.064, width: 0.4815, height: 0.28125 }, { x: 0.0648, y: 0.35925, width: 0.4815, height: 0.28125 }, { x: 0.0648, y: 0.6564, width: 0.4815, height: 0.28125 }]
                }]
            }, {
                name: '4',
                data: [{
                    id: "4_1",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.25 }, { x: 0, y: 0.25, width: 1, height: 0.25 }, { x: 0, y: 0.5, width: 1, height: 0.25 }, { x: 0, y: 0.75, width: 1, height: 0.25 }]
                }, {
                    id: "4_2",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.24267 }, { x: 0, y: 0.25264333, width: 1, height: 0.24267 }, { x: 0, y: 0.50498666, width: 1, height: 0.24267 }, { x: 0, y: 0.75733, width: 1, height: 0.24267 }]
                }, {
                    id: "4_3",
                    frames: [{ x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875 }]
                }, {
                    id: "4_4",
                    frames: [{ x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }]
                }, {
                    id: "4_5",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "4_6",
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.4948 }, { x: 0.50925, y: 0, width: 0.49075, height: 0.4948 }, { x: 0, y: 0.5052, width: 0.49075, height: 0.4948 }, { x: 0.50925, y: 0.5052, width: 0.49075, height: 0.4948 }]
                }, {
                    id: "4_7",
                    frames: [{ x: 0.0315, y: 0.017708, width: 0.45925, height: 0.410417 }, { x: 0.50925, y: 0.017708, width: 0.45927, height: 0.410417 }, { x: 0.0315, y: 0.438542, width: 0.45927, height: 0.410417 }, { x: 0.50925, y: 0.438542, width: 0.45927, height: 0.410417 }]
                }, {
                    id: "4_8",
                    frames: [{ x: 0.0407, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.5213, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.0407, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.5213, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }]
                }, {
                    id: "4_9",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.5 }, { x: 0, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 }]
                }, {
                    id: "4_10",
                    frames: [{ x: 0.01852, y: 0.010717, width: 0.96296, height: 0.48381425 }, { x: 0.01852, y: 0.50546875, width: 0.30864, height: 0.48411425 }, { x: 0.34568, y: 0.50546875, width: 0.30864, height: 0.48411425 }, { x: 0.67284, y: 0.50546875, width: 0.30864, height: 0.48411425 }]
                }, {
                    id: "4_11",
                    frames: [{ x: 0.01852, y: 0.010417, width: 0.400926, height: 0.4843745 }, { x: 0.437966, y: 0.010417, width: 0.543514, height: 0.4843745 }, { x: 0.01852, y: 0.5052085, width: 0.543514, height: 0.4843745 }, { x: 0.580554, y: 0.5052085, width: 0.400926, height: 0.4843745 }]
                }, {
                    id: "4_12",
                    frames: [{ x: 0, y: 0, width: 0.49074, height: 0.4895829967 }, { x: 0.50926, y: 0, width: 0.49074, height: 0.4895829967 }, { x: 0, y: 0.4999996633, width: 1, height: 0.2447917 }, { x: 0, y: 0.7552083, width: 1, height: 0.2447917 }]
                }]
            }, {
                name: '5',
                data: [{
                    id: '5_1',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.2 }, { x: 0, y: 0.2, width: 1, height: 0.2 }, { x: 0, y: 0.4, width: 1, height: 0.2 }, { x: 0, y: 0.6, width: 1, height: 0.2 }, { x: 0, y: 0.8, width: 1, height: 0.2 }]
                }, {
                    id: '5_2',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.1875 }, { x: 0, y: 0.203125, width: 1, height: 0.1875 }, { x: 0, y: 0.40625, width: 1, height: 0.1875 }, { x: 0, y: 0.609375, width: 1, height: 0.1875 }, { x: 0, y: 0.8125, width: 1, height: 0.1875 }]
                }, {
                    id: '5_3',
                    frames: [{ x: 0.028, y: 0.015825, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095 }]
                }, {
                    id: '5_4',
                    frames: [{ x: 0.028, y: 0.015825, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '5_5',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.5, height: 0.3334 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '5_6',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 1 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0.3333, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0, width: 0.3334, height: 1 }]
                }, {
                    id: '5_7',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.6666, y: 0, width: 0.3334, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3333 }, { x: 0, y: 0.6666, width: 1, height: 0.3334 }]
                }, {
                    id: '5_8',
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.4947915 }, { x: 0, y: 0.5052085, width: 0.49075, height: 0.4947915 }, { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.33710567, width: 0.49075, height: 0.32608867 }, { x: 0.50927, y: 0.67361134, width: 0.49075, height: 0.32638867 }]
                }, {
                    id: '5_9',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '5_11',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 }]
                }]
            }, {
                name: '6',
                data: [{
                    id: '6_1',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.16697 }, { x: 0, y: 0.16637, width: 1, height: 0.16697 }, { x: 0, y: 0.33304, width: 1, height: 0.16697 }, { x: 0, y: 0.49971, width: 1, height: 0.16697 }, { x: 0, y: 0.66638, width: 1, height: 0.16696 }, { x: 0, y: 0.83304, width: 1, height: 0.16696 }]
                }, {
                    id: '6_2',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.15798583 }, { x: 0, y: 0.16790283, width: 1, height: 0.15798583 }, { x: 0, y: 0.33680566, width: 1, height: 0.15798583 }, { x: 0, y: 0.50520849, width: 1, height: 0.15798583 }, { x: 0, y: 0.67361132, width: 1, height: 0.15798583 }, { x: 0, y: 0.84201415, width: 1, height: 0.15798583 }]
                }, {
                    id: '6_3',
                    frames: [{ x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152 }]
                }, {
                    id: '6_4',
                    frames: [{ x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '6_14',
                    frames: [{ x: 0, y: 0, width: 0.1667, height: 1 }, { x: 0.1667, y: 0, width: 0.1666, height: 1 }, { x: 0.3333, y: 0, width: 0.1667, height: 1 }, { x: 0.5, y: 0, width: 0.1667, height: 1 }, { x: 0.6667, y: 0, width: 0.1666, height: 1 }, { x: 0.8333, y: 0, width: 0.1667, height: 1 }]
                }, {
                    id: '6_5',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0.6666, width: 0.3333, height: 0.3334 }]
                }, {
                    id: '6_6',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.5, height: 0.3334 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '6_7',
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0, y: 0.33685567, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.33685567, width: 0.49075, height: 0.32638867 }, { x: 0, y: 0.67321134, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.67321134, width: 0.49075, height: 0.32638867 }]
                }, {
                    id: '6_8',
                    frames: [{ x: 0, y: 0, width: 0.369444, height: 0.25 }, { x: 0, y: 0.25, width: 0.369444, height: 0.25 }, { x: 0.369444, y: 0, width: 0.630556, height: 0.5 }, { x: 0, y: 0.5, width: 0.630556, height: 0.5 }, { x: 0.630556, y: 0.5, width: 0.369444, height: 0.25 }, { x: 0.630556, y: 0.75, width: 0.369444, height: 0.25 }]
                }, {
                    id: '6_9',
                    frames: [{ x: 0, y: 0, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.2526175, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.505235, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.7578525, width: 0.369444, height: 0.2421475 }, { x: 0.387964, y: 0, width: 0.612036, height: 0.4947915 }, { x: 0.387964, y: 0.505235, width: 0.612036, height: 0.4947915 }]
                }, {
                    id: '6_10',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.65833 }, { x: 0, y: 0.65833, width: 0.3333, height: 0.34167 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.34167 }, { x: 0.3333, y: 0.34167, width: 0.3333, height: 0.65833 }, { x: 0.6666, y: 0, width: 0.3334, height: 0.65833 }, { x: 0.6666, y: 0.65833, width: 0.3334, height: 0.34167 }]
                }, {
                    id: '6_11',
                    frames: [{ x: 0, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0.33950667, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0.67851334, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0, y: 0.33685867, width: 0.32098667, height: 0.32638867 }, { x: 0, y: 0.67321734, width: 0.32098667, height: 0.32638867 }, { x: 0.33950667, y: 0.33685867, width: 0.66049333, height: 0.66314133 }]
                }, {
                    id: '6_12',
                    frames: [{ x: 0, y: 0, width: 0.68611, height: 0.3333 }, { x: 0.68611, y: 0, width: 0.31389, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.31389, height: 0.3333 }, { x: 0.31389, y: 0.3333, width: 0.68611, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.68611, height: 0.3334 }, { x: 0.68611, y: 0.6666, width: 0.31389, height: 0.3334 }]
                }, {
                    id: '6_13',
                    frames: [{ x: 0.084185, y: 0.14375, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.14375, width: 0.391667, height: 0.22013867 }, { x: 0.084185, y: 0.38993067, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.38993067, width: 0.391667, height: 0.22013867 }, { x: 0.084185, y: 0.63611134, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.63611134, width: 0.391667, height: 0.22013867 }]
                }]
            }]
        };
    },

    watch: {},
    created: function created() {
        var self = this;
        self.id = this.$route.params.id;

        self.getResources();
        self._nudgeKeydownHandler = self.onNudgeKeydown.bind(self);
        document.addEventListener('keydown', self._nudgeKeydownHandler, true);
    },
    beforeDestroy: function beforeDestroy() {
        document.removeEventListener('keydown', this._nudgeKeydownHandler, true);
    },
    computed: {
        graphicsUrl: function graphicsUrl() {
            return this.$graphicsUrl;
        },
        framesUrl: function framesUrl() {
            return this.$framesUrl;
        },
        fontsUrl: function fontsUrl() {
            return this.$fontsUrl;
        },
        previewSlideHeight: function previewSlideHeight() {
            return Math.round(92 * this.heightCanvas / 360);
        },
        sortedFonts: function sortedFonts() {
            return _.sortBy(this.fonts, function (f) {
                return f.name;
            });
        },
        versions: function versions() {
            var result = [];
            var start = 101;
            var end = start + 19;

            for (var i = start; i <= end; i++) {
                result.push((i / 10).toFixed(1));
            }

            return result;
        },
        nolaVersions: function nolaVersions() {
            var result = [];
            var start = 11;
            var end = start + 19;

            for (var i = start; i <= end; i++) {
                result.push((i / 10).toFixed(1));
            }

            return result;
        },
        calculatedMediaCount: function calculatedMediaCount() {
            var parts = this.post && this.post.parts ? this.post.parts : [];
            var count = 0;

            for (var i = 0; i < parts.length; i++) {
                var part = parts[i] || {};
                count += Array.isArray(part.layouts) ? part.layouts.length : 0;

                var frames = Array.isArray(part.frames) ? part.frames : [];
                for (var j = 0; j < frames.length; j++) {
                    var frame = frames[j] || {};
                    count += Array.isArray(frame.layouts) ? frame.layouts.length : 0;
                }
            }

            return count;
        }
    },
    methods: {
        openResource: function openResource(url) {
            window.open(url, "_blank");
        },
        text_html: function text_html(index) {
            var textModel = this.template.texts[index];

            var text = _.find(this.fonts, function (f) {
                return f.name === textModel.font_name;
            });
            if (!text) {
                // alert('Шрифт ' + textModel.font_name + ' не найден. Пожалуйста, замените на другой.');

                text = _.first(this.fonts);
            }

            var line_height = parseFloat(textModel.font_size) + parseFloat(textModel.line_spacing);
            var alpha = textModel.alpha;

            var bgColor = textModel.background_color;

            if (parseFloat(textModel.bg_alpha) < 0.99) {
                bgColor = textModel.background_color + ('' + textModel.bg_alpha * 100);
            }

            var direction = '';
            if (textModel.direction === 'vertical') {
                direction = '  writing-mode: vertical-rl;\n' + '  text-orientation: upright;\n';
            }

            var offset = 4 / 88 * textModel.font_size;
            var blur = 0.29 * textModel.font_size / 88 * textModel.shadow_blur;
            var shadow = 'text-shadow: ' + offset + 'px ' + offset + 'px ' + blur + 'px ' + textModel.shadow_color + this.convertAlphaToHex(textModel.shadow_alpha) + ';';

            return '<span style="color: ' + textModel.text_color + '; ' + 'background-color: ' + bgColor + '; ' + 'font-size: ' + textModel.font_size + 'px; ' + 'letter-spacing: ' + textModel.letter_spacing + 'px; ' + 'opacity: ' + alpha + '; ' + 'line-height: ' + line_height + 'px; ' + 'transform: rotate( ' + textModel.angle + 'deg); ' + 'display: block;' + direction + shadow + 'text-align: ' + textModel.text_align + '; ' + 'z-index: ' + textModel.z_index + '; ' + 'font-family:' + text.params + ';">' + textModel.text + '</span>';
        },
        object_html: function object_html(index) {
            return this.renderSvgObjectHtml(this.template.objects[index]);
        },
        image_html: function image_html(index) {
            var objectModel = this.template.objects[index];

            if (!objectModel.source || !objectModel.dimensions) {
                return "";
            }

            var width = objectModel.dimensions.width;
            var height = objectModel.dimensions.height;

            width = width * parseFloat(objectModel.scale);
            height = height * parseFloat(objectModel.scale);

            var img = '<img src="' + this.objectPlayerSrc(objectModel) + '">';

            var style = ' style="width: ' + width + 'px; height: ' + height + 'px; opacity: ' + objectModel.alpha + '; transform: rotate(' + objectModel.angle + 'deg); z-index: ' + objectModel.z_index + '; display: block;"';

            img = this.insertAt(img, style, 5);

            return img;
        },
        layout_html: function layout_html(index) {
            var layoutModel = this.template.layouts[index].rawData;
            var layout = this.template.layouts[index];

            var scale = 360 / parseFloat(layoutModel.original_w);

            var overlay = {
                w: layoutModel.w * scale,
                h: layoutModel.h * scale,
                x: layoutModel.x * scale,
                y: layoutModel.y * scale,
                b_tl: parseFloat(layoutModel.b_tl * scale).toFixed(2),
                b_tr: parseFloat(layoutModel.b_tr * scale).toFixed(2),
                b_br: parseFloat(layoutModel.b_br * scale).toFixed(2),
                b_bl: parseFloat(layoutModel.b_bl * scale).toFixed(2)
            };

            var colors = ['rgba(255, 0, 0, 0.4)', 'rgba(0, 128, 0, 0.4)', 'rgba(0, 0, 255, 0.4)', 'rgba(255, 165, 0, 0.4)', 'rgba(128, 0, 128, 0.4)', 'rgba(0, 206, 209, 0.4)', 'rgba(255, 192, 203, 0.4)', 'rgba(255, 255, 0, 0.4)', 'rgba(165, 42, 42, 0.4)', 'rgba(128, 128, 128, 0.4)'];

            var layoutDiv = '<div class="overlay ' + (index === this.active_layout && this.active_type === 'layout' ? 'active' : '') + '"></div>';

            var background = this.show_layout_highlight ? 'background: ' + (colors[index] ? colors[index] : colors[0]) : 'background: transparent';

            if (layout.is_content && layout.co) {
                background = 'background-image: url(\'' + layout.co_full + '\'); background-size: cover;';
            }

            var style = ' style="' + background + '; top: ' + overlay.y + 'px; left: ' + overlay.x + 'px; width: ' + overlay.w + 'px; height: ' + overlay.h + 'px;\n                border-radius: ' + overlay.b_tl + 'px ' + overlay.b_tr + 'px ' + overlay.b_br + 'px ' + overlay.b_bl + 'px; z-index: 0;\n                opacity: ' + layout.alpha + '; padding: 0px; transform: rotate(' + layout.angle + 'deg);"';

            layoutDiv = this.insertAt(layoutDiv, style, 5);

            return layoutDiv;
        },
        frame_html: function frame_html(index) {
            var frameModel = this.template.frames[index];

            var scale = 360 / parseFloat(frameModel.rawData.original_w);

            var width = frameModel.rawData.w * scale;

            var img = '<img src="' + this.framesUrl + frameModel.src + '">';

            var style = ' style="width: ' + width + 'px; opacity: ' + frameModel.alpha + '; padding: 0px; transform: rotate(' + frameModel.angle + 'deg); z-index: ' + frameModel.z_index + '; display: block;"';

            img = this.insertAt(img, style, 5);

            return img;
        },

        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        getUnsavedState: function getUnsavedState() {
            return this.stringifyUnsaved({
                post: this.post,
                effect: this.effect,
                effect_intensity: this.effect_intensity,
                filter: this.filter,
                filter_intensity: this.filter_intensity
            });
        },
        isEmptyFilter: function isEmptyFilter(value) {
            return value == null || value === '' || value === '-';
        },
        normalizeLayoutFilter: function normalizeLayoutFilter(layout) {
            var name = '';
            var intensity = 100;

            if (!this.isEmptyFilter(layout.filters)) {
                name = String(layout.filters).split(':')[0];
                intensity = String(layout.filters).split(':')[1] || 100;
            } else if (!this.isEmptyFilter(layout.filter)) {
                name = layout.filter;
                intensity = layout.filter_intensity || 100;
            }

            if (this.isEmptyFilter(name)) {
                layout.filter = '';
                layout.filter_intensity = 100;
                layout.filters = '';
            } else {
                layout.filter = name;
                layout.filter_intensity = intensity;
            }

            var effectName = '';
            var effectIntensity = 100;

            if (!this.isEmptyFilter(layout.effects)) {
                effectName = String(layout.effects).split(':')[0];
                effectIntensity = String(layout.effects).split(':')[1] || 100;
            } else if (!this.isEmptyFilter(layout.effect)) {
                effectName = layout.effect;
                effectIntensity = layout.effect_intensity || 100;
            }

            if (this.isEmptyFilter(effectName)) {
                layout.effect = '';
                layout.effect_intensity = 100;
                layout.effects = '';
                return;
            }

            layout.effect = effectName;
            layout.effect_intensity = effectIntensity;
        },

        goBack: function goBack() {
            this.$router.push('/posts');
        },
        insertAt: function insertAt(str, sub, pos) {
            return '' + str.slice(0, pos) + sub + str.slice(pos);
        },
        formatStartTime: function formatStartTime(event, index, object) {
            this.client_parts[index][object] = this.client_parts[index][object].replace(',', '.');
        },
        formatDuration: function formatDuration(event, index) {
            this.client_parts[index].duration = this.client_parts[index].duration.replace(',', '.');
        },
        formatSpeed: function formatSpeed(event, index) {
            this.client_parts[index].speed = this.client_parts[index].speed.replace(',', '.');
        },
        formatVideoDuration: function formatVideoDuration(event, index) {
            this.template.duration = this.template.duration.replace(',', '.');
        },
        copyPart: function copyPart() {

            var part = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.post.parts[this.active_part_index]));
            part.n = this.post.parts.length + 1;
            delete part.id;
            this.post.parts.push(part);

            this.selectPart(this.post.parts.length - 1);
        },
        addLayout: function addLayout() {
            var copy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var self = this;

            // if copied
            if (copy !== false) {

                var copiedLayout = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.template.layouts[self.active_layout]));
                copiedLayout.z_index = 0;

                self.template.layouts.push(copiedLayout);

                if (self.positions[self.active_layout]) {
                    self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.positions[self.active_layout])));
                } else {
                    self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));
                }

                self.active_layout = self.template.layouts.length - 1;
                self.active_type = 'layout';
            } else {
                self.default_layout.z_index = 0;
                self.template.layouts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_layout)));
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                self.active_layout = self.template.layouts.length - 1;
                self.active_type = 'layout';
            }
        },
        addText: function addText() {
            var copy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var tool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            // if copied
            if (copy !== false) {
                var copiedText = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.template.texts[self.active_text]));
                copiedText.z_index = self.template.texts.length + self.template.objects.length + 1;
                copiedText.text = 'Default text';

                self.template.texts.push(copiedText);

                var positions = self.positions[self.active_text];
                positions.clientX = positions.clientX ? positions.clientX + 5 : positions.clientX;
                positions.clientY = positions.clientY ? positions.clientY + 5 : positions.clientY;
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(positions)));

                setTimeout(function () {

                    self.$refs.draggableContainer[self.template.texts.length - 1].style.left = self.$refs.draggableContainer[self.active_text].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = self.$refs.draggableContainer[self.active_text].offsetTop + 5 + 'px';

                    self.active_text = self.template.texts.length - 1;
                    self.active_type = 'text';

                    //console.log(self.$refs.draggableContainer[self.template.texts.length - 1].style.left);
                }, 100);
            } else {
                var newText = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_text));

                if (tool) {
                    newText.type = 1;
                    newText.background_color = '#448AF7';
                }

                self.default_text.z_index = self.template.texts.length + self.template.objects.length + 1;
                self.template.texts.push(newText);
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                self.active_text = self.template.texts.length - 1;
                self.active_type = 'text';
            }
        },
        addObject: function addObject(object) {
            var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            // if copied
            if (copy !== false) {
                var copiedObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.template.objects[self.active_object]));
                copiedObject.z_index = self.template.texts.length + self.template.objects.length + 1;

                self.template.objects.push(copiedObject);
                self.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.object_positions[self.active_object])));

                setTimeout(function () {

                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.left = self.$refs.draggableContainer2[self.active_object].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.top = self.$refs.draggableContainer2[self.active_object].offsetTop + 5 + 'px';

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object';
                }, 100);
            } else {
                self.placeGraphicObject(object);
            }

            self.active_object_category = 'Arrows';
        },
        addFrame: function addFrame(frame) {
            var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            if (!self.template.frames) {
                self.template.frames = [];
            }

            if (copy !== false) {
                var copiedFrame = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.template.frames[self.active_frame]));

                self.template.frames.push(copiedFrame);
                self.frame_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));
                self.active_frame = self.template.frames.length - 1;
                self.active_type = 'frame';
                self.syncFrameCalculations(self.active_frame);

                self.$nextTick(function () {
                    self.applyFrameContainerPosition(self.active_frame);
                });
            } else if (self.is_frame_changing) {
                var current = self.template.frames[self.active_frame];
                current.id = frame.id;
                current.src = frame.src;
                current.layouts = frame.layouts;
                self.is_frame_changing = false;
                self.show_frames_modal = false;
            } else {
                self.template.frames.push({
                    id: frame.id,
                    src: frame.src,
                    z_index: 1,
                    angle: 0,
                    alpha: 1,
                    layouts: frame.layouts,
                    w: 0,
                    x: 0,
                    y: 0,
                    rawData: {
                        original_w: 1080,
                        w: 540,
                        x: 0,
                        y: 0
                    }
                });

                self.frame_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));
                self.active_frame = self.template.frames.length - 1;
                self.active_type = 'frame';
                self.syncFrameCalculations(self.active_frame);
                self.show_frames_modal = false;

                self.$nextTick(function () {
                    self.applyFrameContainerPosition(self.active_frame);
                });
            }
        },
        changeObject: function changeObject() {
            this.is_object_changing = true;
            this.show_svg_modal = true;
        },
        changeFrame: function changeFrame() {
            this.is_frame_changing = true;
            this.show_frames_modal = true;
        },
        addCollage: function addCollage(e) {
            // 888
            var data = e.target.dataset.params;
            var params = data.split(';');
            var id = params[0];
            var part = params[1];
            var x = params[2];
            var y = params[3];
            var w = params[4];
            var h = params[5];

            this.client_parts[this.active_part_index].collage_type = id + ';' + part;
            this.client_parts[this.active_part_index].frame = {
                x: parseFloat(x),
                y: parseFloat(y),
                w: parseFloat(w),
                h: parseFloat(h)
            };

            this.previous_collage_id = id;

            this.show_collage_modal = false;
        },
        convertCollageTypeToNewFormat: function convertCollageTypeToNewFormat(oldType) {

            if (oldType.toString().indexOf('_') > 0) return oldType;

            var oldTypeName = _.find(this.collage_types, function (c) {
                return c.id === parseInt(oldType);
            }).name;
            var oldCategory = oldTypeName.split('/');
            var collageCategory = parseInt(oldCategory[1]) === 6 ? 6 : 1;

            return oldCategory[1] + '_' + collageCategory + ';' + oldCategory[0];
        },
        convertAlphaToHex: function convertAlphaToHex(alpha) {
            if (alpha < 0.08) return '00';
            return Math.floor(alpha * 255).toString(16);
        },
        updatePartsOrder: function updatePartsOrder() {
            if (this.template.n) {
                this.post.parts = _.sortBy(this.post.parts, 'n');
            }
        },
        toggleVideoPreview: function toggleVideoPreview() {
            if (!this.template.video_preview) {
                this.template.video_src = null;
                this.template.video_src_full = null;
                this.template.video_src_size = 0;
            }
        },
        addPart: function addPart() {

            var part = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.default_part));
            part.n = this.post.parts.length + 1;
            part.layouts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.default_layout)));
            this.post.parts.push(part);

            this.selectPart(this.post.parts.length - 1);
        },
        removePart: function removePart() {
            var self = this;
            var index = this.active_part_index;

            if (self.post.parts.length === 1) {
                alert('Нельзя удалить последний слайд');
                return;
            }

            if (confirm("Подтверждение удаления слайда " + (parseInt(index) + 1))) {
                self.active_part_index = 0;
                self.active_type = 'layout';

                self.post.parts = self.post.parts.filter(function (t, i) {
                    return i !== index;
                });
            }
        },
        selectPart: function selectPart(part) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _loop, i, _loop2;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:

                                //this.textWaiting = true;

                                _this.template = _this.post.parts[part];

                                // if (this.template.objects.length < 1) {
                                //     this.template.objects = [];
                                //     this.object_positions = [];
                                // }

                                _this.object_positions = [];

                                if (!(_this.template.objects.length > 0)) {
                                    _context2.next = 11;
                                    break;
                                }

                                _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _loop(i) {
                                    var dataSource, size;
                                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _loop$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:

                                                    _this.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.default_positions)));

                                                    if (!(_this.template.objects[i].id.indexOf('.svg') > -1)) {
                                                        _context.next = 8;
                                                        break;
                                                    }

                                                    _context.next = 4;
                                                    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this.$hostname + '/admin/services/graphics/svg/source', {
                                                        'params': {
                                                            url: _this.graphicsUrl + _this.template.objects[i].id
                                                        },
                                                        'headers': {
                                                            'Authorization': 'Bearer ' + localStorage.getItem('token')
                                                        }
                                                    });

                                                case 4:
                                                    dataSource = _context.sent;


                                                    _this.template.objects[i].source = dataSource.data;

                                                    _context.next = 20;
                                                    break;

                                                case 8:
                                                    if (!(_this.isGifSrc(_this.template.objects[i].id) || !_this.template.objects[i].dimensions)) {
                                                        _context.next = 19;
                                                        break;
                                                    }

                                                    _context.prev = 9;
                                                    _context.next = 12;
                                                    return _this.loadRasterGraphic(_this.template.objects[i].id);

                                                case 12:
                                                    size = _context.sent;

                                                    if (size && !_this.template.objects[i].dimensions) {
                                                        _this.$set(_this.template.objects[i], 'dimensions', size);
                                                    }
                                                    _context.next = 19;
                                                    break;

                                                case 16:
                                                    _context.prev = 16;
                                                    _context.t0 = _context['catch'](9);

                                                    console.log(_context.t0);

                                                case 19:
                                                    _this.template.objects[i].source = "Image";

                                                case 20:

                                                    _this.template.objects[i].is_visible = 1;
                                                    _this.$nextTick(function () {
                                                        _this.applyObjectContainerPosition(i);
                                                    });

                                                case 22:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _loop, _this, [[9, 16]]);
                                });
                                i = 0;

                            case 5:
                                if (!(i < _this.template.objects.length)) {
                                    _context2.next = 10;
                                    break;
                                }

                                return _context2.delegateYield(_loop(i), 't0', 7);

                            case 7:
                                i++;
                                _context2.next = 5;
                                break;

                            case 10:

                                _this.$nextTick(function () {
                                    _this.applyAllObjectContainerPositions();
                                });

                            case 11:

                                if (_this.template.texts.length > 0) {
                                    _loop2 = function _loop2(i) {
                                        _this.positions.push(_this.default_positions);

                                        if (!_this.template.texts[i].angle) {
                                            _this.template.texts[i].angle = 0;
                                        }

                                        _this.textWaiting = true;

                                        setTimeout(function () {

                                            if (_this.$refs.draggableContainer[i]) {
                                                if (_this.$refs.draggableContainer[i].clientHeight < 1) {
                                                    console.log('2275');
                                                    location.reload();
                                                }
                                                var centerX = _this.template.texts[i].position_x * 360 - _this.$refs.draggableContainer[i].clientWidth / 2;
                                                var centerY = _this.template.texts[i].position_y * _this.heightCanvas - _this.$refs.draggableContainer[i].clientHeight / 2;

                                                _this.$refs.draggableContainer[i].style.left = centerX + 'px';
                                                _this.$refs.draggableContainer[i].style.top = centerY + 'px';
                                            }

                                            _this.textWaiting = false;
                                        }, 1000);
                                    };

                                    for (i = 0; i < _this.template.texts.length; i++) {
                                        _loop2(i);
                                    }
                                }

                                _this.frame_positions = [];
                                if ((_this.template.frames || []).length > 0) {
                                    for (i = 0; i < _this.template.frames.length; i++) {
                                        _this.frame_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.default_positions)));
                                    }

                                    setTimeout(function () {
                                        for (var _i = 0; _i < _this.template.frames.length; _i++) {
                                            _this.applyFrameContainerPosition(_i);
                                        }
                                    }, 1000);
                                }

                                _this.textWaiting = false;

                                if (_this.template.layouts.length > 0) {
                                    _this.active_layout = 0;
                                    _this.active_type = 'layout';
                                } else {
                                    _this.active_frame = 0;
                                    _this.active_type = 'frame';
                                }

                                _this.active_part_index = part;

                                if (_this.unsavedSnapshot === null) {
                                    _this.captureUnsavedSnapshot();
                                }

                            case 18:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        selectText: function selectText(text) {
            this.active_text = text;
            this.active_type = 'text';
        },
        selectObject: function selectObject(object) {
            this.active_object = object;
            this.active_type = 'object';
        },
        selectLayout: function selectLayout(layout) {
            this.active_layout = layout;
            this.active_type = 'layout';
        },
        selectFrame: function selectFrame(frame) {
            this.active_frame = frame;
            this.active_type = 'frame';
        },
        selectObjectCategory: function selectObjectCategory(category) {
            this.active_object_category = category;
        },
        selectFrameCategory: function selectFrameCategory(id) {
            this.active_frame_category = id;
        },
        selectCollageCategory: function selectCollageCategory(category) {
            this.active_collage_category = category;
        },

        calculateLayouts: function calculateLayouts() {

            var parts = this.post.parts;
            for (var i = 0; i < parts.length; i++) {
                var layouts = parts[i].layouts;

                for (var j = 0; j < layouts.length; j++) {
                    var layout = layouts[j].rawData;

                    var originalH = this.getOriginalH(layout.original_w);

                    layouts[j].data = {
                        w: parseFloat(parseFloat(layout.w) / parseFloat(layout.original_w)).toFixed(6),
                        h: parseFloat(parseFloat(layout.h) / parseFloat(originalH)).toFixed(6),
                        x: parseFloat(parseFloat(layout.x) / parseFloat(layout.original_w)).toFixed(6),
                        y: parseFloat(parseFloat(layout.y) / parseFloat(originalH)).toFixed(6),
                        b_tl: parseFloat(parseFloat(layout.b_tl) / parseFloat(layout.w)).toFixed(6),
                        b_tr: parseFloat(parseFloat(layout.b_tr) / parseFloat(layout.w)).toFixed(6),
                        b_br: parseFloat(parseFloat(layout.b_br) / parseFloat(layout.w)).toFixed(6),
                        b_bl: parseFloat(parseFloat(layout.b_bl) / parseFloat(layout.w)).toFixed(6)
                    };
                }

                var frames = parts[i].frames;
                for (var _j = 0; _j < frames.length; _j++) {
                    this.syncFrameCalculationsForFrame(frames[_j]);
                }
            }
        },
        syncFrameCalculations: function syncFrameCalculations(index) {
            var frame = this.template.frames[index];
            if (!frame || !frame.rawData) {
                return;
            }
            this.syncFrameCalculationsForFrame(frame);
        },
        syncFrameCalculationsForFrame: function syncFrameCalculationsForFrame(frame) {
            var originalH = this.getOriginalH(frame.rawData.original_w);

            frame.w = parseFloat(parseFloat(frame.rawData.w) / parseFloat(frame.rawData.original_w)).toFixed(6);
            frame.x = parseFloat(parseFloat(frame.rawData.x) / parseFloat(frame.rawData.original_w)).toFixed(6);
            frame.y = parseFloat(parseFloat(frame.rawData.y) / parseFloat(originalH)).toFixed(6);
        },
        applyFrameContainerPosition: function applyFrameContainerPosition(index) {
            var frame = this.template.frames[index];
            var containers = this.$refs.draggableContainer3;
            if (!frame || !frame.rawData || !containers || !containers[index]) {
                return;
            }

            var scale = 360 / parseFloat(frame.rawData.original_w);
            containers[index].style.left = parseFloat(frame.rawData.x) * scale + 'px';
            containers[index].style.top = parseFloat(frame.rawData.y) * scale + 'px';
        },
        onFrameRawDataChange: function onFrameRawDataChange() {
            this.syncFrameCalculations(this.active_frame);
            this.applyFrameContainerPosition(this.active_frame);
        },
        updateFramePositionFromDom: function updateFramePositionFromDom(index) {
            var frame = this.template.frames[index];
            var containers = this.$refs.draggableContainer3;
            if (!frame || !frame.rawData || !containers || !containers[index]) {
                return;
            }

            var scale = 360 / parseFloat(frame.rawData.original_w);
            frame.rawData.x = parseFloat((containers[index].offsetLeft / scale).toFixed(2));
            frame.rawData.y = parseFloat((containers[index].offsetTop / scale).toFixed(2));
            this.syncFrameCalculations(index);
        },
        getOriginalH: function getOriginalH(originalW) {
            originalW = parseFloat(originalW);
            var ratio = parseInt(this.post.ratio);

            if (ratio === 2) {
                return originalW * 810 / 1080;
            }

            if (ratio === 3) {
                return originalW / 9 * 16;
            }

            if (ratio === 4) {
                return originalW;
            }

            return originalW / 4 * 5;
        },
        removeLayout: function removeLayout(index) {
            var self = this;
            //
            // if (self.template.layouts.length === 1) {
            //     alert('Нельзя удалить последний layout')
            //     return;
            // }

            if (confirm("Подтверждение удаления layout " + (parseInt(index) + 1))) {

                self.template.layouts = self.template.layouts.filter(function (t, i) {
                    return i !== index;
                });

                if (self.template.layouts.length > 0) {
                    self.active_layout = self.template.layouts.length - 1;
                    self.active_type = 'layout';
                } else {
                    if (self.template.frames.length > 0) {
                        self.active_frame = 0;
                        self.active_type = 'frame';
                    } else {
                        self.active_text = 0;
                        self.active_type = 'text';
                    }
                }
            }
        },
        removeFrame: function removeFrame(index) {
            var self = this;

            if (confirm("Подтверждение удаления фрейма " + (parseInt(index) + 1))) {
                self.active_layout = 0;
                self.active_type = 'layout';

                self.template.frames = self.template.frames.filter(function (t, i) {
                    return i !== index;
                });
                self.frame_positions = self.frame_positions.filter(function (t, i) {
                    return i !== index;
                });
            }
        },
        removeText: function removeText(index) {
            var self = this;

            if (confirm("Подтверждение удаления текста: " + self.template.texts[index].text)) {
                self.active_text = 0;
                self.active_type = 'text';

                self.template.texts = self.template.texts.filter(function (t, i) {
                    return i !== index;
                });
            }

            if (self.template.texts.length < 1) {
                self.active_layout = 0;
                self.active_type = 'layout';
            }
        },
        removeObject: function removeObject(index) {
            var self = this;

            if (confirm("Подтверждение удаления объекта")) {
                self.active_object = 0;
                self.active_type = 'object';

                self.template.objects = self.template.objects.filter(function (t, i) {
                    return i !== index;
                });
            }

            if (self.template.objects.length < 1) {
                self.active_layout = 0;
                self.active_type = 'layout';
            }
        },
        toggleText: function toggleText() {
            var self = this;

            if (self.is_text_active) {
                self.template.texts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_text)));
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));
                self.active_type = 'text';

                setTimeout(function () {
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = '0px';
                }, 500);
            } else {
                self.template.texts = [];
                self.template.objects = [];
                self.positions = [];
            }
        },
        toggleBackground: function toggleBackground() {
            if (this.template.texts[this.active_text].background_color === 'transparent') {
                this.setColor('#FFFFFF', 'background');
            } else {
                this.setColor('transparent', 'background');
            }
        },

        setTextPosition: function setTextPosition(x, y) {
            // x = parseFloat(x);
            // y = parseFloat(y);

            if (x) {
                this.template.texts[this.active_text].position_x = x;

                var centerX = x * 360 - this.$refs.draggableContainer[this.active_text].clientWidth / 2;

                this.$refs.draggableContainer[this.active_text].style.left = centerX + 'px';
            }

            if (y) {
                this.template.texts[this.active_text].position_y = y;

                var centerY = y * this.heightCanvas - this.$refs.draggableContainer[this.active_text].clientHeight / 2;

                this.$refs.draggableContainer[this.active_text].style.top = centerY + 'px';
            }
        },
        setObjectPosition: function setObjectPosition(x, y) {
            if (x) {
                this.template.objects[this.active_object].position_x = x;
            }

            if (y) {
                this.template.objects[this.active_object].position_y = y;
            }

            this.applyObjectContainerPosition(this.active_object);
        },
        onNudgeKeydown: function onNudgeKeydown(event) {
            if (!this.template) {
                return;
            }

            if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
                return;
            }

            var target = event.target;
            var tag = target && target.tagName;
            if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target && target.isContentEditable) {
                return;
            }

            if (this.show_svg_modal || this.show_frames_modal || this.show_collage_modal) {
                return;
            }

            var dx = 0;
            var dy = 0;
            if (event.key === 'ArrowLeft') {
                dx = -1;
            } else if (event.key === 'ArrowRight') {
                dx = 1;
            } else if (event.key === 'ArrowUp') {
                dy = -1;
            } else if (event.key === 'ArrowDown') {
                dy = 1;
            }

            if (!this.nudgeSelectedLayer(dx, dy)) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
        },
        nudgeSelectedLayer: function nudgeSelectedLayer(dx, dy) {
            if (this.active_type === 'text') {
                return this.nudgeText(dx, dy);
            }
            if (this.active_type === 'object') {
                return this.nudgeObject(dx, dy);
            }
            if (this.active_type === 'frame') {
                return this.nudgeFrame(dx, dy);
            }
            return false;
        },
        nudgeText: function nudgeText(dx, dy) {
            var index = this.active_text;
            var text = this.template.texts[index];
            var containers = this.$refs.draggableContainer;
            if (!text || !containers || !containers[index]) {
                return false;
            }

            var step = 0.0005;
            text.position_x = parseFloat((parseFloat(text.position_x) + dx * step).toFixed(4));
            text.position_y = parseFloat((parseFloat(text.position_y) + dy * step).toFixed(4));

            var el = containers[index];
            el.style.left = text.position_x * 360 - el.clientWidth / 2 + 'px';
            el.style.top = text.position_y * this.heightCanvas - el.clientHeight / 2 + 'px';
            return true;
        },
        nudgeObject: function nudgeObject(dx, dy) {
            var index = this.active_object;
            var obj = this.template.objects[index];
            if (!obj) {
                return false;
            }

            var step = 0.0005;
            obj.position_x = parseFloat((parseFloat(obj.position_x) + dx * step).toFixed(4));
            obj.position_y = parseFloat((parseFloat(obj.position_y) + dy * step).toFixed(4));
            this.applyObjectContainerPosition(index);
            return true;
        },
        nudgeFrame: function nudgeFrame(dx, dy) {
            var index = this.active_frame;
            var frame = this.template.frames[index];
            if (!frame || !frame.rawData) {
                return false;
            }

            frame.rawData.x = parseFloat((parseFloat(frame.rawData.x) + dx).toFixed(2));
            frame.rawData.y = parseFloat((parseFloat(frame.rawData.y) + dy).toFixed(2));
            this.syncFrameCalculations(index);
            this.applyFrameContainerPosition(index);
            return true;
        },
        nudgeLayout: function nudgeLayout(dx, dy) {
            var layout = this.template.layouts[this.active_layout];
            if (!layout || !layout.rawData) {
                return false;
            }

            layout.rawData.x = parseFloat((parseFloat(layout.rawData.x) + dx).toFixed(2));
            layout.rawData.y = parseFloat((parseFloat(layout.rawData.y) + dy).toFixed(2));
            return true;
        },
        changeRatioType: function changeRatioType() {
            var sizes = this.getRatioSizes(this.post.ratio);
            this.heightCanvas = sizes.heightCanvas;
            this.default_layout.rawData.h = sizes.layoutH;

            if (this.post.parts) {
                this.post.parts.forEach(function (part) {
                    (part.layouts || []).forEach(function (layout) {
                        if (!layout.rawData) {
                            return;
                        }
                        var w = parseFloat(layout.rawData.w);
                        var h = parseFloat(layout.rawData.h);
                        if (w === 1080 && (h === 1350 || h === 1920 || h === 810 || h === 1080)) {
                            layout.rawData.h = sizes.layoutH;
                        }
                    });
                });
            }

            if (this.active_part_index !== null) {
                this.selectPart(this.active_part_index);
            }
        },
        getRatioSizes: function getRatioSizes(ratio) {
            ratio = parseInt(ratio);
            if (ratio === 2) {
                return { heightCanvas: Math.round(360 * 810 / 1080), layoutH: 810 };
            }
            if (ratio === 3) {
                return { heightCanvas: 640, layoutH: 1920 };
            }
            if (ratio === 4) {
                return { heightCanvas: 360, layoutH: 1080 };
            }
            return { heightCanvas: 450, layoutH: 1350 };
        },
        changeWidgetType: function changeWidgetType(index, type) {
            var current = (this.template.texts[this.active_text].background_color || '').toUpperCase();
            var isCustom = current && current !== 'TRANSPARENT' && current !== '#448AF7' && current !== '#888888';
            if (isCustom) {
                return;
            }
            if (type === 1 || type === 5 || type === 7) {
                this.template.texts[this.active_text].background_color = '#448AF7';
            }
            if (type === 2 || type === 3 || type === 4 || type === 6) {
                this.template.texts[this.active_text].background_color = '#888888';
            }
        },

        setColor: function setColor(color, type) {
            if (type === 'color') {
                this.template.texts[this.active_text].text_color = color;
            }

            if (type === 'background') {
                this.template.texts[this.active_text].background_color = color;
            }
        },
        getContentColor: function getContentColor(color) {
            if (color && color[0] === '#') {
                return color;
            } else {
                return '#000000';
            }
        },
        isColor: function isColor(color) {
            return color && color[0] === '#';
        },
        isContentCorrected: function isContentCorrected(content) {
            return content && content[0] !== '#';
        },
        setObjColor: function setObjColor(color) {
            this.template.objects[this.active_object].color = color;
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/posts/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response) {
                    var data, sizes, _loop3, k;

                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    data = response.data;
                                    sizes = self.getRatioSizes(data.ratio);

                                    self.heightCanvas = sizes.heightCanvas;
                                    self.default_layout.rawData.h = sizes.layoutH;

                                    _loop3 = function _loop3(k) {
                                        var part = data.parts[k];

                                        var _loop4 = function _loop4(i) {

                                            var text = _.find(self.fonts, function (f) {
                                                return f.name === part.texts[i].font_name;
                                            });
                                            if (!text) {
                                                alert('Шрифт ' + part.texts[i].font_name + ' не найден. Пожалуйста, замените на другой.');
                                            }

                                            part.texts[i].is_visible = 1;
                                            if (part.texts[i].time_start === undefined) {
                                                part.texts[i].time_start = 0;
                                            }
                                            if (part.texts[i].time_end === undefined) {
                                                part.texts[i].time_end = "";
                                            }

                                            if (!part.texts[i].angle) {
                                                part.texts[i].angle = 0;
                                            }

                                            if (!part.texts[i].direction) {
                                                part.texts[i].direction = "normal";
                                            }

                                            if (!part.texts[i].animation_type) {
                                                part.texts[i].animation_type = 0;
                                                part.texts[i].animation_duration = 0;
                                            }

                                            if (!part.texts[i].shadow_blur) {
                                                part.texts[i].shadow_blur = 0;
                                            }

                                            if (!part.texts[i].shadow_distance) {
                                                part.texts[i].shadow_distance = 0;
                                            }

                                            if (!part.texts[i].shadow_alpha) {
                                                part.texts[i].shadow_alpha = 0;
                                            }

                                            if (!part.texts[i].shadow_color) {
                                                part.texts[i].shadow_color = '#000000';
                                            }

                                            if (!part.texts[i].stroke_size) {
                                                part.texts[i].stroke_size = 0;
                                            }

                                            if (!part.texts[i].stroke_size) {
                                                part.texts[i].stroke_color = '#000000';
                                            }

                                            if (!part.texts[i].is_text_brush) {
                                                part.texts[i].text_brush_data = [];
                                            }

                                            if (!part.texts[i].bg_alpha) {
                                                part.texts[i].bg_alpha = 1;
                                            }
                                        };

                                        for (var i = 0; i < part.texts.length; i++) {
                                            _loop4(i);
                                        }

                                        for (var i = 0; i < part.objects.length; i++) {
                                            if (!part.objects[i].animation_type) {
                                                part.objects[i].animation_type = 0;
                                                part.objects[i].animation_duration = 0;
                                            }

                                            if (!part.objects[i].shadow_blur) {
                                                part.objects[i].shadow_blur = 0;
                                            }

                                            if (!part.objects[i].shadow_distance) {
                                                part.objects[i].shadow_distance = 0;
                                            }

                                            if (!part.objects[i].shadow_alpha) {
                                                part.objects[i].shadow_alpha = 0;
                                            }

                                            if (!part.objects[i].shadow_color) {
                                                part.objects[i].shadow_color = '#000000';
                                            }
                                        }

                                        for (var _i2 = 0; _i2 < part.layouts.length; _i2++) {
                                            if (!part.layouts[_i2].stroke_size) {
                                                part.layouts[_i2].stroke_size = 0;
                                                part.layouts[_i2].stroke_color = '#000000';
                                            }

                                            if (!part.layouts[_i2].layout_type) {
                                                part.layouts[_i2].layout_type = 1;
                                            }

                                            self.normalizeLayoutFilter(part.layouts[_i2]);
                                        }
                                    };

                                    for (k = 0; k < data.parts.length; k++) {
                                        _loop3(k);
                                    }

                                    data.v_nola = data.v_nola || '';
                                    data.sort_nola = data.sort_nola != null && data.sort_nola !== '' ? data.sort_nola : data.sort || 0;
                                    self.post = data;
                                    //self.parts = self.post.parts;
                                    self.post.parts = _.sortBy(self.post.parts, 'n');

                                    self.selectPart(0);

                                case 11:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee2, this);
                }));

                return function (_x6) {
                    return _ref.apply(this, arguments);
                };
            }()).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        getResources: function getResources() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/resources/', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.server_effects = response.data.effects;
                self.server_graphics = response.data.graphics;
                self.server_filters = response.data.filters;
                self.server_fonts = response.data.fonts;
                self.server_frames = response.data.frames;

                self.appendFonts();

                self.get(self.id);
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        appendFonts: function appendFonts() {

            var newStyle = document.createElement('style');
            for (var i = 0; i < this.server_fonts.length; i++) {
                var font = this.server_fonts[i];

                newStyle.appendChild(document.createTextNode('\n                    @font-face {\n                      font-family: \'' + font.name + '\';\n                      src: url(\'/static/fonts/' + font.src + '\');\n                    }\n                    '));

                this.fonts.push({
                    params: '\'' + font.name + '\', sans-serif;',
                    code: font.name,
                    name: font.name
                });
            }

            document.head.appendChild(newStyle);
        },
        showSVGModal: function showSVGModal() {
            this.is_object_changing = false;
            this.show_svg_modal = true;
        },
        showFramesModal: function showFramesModal() {
            this.is_frame_changing = false;
            this.show_frames_modal = true;
        },
        closeSVGModal: function closeSVGModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_svg_modal = false;
                this.is_object_changing = false;
                this.active_object_category = 'Arrows';
            }
        },
        closeFramesModal: function closeFramesModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_frames_modal = false;
                this.is_frame_changing = false;
            }
        },
        //'888'
        showCollageModal: function showCollageModal(index) {
            this.active_part_index = index;
            this.show_collage_modal = true;
        },
        closeCollageModal: function closeCollageModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_collage_modal = false;
            }
        },
        save: function save() {
            var _this2 = this;

            var self = this;

            this.calculateLayouts();

            var post = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.post));
            post.media_count = this.calculatedMediaCount;

            console.log(post);

            self.waiting = true;

            setTimeout(function () {

                for (var p = 0; p < post.parts.length; p++) {

                    var _template = post.parts[p];

                    for (var i = 0; i < _template.texts.length; i++) {

                        var activeText = _template.texts[i];

                        activeText.letter_spacing = activeText.letter_spacing == "" ? 0 : activeText.letter_spacing;
                        activeText.line_spacing = activeText.line_spacing == "" ? 0 : activeText.line_spacing;
                        activeText.angle = activeText.angle == "" ? 0 : activeText.angle;
                        activeText.z_index = activeText.z_index == "" ? 0 : activeText.z_index;

                        activeText.position_x = parseFloat(activeText.position_x);
                        activeText.position_y = parseFloat(activeText.position_y);
                        activeText.font_size = parseFloat(activeText.font_size);
                        activeText.alpha = parseFloat(activeText.alpha);
                        activeText.bg_alpha = parseFloat(activeText.bg_alpha);
                        activeText.letter_spacing = parseFloat(activeText.letter_spacing);
                        activeText.line_spacing = parseFloat(activeText.line_spacing);
                        activeText.time_start = parseFloat(activeText.time_start);
                        activeText.shadow_distance = parseFloat(activeText.shadow_distance);
                        activeText.shadow_alpha = parseFloat(activeText.shadow_alpha);
                        activeText.shadow_blur = parseInt(activeText.shadow_blur);
                        activeText.animation_type = parseInt(activeText.animation_type);
                        activeText.animation_duration = parseFloat(activeText.animation_duration);
                        activeText.angle = parseInt(activeText.angle);
                        activeText.z_index = parseInt(activeText.z_index);
                        activeText.time_end = activeText.time_end === "" ? "" : parseFloat(activeText.time_end);

                        activeText.text_brush_data = activeText.is_text_brush ? activeText.text_brush_data : [];

                        _template.texts[i] = activeText;
                    }

                    for (var _i3 = 0; _i3 < _template.objects.length; _i3++) {

                        var activeObj = _template.objects[_i3];

                        activeObj.position_x = parseFloat(activeObj.position_x);
                        activeObj.position_y = parseFloat(activeObj.position_y);
                        activeObj.scale = parseFloat(activeObj.scale);
                        activeObj.alpha = parseFloat(activeObj.alpha);
                        activeObj.time_start = parseFloat(activeObj.time_start);
                        activeObj.animation_type = parseInt(activeObj.animation_type);
                        activeObj.shadow_distance = parseFloat(activeObj.shadow_distance);
                        activeObj.shadow_alpha = parseFloat(activeObj.shadow_alpha);
                        activeObj.shadow_blur = parseInt(activeObj.shadow_blur);
                        activeObj.animation_duration = parseFloat(activeObj.animation_duration);
                        activeObj.angle = activeObj.angle == "" ? 0 : parseInt(activeObj.angle);
                        activeObj.z_index = activeObj.z_index == "" ? 0 : parseInt(activeObj.z_index);
                        activeObj.time_end = activeObj.time_end === "" ? "" : parseFloat(activeObj.time_end);

                        delete activeObj.source;

                        _template.objects[_i3] = activeObj;
                    }

                    for (var _i4 = 0; _i4 < _template.layouts.length; _i4++) {

                        var activeLayout = _template.layouts[_i4];

                        activeLayout.co = activeLayout.is_content ? activeLayout.co ? activeLayout.co : '' : '';
                        activeLayout.alpha = parseFloat(activeLayout.alpha);
                        activeLayout.angle = parseInt(activeLayout.angle);
                        activeLayout.z_index = parseInt(activeLayout.z_index);

                        if (self.isEmptyFilter(activeLayout.filter)) {
                            activeLayout.filter = "";
                            activeLayout.filter_intensity = 100;
                            activeLayout.filters = "";
                        } else {
                            activeLayout.filter_intensity = parseInt(activeLayout.filter_intensity) || 100;
                            activeLayout.filters = activeLayout.filter + ":" + activeLayout.filter_intensity;
                        }

                        if (self.isEmptyFilter(activeLayout.effect)) {
                            activeLayout.effect = "";
                            activeLayout.effect_intensity = 100;
                            activeLayout.effects = "";
                        } else {
                            activeLayout.effect_intensity = parseInt(activeLayout.effect_intensity) || 100;
                            activeLayout.effects = activeLayout.effect + ":" + activeLayout.effect_intensity;
                        }

                        delete activeLayout.co_full;
                        delete activeLayout.co_size;

                        _template.layouts[_i4] = activeLayout;
                    }

                    for (var _i5 = 0; _i5 < _template.frames.length; _i5++) {

                        var activeFrame = _template.frames[_i5];

                        activeFrame.alpha = parseFloat(activeFrame.alpha);
                        activeFrame.angle = parseInt(activeFrame.angle);
                        activeFrame.z_index = parseInt(activeFrame.z_index);

                        _template.frames[_i5] = activeFrame;
                    }
                }
                console.log(post);

                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this2.$hostname + '/admin/posts/' + _this2.id + '/update', post, {
                    'headers': {
                        'Authorization': 'Bearer ' + _this2.token
                    }
                }).then(function (response) {
                    var notification = {
                        template: '<span><b>\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.waiting = false;
                    self.captureUnsavedSnapshot();

                    //                    self.$router.push('/posts');
                }).catch(function (error) {
                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;
                });
            }, 200);
        },
        remove: function remove() {
            var self = this;

            if (confirm("Внимание! Подтверждение удаления шаблона: " + self.id)) {
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$hostname + '/admin/posts/' + this.id + '/delete', this.template, {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                }).then(function (response) {
                    var notification = {
                        template: '<span><b>\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.allowUnsavedLeave = true;
                    self.$router.push('/posts');
                }).catch(function (error) {

                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
                });
            }
        },
        clickContentFileButton: function clickContentFileButton(index) {
            var ref = _.get(this.$refs, 'contentFileInput_' + index);
            ref[0].click();
        },
        uploadFile: function uploadFile(event, type, index) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data));

                if (type === 'preview_src') {
                    self.post[data.file_type] = data.url;
                    self.post[data.file_type + '_full'] = data.url_full;
                    self.post[data.file_type + '_size'] = data.filesize;
                }

                if (type === 'src') {
                    self.template[data.file_type] = data.url;
                    self.template[data.file_type + '_full'] = data.url_full;
                    self.template[data.file_type + '_size'] = data.filesize;
                }

                if (type === 'video_src') {
                    self.template[data.file_type] = data.url;
                    self.template[data.file_type + '_full'] = data.url_full;
                    self.template[data.file_type + '_size'] = data.filesize;
                }

                if (type === 'co') {

                    self.template.layouts[self.active_layout][data.file_type] = data.url;
                    self.template.layouts[self.active_layout][data.file_type + '_full'] = data.url_full;
                    self.template.layouts[self.active_layout][data.file_type + '_size'] = data.filesize;
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        dragMouseDown: function dragMouseDown(event) {
            event.preventDefault();

            var path = event.composedPath ? event.composedPath() : event.path;
            var id = null;
            _.each(path, function (p) {
                if (p.className === 'draggable-container') {
                    id = p.id;
                }
            });

            if (!id) {
                return;
            }

            this.preview_drag_start = { x: event.clientX, y: event.clientY };
            this.preview_drag_moved = false;

            if (id.indexOf('o') === 0) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'object';

                this.object_positions[this.draggable_index].clientX = event.clientX;
                this.object_positions[this.draggable_index].clientY = event.clientY;
                this.$refs.draggableContainer2[this.draggable_index].style.opacity = '0.6';

                document.onmousemove = this.objectDrag;
                document.onmouseup = this.closeDragObject;
            } else if (id.indexOf('f') === 0) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'frame';

                if (!this.frame_positions[this.draggable_index]) {
                    this.$set(this.frame_positions, this.draggable_index, JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.default_positions)));
                }

                this.frame_positions[this.draggable_index].clientX = event.clientX;
                this.frame_positions[this.draggable_index].clientY = event.clientY;
                this.$refs.draggableContainer3[this.draggable_index].style.opacity = '0.6';

                document.onmousemove = this.frameDrag;
                document.onmouseup = this.closeDragFrame;
            } else {
                this.draggable_index = id;
                this.draggable_type = 'text';

                this.positions[this.draggable_index].clientX = event.clientX;
                this.positions[this.draggable_index].clientY = event.clientY;
                this.$refs.draggableContainer[this.draggable_index].style.opacity = '0.6';

                document.onmousemove = this.textDrag;
                document.onmouseup = this.closeDragText;
            }
        },
        markPreviewDragIfMoved: function markPreviewDragIfMoved(event) {
            if (this.preview_drag_moved || !this.preview_drag_start) {
                return;
            }

            var dx = event.clientX - this.preview_drag_start.x;
            var dy = event.clientY - this.preview_drag_start.y;
            if (dx * dx + dy * dy > 0) {
                this.preview_drag_moved = true;
            }
        },
        selectPreviewIfClicked: function selectPreviewIfClicked(type) {
            if (this.preview_drag_moved || this.draggable_index == null) {
                return;
            }

            var index = parseInt(this.draggable_index);
            if (type === 'text') {
                this.selectText(index);
            } else if (type === 'object') {
                this.selectObject(index);
            } else if (type === 'frame') {
                this.selectFrame(index);
            }
        },
        textDrag: function textDrag(event) {
            event.preventDefault();
            this.markPreviewDragIfMoved(event);

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX;
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY;
            this.positions[this.draggable_index].clientX = event.clientX;
            this.positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer[this.draggable_index].style.top = this.$refs.draggableContainer[this.draggable_index].offsetTop - this.positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer[this.draggable_index].style.left = this.$refs.draggableContainer[this.draggable_index].offsetLeft - this.positions[this.draggable_index].movementX + 'px';

            var centerX = this.$refs.draggableContainer[this.draggable_index].offsetLeft + this.$refs.draggableContainer[this.draggable_index].clientWidth / 2;
            var centerY = this.$refs.draggableContainer[this.draggable_index].offsetTop + this.$refs.draggableContainer[this.draggable_index].clientHeight / 2;

            this.template.texts[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.texts[this.draggable_index].position_y = parseFloat((centerY / this.heightCanvas).toFixed(4));
        },
        closeDragText: function closeDragText() {
            document.onmouseup = null;
            document.onmousemove = null;

            if (this.draggable_index != null && this.$refs.draggableContainer[this.draggable_index]) {
                this.$refs.draggableContainer[this.draggable_index].style.opacity = '';
            }

            this.selectPreviewIfClicked('text');
            this.draggable_index = null;

            return false;
        },

        objectDrag: function objectDrag(event) {
            event.preventDefault();
            this.markPreviewDragIfMoved(event);

            this.object_positions[this.draggable_index].movementX = this.object_positions[this.draggable_index].clientX - event.clientX;
            this.object_positions[this.draggable_index].movementY = this.object_positions[this.draggable_index].clientY - event.clientY;
            this.object_positions[this.draggable_index].clientX = event.clientX;
            this.object_positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer2[this.draggable_index].style.top = this.$refs.draggableContainer2[this.draggable_index].offsetTop - this.object_positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer2[this.draggable_index].style.left = this.$refs.draggableContainer2[this.draggable_index].offsetLeft - this.object_positions[this.draggable_index].movementX + 'px';

            this.syncObjectModelFromElement(this.draggable_index);
        },
        closeDragObject: function closeDragObject() {
            document.onmouseup = null;
            document.onmousemove = null;

            if (this.draggable_index != null && this.$refs.draggableContainer2[this.draggable_index]) {
                this.$refs.draggableContainer2[this.draggable_index].style.opacity = '';
            }

            this.selectPreviewIfClicked('object');
            this.draggable_index = null;

            return false;
        },

        frameDrag: function frameDrag(event) {
            event.preventDefault();
            this.markPreviewDragIfMoved(event);

            this.frame_positions[this.draggable_index].movementX = this.frame_positions[this.draggable_index].clientX - event.clientX;
            this.frame_positions[this.draggable_index].movementY = this.frame_positions[this.draggable_index].clientY - event.clientY;
            this.frame_positions[this.draggable_index].clientX = event.clientX;
            this.frame_positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer3[this.draggable_index].style.top = this.$refs.draggableContainer3[this.draggable_index].offsetTop - this.frame_positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer3[this.draggable_index].style.left = this.$refs.draggableContainer3[this.draggable_index].offsetLeft - this.frame_positions[this.draggable_index].movementX + 'px';

            this.updateFramePositionFromDom(this.draggable_index);
        },
        closeDragFrame: function closeDragFrame() {
            document.onmouseup = null;
            document.onmousemove = null;

            if (this.draggable_index != null && this.$refs.draggableContainer3[this.draggable_index]) {
                this.$refs.draggableContainer3[this.draggable_index].style.opacity = '';
            }

            this.selectPreviewIfClicked('frame');
            this.draggable_index = null;

            return false;
        },
        renderCollagePart: function renderCollagePart(index) {
            var layout = index.split(';');

            if (index) {
                var category = layout[0].split('_')[0];
                var collageId = layout[0];
                var partId = parseInt(layout[1]);
                var collages = _.find(this.collages, function (c) {
                    return c.name === category;
                });
                var collage = _.find(collages.data, function (c) {
                    return c.id === collageId;
                });

                return this.renderCollage(collage, 0.7, partId - 1);
            }
        },
        renderCollage: function renderCollage(layout) {
            var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var partId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


            var palette = ["#FFDFBA", "#FFFFBA", "#BAFFC9", "#BAE1FF", "#D7C4F3", "#C1F0F6", "#FAD6A5", "#F7C5CC", "#C9E4DE"];

            var containerStyle = "position:relative;" + ('width:' + 108 * scale + 'px;height:' + 192 * scale + 'px;') + "background:#f7f7f7;overflow:hidden;" + ('border: 1px solid ' + (partId === null && this.previous_collage_id === layout.id ? 'red' : '#000') + ';') + "box-shadow:0 6px 20px rgba(0,0,0,.08);";

            var html = '<div style="' + containerStyle + '">';

            for (var i = 0; i < layout.frames.length; i++) {
                var f = layout.frames[i];

                var left = f.x * 108 * scale;
                var top = f.y * 192 * scale;
                var width = f.width * 108 * scale;
                var height = f.height * 192 * scale;

                var color = palette[i % palette.length];

                var radiusStyle = "0px";
                if (f.crop && f.crop.type === "roundedCorner") {
                    var v = f.crop.value;
                    if (v < 0) v = 0;
                    if (v > 1) v = 1;
                    radiusStyle = v * Math.min(width, height) / 2 + "px";
                }

                var frameStyle = "position:absolute;" + "left:" + left + "px;top:" + top + "px;" + "width:" + width + "px;height:" + height + "px;" + "background:" + color + ";" + "border-radius:" + radiusStyle + ";overflow:hidden;" + "display:flex;align-items:center;justify-content:center;" + "color:rgba(0,0,0,.5);" + "font:600 12px sans-serif;";

                var params = layout.id + ';' + (i + 1) + ';' + f.x + ';' + f.y + ';' + f.width + ';' + f.height;

                html += '\n                          <div\n                            data-params="' + params + '"\n                            class="collage-item-part ' + (partId === i ? 'diagonal-lines' : '') + '"\n                            style="' + frameStyle + '"\n                          >\n                            ' + (i + 1) + '\n                          </div>\n                        ';
            }

            html += "</div>";
            return html;
        },
        showPrevNext: function showPrevNext() {
            console.log('show');
        },
        toggleLayoutHighlight: function toggleLayoutHighlight() {
            this.show_layout_highlight = !this.show_layout_highlight;
        }
    }
});

/***/ }),

/***/ "fMfY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Posts_vue__ = __webpack_require__("Tov1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d154c48e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Posts_vue__ = __webpack_require__("JlLP");
function injectStyle (ssrContext) {
  __webpack_require__("GlkW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d154c48e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Posts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d154c48e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Posts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fPBy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fign":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fn8/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "frD+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("pOGF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cece969c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("rwrd");
function injectStyle (ssrContext) {
  __webpack_require__("YbR3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cece969c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cece969c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g69p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        getGraphicSourceSize: function getGraphicSourceSize(source) {
            if (!source || typeof source !== 'string' || source === 'Image') {
                return null;
            }

            var widthAttr = source.match(/\bwidth=["']([\d.]+)(?:px)?["']/i);
            var heightAttr = source.match(/\bheight=["']([\d.]+)(?:px)?["']/i);
            if (widthAttr && heightAttr) {
                var width = parseFloat(widthAttr[1]);
                var height = parseFloat(heightAttr[1]);
                if (width > 0 && height > 0) {
                    return { width: width, height: height };
                }
            }

            var vb = source.match(/\bviewBox=["']([^"']+)["']/i);
            if (vb) {
                var parts = vb[1].trim().split(/[\s,]+/);
                if (parts.length === 4) {
                    var _width = parseFloat(parts[2]);
                    var _height = parseFloat(parts[3]);
                    if (_width > 0 && _height > 0) {
                        return { width: _width, height: _height };
                    }
                }
            }

            return null;
        },
        getObjectDisplaySize: function getObjectDisplaySize(obj) {
            if (!obj) {
                return null;
            }

            var scale = parseFloat(obj.scale);
            var safeScale = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(scale) && scale > 0 ? scale : 1;

            if (obj.dimensions && parseFloat(obj.dimensions.width) > 0 && parseFloat(obj.dimensions.height) > 0) {
                return {
                    width: parseFloat(obj.dimensions.width) * safeScale,
                    height: parseFloat(obj.dimensions.height) * safeScale
                };
            }

            var sourceSize = this.getGraphicSourceSize(obj.source);
            if (sourceSize) {
                return {
                    width: sourceSize.width * safeScale,
                    height: sourceSize.height * safeScale
                };
            }

            return null;
        },
        applySvgPresentation: function applySvgPresentation(source, width, height, style) {
            var svgOpen = source.match(/<svg\b[^>]*>/i);
            if (!svgOpen) {
                return source;
            }

            var tag = svgOpen[0];
            tag = tag.replace(/\s(width|height)=["'][^"']*["']/gi, '');

            var existingStyle = tag.match(/\sstyle=["']([^"']*)["']/i);
            var nextStyle = style || '';
            if (existingStyle) {
                var prev = existingStyle[1].replace(/;?\s*$/, '');
                nextStyle = [prev, style].filter(Boolean).join('; ');
                tag = tag.replace(/\sstyle=["'][^"']*["']/i, '');
            }

            var isSelfClosing = /\/\s*>$/.test(tag);
            tag = tag.replace(/\s*\/?>\s*$/, '');
            tag += ' width="' + width + '" height="' + height + '" style="' + nextStyle + '"';
            tag += isSelfClosing ? '/>' : '>';

            return source.slice(0, svgOpen.index) + tag + source.slice(svgOpen.index + svgOpen[0].length);
        },
        renderSvgObjectHtml: function renderSvgObjectHtml(obj, extraStyle) {
            if (!obj || !obj.source || obj.source === 'Image') {
                return '';
            }

            var source = obj.source;
            var scale = parseFloat(obj.scale);
            var safeScale = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(scale) && scale > 0 ? scale : 1;
            var size = this.getObjectDisplaySize(obj) || {
                width: 100 * safeScale,
                height: 100 * safeScale
            };

            source = source.replace(/fill="black"/g, 'fill="' + obj.color + '"');
            source = source.replace(/stroke="black"/g, 'stroke="' + obj.color + '"');

            var style = ['opacity: ' + obj.alpha, extraStyle || '', 'transform: rotate(' + (obj.angle || 0) + 'deg)', 'z-index: ' + obj.z_index, 'display: block'].filter(Boolean).join('; ');

            return this.applySvgPresentation(source, size.width, size.height, style);
        },
        getObjectAnchorSize: function getObjectAnchorSize(obj, el) {
            var size = this.getObjectDisplaySize(obj);
            if (size && size.width > 0 && size.height > 0) {
                return size;
            }

            return {
                width: el ? el.clientWidth : 0,
                height: el ? el.clientHeight : 0
            };
        },
        syncObjectModelFromElement: function syncObjectModelFromElement(index) {
            var obj = this.template && this.template.objects && this.template.objects[index];
            var el = this.$refs.draggableContainer2 && this.$refs.draggableContainer2[index];
            if (!obj || !el) {
                return;
            }

            var size = this.getObjectAnchorSize(obj, el);
            var centerX = el.offsetLeft + size.width / 2;
            var centerY = el.offsetTop + size.height / 2;
            obj.position_x = parseFloat((centerX / 360).toFixed(4));
            obj.position_y = parseFloat((centerY / (this.heightCanvas || 640)).toFixed(4));
        },
        applyAllObjectContainerPositions: function applyAllObjectContainerPositions() {
            var objects = this.template && this.template.objects;
            if (!objects) {
                return;
            }

            for (var i = 0; i < objects.length; i++) {
                this.applyObjectContainerPosition(i);
            }
        },
        applyObjectContainerPosition: function applyObjectContainerPosition(index) {
            var _this = this;

            var retry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var obj = this.template && this.template.objects && this.template.objects[index];
            var containers = this.$refs.draggableContainer2;
            if (!obj) {
                return;
            }

            if (!containers || !containers[index]) {
                if (retry < 20) {
                    setTimeout(function () {
                        return _this.applyObjectContainerPosition(index, retry + 1);
                    }, 50);
                }
                return;
            }

            var el = containers[index];
            var size = this.getObjectAnchorSize(obj, el);
            var width = size.width;
            var height = size.height;

            if ((!size || width < 1 || height < 1) && el.clientHeight < 1 && retry < 20) {
                var img = el.querySelector('img');
                if (img && !img.complete) {
                    img.onload = function () {
                        return _this.$nextTick(function () {
                            return _this.applyObjectContainerPosition(index, retry + 1);
                        });
                    };
                    img.onerror = function () {
                        return _this.$nextTick(function () {
                            return _this.applyObjectContainerPosition(index, retry + 1);
                        });
                    };
                    return;
                }

                setTimeout(function () {
                    return _this.applyObjectContainerPosition(index, retry + 1);
                }, 50);
                return;
            }

            var canvasHeight = this.heightCanvas || 640;
            el.style.left = parseFloat(obj.position_x) * 360 - width / 2 + 'px';
            el.style.top = parseFloat(obj.position_y) * canvasHeight - height / 2 + 'px';
        },
        applyReplacedObjectSize: function applyReplacedObjectSize(obj, newWidth, newHeight, setDimensions) {
            var scale = parseFloat(obj.scale) || 1;
            var prevW = 0;
            var prevH = 0;

            if (obj.dimensions && parseFloat(obj.dimensions.width) > 0 && parseFloat(obj.dimensions.height) > 0) {
                prevW = parseFloat(obj.dimensions.width) * scale;
                prevH = parseFloat(obj.dimensions.height) * scale;
            } else {
                var sourceSize = this.getGraphicSourceSize(obj.source);
                if (sourceSize) {
                    prevW = sourceSize.width * scale;
                    prevH = sourceSize.height * scale;
                }
            }

            newWidth = parseFloat(newWidth);
            newHeight = parseFloat(newHeight);

            if (setDimensions && newWidth > 0 && newHeight > 0) {
                this.$set(obj, 'dimensions', {
                    width: newWidth,
                    height: newHeight
                });
            }

            if (prevW > 0 && prevH > 0 && newWidth > 0 && newHeight > 0) {
                var nextScale = Math.min(prevW / newWidth, prevH / newHeight);
                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(nextScale) && nextScale > 0) {
                    obj.scale = parseFloat(nextScale.toFixed(4));
                }
            }
        },
        syncReplacedObjectPosition: function syncReplacedObjectPosition() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.applyObjectContainerPosition(_this2.active_object);
            });
        },
        replaceActiveGraphic: function replaceActiveGraphic(object, source, newWidth, newHeight, setDimensions) {
            var obj = this.template.objects[this.active_object];
            if (!obj) {
                return;
            }

            this.applyReplacedObjectSize(obj, newWidth, newHeight, setDimensions);
            obj.id = object.src;
            obj.source = source;
            this.syncReplacedObjectPosition();
            if (typeof this.ensureFrozenGif === 'function') {
                this.ensureFrozenGif(object.src);
            }
        }
    }
});

/***/ }),

/***/ "hGmM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Треки")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),(_vm.data)?_c('div',{staticClass:"row stats-block mt10"},[_c('span',[_vm._v("Количество альбомов: "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.albums.length))])]),_vm._v(" "),_c('span',[_vm._v("Количество треков: "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.tracksCount))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Альбом")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.album),expression:"album"}],staticClass:"form-control",attrs:{"id":"category-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.album=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('t_album', _vm.album)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.albums),function(a){return _c('option',{domProps:{"value":a.id}},[_vm._v(_vm._s(a.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('t_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить трек\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'album')?_c('span',[_vm._v("альбом")]):(column === 'artist')?_c('span',[_vm._v("артист")]):(column === 'title')?_c('span',[_vm._v("название")]):(column === 'is_premium')?_c('span',[_vm._v("премиум")]):(column === 'is_trendy')?_c('span',[_vm._v("популярное")]):(column === 'src_full')?_c('span',[_vm._v("трек")]):(column === 'image_src_full')?_c('span',[_vm._v("фон")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'duration')?_c('span',[_vm._v("длительность")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'image_src_full')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[(item[column])?_c('div',{staticClass:"device-block device1",style:({ backgroundImage: 'url(' + item[column] + ')' })}):_vm._e(),_vm._v(" "),(!item[column])?_c('img',{staticClass:"device1",attrs:{"src":"/static/img/track.png"}}):_vm._e()]):(column === 'duration')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'src_full')?_c('span',[_c('audio',{attrs:{"src":item[column],"onloadstart":"this.volume=0.5","controls":"controls","controlsList":"nodownload noplaybackrate"}})]):(column === 'is_premium')?_c('span',[(item[column] === 1)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/premium.png"}}):_vm._e()]):(column === 'is_trendy')?_c('span',{staticClass:"emodji"},[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("🖤")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"}):_vm._e()]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активен")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активен")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hLOT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hYIP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hyCC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("VXPv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a47904b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("BPtL");
function injectStyle (ssrContext) {
  __webpack_require__("cTXz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a47904b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a47904b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hz6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-hub"},[(_vm.tabs.length > 1)?_c('div',{staticClass:"preview-tabs"},_vm._l((_vm.tabs),function(tab){return _c('router-link',{key:tab.name,staticClass:"btn btn-text btn-fill",attrs:{"to":{ name: tab.name },"tag":"button","type":"button","active-class":"active"}},[_vm._v("\n            "+_vm._s(tab.label)+"\n        ")])}),1):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.$route.path})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iBrQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Вкладки")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('tabs_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить вкладку\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'type')?_c('span',[_vm._v("тип контента")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'name')?_c('span',[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активен")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активен")]):_vm._e()]):(column === 'type')?_c('span',[(item[column] === 1)?_c('span',[_vm._v("Категория")]):_vm._e(),_vm._v(" "),(item[column] === 2)?_c('span',[_vm._v("По свойству")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iK4w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iMRK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',[_c('mobile-menu',{attrs:{"slot":"content"},slot:"content"}),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/preview"}},[_c('i',{staticClass:"nc-icon nc-apple"}),_vm._v(" "),_c('p',[_vm._v("Превью")])]),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/categories"}},[_c('i',{staticClass:"nc-icon nc-notes"}),_vm._v(" "),_c('p',[_vm._v("Категории")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"resetspan",on:{"click":_vm.resetOffsets}},[_c('sidebar-link',{attrs:{"to":"/templates"}},[_c('i',{staticClass:"nc-icon nc-album-2"}),_vm._v(" "),_c('p',[_vm._v("Шаблоны")])])],1),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/post/categories"}},[_c('i',{staticClass:"nc-icon nc-notes"}),_vm._v(" "),_c('p',[_vm._v("Категории каруселей")])]):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/posts"}},[_c('i',{staticClass:"nc-icon nc-single-copy-04"}),_vm._v(" "),_c('p',[_vm._v("Карусели")])]):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/memories"}},[_c('i',{staticClass:"nc-icon nc-light-3"}),_vm._v(" "),_c('p',[_vm._v("Memories")])]):_vm._e(),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/calendar"}},[_c('i',{staticClass:"nc-icon nc-watch-time"}),_vm._v(" "),_c('p',[_vm._v("Календарь")])]),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/frame/categories"}},[_c('i',{staticClass:"nc-icon nc-notes"}),_vm._v(" "),_c('p',[_vm._v("Категории фреймов")])]):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/frames"}},[_c('i',{staticClass:"nc-icon nc-puzzle-10"}),_vm._v(" "),_c('p',[_vm._v("Фреймы")])]):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/graphic/categories"}},[_c('i',{staticClass:"nc-icon nc-notes"}),_vm._v(" "),_c('p',[_vm._v("Категории стикеров")])]):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/graphics"}},[_c('i',{staticClass:"nc-icon nc-atom"}),_vm._v(" "),_c('p',[_vm._v("Стикеры")])]):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/font/categories"}},[_c('i',{staticClass:"nc-icon nc-notes"}),_vm._v(" "),_c('p',[_vm._v("Категории шрифтов")])]):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/fonts"}},[_c('i',{staticClass:"nc-icon nc-ruler-pencil"}),_vm._v(" "),_c('p',[_vm._v("Шрифты")])]):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/effect/categories"}},[_c('i',{staticClass:"nc-icon nc-notes"}),_vm._v(" "),_c('p',[_vm._v("Категории эффектов")])]):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/effects"}},[_c('i',{staticClass:"nc-icon nc-preferences-circle-rotate"}),_vm._v(" "),_c('p',[_vm._v("Эффекты")])]):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/music/categories"}},[_c('i',{staticClass:"nc-icon nc-single-copy-04"}),_vm._v(" "),_c('p',[_vm._v("Категории музыки")])]):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/new-music"}},[_c('i',{staticClass:"nc-icon nc-note-03"}),_vm._v(" "),_c('p',[_vm._v("Музыка")])]):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/tabs"}},[_c('i',{staticClass:"nc-icon nc-layers-3"}),_vm._v(" "),_c('p',[_vm._v("Вкладки")])]):_vm._e(),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/logs"}},[_c('i',{staticClass:"nc-icon nc-cctv"}),_vm._v(" "),_c('p',[_vm._v("Логи")])]),_vm._v(" "),(_vm.role === 302)?_c('li',{staticClass:"sidebar-divider"}):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/nola-preview"}},[_c('i',{staticClass:"nc-icon nc-apple"}),_vm._v(" "),_c('p',[_vm._v("Превью Nola")])]):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('li',{staticClass:"sidebar-divider"}):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/reports"}},[_c('i',{staticClass:"nc-icon nc-chart-bar-32"}),_vm._v(" "),_c('p',[_vm._v("Отчеты")])]):_vm._e(),_vm._v(" "),(_vm.role === 302)?_c('sidebar-link',{attrs:{"to":"/push-tasks"}},[_c('i',{staticClass:"nc-icon nc-notification-70"}),_vm._v(" "),_c('p',[_vm._v("Рассылки")])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{on:{"click":_vm.toggleSidebar}}),_vm._v(" "),_c('content-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iw6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");
var _ = __webpack_require__("M4fF");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            categories: [],
            active_layout: 0,
            data: {},
            object: {
                status: 0,
                category_id: 0,
                src: null,
                src_full: null,
                is_premium: 0,
                no_color: 1,
                sort: 1,
                layouts: [],
                params: []
            },
            default_layout: {
                w: null,
                h: null,
                x: 0,
                y: 0,
                b_tl: 0,
                b_tr: 0,
                b_br: 0,
                b_bl: 0
            },
            default_param: {
                original_w: null,
                original_h: null,
                w: null,
                h: null,
                x: 0,
                y: 0,
                b_tl: 0,
                b_tr: 0,
                b_br: 0,
                b_bl: 0
            }
        };
    },

    created: function created() {
        this.getCategories();
        this.addLayout(true);
    },
    computed: {
        graphicsUrl: function graphicsUrl() {
            return this.$graphicsUrl;
        }
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/frames');
        },
        getCategories: function getCategories() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/frames/categories', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.categories = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var _this = this;

            var self = this;

            this.calculateParams();

            var i = this.active_layout;
            this.active_layout = -1;

            setTimeout(function () {

                _this.active_layout = i;
            }, 100);

            return;
        },

        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.object.src = data.url;
                self.object.src_full = data.url_full;
                self.object.src_size = data.filesize;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        layout_html: function layout_html(index) {
            var layoutModel = this.object.layouts[index];
            var rawData = this.object.params[index];

            var scale = 360 / parseFloat(rawData.original_w);

            var overlay = {
                w: rawData.w * scale,
                h: rawData.h * scale,
                x: rawData.x * scale,
                y: rawData.y * scale,
                b_tl: parseFloat(rawData.b_tl * scale).toFixed(2),
                b_tr: parseFloat(rawData.b_tr * scale).toFixed(2),
                b_br: parseFloat(rawData.b_br * scale).toFixed(2),
                b_bl: parseFloat(rawData.b_bl * scale).toFixed(2)
            };

            var colors = ['rgba(255, 0, 0, 0.4)', 'rgba(0, 128, 0, 0.4)', 'rgba(0, 0, 255, 0.4)', 'rgba(255, 165, 0, 0.4)', 'rgba(128, 0, 128, 0.4)', 'rgba(0, 206, 209, 0.4)', 'rgba(255, 192, 203, 0.4)', 'rgba(255, 255, 0, 0.4)', 'rgba(165, 42, 42, 0.4)', 'rgba(128, 128, 128, 0.4)'];

            var layout = '<div class="overlay ' + (index === this.active_layout ? 'active' : '') + '"></div>';

            var style = ' style="position: absolute; background: ' + (colors[index] ? colors[index] : colors[0]) + '; top: ' + overlay.y + 'px; left: ' + overlay.x + 'px; width: ' + overlay.w + 'px; height: ' + overlay.h + 'px; border-radius: ' + overlay.b_tl + 'px ' + overlay.b_tr + 'px ' + overlay.b_br + 'px ' + overlay.b_bl + 'px; z-index: ' + layoutModel.z_index + '"';

            layout = this.insertAt(layout, style, 5);

            return layout;
        },
        insertAt: function insertAt(str, sub, pos) {
            return '' + str.slice(0, pos) + sub + str.slice(pos);
        },

        openResource: function openResource(url) {
            window.open(url, "_blank");
        },
        selectLayout: function selectLayout(layout) {
            this.active_layout = layout;
        },
        addLayout: function addLayout() {
            var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.object.layouts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.default_layout)));

            if (!first) {
                this.default_param.original_w = _.last(this.object.params).original_w;
                this.default_param.original_h = _.last(this.object.params).original_h;
            }

            this.object.params.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.default_param)));
            this.active_layout = this.object.layouts.length - 1;
        },
        removeLayout: function removeLayout(index) {
            var self = this;

            if (self.object.layouts.length === 1) {
                alert('Нельзя удалить последний layout');
                return;
            }

            if (confirm("Подтверждение удаления layout " + (parseInt(index) + 1))) {
                self.active_layout = 0;

                self.object.params = self.object.params.filter(function (t, i) {
                    return i !== index;
                });
                self.object.layouts = self.object.layouts.filter(function (t, i) {
                    return i !== index;
                });
            }
        },

        calculateParams: function calculateParams() {

            for (var i = 0; i < this.object.layouts.length; i++) {

                var rawData = this.object.params[i];

                this.object.layouts[i] = {
                    w: parseFloat(parseFloat(rawData.w) / parseFloat(rawData.original_w)).toFixed(6),
                    h: parseFloat(parseFloat(rawData.h) / parseFloat(rawData.original_h)).toFixed(6),
                    x: parseFloat(parseFloat(rawData.x) / parseFloat(rawData.original_w)).toFixed(6),
                    y: parseFloat(parseFloat(rawData.y) / parseFloat(rawData.original_h)).toFixed(6),
                    b_tl: parseFloat(parseFloat(rawData.b_tl) / parseFloat(rawData.original_w)).toFixed(6),
                    b_tr: parseFloat(parseFloat(rawData.b_tr) / parseFloat(rawData.original_w)).toFixed(6),
                    b_br: parseFloat(parseFloat(rawData.b_br) / parseFloat(rawData.original_w)).toFixed(6),
                    b_bl: parseFloat(parseFloat(rawData.b_bl) / parseFloat(rawData.original_w)).toFixed(6)
                    //z_index: parseInt(this.object.layouts[i].z_index)
                };
            }
        }

    }
});

/***/ }),

/***/ "jEp+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__("QDyf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5988fdbd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__("u6Ka");
function injectStyle (ssrContext) {
  __webpack_require__("YyF9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5988fdbd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jP93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GraphicsCategories_vue__ = __webpack_require__("5P5o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_316e4fca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GraphicsCategories_vue__ = __webpack_require__("VtWE");
function injectStyle (ssrContext) {
  __webpack_require__("lj6E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-316e4fca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GraphicsCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_316e4fca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GraphicsCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jwN2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("s8pP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75fa270d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("SvCM");
function injectStyle (ssrContext) {
  __webpack_require__("JM/w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75fa270d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75fa270d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k7vH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FontsCategories_vue__ = __webpack_require__("vbaG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ee53de1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FontsCategories_vue__ = __webpack_require__("0q5V");
function injectStyle (ssrContext) {
  __webpack_require__("EuQ/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ee53de1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FontsCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ee53de1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FontsCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kP44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_mixins_unsavedLeaveGuard__ = __webpack_require__("WSC3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_mixins_replaceGraphicSize__ = __webpack_require__("g69p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_mixins_gifGraphic__ = __webpack_require__("pJH4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_mixins_stickyLayers__ = __webpack_require__("P+tE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_mixins_pastePartDurations__ = __webpack_require__("nsOS");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateCategory',
    mixins: [__WEBPACK_IMPORTED_MODULE_5_src_mixins_unsavedLeaveGuard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_src_mixins_replaceGraphicSize__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_src_mixins_gifGraphic__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_src_mixins_pastePartDurations__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_src_mixins_stickyLayers__["a" /* default */]],
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            lock_waiting: false,
            visibilityRaf: null,
            is_playing: false,
            show_svg_modal: false,
            show_frames_modal: false,
            is_object_changing: false,
            is_frame_changing: false,
            video: null,
            active_text: 0,
            active_object: 0,
            active_frame: 0,
            draggable_index: 0,
            draggable_type: null,
            active_type: 'text',
            svg_list: [],
            realVideoDuration: null,
            realAudioDuration: null,
            effect: "",
            effect_intensity: 100,
            filter: "",
            filter_intensity: 100,
            heightCanvas: 640,
            show_collage_modal: false,
            active_collage_category: '2',
            previous_collage_id: null,
            active_part_index: null,
            default_custom_collage_rawData: {
                original_w: 1080,
                original_h: 1920,
                w: 0,
                h: 0,
                x: 0,
                y: 0,
                b_tl: 0,
                b_tr: 0,
                b_br: 0,
                b_bl: 0
            },
            custom_collage_rawData: {
                original_w: 1080,
                original_h: 1920,
                w: 0,
                h: 0,
                x: 0,
                y: 0,
                b_tl: 0,
                b_tr: 0,
                b_br: 0,
                b_bl: 0
            },
            active_object_category: null,
            active_frame_category: 1,
            template: {
                status: 0,
                category_id: null,
                sort: 1,
                videos: null,
                duration: null,
                v: "",
                src: null,
                src_full: null,
                src_size: null,
                preview_src: null,
                preview_src_full: null,
                preview_src_size: null,
                preview_image: null,
                preview_image_full: null,
                preview_image_size: null,
                audio: null,
                audio_full: null,
                audio_size: null,
                song: null,
                song_insta: "",
                song_tiktok: "",
                filters: "",
                effects: "",
                release_date: null,
                release_time: '12:00',
                is_premium: 0,
                is_trendy: 0,
                is_trending_music: 0,
                is_collage: 0,
                is_cut_out: 0,
                is_paper_cut_out: 0,
                is_copyrighted: 0,
                is_stories: 0,
                is_new: 0,
                parts: [],
                texts: [],
                objects: [],
                frames: [],
                tags: [],
                type: 0,
                ratio: 1,
                background: '#000000'
            },
            categories: [],
            client_parts: [],
            tags: [],
            server_effects: [],
            server_graphics: [],
            server_filters: [],
            server_fonts: [],
            server_frames: [],
            is_text_active: false,
            default_text: {
                text: 'Default text',
                font_name: 'SF Pro',
                font_size: 30,
                text_color: "#ffffff",
                letter_spacing: 0,
                line_spacing: 0,
                alpha: 1,
                text_align: 'center',
                background_color: 'transparent',
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                is_animated: 0,
                angle: 0,
                direction: 'normal',
                animation_type: 0,
                animation_duration: 0,
                shadow_blur: 0,
                shadow_alpha: 0,
                shadow_distance: 0,
                shadow_color: '#ffffff',
                stroke_size: 0,
                stroke_color: '#000000'
            },
            default_object: {
                id: "b-330x298.svg",
                scale: 1,
                source: '<span>SVG</span>',
                color: '#ffffff',
                alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                animation_type: 0,
                animation_duration: 0,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                is_animated: 0,
                angle: 0
            },
            fonts: [{
                params: "'SF Pro', sans-serif;",
                code: "SF Pro",
                name: "SF Pro"
            }],
            colors: ["#FFFFFF", "#000000", "#F9F7F4", "#FAF5ED", "#F2E8DD", "#F4E4DD", "#D9BEBD", "#C5AEB6", "#E3C2D2", "#F1E0EF", "#D5C9E9", "#C8ACE0", "#E06E97", "#E64F3C", "#AB613E", "#B97959", "#D99056", "#E8BF88", "#EDD8AB", "#FAE389", "#F5C154", "#B78C3A", "#585B3B", "#7B7C41", "#BBB595", "#DFE7DA", "#C0DED3", "#B4C5C9", "#C9D9F0", "#4E63EC", "#4F5E8D", "#725B6E", "#F0F0F0", "#D9D9D9", "#616161", "#3C3C3C"],
            widget_types: [{
                id: 1,
                name: "Message (справа)"
            }, {
                id: 5,
                name: "Message (слева)"
            }, {
                id: 2,
                name: "Time"
            }, {
                id: 3,
                name: "Location"
            }, {
                id: 4,
                name: "Custom tag (снизу)"
            }, {
                id: 6,
                name: "Custom tag (сверху)"
            }, {
                id: 7,
                name: "Selection"
            }],
            animation_types: [{
                id: 0,
                name: "-"
            }, {
                id: 1,
                name: "Fade"
            }, {
                id: 4,
                name: "Zoom In"
            }, {
                id: 18,
                name: "Zoom Out"
            }, {
                id: 6,
                name: "Reveal ↓"
            }, {
                id: 7,
                name: "Reveal ↑"
            }, {
                id: 8,
                name: "Reveal →"
            }, {
                id: 9,
                name: "Reveal ←"
            }, {
                id: 10,
                name: "Float ↓"
            }, {
                id: 11,
                name: "Float ↑"
            }, {
                id: 12,
                name: "Float →"
            }, {
                id: 13,
                name: "Float ←"
            }, {
                id: 14,
                name: "Typewriter"
            }, {
                id: 15,
                name: "Typewriter Fade In"
            }, {
                id: 16,
                name: "Typewriter By Word"
            }, {
                id: 17,
                name: "Typewriter By Word Fade In"
            }],
            effect_types: [{
                id: 0,
                name: "-"
            }, {
                id: 1,
                name: "Zoom in"
            }, {
                id: 2,
                name: "Zoom out"
            }, {
                id: 3,
                name: "Snow"
            }, {
                id: 4,
                name: "VHS"
            }],
            content_types: [{
                id: 0,
                name: "Обычный"
            }, {
                id: 1,
                name: "Статика"
            }, {
                id: 2,
                name: "Цвет"
            }],
            collage_types: [{
                id: 0,
                name: "-",
                params: null
            }, {
                id: 1,
                name: "1/4",
                params: { x: 0, y: 0, w: 0.5, h: 0.5 }
            }, {
                id: 2,
                name: "2/4",
                params: { x: 0.5, y: 0, w: 0.5, h: 0.5 }
            }, {
                id: 3,
                name: "3/4",
                params: { x: 0, y: 0.5, w: 0.5, h: 0.5 }
            }, {
                id: 4,
                name: "4/4",
                params: { x: 0.5, y: 0.5, w: 0.5, h: 0.5 }
            }, {
                id: 5,
                name: "1/3",
                params: { x: 0, y: 0, w: 1, h: 0.3333 }
            }, {
                id: 6,
                name: "2/3",
                params: { x: 0, y: 0.3333, w: 1, h: 0.3333 }
            }, {
                id: 7,
                name: "3/3",
                params: { x: 0, y: 0.6666, w: 1, h: 0.3333 }
            }, {
                id: 8,
                name: "1/2",
                params: { x: 0, y: 0, w: 1, h: 0.5 }
            }, {
                id: 9,
                name: "2/2",
                params: { x: 0, y: 0.5, w: 1, h: 0.5 }
            }, {
                id: 10,
                name: "1/6",
                params: { x: 0, y: 0, w: 0.5, h: 0.3333 }
            }, {
                id: 11,
                name: "2/6",
                params: { x: 0.5, y: 0, w: 0.5, h: 0.3333 }
            }, {
                id: 12,
                name: "3/6",
                params: { x: 0, y: 0.3333, w: 0.5, h: 0.3333 }
            }, {
                id: 13,
                name: "4/6",
                params: { x: 0.5, y: 0.3333, w: 0.5, h: 0.3333 }
            }, {
                id: 14,
                name: "5/6",
                params: { x: 0, y: 0.6666, w: 0.5, h: 0.3333 }
            }, {
                id: 15,
                name: "6/6",
                params: { x: 0.5, y: 0.6666, w: 0.5, h: 0.3333 }
            }],
            text_aligns: [{
                name: "center"
            }, {
                name: "start"
            }, {
                name: "end"
            }],
            default_positions: {
                clientX: undefined,
                clientY: undefined,
                movementX: 0,
                movementY: 0
            },
            positions: [],
            object_positions: [],
            frame_positions: [],
            collages: [{
                name: '2',
                data: [{
                    id: '2_1',
                    frames: [{ x: 0, y: 0, width: 1.0, height: 0.5 }, { x: 0, y: 0.5, width: 1.0, height: 0.5 }]
                }, {
                    id: '2_2',
                    frames: [{ x: 0, y: 0, width: 1.0, height: 0.491 }, { x: 0, y: 0.509, width: 1.0, height: 0.491 }]
                }, {
                    id: '2_3',
                    frames: [{ x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474 }, { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474 }]
                }, {
                    id: '2_4',
                    frames: [{ x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '2_5',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 1.0 }, { x: 0.5, y: 0, width: 0.5, height: 1.0 }]
                }, {
                    id: '2_6',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.315 }, { x: 0, y: 0.315, width: 1, height: 0.685 }]
                }, {
                    id: '2_7',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.685 }, { x: 0, y: 0.685, width: 1, height: 0.315 }]
                }, {
                    id: '2_8',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: '2_9',
                    frames: [{ x: 0.2375, y: 0.1223, width: 0.532, height: 0.3647 }, { x: 0.2375, y: 0.5133, width: 0.532, height: 0.3647 }]
                }]
            }, {
                name: '3',
                data: [{
                    id: "3_1",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3334 }, { x: 0, y: 0.6667, width: 1, height: 0.3333 }]
                }, {
                    id: "3_2",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.326783 }, { x: 0, y: 0.336758, width: 1, height: 0.326783 }, { x: 0, y: 0.673216, width: 1, height: 0.326783 }]
                }, {
                    id: "3_3",
                    frames: [{ x: 0.028, y: 0.015625, width: 0.944, height: 0.3125 }, { x: 0.028, y: 0.34375, width: 0.944, height: 0.3125 }, { x: 0.028, y: 0.671875, width: 0.944, height: 0.3125 }]
                }, {
                    id: "3_4",
                    frames: [{
                        x: 0.028,
                        y: 0.015625,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }, {
                        x: 0.028,
                        y: 0.34375,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }, {
                        x: 0.028,
                        y: 0.671875,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }]
                }, {
                    id: "3_5",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6667, width: 0.5, height: 0.3333 }]
                }, {
                    id: "3_6",
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 1 }, { x: 0.3333, y: 0, width: 0.3333, height: 1 }, { x: 0.6667, y: 0, width: 0.3333, height: 1 }]
                }, {
                    id: "3_7",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_8",
                    frames: [{ x: 0, y: 0.5, width: 1, height: 0.5 }, { x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_9",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_10",
                    frames: [{ x: 0.0648, y: 0.064, width: 0.4815, height: 0.28125 }, { x: 0.0648, y: 0.35925, width: 0.4815, height: 0.28125 }, { x: 0.0648, y: 0.6564, width: 0.4815, height: 0.28125 }]
                }]
            }, {
                name: '4',
                data: [{
                    id: "4_1",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.25 }, { x: 0, y: 0.25, width: 1, height: 0.25 }, { x: 0, y: 0.5, width: 1, height: 0.25 }, { x: 0, y: 0.75, width: 1, height: 0.25 }]
                }, {
                    id: "4_2",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.24267 }, { x: 0, y: 0.25264333, width: 1, height: 0.24267 }, { x: 0, y: 0.50498666, width: 1, height: 0.24267 }, { x: 0, y: 0.75733, width: 1, height: 0.24267 }]
                }, {
                    id: "4_3",
                    frames: [{ x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875 }]
                }, {
                    id: "4_4",
                    frames: [{ x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }]
                }, {
                    id: "4_5",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "4_6",
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.4948 }, { x: 0.50925, y: 0, width: 0.49075, height: 0.4948 }, { x: 0, y: 0.5052, width: 0.49075, height: 0.4948 }, { x: 0.50925, y: 0.5052, width: 0.49075, height: 0.4948 }]
                }, {
                    id: "4_7",
                    frames: [{ x: 0.0315, y: 0.017708, width: 0.45925, height: 0.410417 }, { x: 0.50925, y: 0.017708, width: 0.45927, height: 0.410417 }, { x: 0.0315, y: 0.438542, width: 0.45927, height: 0.410417 }, { x: 0.50925, y: 0.438542, width: 0.45927, height: 0.410417 }]
                }, {
                    id: "4_8",
                    frames: [{ x: 0.0407, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.5213, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.0407, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.5213, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }]
                }, {
                    id: "4_9",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.5 }, { x: 0, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 }]
                }, {
                    id: "4_10",
                    frames: [{ x: 0.01852, y: 0.010717, width: 0.96296, height: 0.48381425 }, { x: 0.01852, y: 0.50546875, width: 0.30864, height: 0.48411425 }, { x: 0.34568, y: 0.50546875, width: 0.30864, height: 0.48411425 }, { x: 0.67284, y: 0.50546875, width: 0.30864, height: 0.48411425 }]
                }, {
                    id: "4_11",
                    frames: [{ x: 0.01852, y: 0.010417, width: 0.400926, height: 0.4843745 }, { x: 0.437966, y: 0.010417, width: 0.543514, height: 0.4843745 }, { x: 0.01852, y: 0.5052085, width: 0.543514, height: 0.4843745 }, { x: 0.580554, y: 0.5052085, width: 0.400926, height: 0.4843745 }]
                }, {
                    id: "4_12",
                    frames: [{ x: 0, y: 0, width: 0.49074, height: 0.4895829967 }, { x: 0.50926, y: 0, width: 0.49074, height: 0.4895829967 }, { x: 0, y: 0.4999996633, width: 1, height: 0.2447917 }, { x: 0, y: 0.7552083, width: 1, height: 0.2447917 }]
                }]
            }, {
                name: '5',
                data: [{
                    id: '5_1',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.2 }, { x: 0, y: 0.2, width: 1, height: 0.2 }, { x: 0, y: 0.4, width: 1, height: 0.2 }, { x: 0, y: 0.6, width: 1, height: 0.2 }, { x: 0, y: 0.8, width: 1, height: 0.2 }]
                }, {
                    id: '5_2',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.1875 }, { x: 0, y: 0.203125, width: 1, height: 0.1875 }, { x: 0, y: 0.40625, width: 1, height: 0.1875 }, { x: 0, y: 0.609375, width: 1, height: 0.1875 }, { x: 0, y: 0.8125, width: 1, height: 0.1875 }]
                }, {
                    id: '5_3',
                    frames: [{ x: 0.028, y: 0.015825, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095 }]
                }, {
                    id: '5_4',
                    frames: [{ x: 0.028, y: 0.015825, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '5_5',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.5, height: 0.3334 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '5_6',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 1 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0.3333, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0, width: 0.3334, height: 1 }]
                }, {
                    id: '5_7',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.6666, y: 0, width: 0.3334, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3333 }, { x: 0, y: 0.6666, width: 1, height: 0.3334 }]
                }, {
                    id: '5_8',
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.4947915 }, { x: 0, y: 0.5052085, width: 0.49075, height: 0.4947915 }, { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.33710567, width: 0.49075, height: 0.32608867 }, { x: 0.50927, y: 0.67361134, width: 0.49075, height: 0.32638867 }]
                }, {
                    id: '5_9',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '5_11',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 }]
                }]
            }, {
                name: '6',
                data: [{
                    id: '6_1',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.16697 }, { x: 0, y: 0.16637, width: 1, height: 0.16697 }, { x: 0, y: 0.33304, width: 1, height: 0.16697 }, { x: 0, y: 0.49971, width: 1, height: 0.16697 }, { x: 0, y: 0.66638, width: 1, height: 0.16696 }, { x: 0, y: 0.83304, width: 1, height: 0.16696 }]
                }, {
                    id: '6_2',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.15798583 }, { x: 0, y: 0.16790283, width: 1, height: 0.15798583 }, { x: 0, y: 0.33680566, width: 1, height: 0.15798583 }, { x: 0, y: 0.50520849, width: 1, height: 0.15798583 }, { x: 0, y: 0.67361132, width: 1, height: 0.15798583 }, { x: 0, y: 0.84201415, width: 1, height: 0.15798583 }]
                }, {
                    id: '6_3',
                    frames: [{ x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152 }]
                }, {
                    id: '6_4',
                    frames: [{ x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '6_14',
                    frames: [{ x: 0, y: 0, width: 0.1667, height: 1 }, { x: 0.1667, y: 0, width: 0.1666, height: 1 }, { x: 0.3333, y: 0, width: 0.1667, height: 1 }, { x: 0.5, y: 0, width: 0.1667, height: 1 }, { x: 0.6667, y: 0, width: 0.1666, height: 1 }, { x: 0.8333, y: 0, width: 0.1667, height: 1 }]
                }, {
                    id: '6_5',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0.6666, width: 0.3333, height: 0.3334 }]
                }, {
                    id: '6_6',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.5, height: 0.3334 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '6_7',
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0, y: 0.33685567, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.33685567, width: 0.49075, height: 0.32638867 }, { x: 0, y: 0.67321134, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.67321134, width: 0.49075, height: 0.32638867 }]
                }, {
                    id: '6_8',
                    frames: [{ x: 0, y: 0, width: 0.369444, height: 0.25 }, { x: 0, y: 0.25, width: 0.369444, height: 0.25 }, { x: 0.369444, y: 0, width: 0.630556, height: 0.5 }, { x: 0, y: 0.5, width: 0.630556, height: 0.5 }, { x: 0.630556, y: 0.5, width: 0.369444, height: 0.25 }, { x: 0.630556, y: 0.75, width: 0.369444, height: 0.25 }]
                }, {
                    id: '6_9',
                    frames: [{ x: 0, y: 0, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.2526175, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.505235, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.7578525, width: 0.369444, height: 0.2421475 }, { x: 0.387964, y: 0, width: 0.612036, height: 0.4947915 }, { x: 0.387964, y: 0.505235, width: 0.612036, height: 0.4947915 }]
                }, {
                    id: '6_10',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.65833 }, { x: 0, y: 0.65833, width: 0.3333, height: 0.34167 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.34167 }, { x: 0.3333, y: 0.34167, width: 0.3333, height: 0.65833 }, { x: 0.6666, y: 0, width: 0.3334, height: 0.65833 }, { x: 0.6666, y: 0.65833, width: 0.3334, height: 0.34167 }]
                }, {
                    id: '6_11',
                    frames: [{ x: 0, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0.33950667, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0.67851334, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0, y: 0.33685867, width: 0.32098667, height: 0.32638867 }, { x: 0, y: 0.67321734, width: 0.32098667, height: 0.32638867 }, { x: 0.33950667, y: 0.33685867, width: 0.66049333, height: 0.66314133 }]
                }, {
                    id: '6_12',
                    frames: [{ x: 0, y: 0, width: 0.68611, height: 0.3333 }, { x: 0.68611, y: 0, width: 0.31389, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.31389, height: 0.3333 }, { x: 0.31389, y: 0.3333, width: 0.68611, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.68611, height: 0.3334 }, { x: 0.68611, y: 0.6666, width: 0.31389, height: 0.3334 }]
                }, {
                    id: '6_13',
                    frames: [{ x: 0.084185, y: 0.14375, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.14375, width: 0.391667, height: 0.22013867 }, { x: 0.084185, y: 0.38993067, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.38993067, width: 0.391667, height: 0.22013867 }, { x: 0.084185, y: 0.63611134, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.63611134, width: 0.391667, height: 0.22013867 }]
                }]
            }, {
                name: '9',
                data: [{
                    id: '9_1',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.6666, y: 0, width: 0.3333, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.3333, height: 0.3334 }, { x: 0.3333, y: 0.3333, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0.3333, width: 0.3333, height: 0.3334 }, { x: 0, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0.6666, width: 0.3333, height: 0.3334 }]
                }]
            }, {
                name: '10',
                data: [{
                    id: '10_1',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.2 }, { x: 0.5, y: 0, width: 0.5, height: 0.2 }, { x: 0, y: 0.2, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.2, width: 0.5, height: 0.2 }, { x: 0, y: 0.4, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.4, width: 0.5, height: 0.2 }, { x: 0, y: 0.6, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.6, width: 0.5, height: 0.2 }, { x: 0, y: 0.8, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.8, width: 0.5, height: 0.2 }]
                }, {
                    id: '10_2',
                    frames: [{ x: 0, y: 0, width: 0.2, height: 0.5 }, { x: 0, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.2, y: 0, width: 0.2, height: 0.5 }, { x: 0.2, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.4, y: 0, width: 0.2, height: 0.5 }, { x: 0.4, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.6, y: 0, width: 0.2, height: 0.5 }, { x: 0.6, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.8, y: 0, width: 0.2, height: 0.5 }, { x: 0.8, y: 0.5, width: 0.2, height: 0.5 }]
                }]
            }, {
                name: '12',
                data: [{
                    id: '12_1',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0, width: 0.3333, height: 0.25 }, { x: 0, y: 0.25, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0.25, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0.25, width: 0.3333, height: 0.25 }, { x: 0, y: 0.5, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0.5, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0.5, width: 0.3333, height: 0.25 }, { x: 0, y: 0.75, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0.75, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0.75, width: 0.3333, height: 0.25 }]
                }, {
                    name: '20',
                    data: [{
                        id: '20_1',
                        frames: [{ x: 0, y: 0, width: 0.25, height: 0.2 }, { x: 0.25, y: 0, width: 0.25, height: 0.2 }, { x: 0.5, y: 0, width: 0.25, height: 0.2 }, { x: 0.75, y: 0, width: 0.25, height: 0.2 }, { x: 0, y: 0.2, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.2, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.2, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.2, width: 0.25, height: 0.2 }, { x: 0, y: 0.4, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.4, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.4, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.4, width: 0.25, height: 0.2 }, { x: 0, y: 0.6, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.6, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.6, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.6, width: 0.25, height: 0.2 }, { x: 0, y: 0.8, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.8, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.8, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.8, width: 0.25, height: 0.2 }]
                    }]
                }]
            }]
        };
    },

    watch: {
        is_playing: function is_playing(val) {
            if (val) {
                this.startVisibilityLoop();
            } else {
                this.stopVisibilityLoop();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.stopVisibilityLoop();
        document.removeEventListener('keydown', this._nudgeKeydownHandler, true);
    },
    created: function created() {

        var self = this;

        self._nudgeKeydownHandler = self.onNudgeKeydown.bind(self);
        document.addEventListener('keydown', self._nudgeKeydownHandler, true);

        self.captureUnsavedSnapshot();
        self.getResources();

        self.waiting = true;

        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$hostname + '/admin/categories/', {
            'params': {},
            'headers': {
                'Authorization': 'Bearer ' + self.token
            }
        }).then(function (response) {
            self.waiting = false;
            self.categories = response.data;

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(self.$hostname + '/admin/tags/', {
                'params': {},
                'headers': {
                    'Authorization': 'Bearer ' + self.token
                }
            }).then(function (response) {
                self.tags = response.data;

                self.waiting = false;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }).catch(function (error) {
            self.waiting = false;
            console.log(error);
        });
    },
    computed: {
        graphicsUrl: function graphicsUrl() {
            return this.$graphicsUrl;
        },
        framesUrl: function framesUrl() {
            return this.$framesUrl;
        },
        sumParts: function sumParts() {
            var sum = 0;
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(this.visibleClientParts, function (p) {
                if (!p.cutout_only) {
                    var duration = parseFloat(p.duration);
                    duration = isNaN(duration) ? 0 : duration;

                    // Collages block
                    if (p.collage_type !== 0) {
                        var startTime = parseFloat(p.start_time);
                        startTime = isNaN(startTime) ? 0 : startTime;

                        var collageDuration = startTime + duration;
                        duration = sum > collageDuration ? 0 : collageDuration - sum;
                    }

                    sum += duration;
                }
            });

            return sum.toFixed(2);
        },
        sortedFonts: function sortedFonts() {
            return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sortBy(this.fonts, function (f) {
                return f.name;
            });
        },
        versions: function versions() {
            var result = [];
            var start = 101;
            var end = start + 19;

            for (var i = start; i <= end; i++) {
                result.push((i / 10).toFixed(1));
            }

            return result;
        },
        collageModalFrameText: function collageModalFrameText() {
            var frame = null;

            if (this.active_collage_category === 'Custom') {
                frame = this.buildCustomCollageFrame(false);
            } else if (this.active_part_index !== null && this.client_parts[this.active_part_index]) {
                frame = this.client_parts[this.active_part_index].frame;
            }

            if (!frame) {
                return '';
            }

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(frame).replace(/:/g, ': ').replace(/,/g, ', ');
        }
    },
    methods: {
        text_html: function text_html(index) {

            var textModel = this.template.texts[index];

            var text = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.fonts, function (f) {
                return f.name === textModel.font_name;
            });

            var line_height = parseFloat(textModel.font_size) + parseFloat(textModel.line_spacing);
            var alpha = textModel.alpha;

            var direction = '';
            if (textModel.direction == 'vertical') {
                direction = '  writing-mode: vertical-rl;\n' + '  text-orientation: upright;\n';
            }

            var offset = 4 / 88 * textModel.font_size;
            var blur = 0.29 * textModel.font_size / 88 * textModel.shadow_blur;
            var shadow = 'text-shadow: ' + offset + 'px ' + offset + 'px ' + blur + 'px ' + textModel.shadow_color + this.convertAlphaToHex(textModel.shadow_alpha) + ';';

            return '<span style="color: ' + textModel.text_color + '; ' + 'background-color: ' + textModel.background_color + '; ' + 'font-size: ' + textModel.font_size + 'px; ' + 'letter-spacing: ' + textModel.letter_spacing + 'px; ' + 'opacity: ' + alpha + '; ' + 'line-height: ' + line_height + 'px; ' + 'transform: rotate( ' + textModel.angle + 'deg); ' + 'display: block;' + direction + shadow + 'text-align: ' + textModel.text_align + '; ' + 'z-index: ' + textModel.z_index + '; ' + 'font-family:' + text.params + ';">' + textModel.text + '</span>';
        },
        object_html: function object_html(index) {
            return this.renderSvgObjectHtml(this.template.objects[index]);
        },
        frame_html: function frame_html(index) {
            var frameModel = this.template.frames[index];
            if (!frameModel) {
                return "";
            }

            var rawData = frameModel.rawData || {};
            var originalW = parseFloat(rawData.original_w);
            if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(originalW) || originalW <= 0) {
                originalW = 1080;
            }

            var scale = 360 / originalW;
            var rawW = parseFloat(rawData.w);
            var width = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(rawW) ? rawW * scale : (parseFloat(frameModel.w) || 1) * 360;

            var img = '<img src="' + this.framesUrl + frameModel.src + '">';

            var style = ' style="width: ' + width + 'px; opacity: ' + frameModel.alpha + '; padding: 0px; transform: rotate(' + frameModel.angle + 'deg); z-index: ' + frameModel.z_index + '; display: block;"';

            img = this.insertAt(img, style, 5);

            return img;
        },
        image_html: function image_html(index) {
            var objectModel = this.template.objects[index];

            if (!objectModel.source || !objectModel.dimensions) {
                return "";
            }

            var width = objectModel.dimensions.width;
            var height = objectModel.dimensions.height;

            width = width * parseFloat(objectModel.scale);
            height = height * parseFloat(objectModel.scale);

            var img = '<img src="' + this.objectPlayerSrc(objectModel) + '">';

            var style = ' style="width: ' + width + 'px; height: ' + height + 'px; opacity: ' + objectModel.alpha + '; padding: 0px; transform: rotate(' + objectModel.angle + 'deg); z-index: ' + objectModel.z_index + '; display: block;"';

            img = this.insertAt(img, style, 5);

            return img;
        },

        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        insertAt: function insertAt(str, sub, pos) {
            return '' + str.slice(0, pos) + sub + str.slice(pos);
        },
        formatStartTime: function formatStartTime(event, index, object) {
            this.client_parts[index][object] = this.client_parts[index][object].replace(',', '.');
        },
        formatDuration: function formatDuration(event, index) {
            this.client_parts[index].duration = this.client_parts[index].duration.replace(',', '.');
        },
        formatSpeed: function formatSpeed(event, index) {
            this.client_parts[index].speed = this.client_parts[index].speed.replace(',', '.');
        },
        formatVideoDuration: function formatVideoDuration(event, index) {
            this.template.duration = this.template.duration.replace(',', '.');
        },
        addText: function addText() {
            var copy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var tool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            if (copy !== false) {
                var copiedText = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(self.template.texts[self.active_text]));
                copiedText.z_index = self.template.texts.length + self.template.objects.length + 1;
                copiedText.text = 'Default text';

                self.template.texts.push(copiedText);

                var positions = self.positions[self.active_text];
                positions.clientX = positions.clientX ? positions.clientX + 5 : positions.clientX;
                positions.clientY = positions.clientY ? positions.clientY + 5 : positions.clientY;
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(positions)));

                setTimeout(function () {

                    self.$refs.draggableContainer[self.template.texts.length - 1].style.left = self.$refs.draggableContainer[self.active_text].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = self.$refs.draggableContainer[self.active_text].offsetTop + 5 + 'px';

                    self.active_text = self.template.texts.length - 1;
                    self.active_type = 'text';

                    //console.log(self.$refs.draggableContainer[self.template.texts.length - 1].style.left);
                }, 100);
            } else {
                var newText = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(self.default_text));

                if (tool) {
                    newText.type = 1;
                    newText.background_color = '#448AF7';
                }

                newText.z_index = self.template.texts.length + self.template.objects.length + 1;
                self.template.texts.push(newText);
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                self.active_text = self.template.texts.length - 1;
                self.active_type = 'text';
            }
        },
        addObject: function addObject(object) {
            var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            // if copied
            if (copy !== false) {
                var copiedObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(self.template.objects[self.active_object]));
                copiedObject.z_index = self.template.texts.length + self.template.objects.length + 1;

                self.template.objects.push(copiedObject);
                self.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(self.object_positions[self.active_object])));

                setTimeout(function () {

                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.left = self.$refs.draggableContainer2[self.active_object].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.top = self.$refs.draggableContainer2[self.active_object].offsetTop + 5 + 'px';

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object';
                }, 100);
            } else {
                self.placeGraphicObject(object);
            }
        },
        addCollage: function addCollage(e) {
            // 888
            var data = e.target.dataset.params;
            var params = data.split(';');
            var id = params[0];
            var part = params[1];
            var x = params[2];
            var y = params[3];
            var w = params[4];
            var h = params[5];

            this.client_parts[this.active_part_index].collage_type = id + ';' + part;
            this.client_parts[this.active_part_index].frame = {
                x: parseFloat(x),
                y: parseFloat(y),
                w: parseFloat(w),
                h: parseFloat(h)
            };

            this.previous_collage_id = id;

            this.show_collage_modal = false;
        },
        addCustomCollage: function addCustomCollage() {
            var frame = this.buildCustomCollageFrame(true);

            if (!frame) {
                alert('Заполните размеры фрейма и редактируемой области');
                return;
            }

            this.client_parts[this.active_part_index].collage_type = 'custom';
            this.client_parts[this.active_part_index].frame = frame;

            this.previous_collage_id = 'custom';
            this.show_collage_modal = false;
        },
        buildCustomCollageFrame: function buildCustomCollageFrame() {
            var withRawData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            var raw = this.custom_collage_rawData;
            var originalW = parseFloat(raw.original_w);
            var originalH = parseFloat(raw.original_h);
            var w = parseFloat(raw.w);
            var h = parseFloat(raw.h);
            var x = parseFloat(raw.x) || 0;
            var y = parseFloat(raw.y) || 0;
            var bTl = parseFloat(raw.b_tl) || 0;
            var bTr = parseFloat(raw.b_tr) || 0;
            var bBr = parseFloat(raw.b_br) || 0;
            var bBl = parseFloat(raw.b_bl) || 0;

            if (!originalW || !originalH || !w || !h) {
                return null;
            }

            var frame = {
                w: parseFloat((w / originalW).toFixed(6)),
                h: parseFloat((h / originalH).toFixed(6)),
                x: parseFloat((x / originalW).toFixed(6)),
                y: parseFloat((y / originalH).toFixed(6)),
                b_tl: parseFloat((bTl / w).toFixed(6)),
                b_tr: parseFloat((bTr / w).toFixed(6)),
                b_br: parseFloat((bBr / w).toFixed(6)),
                b_bl: parseFloat((bBl / w).toFixed(6))
            };

            if (withRawData) {
                frame.rawData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(raw));
            }

            return frame;
        },
        changeObject: function changeObject() {
            this.is_object_changing = true;
            this.show_svg_modal = true;
        },
        changeFrame: function changeFrame() {
            this.is_frame_changing = true;
            this.show_frames_modal = true;
        },
        convertAlphaToHex: function convertAlphaToHex(alpha) {
            if (alpha < 0.08) return '00';
            return Math.floor(alpha * 255).toString(16);
        },
        selectText: function selectText(text) {
            this.active_text = text;
            this.active_type = 'text';
        },
        selectObject: function selectObject(object) {
            this.active_object = object;
            this.active_type = 'object';
        },
        selectFrame: function selectFrame(frame) {
            this.active_frame = frame;
            this.active_type = 'frame';
        },
        selectFrameCategory: function selectFrameCategory(id) {
            this.active_frame_category = id;
        },
        addFrame: function addFrame(frame) {
            var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            if (!self.template.frames) {
                self.template.frames = [];
            }

            if (copy !== false) {
                var copiedFrame = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(self.template.frames[self.active_frame]));

                self.template.frames.push(copiedFrame);
                self.frame_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(self.default_positions)));
                self.active_frame = self.template.frames.length - 1;
                self.active_type = 'frame';
                self.syncFrameCalculations(self.active_frame);

                self.$nextTick(function () {
                    self.applyFrameContainerPosition(self.active_frame);
                });
            } else if (self.is_frame_changing) {
                var current = self.template.frames[self.active_frame];
                current.id = frame.id;
                current.src = frame.src;
                current.layouts = frame.layouts;
                self.is_frame_changing = false;
                self.show_frames_modal = false;
            } else {
                self.template.frames.push({
                    id: frame.id,
                    src: frame.src,
                    z_index: 1,
                    angle: 0,
                    alpha: 1,
                    layouts: frame.layouts,
                    w: 0,
                    x: 0,
                    y: 0,
                    time_start: 0,
                    time_end: "",
                    is_visible: 1,
                    rawData: {
                        original_w: 1080,
                        w: 540,
                        x: 0,
                        y: 0
                    }
                });

                self.frame_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(self.default_positions)));
                self.active_frame = self.template.frames.length - 1;
                self.active_type = 'frame';
                self.syncFrameCalculations(self.active_frame);
                self.show_frames_modal = false;

                self.$nextTick(function () {
                    self.applyFrameContainerPosition(self.active_frame);
                });
            }
        },
        removeFrame: function removeFrame(index) {
            var self = this;

            if (confirm("Подтверждение удаления фрейма " + (parseInt(index) + 1))) {
                self.template.frames = self.template.frames.filter(function (t, i) {
                    return i !== index;
                });
                self.frame_positions = self.frame_positions.filter(function (t, i) {
                    return i !== index;
                });
                self.active_frame = 0;
                self.syncOverlayActiveType();
            }
        },

        calculateFrames: function calculateFrames() {
            var frames = this.template.frames || [];
            for (var j = 0; j < frames.length; j++) {
                this.syncFrameCalculations(j);
            }
        },
        syncFrameCalculations: function syncFrameCalculations(index) {
            var frame = this.template.frames[index];
            if (!frame || !frame.rawData) {
                return;
            }

            var originalH = this.getOriginalH(frame.rawData.original_w);

            frame.w = parseFloat(parseFloat(frame.rawData.w) / parseFloat(frame.rawData.original_w)).toFixed(6);
            frame.x = parseFloat(parseFloat(frame.rawData.x) / parseFloat(frame.rawData.original_w)).toFixed(6);
            frame.y = parseFloat(parseFloat(frame.rawData.y) / parseFloat(originalH)).toFixed(6);
        },
        applyFrameContainerPosition: function applyFrameContainerPosition(index) {
            var frame = this.template.frames[index];
            var containers = this.$refs.draggableContainer3;
            if (!frame || !frame.rawData || !containers || !containers[index]) {
                return;
            }

            var scale = 360 / parseFloat(frame.rawData.original_w);
            containers[index].style.left = parseFloat(frame.rawData.x) * scale + 'px';
            containers[index].style.top = parseFloat(frame.rawData.y) * scale + 'px';
        },
        onFrameRawDataChange: function onFrameRawDataChange() {
            this.syncFrameCalculations(this.active_frame);
            this.applyFrameContainerPosition(this.active_frame);
        },
        updateFramePositionFromDom: function updateFramePositionFromDom(index) {
            var frame = this.template.frames[index];
            var containers = this.$refs.draggableContainer3;
            if (!frame || !frame.rawData || !containers || !containers[index]) {
                return;
            }

            var scale = 360 / parseFloat(frame.rawData.original_w);
            frame.rawData.x = parseFloat((containers[index].offsetLeft / scale).toFixed(2));
            frame.rawData.y = parseFloat((containers[index].offsetTop / scale).toFixed(2));
            this.syncFrameCalculations(index);
        },
        getOriginalH: function getOriginalH(originalW) {
            originalW = parseFloat(originalW);
            var ratio = parseInt(this.template.ratio);

            if (ratio === 2) {
                // Горизонтальный 16:9
                return originalW * 9 / 16;
            }

            if (ratio === 3) {
                // Горизонтальный 5:1
                return originalW / 5;
            }

            // Обычный 9:16
            return originalW / 9 * 16;
        },
        selectObjectCategory: function selectObjectCategory(category) {
            this.active_object_category = category;
        },
        selectCollageCategory: function selectCollageCategory(category) {
            this.active_collage_category = category;
        },
        removeCollageFromPart: function removeCollageFromPart(index) {
            var self = this;

            if (confirm("Подтверждение удаления коллажа")) {
                self.client_parts[index].collage_type = 0;
                self.client_parts[index].frame = null;
            }
        },
        removeText: function removeText(index) {
            var self = this;

            if (confirm("Подтверждение удаления текста: " + self.template.texts[index].text)) {
                self.template.texts = self.template.texts.filter(function (t, i) {
                    return i !== index;
                });
                self.active_text = 0;
                self.syncOverlayActiveType();
            }
        },
        removeObject: function removeObject(index) {
            var self = this;

            if (confirm("Подтверждение удаления объекта")) {
                self.template.objects = self.template.objects.filter(function (t, i) {
                    return i !== index;
                });
                self.active_object = 0;
                self.syncOverlayActiveType();
            }
        },
        syncOverlayActiveType: function syncOverlayActiveType() {
            var self = this;

            if (self.template.texts.length > 0) {
                self.active_type = 'text';
                self.active_text = Math.min(self.active_text, self.template.texts.length - 1);
            } else if (self.template.objects.length > 0) {
                self.active_type = 'object';
                self.active_object = Math.min(self.active_object, self.template.objects.length - 1);
            } else if ((self.template.frames || []).length > 0) {
                self.active_type = 'frame';
                self.active_frame = Math.min(self.active_frame, self.template.frames.length - 1);
            } else {
                self.active_type = 'text';
            }
        },
        toggleText: function toggleText() {
            var self = this;

            if (self.is_text_active) {
                self.active_type = 'text';

                setTimeout(function () {
                    self.video = self.$refs.videoContainer;
                    if (!self.video) return;

                    self.video.addEventListener("playing", function () {
                        console.log('play ' + self.video.currentTime);

                        self.is_playing = true;
                    });

                    self.video.addEventListener("timeupdate", function () {
                        self.checkElementsVisibility(self.video.currentTime);
                    });

                    self.video.addEventListener("pause", function () {
                        console.log('pause ' + self.video.currentTime);

                        self.is_playing = false;
                    });
                }, 500);
            } else {
                self.template.texts = [];
                self.template.objects = [];
                self.template.frames = [];
                self.positions = [];
                self.frame_positions = [];
            }
        },
        toggleBackground: function toggleBackground() {
            if (this.template.texts[this.active_text].background_color === 'transparent') {
                this.setColor('#FFFFFF', 'background');
            } else {
                this.setColor('transparent', 'background');
            }
        },

        setTextPosition: function setTextPosition(x, y) {
            if (x) {
                this.template.texts[this.active_text].position_x = x;

                var centerX = 0.5 * 360 - this.$refs.draggableContainer[this.active_text].clientWidth / 2;

                this.$refs.draggableContainer[this.active_text].style.left = centerX + 'px';
            }

            if (y) {
                this.template.texts[this.active_text].position_y = y;

                var centerY = 0.5 * this.heightCanvas - this.$refs.draggableContainer[this.active_text].clientHeight / 2;

                this.$refs.draggableContainer[this.active_text].style.top = centerY + 'px';
            }
        },
        setObjectPosition: function setObjectPosition(x, y) {
            if (x) {
                this.template.objects[this.active_object].position_x = x;

                var centerX = 0.5 * 360 - this.$refs.draggableContainer2[this.active_object].clientWidth / 2;

                this.$refs.draggableContainer2[this.active_object].style.left = centerX + 'px';
            }

            if (y) {
                this.template.objects[this.active_object].position_y = y;

                var centerY = 0.5 * this.heightCanvas - this.$refs.draggableContainer2[this.active_object].clientHeight / 2;

                this.$refs.draggableContainer2[this.active_object].style.top = centerY + 'px';
            }
        },
        onNudgeKeydown: function onNudgeKeydown(event) {
            if (!this.template) {
                return;
            }

            if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
                return;
            }

            var target = event.target;
            var tag = target && target.tagName;
            if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target && target.isContentEditable) {
                return;
            }

            if (this.show_svg_modal || this.show_frames_modal || this.show_collage_modal) {
                return;
            }

            var dx = 0;
            var dy = 0;
            if (event.key === 'ArrowLeft') {
                dx = -1;
            } else if (event.key === 'ArrowRight') {
                dx = 1;
            } else if (event.key === 'ArrowUp') {
                dy = -1;
            } else if (event.key === 'ArrowDown') {
                dy = 1;
            }

            if (!this.nudgeSelectedLayer(dx, dy)) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
        },
        nudgeSelectedLayer: function nudgeSelectedLayer(dx, dy) {
            if (this.active_type === 'text') {
                return this.nudgeText(dx, dy);
            }
            if (this.active_type === 'object') {
                return this.nudgeObject(dx, dy);
            }
            if (this.active_type === 'frame') {
                return this.nudgeFrame(dx, dy);
            }
            return false;
        },
        nudgeText: function nudgeText(dx, dy) {
            var index = this.active_text;
            var text = this.template.texts[index];
            var containers = this.$refs.draggableContainer;
            if (!text || !containers || !containers[index]) {
                return false;
            }

            var step = 0.0005;
            text.position_x = parseFloat((parseFloat(text.position_x) + dx * step).toFixed(4));
            text.position_y = parseFloat((parseFloat(text.position_y) + dy * step).toFixed(4));

            var el = containers[index];
            el.style.left = text.position_x * 360 - el.clientWidth / 2 + 'px';
            el.style.top = text.position_y * this.heightCanvas - el.clientHeight / 2 + 'px';
            return true;
        },
        nudgeObject: function nudgeObject(dx, dy) {
            var index = this.active_object;
            var obj = this.template.objects[index];
            var containers = this.$refs.draggableContainer2;
            if (!obj || !containers || !containers[index]) {
                return false;
            }

            var step = 0.0005;
            obj.position_x = parseFloat((parseFloat(obj.position_x) + dx * step).toFixed(4));
            obj.position_y = parseFloat((parseFloat(obj.position_y) + dy * step).toFixed(4));

            var el = containers[index];
            el.style.left = obj.position_x * 360 - el.clientWidth / 2 + 'px';
            el.style.top = obj.position_y * this.heightCanvas - el.clientHeight / 2 + 'px';
            return true;
        },
        nudgeFrame: function nudgeFrame(dx, dy) {
            var index = this.active_frame;
            var frame = this.template.frames[index];
            if (!frame || !frame.rawData) {
                return false;
            }

            frame.rawData.x = parseFloat((parseFloat(frame.rawData.x) + dx).toFixed(2));
            frame.rawData.y = parseFloat((parseFloat(frame.rawData.y) + dy).toFixed(2));
            this.syncFrameCalculations(index);
            this.applyFrameContainerPosition(index);
            return true;
        },
        changeEffectType: function changeEffectType(index, type) {

            if (type !== 1 || type !== 2) {
                return;
            }

            var from = 1;
            var to = 0.85;
            if (type === 2) {
                from = 0.85;
                to = 1;
            }

            this.client_parts[index].effect_values = {
                from: from,
                to: to,
                x: 0.5,
                y: 0.5
            };
        },
        changeCollageType: function changeCollageType(index, type) {

            if (type === 0) {
                this.client_parts[index].frame = null;
                return;
            }

            this.client_parts[index].frame = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.collage_types, function (c) {
                return c.id === type;
            }).params;
        },
        changeContentType: function changeContentType(index, type) {
            this.client_parts[index].content = type === 2 ? '#000000' : null;
        },
        changeRatioType: function changeRatioType() {
            this.heightCanvas = 640;
            var ratio = parseInt(this.template.ratio);

            if (ratio > 1) {
                this.heightCanvas = ratio === 2 ? 202.5 : ratio === 3 ? 72 : 640;
            }
        },

        changeEffectPosition: function changeEffectPosition(event, index) {
            var offsetX = void 0;
            var offsetY = void 0;

            if (event.target.className !== 'effect-preview') {
                var parent = event.target.parentElement;
                if (parent.className !== 'effect-preview') {
                    parent = parent.parentElement;
                } else {}

                offsetX = 0;
                offsetY = 0;
            } else {
                offsetX = event.offsetX < 0 ? 0 : event.offsetX;
                offsetY = event.offsetY < 0 ? 0 : event.offsetY;
            }

            this.client_parts[index].effect_values.x = (offsetX / 50).toFixed(2);
            if (this.client_parts[index].effect_values.x > 1) {
                this.client_parts[index].effect_values.x = 1;
            }

            this.client_parts[index].effect_values.y = (offsetY / 89).toFixed(2);
            if (this.client_parts[index].effect_values.y > 1) {
                this.client_parts[index].effect_values.y = 1;
            }
        },
        changeCutoutPosition: function changeCutoutPosition(event, index) {
            var offsetX = void 0;
            var offsetY = void 0;

            if (event.target.className !== 'cutout-preview') {
                var parent = event.target.parentElement;
                if (parent.className !== 'cutout-preview') {
                    parent = parent.parentElement;
                } else {}

                offsetX = 0;
                offsetY = 0;
            } else {
                offsetX = event.offsetX < 0 ? 0 : event.offsetX;
                offsetY = event.offsetY < 0 ? 0 : event.offsetY;
            }

            this.client_parts[index].cutout_x = (offsetX / 50).toFixed(2);
            if (this.client_parts[index].cutout_x > 1) {
                this.client_parts[index].cutout_x = 1;
            }

            this.client_parts[index].cutout_y = (offsetY / 89).toFixed(2);
            if (this.client_parts[index].cutout_y > 1) {
                this.client_parts[index].cutout_y = 1;
            }

            this.$forceUpdate();
        },
        refreshTags: function refreshTags() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(this.tags, function (t) {
                t.active = _this.template.tags.indexOf(t.id) > -1;
            });
        },
        toggleTag: function toggleTag(tag) {
            var tags = this.template.tags;
            var index = tags.indexOf(tag.id);
            index > -1 ? tags.splice(index, 1) : tags.push(tag.id);

            this.refreshTags();
        },
        setColor: function setColor(color, type) {
            if (type === 'color') {
                this.template.texts[this.active_text].text_color = color;
            }

            if (type === 'background') {
                this.template.texts[this.active_text].background_color = color;
            }
        },
        changeWidgetType: function changeWidgetType(index, type) {
            var current = (this.template.texts[this.active_text].background_color || '').toUpperCase();
            var isCustom = current && current !== 'TRANSPARENT' && current !== '#448AF7' && current !== '#888888';
            if (isCustom) {
                return;
            }
            if (type === 1 || type === 5 || type === 7) {
                this.template.texts[this.active_text].background_color = '#448AF7';
            }
            if (type === 2 || type === 3 || type === 4 || type === 6) {
                this.template.texts[this.active_text].background_color = '#888888';
            }
        },

        getContentColor: function getContentColor(color) {
            if (color && color[0] === '#') {
                return color;
            } else {
                return '#000000';
            }
        },
        isContentCorrected: function isContentCorrected(content) {
            return content && content[0] !== '#';
        },
        setObjColor: function setObjColor(color) {
            this.template.objects[this.active_object].color = color;
        },
        showPreview: function showPreview() {
            this.is_playing = false;
            this.checkElementsVisibility(0);
            this.video.load();
        },
        isEmptyTimeEnd: function isEmptyTimeEnd(value) {
            return value === "" || value === null || value === undefined;
        },
        normalizeTimeEnd: function normalizeTimeEnd(value) {
            if (this.isEmptyTimeEnd(value)) {
                return "";
            }
            var parsed = parseFloat(value);
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(parsed) ? parsed : "";
        },
        isElementVisibleAt: function isElementVisibleAt(element, currentTime) {
            if (currentTime === 0) {
                return true;
            }

            var start = parseFloat(element.time_start);
            if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(start)) {
                start = 0;
            }

            if (this.isEmptyTimeEnd(element.time_end)) {
                return start < currentTime;
            }

            var end = parseFloat(element.time_end);
            if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(end)) {
                return start < currentTime;
            }

            return start < currentTime && end > currentTime;
        },
        checkElementsVisibility: function checkElementsVisibility(currentTime) {
            var self = this;
            var time = parseFloat(currentTime);
            if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(time)) {
                time = 0;
            }

            var elements = [self.template.texts, self.template.objects, self.template.frames];
            for (var o = 0; o < elements.length; o++) {
                var element = elements[o];
                if (!element) {
                    continue;
                }

                for (var i = 0; i < element.length; i++) {
                    if (!element[i]) {
                        continue;
                    }

                    self.$set(element[i], 'is_visible', self.isElementVisibleAt(element[i], time) ? 1 : 0);
                }
            }
        },
        stopVisibilityLoop: function stopVisibilityLoop() {
            if (this.visibilityRaf) {
                cancelAnimationFrame(this.visibilityRaf);
                this.visibilityRaf = null;
            }
        },
        startVisibilityLoop: function startVisibilityLoop() {
            var self = this;

            this.stopVisibilityLoop();

            var tick = function tick() {
                if (!self.is_playing) {
                    self.visibilityRaf = null;
                    return;
                }

                if (self.video) {
                    self.checkElementsVisibility(self.video.currentTime);
                }

                self.visibilityRaf = requestAnimationFrame(tick);
            };

            this.visibilityRaf = requestAnimationFrame(tick);
        },
        getUnsavedState: function getUnsavedState() {
            return this.stringifyUnsaved({
                template: this.template,
                client_parts: this.client_parts,
                effect: this.effect,
                effect_intensity: this.effect_intensity,
                filter: this.filter,
                filter_intensity: this.filter_intensity
            });
        },

        goBack: function goBack() {
            this.$router.push('/templates');
        },
        getResources: function getResources() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$hostname + '/admin/resources/', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.server_effects = response.data.effects;
                self.server_graphics = response.data.graphics;
                self.server_filters = response.data.filters;
                self.server_fonts = response.data.fonts;
                self.server_frames = response.data.frames;

                if (!self.active_object_category && self.server_graphics.length) {
                    self.active_object_category = self.server_graphics[0].name;
                }

                self.appendFonts();
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        appendFonts: function appendFonts() {

            var newStyle = document.createElement('style');
            for (var i = 0; i < this.server_fonts.length; i++) {
                var font = this.server_fonts[i];

                newStyle.appendChild(document.createTextNode('\n                    @font-face {\n                      font-family: \'' + font.name + '\';\n                      src: url(\'/static/fonts/' + font.src + '\');\n                    }\n                    '));

                this.fonts.push({
                    params: '\'' + font.name + '\', sans-serif;',
                    code: font.name,
                    name: font.name
                });
            }

            document.head.appendChild(newStyle);
        },
        showSVGModal: function showSVGModal() {
            this.is_object_changing = false;
            this.show_svg_modal = true;
        },
        showFramesModal: function showFramesModal() {
            this.is_frame_changing = false;
            this.show_frames_modal = true;
        },
        closeSVGModal: function closeSVGModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_svg_modal = false;
                this.is_object_changing = false;
            }
        },
        closeFramesModal: function closeFramesModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_frames_modal = false;
                this.is_frame_changing = false;
            }
        },
        showCollageModal: function showCollageModal(index) {
            this.active_part_index = index;

            var part = this.client_parts[index];
            if (part.collage_type === 'custom') {
                this.active_collage_category = 'Custom';
                if (part.frame && part.frame.rawData) {
                    this.custom_collage_rawData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(part.frame.rawData));
                } else {
                    this.custom_collage_rawData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.default_custom_collage_rawData));
                }
            } else {
                if (part.collage_type && part.collage_type !== 0) {
                    this.active_collage_category = part.collage_type.toString().split(';')[0].split('_')[0];
                }
                this.custom_collage_rawData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.default_custom_collage_rawData));
            }

            this.show_collage_modal = true;
        },
        closeCollageModal: function closeCollageModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_collage_modal = false;
            }
        },
        save: function save() {
            var _this2 = this;

            var self = this;

            this.commitVideoCount();
            this.calculateFrames();

            var template = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.template));
            template.parts = self.partsForSave();

            if (!this.validatePartDurations()) {
                return false;
            }

            if (template.type < 0 && Math.abs(this.sumParts - this.template.duration) > 0) {

                var notification = {
                    template: '<span><b>\u0414\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u043E\u0432 \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0439 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C\u044E \u0432\u0438\u0434\u0435\u043E</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                return false;
            }
            //
            // if (Math.abs(this.realAudioDuration.toFixed(2) - this.realVideoDuration.toFixed(2)) > 0) {
            //
            //     const notification = {
            //         template: `<span><b>Длительность загруженного видео не совпадает с длительностью загруженного аудио</b></span>`
            //     };
            //
            //     self.$notifications.notify(
            //         {
            //             component: notification,
            //             icon: 'nc-icon nc-simple-remove',
            //             horizontalAlign: 'right',
            //             verticalAlign: 'top',
            //             type: 'danger'
            //         })
            //
            //     return false;
            // }

            if (template.type < 0 && Math.abs(this.sumParts - this.realVideoDuration.toFixed(2)) > 0) {

                var _notification = {
                    template: '<span><b>\u0423\u043A\u0430\u0437\u0430\u043D\u043D\u0430\u044F \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0432\u0438\u0434\u0435\u043E \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0439 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C\u044E, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u043E\u0439 \u0438\u0437 \u0432\u0438\u0434\u0435\u043E</b></span>'
                };

                self.$notifications.notify({
                    component: _notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                return false;
            }

            if (template.song_insta) {
                var regex = /(\d{14,22})/gi;
                var match = regex.exec(template.song_insta);

                var reelId = match ? match[0] : null;
                template.song_insta = reelId;

                if (!reelId) {
                    var _notification2 = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 Reels Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification2,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (template.song_tiktok) {
                var parts = template.song_tiktok.split('/');

                if (parts.length > 3 && parts[3].length > 5) {
                    template.song_tiktok = parts[3];
                } else {

                    var _notification3 = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 TikTok Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification3,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (this.video) {
                this.showPreview();
            }

            self.waiting = true;

            setTimeout(function () {

                if (_this2.is_text_active) {

                    for (var i = 0; i < self.template.texts.length; i++) {

                        var activeText = template.texts[i];

                        if (activeText.position_x !== 0.5) {
                            var centerX = _this2.$refs.draggableContainer[i].offsetLeft + _this2.$refs.draggableContainer[i].clientWidth / 2;

                            activeText.position_x = parseFloat((centerX / 360).toFixed(4));
                        }

                        if (activeText.position_y !== 0.5) {
                            var centerY = _this2.$refs.draggableContainer[i].offsetTop + _this2.$refs.draggableContainer[i].clientHeight / 2;

                            activeText.position_y = parseFloat((centerY / _this2.heightCanvas).toFixed(4));
                        }

                        activeText.letter_spacing = activeText.letter_spacing == "" ? 0 : activeText.letter_spacing;
                        activeText.line_spacing = activeText.line_spacing == "" ? 0 : activeText.line_spacing;
                        activeText.angle = activeText.angle == "" ? 0 : activeText.angle;
                        activeText.z_index = activeText.z_index == "" ? 0 : activeText.z_index;

                        activeText.position_x = parseFloat(activeText.position_x);
                        activeText.position_y = parseFloat(activeText.position_y);
                        activeText.font_size = parseFloat(activeText.font_size);
                        activeText.alpha = parseFloat(activeText.alpha);
                        activeText.letter_spacing = parseFloat(activeText.letter_spacing);
                        activeText.line_spacing = parseFloat(activeText.line_spacing);
                        activeText.time_start = parseFloat(activeText.time_start);
                        activeText.shadow_alpha = parseFloat(activeText.shadow_alpha);
                        activeText.shadow_distance = parseFloat(activeText.shadow_distance);
                        activeText.shadow_blur = parseInt(activeText.shadow_blur);
                        activeText.animation_type = parseInt(activeText.animation_type);
                        activeText.animation_duration = parseFloat(activeText.animation_duration);
                        activeText.is_animated = parseInt(activeText.is_animated);
                        activeText.angle = parseInt(activeText.angle);
                        activeText.z_index = parseInt(activeText.z_index);
                        activeText.time_end = self.normalizeTimeEnd(activeText.time_end);

                        template.texts[i] = activeText;
                    }

                    for (var _i = 0; _i < self.template.objects.length; _i++) {

                        var activeObj = template.objects[_i];

                        activeObj.position_x = parseFloat(activeObj.position_x);
                        activeObj.position_y = parseFloat(activeObj.position_y);

                        activeObj.scale = parseFloat(activeObj.scale);
                        activeObj.alpha = parseFloat(activeObj.alpha);
                        activeObj.time_start = parseFloat(activeObj.time_start);
                        activeObj.animation_type = parseInt(activeObj.animation_type);
                        activeObj.animation_duration = parseFloat(activeObj.animation_duration);
                        activeObj.is_animated = parseInt(activeObj.is_animated) || 0;
                        activeObj.angle = activeObj.angle == "" ? 0 : parseInt(activeObj.angle);
                        activeObj.z_index = activeObj.z_index == "" ? 0 : parseInt(activeObj.z_index);
                        activeObj.time_end = self.normalizeTimeEnd(activeObj.time_end);

                        delete activeObj.source;

                        template.objects[_i] = activeObj;
                    }

                    for (var _i2 = 0; _i2 < (template.frames || []).length; _i2++) {
                        var activeFrame = template.frames[_i2];

                        activeFrame.alpha = parseFloat(activeFrame.alpha);
                        activeFrame.angle = parseInt(activeFrame.angle);
                        activeFrame.z_index = parseInt(activeFrame.z_index);
                        activeFrame.time_start = parseFloat(activeFrame.time_start);
                        activeFrame.time_end = self.normalizeTimeEnd(activeFrame.time_end);

                        template.frames[_i2] = activeFrame;
                    }
                } else {
                    template.texts = [];
                    template.objects = [];
                    template.frames = [];
                }

                if (!template.is_copyrighted) {
                    template.song_insta = "";
                    template.song_tiktok = "";
                }

                if (_this2.effect) {
                    template.effects = _this2.effect + ":" + _this2.effect_intensity;
                } else {
                    template.effects = "";
                }
                if (_this2.filter) {
                    template.filters = _this2.filter + ":" + _this2.filter_intensity;
                } else {
                    template.filters = "";
                }

                template.release_date = template.release_date + ' ' + template.release_time + ':00';

                __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this2.$hostname + '/admin/templates/create', template, {
                    'headers': {
                        'Authorization': 'Bearer ' + _this2.token
                    }
                }).then(function (response) {
                    var notification = {
                        template: '<span><b>\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.waiting = false;
                    self.allowUnsavedLeave = true;
                    self.$router.push('/templates');
                }).catch(function (error) {
                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;
                });
            }, 200);
        },
        clickContentFileButton: function clickContentFileButton(index) {
            var ref = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.$refs, 'contentFileInput_' + index);
            ref[0].click();
        },
        uploadFile: function uploadFile(event, type, index) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response.data));

                if (data.file_type !== 'content') {
                    self.template[data.file_type] = data.url;
                    self.template[data.file_type + '_full'] = data.url_full;
                    self.template[data.file_type + '_size'] = data.filesize;

                    if (data.file_type === 'src') {
                        self.realVideoDuration = data.duration ? data.duration : null;
                    }

                    if (data.file_type === 'audio') {
                        self.realAudioDuration = data.duration ? data.duration : null;
                    }

                    if (self.video) {
                        self.showPreview();
                    }
                } else {
                    self.client_parts[index].content = data.url;
                    self.client_parts[index].content_full = data.url_full;
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        dragMouseDown: function dragMouseDown(event) {
            event.preventDefault();

            var path = event.composedPath ? event.composedPath() : event.path;
            var id = null;
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(path, function (p) {
                if (p.className === 'draggable-container') {
                    id = p.id;
                }
            });

            if (!id) {
                return;
            }

            this.preview_drag_start = { x: event.clientX, y: event.clientY };
            this.preview_drag_moved = false;

            if (id.indexOf('o') === 0) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'object';

                this.object_positions[this.draggable_index].clientX = event.clientX;
                this.object_positions[this.draggable_index].clientY = event.clientY;
                this.$refs.draggableContainer2[this.draggable_index].style.opacity = '0.6';

                document.onmousemove = this.objectDrag;
                document.onmouseup = this.closeDragObject;
            } else if (id.indexOf('f') === 0) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'frame';

                if (!this.frame_positions[this.draggable_index]) {
                    this.$set(this.frame_positions, this.draggable_index, JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.default_positions)));
                }

                this.frame_positions[this.draggable_index].clientX = event.clientX;
                this.frame_positions[this.draggable_index].clientY = event.clientY;
                this.$refs.draggableContainer3[this.draggable_index].style.opacity = '0.6';

                document.onmousemove = this.frameDrag;
                document.onmouseup = this.closeDragFrame;
            } else {
                this.draggable_index = id;
                this.draggable_type = 'text';

                this.positions[this.draggable_index].clientX = event.clientX;
                this.positions[this.draggable_index].clientY = event.clientY;
                this.$refs.draggableContainer[this.draggable_index].style.opacity = '0.6';

                document.onmousemove = this.textDrag;
                document.onmouseup = this.closeDragText;
            }
        },
        markPreviewDragIfMoved: function markPreviewDragIfMoved(event) {
            if (this.preview_drag_moved || !this.preview_drag_start) {
                return;
            }

            var dx = event.clientX - this.preview_drag_start.x;
            var dy = event.clientY - this.preview_drag_start.y;
            if (dx * dx + dy * dy > 0) {
                this.preview_drag_moved = true;
            }
        },
        selectPreviewIfClicked: function selectPreviewIfClicked(type) {
            if (this.preview_drag_moved || this.draggable_index == null) {
                return;
            }

            var index = parseInt(this.draggable_index);
            if (type === 'text') {
                this.selectText(index);
            } else if (type === 'object') {
                this.selectObject(index);
            } else if (type === 'frame') {
                this.selectFrame(index);
            }
        },
        elementDrag: function elementDrag(event) {
            event.preventDefault();

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX;
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY;
            this.positions[this.draggable_index].clientX = event.clientX;
            this.positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer[this.draggable_index].style.top = this.$refs.draggableContainer[this.draggable_index].offsetTop - this.positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer[this.draggable_index].style.left = this.$refs.draggableContainer[this.draggable_index].offsetLeft - this.positions[this.draggable_index].movementX + 'px';
        },
        textDrag: function textDrag(event) {
            event.preventDefault();
            this.markPreviewDragIfMoved(event);

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX;
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY;
            this.positions[this.draggable_index].clientX = event.clientX;
            this.positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer[this.draggable_index].style.top = this.$refs.draggableContainer[this.draggable_index].offsetTop - this.positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer[this.draggable_index].style.left = this.$refs.draggableContainer[this.draggable_index].offsetLeft - this.positions[this.draggable_index].movementX + 'px';

            var centerX = this.$refs.draggableContainer[this.draggable_index].offsetLeft + this.$refs.draggableContainer[this.draggable_index].clientWidth / 2;
            var centerY = this.$refs.draggableContainer[this.draggable_index].offsetTop + this.$refs.draggableContainer[this.draggable_index].clientHeight / 2;

            this.template.texts[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.texts[this.draggable_index].position_y = parseFloat((centerY / this.heightCanvas).toFixed(4));
        },
        closeDragText: function closeDragText() {
            document.onmouseup = null;
            document.onmousemove = null;

            if (this.draggable_index != null && this.$refs.draggableContainer[this.draggable_index]) {
                this.$refs.draggableContainer[this.draggable_index].style.opacity = '';
            }

            this.selectPreviewIfClicked('text');
            this.draggable_index = null;

            return false;
        },

        objectDrag: function objectDrag(event) {
            event.preventDefault();
            this.markPreviewDragIfMoved(event);

            this.object_positions[this.draggable_index].movementX = this.object_positions[this.draggable_index].clientX - event.clientX;
            this.object_positions[this.draggable_index].movementY = this.object_positions[this.draggable_index].clientY - event.clientY;
            this.object_positions[this.draggable_index].clientX = event.clientX;
            this.object_positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer2[this.draggable_index].style.top = this.$refs.draggableContainer2[this.draggable_index].offsetTop - this.object_positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer2[this.draggable_index].style.left = this.$refs.draggableContainer2[this.draggable_index].offsetLeft - this.object_positions[this.draggable_index].movementX + 'px';

            this.syncObjectModelFromElement(this.draggable_index);
        },
        closeDragObject: function closeDragObject() {
            document.onmouseup = null;
            document.onmousemove = null;

            if (this.draggable_index != null && this.$refs.draggableContainer2[this.draggable_index]) {
                this.$refs.draggableContainer2[this.draggable_index].style.opacity = '';
            }

            this.selectPreviewIfClicked('object');
            this.draggable_index = null;

            return false;
        },

        frameDrag: function frameDrag(event) {
            event.preventDefault();
            this.markPreviewDragIfMoved(event);

            this.frame_positions[this.draggable_index].movementX = this.frame_positions[this.draggable_index].clientX - event.clientX;
            this.frame_positions[this.draggable_index].movementY = this.frame_positions[this.draggable_index].clientY - event.clientY;
            this.frame_positions[this.draggable_index].clientX = event.clientX;
            this.frame_positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer3[this.draggable_index].style.top = this.$refs.draggableContainer3[this.draggable_index].offsetTop - this.frame_positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer3[this.draggable_index].style.left = this.$refs.draggableContainer3[this.draggable_index].offsetLeft - this.frame_positions[this.draggable_index].movementX + 'px';

            this.updateFramePositionFromDom(this.draggable_index);
        },
        closeDragFrame: function closeDragFrame() {
            document.onmouseup = null;
            document.onmousemove = null;

            if (this.draggable_index != null && this.$refs.draggableContainer3[this.draggable_index]) {
                this.$refs.draggableContainer3[this.draggable_index].style.opacity = '';
            }

            this.selectPreviewIfClicked('frame');
            this.draggable_index = null;

            return false;
        },
        renderCollagePart: function renderCollagePart(collageType, partIndex) {
            if (!collageType) {
                return;
            }

            if (collageType === 'custom') {
                var frame = this.client_parts[partIndex] && this.client_parts[partIndex].frame;
                return this.renderCustomCollageFrame(frame, 0.7);
            }

            var layout = collageType.split(';');
            var category = layout[0].split('_')[0];
            var collageId = layout[0];
            var partId = parseInt(layout[1]);
            var collages = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.collages, function (c) {
                return c.name === category;
            });
            var collage = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(collages.data, function (c) {
                return c.id === collageId;
            });

            return this.renderCollage(collage, 0.7, partId - 1);
        },
        renderCustomCollageFrame: function renderCustomCollageFrame(frame) {
            var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            if (!frame) {
                return '';
            }

            var left = parseFloat(frame.x) * 108 * scale;
            var top = parseFloat(frame.y) * 192 * scale;
            var width = parseFloat(frame.w) * 108 * scale;
            var height = parseFloat(frame.h) * 192 * scale;
            var rtl = (parseFloat(frame.b_tl) || 0) * width;
            var rtr = (parseFloat(frame.b_tr) || 0) * width;
            var rbr = (parseFloat(frame.b_br) || 0) * width;
            var rbl = (parseFloat(frame.b_bl) || 0) * width;

            var containerStyle = "position:relative;" + ('width:' + 108 * scale + 'px;height:' + 192 * scale + 'px;') + "background:#f7f7f7;overflow:hidden;" + "border: 1px solid #000;" + "box-shadow:0 6px 20px rgba(0,0,0,.08);";

            var frameStyle = "position:absolute;" + ('left:' + left + 'px;top:' + top + 'px;') + ('width:' + width + 'px;height:' + height + 'px;') + "background:#BAE1FF;" + ('border-radius:' + rtl + 'px ' + rtr + 'px ' + rbr + 'px ' + rbl + 'px;overflow:hidden;') + "display:flex;align-items:center;justify-content:center;" + "color:rgba(0,0,0,.5);" + "font:600 12px sans-serif;";

            return '<div style="' + containerStyle + '"><div class="collage-item-part diagonal-lines" style="' + frameStyle + '">1</div></div>';
        },

        /*'888'*/
        renderCollage: function renderCollage(layout) {
            var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var partId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


            var palette = ["#FFDFBA", "#FFFFBA", "#BAFFC9", "#BAE1FF", "#D7C4F3", "#C1F0F6", "#FAD6A5", "#F7C5CC", "#C9E4DE"];

            var containerStyle = "position:relative;" + ('width:' + 108 * scale + 'px;height:' + 192 * scale + 'px;') + "background:#f7f7f7;overflow:hidden;" + ('border: 1px solid ' + (partId === null && this.previous_collage_id === layout.id ? 'red' : '#000') + ';') + "box-shadow:0 6px 20px rgba(0,0,0,.08);";

            var html = '<div style="' + containerStyle + '">';

            for (var i = 0; i < layout.frames.length; i++) {
                var f = layout.frames[i];

                var left = f.x * 108 * scale;
                var top = f.y * 192 * scale;
                var width = f.width * 108 * scale;
                var height = f.height * 192 * scale;

                var color = palette[i % palette.length];

                var radiusStyle = "0px";
                if (f.crop && f.crop.type === "roundedCorner") {
                    var v = f.crop.value;
                    if (v < 0) v = 0;
                    if (v > 1) v = 1;
                    radiusStyle = v * Math.min(width, height) / 2 + "px";
                }

                var frameStyle = "position:absolute;" + "left:" + left + "px;top:" + top + "px;" + "width:" + width + "px;height:" + height + "px;" + "background:" + color + ";" + "border-radius:" + radiusStyle + ";overflow:hidden;" + "display:flex;align-items:center;justify-content:center;" + "color:rgba(0,0,0,.5);" + "font:600 12px sans-serif;";

                var params = layout.id + ';' + (i + 1) + ';' + f.x + ';' + f.y + ';' + f.width + ';' + f.height;

                html += '\n                          <div\n                            data-params="' + params + '"\n                            class="collage-item-part ' + (partId === i ? 'diagonal-lines' : '') + '"\n                            style="' + frameStyle + '"\n                          >\n                            ' + (i + 1) + '\n                          </div>\n                        ';
            }

            html += "</div>";
            return html;
        }
    }
});

/***/ }),

/***/ "kZs8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kgzt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[_vm._v(_vm._s(column))])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return (_vm.hasValue(item, column))?_c('td',[_vm._v(_vm._s(_vm.itemValue(item, column)))]):_vm._e()})},{"row":item})],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lChS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lIQK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lQ71":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.tag)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tag.status),expression:"tag.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tag, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.tag.sort),callback:function ($$v) {_vm.$set(_vm.tag, "sort", $$v)},expression:"tag.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество шаблонов с тегом","placeholder":"","readonly":""},model:{value:(_vm.tag.templates),callback:function ($$v) {_vm.$set(_vm.tag, "templates", $$v)},expression:"tag.templates"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.tag.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.tag)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lj6E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lnxJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Memories_vue__ = __webpack_require__("06e1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f5ec65_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Memories_vue__ = __webpack_require__("P/+h");
function injectStyle (ssrContext) {
  __webpack_require__("btzk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17f5ec65"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Memories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f5ec65_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Memories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lroX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("M+AW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_237dc154_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("rm95");
function injectStyle (ssrContext) {
  __webpack_require__("Fzuf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-237dc154"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_237dc154_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lt2r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'project_id', 'locale', 'title', 'text', 'push_code', 'status', 'created_at', ''],
            data: [],
            waiting: false,
            status: localStorage.getItem('pp_status') ? localStorage.getItem('pp_status') : "",
            loading: false,
            limit: 10,
            token: localStorage.getItem('token'),
            offset: parseInt(localStorage.getItem('pp_active_offset')) || 0
        };
    },

    filters: {
        toEasyDate: function toEasyDate(value) {
            if (value) {
                return __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(String(value)).format('DD.MM.YYYY HH:mm');
            } else {
                return '';
            }
        }
    },
    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            localStorage.setItem('pp_active_offset', "0");
            this.offset = 0;
            this.get();
        },
        add: function add() {
            this.$router.push('/push-tasks/create');
        },
        get: function get() {
            var self = this;

            self.waiting = true;

            axios.get(this.$hostname + '/admin/services/push/tasks', {
                'params': {
                    status: this.status,
                    limit: self.limit,
                    offset: self.offset
                },
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {
                self.data = response.data;
                self.waiting = false;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        removeTask: function removeTask(id) {
            var self = this;

            if (confirm("Подтверждение удаления задачи " + id)) {
                self.waiting = true;

                axios.post(this.$hostname + '/admin/services/push/tasks/delete', { task_id: id }, {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                }).then(function (response) {

                    self.waiting = false;

                    var notification = {
                        template: '<span><b>\u0417\u0430\u0434\u0430\u0447\u0430 \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.get();
                }).catch(function (error) {

                    self.waiting = false;

                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
                });
            }
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('pp_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('pp_active_offset', parseInt(this.offset));
            }
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('push-tasks') < 1) {
            localStorage.setItem('pp_active_offset', "");
        }
        next();
    }
});

/***/ }),

/***/ "lvPc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "miwB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n5E6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.object.sort),callback:function ($$v) {_vm.$set(_vm.object, "sort", $$v)},expression:"object.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Цвет фона (начинается с #)","placeholder":""},model:{value:(_vm.object.color),callback:function ($$v) {_vm.$set(_vm.object, "color", $$v)},expression:"object.color"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nQI6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                            Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.category_id),expression:"template.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return (c.id !== 999)?_c('option',{domProps:{"value":c.id}},[_vm._v("\n                                                "+_vm._s(c.name)+"\n                                            ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.status),expression:"template.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Опубликовано")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ожидает")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип шаблона")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.type),expression:"template.type"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Обычный")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Slide 2 кусочка (справа-налево)")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Slide 3 кусочка (справа-налево)")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Slide 2 кусочка (снизу-вверх)")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Slide 3 кусочка (снизу-вверх)")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Slide слева вниз, справа вверх")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Разъезжается центральный кадр")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Slide 2 кусочка (слева-направо)")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Slide 3 кусочка (слева-направо)")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Slide 2 кусочка (сверху-вниз)")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Slide 3 кусочка (сверху-вниз)")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Разъезжается первый кадр")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Появляются по очереди 3 кусочка и уезжают вверх")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("Cutout (смешанный)")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("Slide 1 кусочек (справа-налево)")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("Slide 1 кусочек (слева-направо)")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("Slide 1 кусочек (снизу-вверх)")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("Slide 1 кусочек (сверху-вниз)")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("Съезжается первый кадр")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("19")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Формат")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.ratio),expression:"template.ratio"}],staticClass:"form-control",attrs:{"id":"ratio-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "ratio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeRatioType()}]}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Обычный")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Горизонтальный (16:9)")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Горизонтальный (5:1)")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Минимальная версия")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.v),expression:"template.v"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "v", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Все версии")]),_vm._v(" "),_vm._l((_vm.versions),function(version){return _c('option',{key:version,domProps:{"value":version}},[_vm._v("\n                                                "+_vm._s(version)+"\n                                            ")])})],2)]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.template.sort),callback:function ($$v) {_vm.$set(_vm.template, "sort", $$v)},expression:"template.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название трека","placeholder":""},model:{value:(_vm.template.song),callback:function ($$v) {_vm.$set(_vm.template, "song", $$v)},expression:"template.song"}}),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на Reels audio","placeholder":""},model:{value:(_vm.template.song_insta),callback:function ($$v) {_vm.$set(_vm.template, "song_insta", $$v)},expression:"template.song_insta"}}):_vm._e(),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на TikTok audio","placeholder":""},model:{value:(_vm.template.song_tiktok),callback:function ($$v) {_vm.$set(_vm.template, "song_tiktok", $$v)},expression:"template.song_tiktok"}}):_vm._e(),_vm._v(" "),_c('fg-input',{attrs:{"type":"date","label":"Дата публикации (формат ДД.ММ.ГГГГ)","placeholder":""},model:{value:(_vm.template.release_date),callback:function ($$v) {_vm.$set(_vm.template, "release_date", $$v)},expression:"template.release_date"}}),_vm._v(" "),(_vm.template.release_date)?_c('fg-input',{attrs:{"type":"time","label":"Время публикации (формат HH:MM)","placeholder":""},model:{value:(_vm.template.release_time),callback:function ($$v) {_vm.$set(_vm.template, "release_time", $$v)},expression:"template.release_time"}}):_vm._e(),_vm._v(" "),_c('div',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                            Теги:\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',{staticClass:"d-none"},[_vm._v(_vm._s(_vm.template.tags))]),_vm._v(" "),_c('div',{staticClass:"tags-set"},_vm._l((_vm.tags),function(t){return _c('div',{class:{ 'active' : t.active },on:{"click":function($event){return _vm.toggleTag(t)}}},[_vm._v(_vm._s(t.name))])}),0)])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 checkbox-block"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_premium),expression:"template.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_premium)?_vm._i(_vm.template.is_premium,null)>-1:(_vm.template.is_premium)},on:{"change":function($event){var $$a=_vm.template.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trendy-control"}},[_vm._v("Популярное")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_trendy),expression:"template.is_trendy"}],staticClass:"form-check-inline",attrs:{"id":"trendy-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_trendy)?_vm._i(_vm.template.is_trendy,null)>-1:(_vm.template.is_trendy)},on:{"change":function($event){var $$a=_vm.template.is_trendy,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_trendy", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_trendy", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_trendy", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"new-control"}},[_vm._v("Новое")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_new),expression:"template.is_new"}],staticClass:"form-check-inline",attrs:{"id":"new-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_new)?_vm._i(_vm.template.is_new,null)>-1:(_vm.template.is_new)},on:{"change":function($event){var $$a=_vm.template.is_new,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_new", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_new", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_new", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trending-music-control"}},[_vm._v("Трендовая музыка")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_trending_music),expression:"template.is_trending_music"}],staticClass:"form-check-inline",attrs:{"id":"trending-music-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_trending_music)?_vm._i(_vm.template.is_trending_music,null)>-1:(_vm.template.is_trending_music)},on:{"change":function($event){var $$a=_vm.template.is_trending_music,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_trending_music", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_trending_music", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_trending_music", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"collage-control"}},[_vm._v("Коллаж")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_collage),expression:"template.is_collage"}],staticClass:"form-check-inline",attrs:{"id":"collage-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_collage)?_vm._i(_vm.template.is_collage,null)>-1:(_vm.template.is_collage)},on:{"change":function($event){var $$a=_vm.template.is_collage,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_collage", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_collage", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_collage", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"copyrighted-control"}},[_vm._v("Copyrighted-музыка")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_copyrighted),expression:"template.is_copyrighted"}],staticClass:"form-check-inline",attrs:{"id":"copyrighted-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_copyrighted)?_vm._i(_vm.template.is_copyrighted,null)>-1:(_vm.template.is_copyrighted)},on:{"change":function($event){var $$a=_vm.template.is_copyrighted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_copyrighted", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_copyrighted", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_copyrighted", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"stories-control"}},[_vm._v("Stories")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_stories),expression:"template.is_stories"}],staticClass:"form-check-inline",attrs:{"id":"stories-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_stories)?_vm._i(_vm.template.is_stories,null)>-1:(_vm.template.is_stories)},on:{"change":function($event){var $$a=_vm.template.is_stories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_stories", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_stories", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_stories", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"cut-out-control"}},[_vm._v("Cut out")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_cut_out),expression:"template.is_cut_out"}],staticClass:"form-check-inline",attrs:{"id":"cut-out-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_cut_out)?_vm._i(_vm.template.is_cut_out,null)>-1:(_vm.template.is_cut_out)},on:{"change":function($event){var $$a=_vm.template.is_cut_out,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_cut_out", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_cut_out", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_cut_out", $$c)}}}})]),_vm._v(" "),(_vm.template.is_cut_out)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"cut-out-control"}},[_vm._v("Paper Cutout")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_paper_cut_out),expression:"template.is_paper_cut_out"}],staticClass:"form-check-inline",attrs:{"id":"cut-out-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_paper_cut_out)?_vm._i(_vm.template.is_paper_cut_out,null)>-1:(_vm.template.is_paper_cut_out)},on:{"change":function($event){var $$a=_vm.template.is_paper_cut_out,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_paper_cut_out", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_paper_cut_out", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_paper_cut_out", $$c)}}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"text-control"}},[_vm._v("Наложение\n                                                    текста/объекта")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.is_text_active),expression:"is_text_active"}],staticClass:"form-check-inline",attrs:{"disabled":!_vm.template.src_full || !_vm.template.preview_src_full,"id":"text-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.is_text_active)?_vm._i(_vm.is_text_active,null)>-1:(_vm.is_text_active)},on:{"change":[function($event){var $$a=_vm.is_text_active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.is_text_active=$$a.concat([$$v]))}else{$$i>-1&&(_vm.is_text_active=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.is_text_active=$$c}},function($event){return _vm.toggleText()}]}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет фона: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.background))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.background),expression:"template.background"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.background)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template, "background", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Эффект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.effect),expression:"effect"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.effect=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("-")]),_vm._v(" "),_vm._l((_vm.server_effects),function(se){return _c('option',{domProps:{"value":se.name}},[_vm._v("\n                                                        "+_vm._s(se.name)+"\n                                                    ")])})],2)]),_vm._v(" "),(_vm.effect)?_c('label',{staticClass:"control-label"},[_vm._v("Интенсивность эффекта: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.effect_intensity))])]):_vm._e(),_vm._v(" "),(_vm.effect)?_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.effect_intensity),callback:function ($$v) {_vm.effect_intensity=$$v},expression:"effect_intensity"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Фильтр")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("-")]),_vm._v(" "),_vm._l((_vm.server_filters),function(sf){return _c('option',{domProps:{"value":sf.name}},[_vm._v("\n                                                        "+_vm._s(sf.name)+"\n                                                    ")])})],2)]),_vm._v(" "),(_vm.filter)?_c('label',{staticClass:"control-label"},[_vm._v("Интенсивность фильтра: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.filter_intensity))])]):_vm._e(),_vm._v(" "),(_vm.filter)?_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.filter_intensity),callback:function ($$v) {_vm.filter_intensity=$$v},expression:"filter_intensity"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                                    Видео: "),(_vm.template.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.src_size >= 4)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]):(_vm.template.src_size >= 3)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"videoFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.videoFileInput.click()}}},[_vm._v("\n                                                        Загрузить\n                                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                                    Превью: "),(_vm.template.preview_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.preview_src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):(_vm.template.preview_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.preview_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"previewFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'preview_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.previewFileInput.click()}}},[_vm._v("\n                                                        Загрузить\n                                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                                    Аудио: "),(_vm.template.audio)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.audio_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):(_vm.template.audio_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.audio_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"audioFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"audio/mp3"},on:{"change":function($event){return _vm.uploadFile($event, 'audio')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.audioFileInput.click()}}},[_vm._v("\n                                                        Загрузить\n                                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                                    Превью: "),(_vm.template.preview_image)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.preview_image_size >= 0.1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.preview_image_size)+"Mb")]):(_vm.template.preview_image_size >= 0.05)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.preview_image_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.preview_image_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.preview_image_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"previewImageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'preview_image')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.previewImageFileInput.click()}}},[_vm._v("\n                                                        Загрузить\n                                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.template.duration || !_vm.template.videos || !_vm.template.category_id || !_vm.template.song
                                        || !_vm.template.src || !_vm.template.preview_src || !_vm.template.audio || !_vm.template.preview_image
                                        || (_vm.template.is_copyrighted == true && (!_vm.template.song_insta && !_vm.template.song_tiktok))},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                    Сохранить\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),(_vm.show_collage_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeCollageModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return [_c('button',{staticClass:"btn btn-text btn-fill collage-category",class:{ 'active' : _vm.active_collage_category === 'Custom'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectCollageCategory('Custom')}}},[_vm._v("\n                                            Custom\n                                        ")]),_vm._v(" "),_vm._l((_vm.collages),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill collage-category",class:{ 'active' : t.name === _vm.active_collage_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectCollageCategory(t.name)}}},[_vm._v("\n                                            "+_vm._s(t.name)+"\n                                        ")])})]})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return [(_vm.active_collage_category === 'Custom')?_c('div',{staticClass:"collage-custom-form",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Ширина фрейма в Figma","placeholder":""},model:{value:(_vm.custom_collage_rawData.original_w),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "original_w", $$v)},expression:"custom_collage_rawData.original_w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Высота фрейма в Figma","placeholder":""},model:{value:(_vm.custom_collage_rawData.original_h),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "original_h", $$v)},expression:"custom_collage_rawData.original_h"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Ширина редактируемой области","placeholder":""},model:{value:(_vm.custom_collage_rawData.w),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "w", $$v)},expression:"custom_collage_rawData.w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Высота редактируемой области","placeholder":""},model:{value:(_vm.custom_collage_rawData.h),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "h", $$v)},expression:"custom_collage_rawData.h"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ сверху","placeholder":""},model:{value:(_vm.custom_collage_rawData.y),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "y", $$v)},expression:"custom_collage_rawData.y"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ слева","placeholder":""},model:{value:(_vm.custom_collage_rawData.x),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "x", $$v)},expression:"custom_collage_rawData.x"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Радиус верхний левый","placeholder":""},model:{value:(_vm.custom_collage_rawData.b_tl),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "b_tl", $$v)},expression:"custom_collage_rawData.b_tl"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус верхний правый","placeholder":""},model:{value:(_vm.custom_collage_rawData.b_tr),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "b_tr", $$v)},expression:"custom_collage_rawData.b_tr"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус нижний правый","placeholder":""},model:{value:(_vm.custom_collage_rawData.b_br),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "b_br", $$v)},expression:"custom_collage_rawData.b_br"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус нижний левый","placeholder":""},model:{value:(_vm.custom_collage_rawData.b_bl),callback:function ($$v) {_vm.$set(_vm.custom_collage_rawData, "b_bl", $$v)},expression:"custom_collage_rawData.b_bl"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"button"},on:{"click":_vm.addCustomCollage}},[_vm._v("\n                                                        Применить\n                                                    ")])],1)])]):_c('div',_vm._l((_vm.collages),function(t,index){return _c('div',_vm._l((t.data),function(c,index){return (t.name === _vm.active_collage_category)?_c('div',{staticClass:"collage-item"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.renderCollage(c))},on:{"click":_vm.addCollage}})]):_vm._e()}),0)}),0)]})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer collage-modal-footer"},[_vm._t("footer",function(){return [_c('div',{staticClass:"collage-frame-footer"},[_vm._v(_vm._s(_vm.collageModalFrameText))]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeCollageModal}},[_vm._v("\n                                            Закрыть\n                                        ")])]})],2)])])]):_vm._e(),_vm._v(" "),(_vm.is_text_active)?_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                            Текст")]),_vm._v(" "),(_vm.is_text_active)?_c('div',{staticClass:"texts-buttons"},[_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.addText()}}},[_vm._v("Добавить текст\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.addText(false, true)}}},[_vm._v("Добавить tool\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showSVGModal()}}},[_vm._v("Добавить объект\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showFramesModal()}}},[_vm._v("Добавить фрейм\n                            ")])]):_vm._e(),_vm._v(" "),(_vm.is_text_active)?_c('div',{ref:"layersBar",staticClass:"texts-buttons layers-sticky"},[_vm._l((_vm.template.texts),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_text && _vm.active_type === 'text'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectText(index)}}},[_vm._v(_vm._s(t.text)+"\n                                "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.template.objects),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_object && _vm.active_type === 'object'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObject(index)}}},[_c('div',{staticClass:"button-preview",style:({ backgroundImage: 'url(\'' + _vm.objectPlayerSrc(t) + '\')' })}),_vm._v(" "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.template.frames),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_frame && _vm.active_type === 'frame'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectFrame(index)}}},[_c('div',{staticClass:"button-preview",style:({ backgroundImage: 'url(' + _vm.framesUrl + t.src + ')' })})])}),_vm._v(" "),((_vm.active_type === 'text' && _vm.template.texts.length) || (_vm.active_type === 'object' && _vm.template.objects.length) || (_vm.active_type === 'frame' && (_vm.template.frames || []).length))?_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.active_type === 'text' ? _vm.addText(_vm.active_text) : _vm.active_type === 'frame' ? _vm.addFrame(null, _vm.active_frame) : _vm.addObject(null, _vm.active_object)}}},[_vm._v("\n                                Копировать\n                            ")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.show_svg_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeSVGModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.server_graphics),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : t.name === _vm.active_object_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObjectCategory(t.name)}}},[_vm._v("\n                                                "+_vm._s(t.name)+"\n                                            ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return _vm._l((_vm.server_graphics),function(t,index){return _c('div',_vm._l((t.data),function(c,index){return (t.name === _vm.active_object_category)?_c('div',{staticClass:"object-item",on:{"click":function($event){return _vm.addObject(c)}}},[_c('img',{staticClass:"image",attrs:{"src":("" + _vm.graphicsUrl + (c.src))}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeSVGModal}},[_vm._v("\n                                                Закрыть\n                                            ")])]})],2)])])]):_vm._e(),_vm._v(" "),(_vm.show_frames_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeFramesModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.server_frames),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : t.id === _vm.active_frame_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectFrameCategory(t.id)}}},[_vm._v("\n                                                "+_vm._s(t.name)+"\n                                            ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"background":"#C9D5DF"}},[_vm._t("body",function(){return _vm._l((_vm.server_frames),function(t,index){return _c('div',_vm._l((t.data),function(f,index){return (t.id === _vm.active_frame_category)?_c('div',{staticClass:"frame-item",on:{"click":function($event){return _vm.addFrame(f)}}},[_c('img',{staticClass:"image",attrs:{"src":("" + (f.src_full))}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeFramesModal}},[_vm._v("\n                                                Закрыть\n                                            ")])]})],2)])])]):_vm._e(),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.active_type === 'text' && _vm.template.texts.length > 0)?_c('div',{staticClass:"col-md-4 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Текст")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text),expression:"template.texts[active_text].text"}],staticClass:"text-area",domProps:{"value":(_vm.template.texts[_vm.active_text].text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":_vm.template.texts[_vm.active_text].type ? 'Время появления tool (0 - c начала)' : 'Время появления текста (0 - c начала)',"placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_start),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_start", $$v)},expression:"template.texts[active_text].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_end),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_end", $$v)},expression:"template.texts[active_text].time_end"}})],1)]),_vm._v(" "),(_vm.template.texts[_vm.active_text].type)?_c('img',{staticClass:"widget-icon",attrs:{"src":("/static/img/widget" + (_vm.template.texts[_vm.active_text].type) + ".png")}}):_vm._e(),_vm._v(" "),(_vm.template.texts[_vm.active_text].type)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип виджета")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].type),expression:"template.texts[active_text].type"}],staticClass:"form-control",attrs:{"id":"widget-type-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeWidgetType(_vm.active_text, _vm.template.texts[_vm.active_text].type)}]}},_vm._l((_vm.widget_types),function(f){return _c('option',{domProps:{"value":f.id}},[_vm._v(_vm._s(f.name))])}),0)]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер шрифта: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].font_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"5","max":"200","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].font_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "font_size", $$v)},expression:"template.texts[active_text].font_size"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].z_index),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "z_index", $$v)},expression:"template.texts[active_text].z_index"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Шрифт")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].font_name),expression:"template.texts[active_text].font_name"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "font_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.sortedFonts),function(f){return _c('option',{domProps:{"value":f.name}},[_vm._v(_vm._s(f.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control1"}},[_vm._v("По центру по горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control1","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_x == 0.5},on:{"change":function($event){return _vm.setTextPosition(0.5, null)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control2"}},[_vm._v("По центру по вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control2","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_y == 0.5},on:{"change":function($event){return _vm.setTextPosition(null, 0.5)}}})]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот текста (градусы)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].angle),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "angle", $$v)},expression:"template.texts[active_text].angle"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межбуквенный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].letter_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "letter_spacing", $$v)},expression:"template.texts[active_text].letter_spacing"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межстрочный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].line_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "line_spacing", $$v)},expression:"template.texts[active_text].line_spacing"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет текста: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].text_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_color),expression:"template.texts[active_text].text_color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].text_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'color')}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет фона:\n                                            "),(_vm.template.texts[_vm.active_text].background_color === 'transparent')?_c('span',{staticClass:"param-span"},[_vm._v("Прозрачный")]):_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].background_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].background_color),expression:"template.texts[active_text].background_color"},{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "background_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"background-control"}},[_vm._v("Прозрачный")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"background-control","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].background_color === 'transparent'},on:{"change":function($event){return _vm.toggleBackground()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.texts[_vm.active_text].background_color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'background')}}})}),0)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "alpha", $$v)},expression:"template.texts[active_text].alpha"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"animated-control"}},[_vm._v("Анимированный (привязан к кусочку)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].is_animated),expression:"template.texts[active_text].is_animated"}],staticClass:"form-check-inline",attrs:{"true-value":"1","false-value":"0","id":"animated-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.texts[_vm.active_text].is_animated)?_vm._i(_vm.template.texts[_vm.active_text].is_animated,null)>-1:_vm._q(_vm.template.texts[_vm.active_text].is_animated,"1")},on:{"change":function($event){var $$a=_vm.template.texts[_vm.active_text].is_animated,$$el=$event.target,$$c=$$el.checked?("1"):("0");if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template.texts[_vm.active_text], "is_animated", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template.texts[_vm.active_text], "is_animated", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template.texts[_vm.active_text], "is_animated", $$c)}}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Направление текста")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].direction),expression:"template.texts[active_text].direction"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "direction", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"normal"}},[_vm._v("normal")]),_vm._v(" "),_c('option',{attrs:{"value":"vertical"}},[_vm._v("vertical")]),_vm._v(" "),_c('option',{attrs:{"value":"round"}},[_vm._v("round")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Выравнивание "),_c('br'),_vm._v("(если больше одной строки)")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_align),expression:"template.texts[active_text].text_align"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "text_align", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.text_aligns),function(ta){return _c('option',{domProps:{"value":ta.name}},[_vm._v(_vm._s(ta.name)+"\n                                            ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].animation_type),expression:"template.texts[active_text].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name))])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].animation_duration))])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"20","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "animation_duration", $$v)},expression:"template.texts[active_text].animation_duration"}}),_vm._v(" "),_c('label',{attrs:{"for":"shadow-color"}},[_vm._v("Цвет тени:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].shadow_color),expression:"template.texts[active_text].shadow_color"}],attrs:{"type":"color","id":"shadow-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "shadow_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Радиус размытия тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_blur))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_blur),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_blur", $$v)},expression:"template.texts[active_text].shadow_blur"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Сдвиг тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_distance))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_distance),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_distance", $$v)},expression:"template.texts[active_text].shadow_distance"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_alpha", $$v)},expression:"template.texts[active_text].shadow_alpha"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер обводки: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].stroke_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].stroke_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "stroke_size", $$v)},expression:"template.texts[active_text].stroke_size"}}),_vm._v(" "),_c('label',{attrs:{"for":"stroke-color"}},[_vm._v("Цвет обводки:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].stroke_color),expression:"template.texts[active_text].stroke_color"}],attrs:{"type":"color","id":"stroke-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].stroke_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "stroke_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeText(_vm.active_text)}}},[_vm._v("Удалить текст\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),(_vm.active_type === 'object' && _vm.template.objects.length > 0)?_c('div',{staticClass:"col-md-4 c-labels"},[_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.changeObject()}}},[_vm._v("Заменить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Объект")]),_vm._v(" "),_c('img',{staticClass:"object-preview",attrs:{"alt":"","src":_vm.objectPlayerSrc(_vm.template.objects[_vm.active_object])},on:{"click":function($event){return _vm.changeObject()}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления объекта (0 - c начала)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_start),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_start", $$v)},expression:"template.objects[active_object].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_end),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_end", $$v)},expression:"template.objects[active_object].time_end"}})],1)]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Размер:","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].scale),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "scale", $$v)},expression:"template.objects[active_object].scale"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0.03","max":"5","step":"0.0001","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].scale),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "scale", $$v)},expression:"template.objects[active_object].scale"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].z_index),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "z_index", $$v)},expression:"template.objects[active_object].z_index"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control3"}},[_vm._v("По центру по горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control3","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_x == 0.5},on:{"change":function($event){return _vm.setObjectPosition(0.5, null)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control4"}},[_vm._v("По центру по вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control4","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_y == 0.5},on:{"change":function($event){return _vm.setObjectPosition(null, 0.5)}}})]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот объекта (градусы)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].angle),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "angle", $$v)},expression:"template.objects[active_object].angle"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].id.indexOf('nocolor') < 0 && !_vm.isGifSrc(_vm.template.objects[_vm.active_object].id)),expression:"template.objects[active_object].id.indexOf('nocolor') < 0 && !isGifSrc(template.objects[active_object].id)"}],staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].color),expression:"template.objects[active_object].color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.objects[_vm.active_object].color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.objects[_vm.active_object], "color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.objects[_vm.active_object].color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setObjColor(c)}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"object-animated-control"}},[_vm._v("Анимированный (привязан к кусочку)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].is_animated),expression:"template.objects[active_object].is_animated"}],staticClass:"form-check-inline",attrs:{"true-value":"1","false-value":"0","id":"object-animated-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.objects[_vm.active_object].is_animated)?_vm._i(_vm.template.objects[_vm.active_object].is_animated,null)>-1:_vm._q(_vm.template.objects[_vm.active_object].is_animated,"1")},on:{"change":function($event){var $$a=_vm.template.objects[_vm.active_object].is_animated,$$el=$event.target,$$c=$$el.checked?("1"):("0");if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template.objects[_vm.active_object], "is_animated", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template.objects[_vm.active_object], "is_animated", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template.objects[_vm.active_object], "is_animated", $$c)}}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].animation_type),expression:"template.objects[active_object].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.objects[_vm.active_object], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name))])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].animation_duration))])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"20","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "animation_duration", $$v)},expression:"template.objects[active_object].animation_duration"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].alpha),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "alpha", $$v)},expression:"template.objects[active_object].alpha"}}),_vm._v(" "),_c('label',{attrs:{"for":"shadow-color"}},[_vm._v("Цвет тени:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].shadow_color),expression:"template.objects[active_object].shadow_color"}],attrs:{"type":"color","id":"shadow-color"},domProps:{"value":(_vm.template.objects[_vm.active_object].shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.objects[_vm.active_object], "shadow_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Радиус размытия тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].shadow_blur))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].shadow_blur),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "shadow_blur", $$v)},expression:"template.objects[active_object].shadow_blur"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Сдвиг тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].shadow_distance))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].shadow_distance),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "shadow_distance", $$v)},expression:"template.objects[active_object].shadow_distance"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].shadow_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].shadow_alpha),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "shadow_alpha", $$v)},expression:"template.objects[active_object].shadow_alpha"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeObject(_vm.active_object)}}},[_vm._v("Удалить объект\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),(_vm.active_type === 'frame' && _vm.template && _vm.template.frames[_vm.active_frame])?_c('div',{staticClass:"col-md-4 c-labels"},[_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.changeFrame()}}},[_vm._v("Заменить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления фрейма (0 - c начала)","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].time_start),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "time_start", $$v)},expression:"template.frames[active_frame].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].time_end),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "time_end", $$v)},expression:"template.frames[active_frame].time_end"}})],1)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.frames[_vm.active_frame].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].alpha),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "alpha", $$v)},expression:"template.frames[active_frame].alpha"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].z_index),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "z_index", $$v)},expression:"template.frames[active_frame].z_index"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Ширина слайда в Figma","placeholder":""},on:{"input":_vm.onFrameRawDataChange},model:{value:(_vm.template.frames[_vm.active_frame].rawData.original_w),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame].rawData, "original_w", $$v)},expression:"template.frames[active_frame].rawData.original_w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Ширина фрейма","placeholder":""},on:{"input":_vm.onFrameRawDataChange},model:{value:(_vm.template.frames[_vm.active_frame].rawData.w),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame].rawData, "w", $$v)},expression:"template.frames[active_frame].rawData.w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ сверху","placeholder":""},on:{"input":_vm.onFrameRawDataChange},model:{value:(_vm.template.frames[_vm.active_frame].rawData.y),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame].rawData, "y", $$v)},expression:"template.frames[active_frame].rawData.y"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ слева","placeholder":""},on:{"input":_vm.onFrameRawDataChange},model:{value:(_vm.template.frames[_vm.active_frame].rawData.x),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame].rawData, "x", $$v)},expression:"template.frames[active_frame].rawData.x"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот объекта (градусы)","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].angle),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "angle", $$v)},expression:"template.frames[active_frame].angle"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Src","placeholder":""},model:{value:(_vm.template.frames[_vm.active_frame].src),callback:function ($$v) {_vm.$set(_vm.template.frames[_vm.active_frame], "src", $$v)},expression:"template.frames[active_frame].src"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeFrame(_vm.active_frame)}}},[_vm._v("Удалить фрейм\n                                    ")])],1):_vm._e(),_vm._v(" "),(!(_vm.active_type === 'text' && _vm.template.texts.length > 0) &&
                                           !(_vm.active_type === 'object' && _vm.template.objects.length > 0) &&
                                           !(_vm.active_type === 'frame' && _vm.template && _vm.template.frames[_vm.active_frame]))?_c('div',{staticClass:"col-md-4 c-labels"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[(_vm.template.src_full)?_c('div',{staticClass:"preview-sticky",style:({ top: _vm.layersBarHeight + 'px' }),attrs:{"id":"preview-container"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.src_full),expression:"template.src_full"}],style:({ height: _vm.heightCanvas + 'px' }),attrs:{"id":"player"}},[(!_vm.isVideo(_vm.template.preview_src_full))?_c('video',{ref:"videoContainer",staticStyle:{"max-width":"100%","cursor":"pointer","border":"1px solid red","position":"relative","z-index":"0"},style:({ height: _vm.heightCanvas + 'px', zIndex: 0 }),attrs:{"controls":"","disablepictureinpicture":"","muted":"","controlsList":"nofullscreen nodownload noremoteplayback noplaybackrate","playsinline":"","id":"video_player","poster":_vm.template.preview_src_full},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.template.src_full}})]):_vm._e(),_vm._v(" "),(_vm.isVideo(_vm.template.preview_src_full))?_c('video',{ref:"videoContainer",staticStyle:{"max-width":"100%","cursor":"pointer","border":"1px solid red","position":"relative","z-index":"0"},style:({ height: _vm.heightCanvas + 'px', zIndex: 0 }),attrs:{"controls":"","disablepictureinpicture":"","muted":"","controlsList":"nofullscreen nodownload noremoteplayback noplaybackrate","playsinline":"","id":"video_player2"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.template.src_full}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.template.texts),function(tt,index){return (tt.font_size)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible !== 0),expression:"tt.is_visible !== 0"}],ref:"draggableContainer",refInFor:true,staticClass:"draggable-container",style:({ zIndex: tt.z_index }),attrs:{"id":("" + index)}},[(_vm.fonts.length > 1)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header",class:{ active: index === _vm.active_text && _vm.active_type === 'text' },domProps:{"innerHTML":_vm._s(_vm.text_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e()]):_vm._e()}),_vm._v(" "),_vm._l((_vm.template.objects),function(tt,index){return (tt.scale)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible !== 0),expression:"tt.is_visible !== 0"}],ref:"draggableContainer2",refInFor:true,staticClass:"draggable-container",style:({ zIndex: tt.z_index }),attrs:{"id":("o" + index)}},[(tt.id.indexOf('.svg') > 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header nospace",class:{ active: index === _vm.active_object && _vm.active_type === 'object' },domProps:{"innerHTML":_vm._s(_vm.object_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e(),_vm._v(" "),(tt.id.indexOf('.svg') < 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header nospace",class:{ active: index === _vm.active_object && _vm.active_type === 'object' },domProps:{"innerHTML":_vm._s(_vm.image_html(index))},on:{"mousedown":_vm.dragMouseDown}}):_vm._e()]):_vm._e()}),_vm._v(" "),_vm._l((_vm.template.frames),function(fr,index){return (fr.layouts)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(fr.is_visible !== 0),expression:"fr.is_visible !== 0"}],ref:"draggableContainer3",refInFor:true,staticClass:"draggable-container",style:({ zIndex: fr.z_index }),attrs:{"id":("f" + index)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(fr.is_visible === 1),expression:"fr.is_visible === 1"}],staticClass:"draggable-header nospace",class:{ active: index === _vm.active_frame && _vm.active_type === 'frame' },domProps:{"innerHTML":_vm._s(_vm.frame_html(index))},on:{"mousedown":_vm.dragMouseDown}})]):_vm._e()})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-toggle",class:{ 'active-state': _vm.template.src_full },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.showPreview()}}},[_vm._v("\n                                            Показать превью\n                                        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Параметры видео\n                            "),(_vm.realVideoDuration)?_c('div',{staticClass:"realDuration"},[_vm._v("\n                                Длительность из видео:\n                                "),_c('span',{class:{'bg-danger' : Math.abs(this.sumParts - this.realVideoDuration.toFixed(2)) > 0}},[_vm._v(_vm._s(_vm.realVideoDuration.toFixed(2)))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partsDuration"},[_vm._v("\n                                Длительность фрагментов:\n                                "),_c('span',{class:{'bg-danger' : Math.abs(this.sumParts - this.template.duration) > 0}},[_vm._v(_vm._s(_vm.sumParts))])])]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Длительность, сек.","placeholder":""},on:{"input":function($event){return _vm.formatVideoDuration($event)}},model:{value:(_vm.template.duration),callback:function ($$v) {_vm.$set(_vm.template, "duration", $$v)},expression:"template.duration"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество фрагментов","placeholder":""},on:{"input":_vm.changeVideoCount},nativeOn:{"focusout":function($event){return _vm.commitVideoCount.apply(null, arguments)}},model:{value:(_vm.template.videos),callback:function ($$v) {_vm.$set(_vm.template, "videos", $$v)},expression:"template.videos"}}),_vm._v(" "),_c('div',{staticClass:"form-group paste-durations"},[_c('label',{staticClass:"control-label"},[_vm._v("Вставить длительности из таблицы")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.pastedDurations),expression:"pastedDurations"}],staticClass:"form-control",attrs:{"rows":"5","placeholder":'0.53\n0.23\n0.90\n0.90\n1.13'},domProps:{"value":(_vm.pastedDurations)},on:{"paste":_vm.onPasteDurations,"blur":_vm.applyPastedDurations,"input":function($event){if($event.target.composing){ return; }_vm.pastedDurations=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"paste-durations-hint"},[_vm._v("\n                                            По одному числу в строке. Заголовок и пустые строки пропускаются.\n                                            "),(_vm.pastedDurationsCount)?_c('span',{staticClass:"paste-durations-applied"},[_vm._v("\n                                                Заполнено "+_vm._s(_vm.pastedDurationsCount)+" кусочков\n                                            ")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-sm paste-durations-btn",attrs:{"type":"button"},on:{"click":_vm.applyPastedDurations}},[_vm._v("\n                                            Заполнить\n                                        ")])]),_vm._v(" "),_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Фрагменты\n                                    ")]),_vm._v(" "),_vm._l((_vm.visibleClientParts),function(itm,index){return (_vm.template.videos)?_c('div',{key:index,staticClass:"content",class:{ 'part-empty-duration': _vm.isPartDurationInvalid(index) }},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"part-actions"},[_c('button',{staticClass:"part-action-btn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.duplicatePart(index)}}},[_vm._v("Дублировать\n                                                ")]),_vm._v(" "),_c('button',{staticClass:"part-action-btn part-action-delete",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removePart(index)}}},[_vm._v("Удалить\n                                                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('span',{staticClass:"block-number"},[_vm._v(_vm._s(index + 1)+".")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3",class:{ 'has-error part-duration-error': _vm.isPartDurationInvalid(index) }},[_c('fg-input',{attrs:{"type":"text","label":"Длительн.","placeholder":""},on:{"input":function($event){return _vm.formatDuration($event, index)}},model:{value:(_vm.client_parts[index].duration),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "duration", $$v)},expression:"client_parts[index].duration"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Скорость","placeholder":""},on:{"input":function($event){return _vm.formatSpeed($event, index)}},model:{value:(_vm.client_parts[index].speed),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "speed", $$v)},expression:"client_parts[index].speed"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Эффект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].effect_type),expression:"client_parts[index].effect_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "effect_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeEffectType(index, _vm.client_parts[index].effect_type)}]}},_vm._l((_vm.effect_types),function(e){return _c('option',{domProps:{"value":e.id}},[_vm._v(_vm._s(e.name))])}),0)])])]),_vm._v(" "),(_vm.template.is_cut_out)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"cut-out-2-control"}},[_vm._v("Cutout-кусочек")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].cutout_only),expression:"client_parts[index].cutout_only"}],staticClass:"form-check-inline",attrs:{"id":"cut-out-2-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.client_parts[index].cutout_only)?_vm._i(_vm.client_parts[index].cutout_only,null)>-1:(_vm.client_parts[index].cutout_only)},on:{"change":function($event){var $$a=_vm.client_parts[index].cutout_only,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.client_parts[index], "cutout_only", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.client_parts[index], "cutout_only", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.client_parts[index], "cutout_only", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип анимации (cutout)")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].cutout_animation_type),expression:"client_parts[index].cutout_animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "cutout_animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(a){return _c('option',{domProps:{"value":a.id}},[_vm._v("\n                                                                "+_vm._s(a.name)+"\n                                                            ")])}),0)])]),_vm._v(" "),(_vm.client_parts[index].cutout_only)?_c('div',{staticClass:"col-md-4",staticStyle:{"padding-right":"15px !important"}},[_c('fg-input',{attrs:{"type":"text","label":"Время появления (cutout)","placeholder":""},on:{"input":function($event){return _vm.formatStartTime($event, index, 'cutout_start_time')}},model:{value:(_vm.client_parts[index].cutout_start_time),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "cutout_start_time", $$v)},expression:"client_parts[index].cutout_start_time"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.template.is_cut_out)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Длительность анимации (cutout): "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.client_parts[index].cutout_animation_duration))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"20","step":"0.1","label":"","placeholder":""},model:{value:(_vm.client_parts[index].cutout_animation_duration),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "cutout_animation_duration", $$v)},expression:"client_parts[index].cutout_animation_duration"}})],1)]):_vm._e(),_vm._v(" "),(_vm.client_parts[index].cutout_only)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"effect-values"},[_vm._v("\n                                                    Позиция (cutout)\n                                                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"cutout-preview",on:{"click":function($event){return _vm.changeCutoutPosition($event, index)}}},[_c('span',{staticClass:"cutout-area",style:({'top': _vm.client_parts[index].cutout_y * 87 - 15 + 'px',
                                                                        'left': _vm.client_parts[index].cutout_x * 48 - 15 + 'px'})},[_c('span',{staticClass:"cutout-center"})])]),_vm._v(" "),_c('span',{staticClass:"cutout-position",staticStyle:{"padding-left":"9px"}},[_vm._v(_vm._s(_vm.client_parts[index].cutout_x))]),_vm._v(" "),_c('span',{staticClass:"cutout-position"},[_vm._v(_vm._s(_vm.client_parts[index].cutout_y))])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[(_vm.template.is_cut_out)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Размер (cutout): "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.client_parts[index].cutout_scale))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"2","step":"0.1","label":"","placeholder":""},model:{value:(_vm.client_parts[index].cutout_scale),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "cutout_scale", $$v)},expression:"client_parts[index].cutout_scale"}})],1)]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",class:{ bordered: _vm.client_parts[index].effect_type === 0 }},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-text btn-fill active control-btn collage-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showCollageModal(index)}}},[_vm._v("Коллаж +\n                                                        ")])])]),_vm._v(" "),(_vm.client_parts[index].collage_type)?_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Время начала","placeholder":""},on:{"input":function($event){return _vm.formatStartTime($event, index, 'start_time')}},model:{value:(_vm.client_parts[index].start_time),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "start_time", $$v)},expression:"client_parts[index].start_time"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4",staticStyle:{"padding-right":"15px !important"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Контент")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].content_type),expression:"client_parts[index].content_type"}],staticClass:"form-control",attrs:{"id":"content-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "content_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeContentType(index, _vm.client_parts[index].content_type)}]}},_vm._l((_vm.content_types),function(e){return _c('option',{domProps:{"value":e.id}},[_vm._v(_vm._s(e.name))])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.client_parts[index].content_type === 1),expression:"client_parts[index].content_type === 1"}],staticClass:"col-md-6 ml9"},[_c('div',[_c('h5',{staticClass:"card-title"},[_vm._v("\n                                                            Контент: "),(_vm.client_parts[index].content)?_c('span',[(_vm.isContentCorrected(_vm.client_parts[index].content))?_c('a',{attrs:{"href":_vm.client_parts[index].content_full,"target":"_blank"}},[_vm._v("(ссылка)")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:("contentFileInput_" + index),refInFor:true,staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'content', index)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.clickContentFileButton(index)}}},[_vm._v("\n                                                                Загрузить\n                                                            ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.client_parts[index].content_type === 2),expression:"client_parts[index].content_type === 2"}],staticClass:"col-md-6 ml9"},[_c('div',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Фон контента: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.getContentColor(_vm.client_parts[index].content)))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].content),expression:"client_parts[index].content"}],attrs:{"type":"color"},domProps:{"value":(_vm.client_parts[index].content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client_parts[index], "content", $event.target.value)}}})])])])]),_vm._v(" "),(_vm.client_parts[index].collage_type)?_c('div',{staticClass:"row bordered"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"collage-preview",domProps:{"innerHTML":_vm._s(_vm.renderCollagePart(_vm.client_parts[index].collage_type, index))},on:{"click":function($event){return _vm.showCollageModal(index)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-danger btn-fill btn-delete-collage",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removeCollageFromPart(index)}}},[_vm._v("Удалить коллаж\n                                                    ")])])]):_vm._e(),_vm._v(" "),((_vm.client_parts[index].effect_type === 1 || _vm.client_parts[index].effect_type === 2) && _vm.client_parts[index].effect_values)?_c('div',{staticClass:"row bordered"},[_c('div',{staticClass:"effect-values"},[_vm._v(_vm._s(_vm.effect_types[_vm.client_parts[index].effect_type].name)+" - Параметры")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"effect-preview",on:{"click":function($event){return _vm.changeEffectPosition($event, index)}}},[_c('span',{staticClass:"effect-area",style:({'top': _vm.client_parts[index].effect_values.y * 87 - 15 + 'px',
                                                                        'left': _vm.client_parts[index].effect_values.x * 48 - 15 + 'px'})},[_c('span',{staticClass:"effect-center"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"Начальное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.from),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "from", $$v)},expression:"client_parts[index].effect_values.from"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"Конечное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.to),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "to", $$v)},expression:"client_parts[index].effect_values.to"}})],1)]):_vm._e()])]):_vm._e()})],2)])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nQqz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tag.status),expression:"tag.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tag, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.tag.sort),callback:function ($$v) {_vm.$set(_vm.tag, "sort", $$v)},expression:"tag.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество шаблонов с тегом","placeholder":"","readonly":""},model:{value:(_vm.tag.templates),callback:function ($$v) {_vm.$set(_vm.tag, "templates", $$v)},expression:"tag.templates"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.tag.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.tag)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ndI3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("Vcpj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_946dba7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("O6yf");
function injectStyle (ssrContext) {
  __webpack_require__("UEX8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-946dba7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_946dba7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nm/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__("9gRq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7366d902_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__("Hxpz");
function injectStyle (ssrContext) {
  __webpack_require__("8SBY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7366d902"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7366d902_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nsOS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__);


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pastedDurations: '',
            pastedDurationsCount: 0,
            showEmptyDurationErrors: false,
            displayedVideoCount: 0,
            videoCountDebounce: null
        };
    },

    computed: {
        visibleClientParts: function visibleClientParts() {
            var count = this.displayedVideoCount || this.getVideoCount();
            return this.client_parts.slice(0, count);
        }
    },
    methods: {
        getVideoCount: function getVideoCount() {
            var count = parseInt(this.template && this.template.videos, 10);
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(count) && count > 0 ? count : 0;
        },
        createEmptyPart: function createEmptyPart() {
            return {
                duration: '',
                speed: '1.0',
                effect_type: 0,
                effect_values: { x: 0.5, y: 0.5 },
                collage_type: 0,
                content_type: 0,
                frame: 0,
                start_time: 0,
                cutout_animation_type: 0,
                cutout_animation_duration: 0,
                cutout_start_time: 0,
                cutout_scale: 0,
                cutout_x: 0.5,
                cutout_y: 0.5,
                cutout_only: 0
            };
        },
        changeVideoCount: function changeVideoCount(value) {
            var _this = this;

            var count = parseInt(value, 10);
            if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(count) || count < 0) {
                if (this.videoCountDebounce) {
                    clearTimeout(this.videoCountDebounce);
                    this.videoCountDebounce = null;
                }
                return;
            }

            while (this.client_parts.length < count) {
                this.client_parts.push(this.createEmptyPart());
            }

            if (this.videoCountDebounce) {
                clearTimeout(this.videoCountDebounce);
                this.videoCountDebounce = null;
            }

            if (count >= this.displayedVideoCount) {
                this.displayedVideoCount = count;
            } else {
                this.videoCountDebounce = setTimeout(function () {
                    _this.displayedVideoCount = _this.getVideoCount();
                    _this.videoCountDebounce = null;
                }, 600);
            }
        },
        commitVideoCount: function commitVideoCount() {
            if (this.videoCountDebounce) {
                clearTimeout(this.videoCountDebounce);
                this.videoCountDebounce = null;
            }

            var count = this.getVideoCount();
            while (this.client_parts.length < count) {
                this.client_parts.push(this.createEmptyPart());
            }
            this.displayedVideoCount = count;
        },
        setVisiblePartCount: function setVisiblePartCount(count) {
            if (this.videoCountDebounce) {
                clearTimeout(this.videoCountDebounce);
                this.videoCountDebounce = null;
            }
            this.template.videos = count;
            this.displayedVideoCount = count;
        },
        duplicatePart: function duplicatePart(index) {
            var count = this.getVideoCount();
            if (index < 0 || index >= count || !this.client_parts[index]) {
                return;
            }

            var visible = this.client_parts.slice(0, count);
            var hidden = this.client_parts.slice(count);
            var copy = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(visible[index]));
            visible.splice(index + 1, 0, copy);
            this.client_parts = visible.concat(hidden);
            this.setVisiblePartCount(visible.length);
        },
        removePart: function removePart(index) {
            var count = this.getVideoCount();
            if (index < 0 || index >= count) {
                return;
            }
            if (!confirm("Подтверждение удаления фрагмента " + (parseInt(index, 10) + 1))) {
                return;
            }

            var visible = this.client_parts.slice(0, count);
            var hidden = this.client_parts.slice(count);
            visible.splice(index, 1);
            this.client_parts = visible.concat(hidden);
            this.setVisiblePartCount(visible.length);
        },
        partsForSave: function partsForSave() {
            return this.client_parts.slice(0, this.getVideoCount());
        },
        parsePastedDurations: function parsePastedDurations(text) {
            if (!text || typeof text !== 'string') {
                return [];
            }

            var durations = [];
            var lines = text.split(/\r?\n/);

            for (var i = 0; i < lines.length; i++) {
                var line = lines[i].trim();
                if (!line) {
                    continue;
                }

                var firstCell = line.split('\t')[0].trim();
                var normalized = firstCell.replace(',', '.');
                if (!/^-?\d+(\.\d+)?$/.test(normalized)) {
                    continue;
                }

                var value = parseFloat(normalized);
                if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(value)) {
                    continue;
                }

                durations.push(normalized);
            }

            return durations;
        },
        isEmptyDuration: function isEmptyDuration(value) {
            if (value === null || value === undefined) {
                return true;
            }

            var str = String(value).trim();
            if (!str) {
                return true;
            }

            var num = parseFloat(str.replace(',', '.'));
            return !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(num);
        },
        isPartDurationInvalid: function isPartDurationInvalid(index) {
            return this.showEmptyDurationErrors && this.client_parts[index] && this.isEmptyDuration(this.client_parts[index].duration);
        },
        applyPastedDurations: function applyPastedDurations() {
            var durations = this.parsePastedDurations(this.pastedDurations);
            if (!durations.length) {
                this.pastedDurationsCount = 0;
                return;
            }

            if (durations.length > this.getVideoCount()) {
                this.template.videos = durations.length;
                this.changeVideoCount(durations.length);
            }

            for (var i = 0; i < durations.length; i++) {
                this.client_parts[i].duration = durations[i];
            }

            this.pastedDurationsCount = durations.length;
            this.showEmptyDurationErrors = false;
        },
        onPasteDurations: function onPasteDurations() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.applyPastedDurations();
            });
        },
        validatePartDurations: function validatePartDurations() {
            var _this3 = this;

            var parts = this.partsForSave();
            var hasEmpty = parts.some(function (part) {
                return _this3.isEmptyDuration(part.duration);
            });
            if (!hasEmpty) {
                this.showEmptyDurationErrors = false;
                return true;
            }

            this.showEmptyDurationErrors = true;
            this.$notifications.notify({
                component: {
                    template: '<span><b>Заполните длительность всех фрагментов</b></span>'
                },
                icon: 'nc-icon nc-simple-remove',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'danger'
            });

            return false;
        }
    }
});

/***/ }),

/***/ "nwib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oKnG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calc_vue__ = __webpack_require__("iw6e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2375724c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calc_vue__ = __webpack_require__("AYP5");
function injectStyle (ssrContext) {
  __webpack_require__("Yjxl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2375724c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2375724c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oMSU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");
var moment = __webpack_require__("PJh5");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'user_id', 'type', 'locale', 'version', 'file', 'created_at'],
            data: [],
            type: "",
            userId: null,
            summary: "",
            types: localStorage.getItem('l_types') ? JSON.parse(localStorage.getItem('l_types')) : [],
            loading: false,
            limit: 20,
            offset: parseInt(localStorage.getItem('logs_active_offset')) || 0
        };
    },

    filters: {
        toEasyDate: function toEasyDate(value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY HH:mm');
            } else {
                return '';
            }
        }
    },
    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            localStorage.setItem('logs_active_offset', "0");
            this.offset = 0;
            this.get();
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('logs_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('logs_active_offset', parseInt(this.offset));
            }
        },
        openLink: function openLink(link) {
            console.log(link);
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            this.loading = true;

            axios.get(this.$hostname + '/admin/services/logs/', {
                'params': {
                    type: this.type,
                    limit: this.limit,
                    offset: this.offset,
                    user_id: this.userId,
                    summary: this.summary
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data.logs;
                if (self.type === "") {
                    self.types = response.data.types;
                    localStorage.setItem('l_types', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.types));
                }
                self.loading = false;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        next();
    }
});

/***/ }),

/***/ "okzn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Push_vue__ = __webpack_require__("lt2r");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7daad2af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Push_vue__ = __webpack_require__("Iqy4");
function injectStyle (ssrContext) {
  __webpack_require__("2fJT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7daad2af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Push_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7daad2af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Push_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "owed":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("XBIO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc89352_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("yYt2");
function injectStyle (ssrContext) {
  __webpack_require__("OmYT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1dc89352"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc89352_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pEA8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_mixins_replaceGraphicSize__ = __webpack_require__("g69p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_mixins_gifGraphic__ = __webpack_require__("pJH4");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateCategory',
    mixins: [__WEBPACK_IMPORTED_MODULE_4_src_mixins_replaceGraphicSize__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_src_mixins_gifGraphic__["a" /* default */]],
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            lock_waiting: false,
            interval: null,
            is_playing: false,
            show_svg_modal: false,
            show_collage_modal: false,
            is_object_changing: false,
            video: null,
            active_text: 0,
            active_object: 0,
            draggable_index: 0,
            draggable_type: null,
            active_type: 'text',
            server_effects: [],
            server_graphics: [],
            server_filters: [],
            server_fonts: [],
            active_object_category: 'Arrows',
            active_collage_category: '2',
            template: {
                status: 0,
                name: null,
                type: null,
                sort: 1,
                videos: null,
                duration: null,
                v: "",
                audio: null,
                audio_full: null,
                audio_size: null,
                song: null,
                song_insta: "",
                song_tiktok: "",
                push_type: 0,
                release_date: null,
                release_date_history: null,
                release_time: '12:00',
                is_premium: 0,
                is_trendy: 0,
                is_trending_music: 0,
                is_copyrighted: 0,
                is_new: 0,
                parts: [],
                texts: [],
                objects: []
            },
            categories: [],
            client_parts: [],
            is_text_active: false,
            default_text: {
                text: 'Default text',
                font_name: 'SF Pro',
                font_size: 30,
                text_color: "#ffffff",
                letter_spacing: 0,
                line_spacing: 0,
                alpha: 1,
                text_align: 'center',
                background_color: 'transparent',
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
                direction: 'normal',
                animation_type: 0,
                animation_duration: 0,
                shadow_blur: 0,
                shadow_alpha: 0,
                shadow_color: '#ffffff',
                stroke_size: 0,
                stroke_color: '#000000'
            },
            default_object: {
                id: "b-330x298.svg",
                scale: 1,
                source: '<span>SVG</span>',
                color: '#ffffff',
                alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                animation_type: 0,
                animation_duration: 0,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0
            },
            fonts: [{
                params: "'SF Pro', sans-serif;",
                code: "SF Pro",
                name: "SF Pro"
            }],
            colors: ["#FFFFFF", "#000000", "#F9F7F4", "#FAF5ED", "#F2E8DD", "#F4E4DD", "#D9BEBD", "#C5AEB6", "#E3C2D2", "#F1E0EF", "#D5C9E9", "#C8ACE0", "#E06E97", "#E64F3C", "#AB613E", "#B97959", "#D99056", "#E8BF88", "#EDD8AB", "#FAE389", "#F5C154", "#B78C3A", "#585B3B", "#7B7C41", "#BBB595", "#DFE7DA", "#C0DED3", "#B4C5C9", "#C9D9F0", "#4E63EC", "#4F5E8D", "#725B6E", "#F0F0F0", "#D9D9D9", "#616161", "#3C3C3C"],
            effect_types: [{
                id: 0,
                name: "-"
            }, {
                id: 1,
                name: "Zoom in"
            }, {
                id: 2,
                name: "Zoom out"
            }],
            content_types: [{
                id: 0,
                name: "Любой"
            }, {
                id: 1,
                name: "Фото"
            }, {
                id: 2,
                name: "Видео"
            }],
            text_aligns: [{
                name: "center"
            }, {
                name: "start"
            }, {
                name: "end"
            }],
            animation_types: [{
                id: 0,
                name: "-"
            }, {
                id: 1,
                name: "Fade"
            }, {
                id: 4,
                name: "Zoom In"
            }, {
                id: 18,
                name: "Zoom Out"
            }, {
                id: 6,
                name: "Reveal ↓"
            }, {
                id: 7,
                name: "Reveal ↑"
            }, {
                id: 8,
                name: "Reveal →"
            }, {
                id: 9,
                name: "Reveal ←"
            }, {
                id: 10,
                name: "Float ↓"
            }, {
                id: 11,
                name: "Float ↑"
            }, {
                id: 12,
                name: "Float →"
            }, {
                id: 13,
                name: "Float ←"
            }, {
                id: 14,
                name: "Typewriter"
            }, {
                id: 15,
                name: "Typewriter Fade In"
            }, {
                id: 16,
                name: "Typewriter By Word"
            }, {
                id: 17,
                name: "Typewriter By Word Fade In"
            }],
            default_positions: {
                clientX: undefined,
                clientY: undefined,
                movementX: 0,
                movementY: 0
            },
            positions: [],
            object_positions: [],
            collages: [{
                name: '2',
                data: [{
                    id: '2_1',
                    frames: [{ x: 0, y: 0, width: 1.0, height: 0.5 }, { x: 0, y: 0.5, width: 1.0, height: 0.5 }]
                }, {
                    id: '2_2',
                    frames: [{ x: 0, y: 0, width: 1.0, height: 0.491 }, { x: 0, y: 0.509, width: 1.0, height: 0.491 }]
                }, {
                    id: '2_3',
                    frames: [{ x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474 }, { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474 }]
                }, {
                    id: '2_4',
                    frames: [{ x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '2_5',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 1.0 }, { x: 0.5, y: 0, width: 0.5, height: 1.0 }]
                }, {
                    id: '2_6',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.315 }, { x: 0, y: 0.315, width: 1, height: 0.685 }]
                }, {
                    id: '2_7',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.685 }, { x: 0, y: 0.685, width: 1, height: 0.315 }]
                }, {
                    id: '2_8',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: '2_9',
                    frames: [{ x: 0.2375, y: 0.1223, width: 0.532, height: 0.3647 }, { x: 0.2375, y: 0.5133, width: 0.532, height: 0.3647 }]
                }]
            }, {
                name: '3',
                data: [{
                    id: "3_1",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3334 }, { x: 0, y: 0.6667, width: 1, height: 0.3333 }]
                }, {
                    id: "3_2",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.326783 }, { x: 0, y: 0.336758, width: 1, height: 0.326783 }, { x: 0, y: 0.673216, width: 1, height: 0.326783 }]
                }, {
                    id: "3_3",
                    frames: [{ x: 0.028, y: 0.015625, width: 0.944, height: 0.3125 }, { x: 0.028, y: 0.34375, width: 0.944, height: 0.3125 }, { x: 0.028, y: 0.671875, width: 0.944, height: 0.3125 }]
                }, {
                    id: "3_4",
                    frames: [{
                        x: 0.028,
                        y: 0.015625,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }, {
                        x: 0.028,
                        y: 0.34375,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }, {
                        x: 0.028,
                        y: 0.671875,
                        width: 0.944,
                        height: 0.3125,
                        crop: { type: "roundedCorner", value: 0.027 }
                    }]
                }, {
                    id: "3_5",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6667, width: 0.5, height: 0.3333 }]
                }, {
                    id: "3_6",
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 1 }, { x: 0.3333, y: 0, width: 0.3333, height: 1 }, { x: 0.6667, y: 0, width: 0.3333, height: 1 }]
                }, {
                    id: "3_7",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_8",
                    frames: [{ x: 0, y: 0.5, width: 1, height: 0.5 }, { x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_9",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "3_10",
                    frames: [{ x: 0.0648, y: 0.064, width: 0.4815, height: 0.28125 }, { x: 0.0648, y: 0.35925, width: 0.4815, height: 0.28125 }, { x: 0.0648, y: 0.6564, width: 0.4815, height: 0.28125 }]
                }]
            }, {
                name: '4',
                data: [{
                    id: "4_1",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.25 }, { x: 0, y: 0.25, width: 1, height: 0.25 }, { x: 0, y: 0.5, width: 1, height: 0.25 }, { x: 0, y: 0.75, width: 1, height: 0.25 }]
                }, {
                    id: "4_2",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.24267 }, { x: 0, y: 0.25264333, width: 1, height: 0.24267 }, { x: 0, y: 0.50498666, width: 1, height: 0.24267 }, { x: 0, y: 0.75733, width: 1, height: 0.24267 }]
                }, {
                    id: "4_3",
                    frames: [{ x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875 }, { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875 }]
                }, {
                    id: "4_4",
                    frames: [{ x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }, { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } }]
                }, {
                    id: "4_5",
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0.5, width: 0.5, height: 0.5 }]
                }, {
                    id: "4_6",
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.4948 }, { x: 0.50925, y: 0, width: 0.49075, height: 0.4948 }, { x: 0, y: 0.5052, width: 0.49075, height: 0.4948 }, { x: 0.50925, y: 0.5052, width: 0.49075, height: 0.4948 }]
                }, {
                    id: "4_7",
                    frames: [{ x: 0.0315, y: 0.017708, width: 0.45925, height: 0.410417 }, { x: 0.50925, y: 0.017708, width: 0.45927, height: 0.410417 }, { x: 0.0315, y: 0.438542, width: 0.45927, height: 0.410417 }, { x: 0.50925, y: 0.438542, width: 0.45927, height: 0.410417 }]
                }, {
                    id: "4_8",
                    frames: [{ x: 0.0407, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.5213, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.0407, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }, { x: 0.5213, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } }]
                }, {
                    id: "4_9",
                    frames: [{ x: 0, y: 0, width: 1, height: 0.5 }, { x: 0, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 }]
                }, {
                    id: "4_10",
                    frames: [{ x: 0.01852, y: 0.010717, width: 0.96296, height: 0.48381425 }, { x: 0.01852, y: 0.50546875, width: 0.30864, height: 0.48411425 }, { x: 0.34568, y: 0.50546875, width: 0.30864, height: 0.48411425 }, { x: 0.67284, y: 0.50546875, width: 0.30864, height: 0.48411425 }]
                }, {
                    id: "4_11",
                    frames: [{ x: 0.01852, y: 0.010417, width: 0.400926, height: 0.4843745 }, { x: 0.437966, y: 0.010417, width: 0.543514, height: 0.4843745 }, { x: 0.01852, y: 0.5052085, width: 0.543514, height: 0.4843745 }, { x: 0.580554, y: 0.5052085, width: 0.400926, height: 0.4843745 }]
                }, {
                    id: "4_12",
                    frames: [{ x: 0, y: 0, width: 0.49074, height: 0.4895829967 }, { x: 0.50926, y: 0, width: 0.49074, height: 0.4895829967 }, { x: 0, y: 0.4999996633, width: 1, height: 0.2447917 }, { x: 0, y: 0.7552083, width: 1, height: 0.2447917 }]
                }]
            }, {
                name: '5',
                data: [{
                    id: '5_1',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.2 }, { x: 0, y: 0.2, width: 1, height: 0.2 }, { x: 0, y: 0.4, width: 1, height: 0.2 }, { x: 0, y: 0.6, width: 1, height: 0.2 }, { x: 0, y: 0.8, width: 1, height: 0.2 }]
                }, {
                    id: '5_2',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.1875 }, { x: 0, y: 0.203125, width: 1, height: 0.1875 }, { x: 0, y: 0.40625, width: 1, height: 0.1875 }, { x: 0, y: 0.609375, width: 1, height: 0.1875 }, { x: 0, y: 0.8125, width: 1, height: 0.1875 }]
                }, {
                    id: '5_3',
                    frames: [{ x: 0.028, y: 0.015825, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095 }, { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095 }]
                }, {
                    id: '5_4',
                    frames: [{ x: 0.028, y: 0.015825, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '5_5',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.5, height: 0.3334 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '5_6',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 1 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0.3333, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0, width: 0.3334, height: 1 }]
                }, {
                    id: '5_7',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.6666, y: 0, width: 0.3334, height: 0.3333 }, { x: 0, y: 0.3333, width: 1, height: 0.3333 }, { x: 0, y: 0.6666, width: 1, height: 0.3334 }]
                }, {
                    id: '5_8',
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.4947915 }, { x: 0, y: 0.5052085, width: 0.49075, height: 0.4947915 }, { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.33710567, width: 0.49075, height: 0.32608867 }, { x: 0.50927, y: 0.67361134, width: 0.49075, height: 0.32638867 }]
                }, {
                    id: '5_9',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '5_11',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.5 }, { x: 0.5, y: 0, width: 0.5, height: 0.5 }, { x: 0, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 }, { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 }]
                }]
            }, {
                name: '6',
                data: [{
                    id: '6_1',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.16697 }, { x: 0, y: 0.16637, width: 1, height: 0.16697 }, { x: 0, y: 0.33304, width: 1, height: 0.16697 }, { x: 0, y: 0.49971, width: 1, height: 0.16697 }, { x: 0, y: 0.66638, width: 1, height: 0.16696 }, { x: 0, y: 0.83304, width: 1, height: 0.16696 }]
                }, {
                    id: '6_2',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.15798583 }, { x: 0, y: 0.16790283, width: 1, height: 0.15798583 }, { x: 0, y: 0.33680566, width: 1, height: 0.15798583 }, { x: 0, y: 0.50520849, width: 1, height: 0.15798583 }, { x: 0, y: 0.67361132, width: 1, height: 0.15798583 }, { x: 0, y: 0.84201415, width: 1, height: 0.15798583 }]
                }, {
                    id: '6_3',
                    frames: [{ x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152 }, { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152 }]
                }, {
                    id: '6_4',
                    frames: [{ x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }, { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } }]
                }, {
                    id: '6_14',
                    frames: [{ x: 0, y: 0, width: 0.1667, height: 1 }, { x: 0.1667, y: 0, width: 0.1666, height: 1 }, { x: 0.3333, y: 0, width: 0.1667, height: 1 }, { x: 0.5, y: 0, width: 0.1667, height: 1 }, { x: 0.6667, y: 0, width: 0.1666, height: 1 }, { x: 0.8333, y: 0, width: 0.1667, height: 1 }]
                }, {
                    id: '6_5',
                    frames: [{ x: 0, y: 0, width: 1, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0.6666, width: 0.3333, height: 0.3334 }]
                }, {
                    id: '6_6',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0, width: 0.5, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.5, height: 0.3334 }, { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 }]
                }, {
                    id: '6_7',
                    frames: [{ x: 0, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 }, { x: 0, y: 0.33685567, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.33685567, width: 0.49075, height: 0.32638867 }, { x: 0, y: 0.67321134, width: 0.49075, height: 0.32638867 }, { x: 0.50927, y: 0.67321134, width: 0.49075, height: 0.32638867 }]
                }, {
                    id: '6_8',
                    frames: [{ x: 0, y: 0, width: 0.369444, height: 0.25 }, { x: 0, y: 0.25, width: 0.369444, height: 0.25 }, { x: 0.369444, y: 0, width: 0.630556, height: 0.5 }, { x: 0, y: 0.5, width: 0.630556, height: 0.5 }, { x: 0.630556, y: 0.5, width: 0.369444, height: 0.25 }, { x: 0.630556, y: 0.75, width: 0.369444, height: 0.25 }]
                }, {
                    id: '6_9',
                    frames: [{ x: 0, y: 0, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.2526175, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.505235, width: 0.369444, height: 0.2421475 }, { x: 0, y: 0.7578525, width: 0.369444, height: 0.2421475 }, { x: 0.387964, y: 0, width: 0.612036, height: 0.4947915 }, { x: 0.387964, y: 0.505235, width: 0.612036, height: 0.4947915 }]
                }, {
                    id: '6_10',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.65833 }, { x: 0, y: 0.65833, width: 0.3333, height: 0.34167 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.34167 }, { x: 0.3333, y: 0.34167, width: 0.3333, height: 0.65833 }, { x: 0.6666, y: 0, width: 0.3334, height: 0.65833 }, { x: 0.6666, y: 0.65833, width: 0.3334, height: 0.34167 }]
                }, {
                    id: '6_11',
                    frames: [{ x: 0, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0.33950667, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0.67851334, y: 0, width: 0.32098667, height: 0.32638867 }, { x: 0, y: 0.33685867, width: 0.32098667, height: 0.32638867 }, { x: 0, y: 0.67321734, width: 0.32098667, height: 0.32638867 }, { x: 0.33950667, y: 0.33685867, width: 0.66049333, height: 0.66314133 }]
                }, {
                    id: '6_12',
                    frames: [{ x: 0, y: 0, width: 0.68611, height: 0.3333 }, { x: 0.68611, y: 0, width: 0.31389, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.31389, height: 0.3333 }, { x: 0.31389, y: 0.3333, width: 0.68611, height: 0.3333 }, { x: 0, y: 0.6666, width: 0.68611, height: 0.3334 }, { x: 0.68611, y: 0.6666, width: 0.31389, height: 0.3334 }]
                }, {
                    id: '6_13',
                    frames: [{ x: 0.084185, y: 0.14375, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.14375, width: 0.391667, height: 0.22013867 }, { x: 0.084185, y: 0.38993067, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.38993067, width: 0.391667, height: 0.22013867 }, { x: 0.084185, y: 0.63611134, width: 0.391667, height: 0.22013867 }, { x: 0.522148, y: 0.63611134, width: 0.391667, height: 0.22013867 }]
                }]
            }, {
                name: '9',
                data: [{
                    id: '9_1',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 }, { x: 0.6666, y: 0, width: 0.3333, height: 0.3333 }, { x: 0, y: 0.3333, width: 0.3333, height: 0.3334 }, { x: 0.3333, y: 0.3333, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0.3333, width: 0.3333, height: 0.3334 }, { x: 0, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 }, { x: 0.6666, y: 0.6666, width: 0.3333, height: 0.3334 }]
                }]
            }, {
                name: '10',
                data: [{
                    id: '10_1',
                    frames: [{ x: 0, y: 0, width: 0.5, height: 0.2 }, { x: 0.5, y: 0, width: 0.5, height: 0.2 }, { x: 0, y: 0.2, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.2, width: 0.5, height: 0.2 }, { x: 0, y: 0.4, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.4, width: 0.5, height: 0.2 }, { x: 0, y: 0.6, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.6, width: 0.5, height: 0.2 }, { x: 0, y: 0.8, width: 0.5, height: 0.2 }, { x: 0.5, y: 0.8, width: 0.5, height: 0.2 }]
                }, {
                    id: '10_2',
                    frames: [{ x: 0, y: 0, width: 0.2, height: 0.5 }, { x: 0, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.2, y: 0, width: 0.2, height: 0.5 }, { x: 0.2, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.4, y: 0, width: 0.2, height: 0.5 }, { x: 0.4, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.6, y: 0, width: 0.2, height: 0.5 }, { x: 0.6, y: 0.5, width: 0.2, height: 0.5 }, { x: 0.8, y: 0, width: 0.2, height: 0.5 }, { x: 0.8, y: 0.5, width: 0.2, height: 0.5 }]
                }]
            }, {
                name: '12',
                data: [{
                    id: '12_1',
                    frames: [{ x: 0, y: 0, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0, width: 0.3333, height: 0.25 }, { x: 0, y: 0.25, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0.25, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0.25, width: 0.3333, height: 0.25 }, { x: 0, y: 0.5, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0.5, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0.5, width: 0.3333, height: 0.25 }, { x: 0, y: 0.75, width: 0.3333, height: 0.25 }, { x: 0.3333, y: 0.75, width: 0.3333, height: 0.25 }, { x: 0.6666, y: 0.75, width: 0.3333, height: 0.25 }]
                }, {
                    name: '20',
                    data: [{
                        id: '20_1',
                        frames: [{ x: 0, y: 0, width: 0.25, height: 0.2 }, { x: 0.25, y: 0, width: 0.25, height: 0.2 }, { x: 0.5, y: 0, width: 0.25, height: 0.2 }, { x: 0.75, y: 0, width: 0.25, height: 0.2 }, { x: 0, y: 0.2, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.2, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.2, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.2, width: 0.25, height: 0.2 }, { x: 0, y: 0.4, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.4, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.4, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.4, width: 0.25, height: 0.2 }, { x: 0, y: 0.6, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.6, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.6, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.6, width: 0.25, height: 0.2 }, { x: 0, y: 0.8, width: 0.25, height: 0.2 }, { x: 0.25, y: 0.8, width: 0.25, height: 0.2 }, { x: 0.5, y: 0.8, width: 0.25, height: 0.2 }, { x: 0.75, y: 0.8, width: 0.25, height: 0.2 }]
                    }]
                }]
            }]
        };
    },

    watch: {
        is_playing: function is_playing(val) {
            if (val) {
                this.startInterval();
            } else {
                clearInterval(this.interval);
            }
        }
    },
    created: function created() {

        var self = this;

        self.getResources();

        self.waiting = true;

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/categories/', {
            'params': {},
            'headers': {
                'Authorization': 'Bearer ' + self.token
            }
        }).then(function (response) {
            self.waiting = false;
            self.categories = response.data;
        }).catch(function (error) {
            self.waiting = false;
            console.log(error);
        });
    },
    computed: {
        graphicsUrl: function graphicsUrl() {
            return this.$graphicsUrl;
        },
        sumParts: function sumParts() {
            var sum = 0;
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(this.client_parts, function (p) {
                if (!p.cutout_only) {
                    var duration = parseFloat(p.duration);
                    duration = isNaN(duration) ? 0 : duration;

                    // Collages block
                    if (p.collage_type !== 0) {
                        var startTime = parseFloat(p.start_time);
                        startTime = isNaN(startTime) ? 0 : startTime;

                        var collageDuration = startTime + duration;
                        duration = sum > collageDuration ? 0 : collageDuration - sum;
                    }

                    sum += duration;
                }
            });

            return sum.toFixed(2);
        },
        sortedFonts: function sortedFonts() {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(this.fonts, function (f) {
                return f.name;
            });
        },
        versions: function versions() {
            var result = [];
            var start = 9.0 * 10;
            var end = this.$endVersion * 10;

            for (var i = start; i <= end; i++) {
                result.push((i / 10).toFixed(1));
            }

            return result;
        }
    },
    methods: {
        text_html: function text_html(index) {

            var textModel = this.template.texts[index];

            var text = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.fonts, function (f) {
                return f.name === textModel.font_name;
            });

            var line_height = parseFloat(textModel.font_size) + parseFloat(textModel.line_spacing);
            var alpha = textModel.alpha;

            var direction = '';
            if (textModel.direction == 'vertical') {
                direction = '  writing-mode: vertical-rl;\n' + '  text-orientation: upright;\n';
            }

            var offset = 4 / 88 * textModel.font_size;
            var blur = 0.29 * textModel.font_size / 88 * textModel.shadow_blur;
            var shadow = 'text-shadow: ' + offset + 'px ' + offset + 'px ' + blur + 'px ' + textModel.shadow_color + this.convertAlphaToHex(textModel.shadow_alpha) + ';';

            return '<span style="color: ' + textModel.text_color + '; ' + 'background-color: ' + textModel.background_color + '; ' + 'font-size: ' + textModel.font_size + 'px; ' + 'letter-spacing: ' + textModel.letter_spacing + 'px; ' + 'opacity: ' + alpha + '; ' + 'line-height: ' + line_height + 'px; ' + 'transform: rotate( ' + textModel.angle + 'deg); ' + 'display: block;' + 'border: 1px solid white;' + 'padding: 5px;' + direction + shadow + 'text-align: ' + textModel.text_align + '; ' + 'z-index: ' + textModel.z_index + '; ' + 'font-family:' + text.params + ';">' + textModel.text + '</span>';
        },
        object_html: function object_html(index) {
            return this.renderSvgObjectHtml(this.template.objects[index]);
        },
        image_html: function image_html(index) {
            var objectModel = this.template.objects[index];

            if (!objectModel.source || !objectModel.dimensions) {
                return "";
            }

            var width = objectModel.dimensions.width;
            var height = objectModel.dimensions.height;

            width = width * parseFloat(objectModel.scale);
            height = height * parseFloat(objectModel.scale);

            var img = '<img src="' + this.objectPlayerSrc(objectModel) + '">';

            var style = ' style="width: ' + width + 'px; height: ' + height + 'px; opacity: ' + objectModel.alpha + '; padding: 0px; transform: rotate(' + objectModel.angle + 'deg); z-index: ' + objectModel.z_index + '; display: block;"';

            img = this.insertAt(img, style, 5);

            return img;
        },

        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        insertAt: function insertAt(str, sub, pos) {
            return '' + str.slice(0, pos) + sub + str.slice(pos);
        },
        formatStartTime: function formatStartTime(event, index, object) {
            this.client_parts[index][object] = this.client_parts[index][object].replace(',', '.');
        },
        formatDuration: function formatDuration(event, index) {
            this.client_parts[index].duration = this.client_parts[index].duration.replace(',', '.');
        },
        formatSpeed: function formatSpeed(event, index) {
            this.client_parts[index].speed = this.client_parts[index].speed.replace(',', '.');
        },
        formatVideoDuration: function formatVideoDuration(event, index) {
            this.template.duration = this.template.duration.replace(',', '.');
        },
        addText: function addText() {
            var copy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var self = this;

            if (copy !== false) {
                var copiedText = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.template.texts[self.active_text]));
                copiedText.text = 'Default text';

                self.template.texts.push(copiedText);

                var positions = self.positions[self.active_text];
                positions.clientX = positions.clientX ? positions.clientX + 5 : positions.clientX;
                positions.clientY = positions.clientY ? positions.clientY + 5 : positions.clientY;
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(positions)));

                setTimeout(function () {

                    self.$refs.draggableContainer[self.template.texts.length - 1].style.left = self.$refs.draggableContainer[self.active_text].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = self.$refs.draggableContainer[self.active_text].offsetTop + 5 + 'px';

                    self.active_text = self.template.texts.length - 1;
                    self.active_type = 'text';

                    //console.log(self.$refs.draggableContainer[self.template.texts.length - 1].style.left);
                }, 100);
            } else {
                self.template.texts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.default_text)));
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                self.active_text = self.template.texts.length - 1;
                self.active_type = 'text';
            }
        },
        addObject: function addObject(object) {
            var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            // if copied
            if (copy !== false) {
                var copiedObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.template.objects[self.active_object]));

                self.template.objects.push(copiedObject);
                self.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.object_positions[self.active_object])));

                setTimeout(function () {

                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.left = self.$refs.draggableContainer2[self.active_object].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.top = self.$refs.draggableContainer2[self.active_object].offsetTop + 5 + 'px';

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object';
                }, 100);
            } else {
                self.placeGraphicObject(object);
            }

            this.active_object_category = 'Arrows';
        },
        changeObject: function changeObject() {
            this.is_object_changing = true;
            this.show_svg_modal = true;
        },
        addCollage: function addCollage(e) {
            // 888
            var data = e.target.dataset.params;
            var params = data.split(';');
            var id = params[0];
            var part = params[1];
            var x = params[2];
            var y = params[3];
            var w = params[4];
            var h = params[5];

            this.client_parts[this.active_part_index].collage_type = id + ';' + part;
            this.client_parts[this.active_part_index].frame = {
                x: parseFloat(x),
                y: parseFloat(y),
                w: parseFloat(w),
                h: parseFloat(h)
            };

            this.previous_collage_id = id;

            this.show_collage_modal = false;
        },
        convertCollageTypeToNewFormat: function convertCollageTypeToNewFormat(oldType) {

            if (oldType.toString().indexOf('_') > 0) return oldType;

            var oldTypeName = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.collage_types, function (c) {
                return c.id === parseInt(oldType);
            }).name;
            var oldCategory = oldTypeName.split('/');
            var collageCategory = parseInt(oldCategory[1]) === 6 ? 6 : 1;

            return oldCategory[1] + '_' + collageCategory + ';' + oldCategory[0];
        },
        convertAlphaToHex: function convertAlphaToHex(alpha) {
            if (alpha < 0.08) return '00';
            return Math.floor(alpha * 255).toString(16);
        },
        selectText: function selectText(text) {
            this.active_text = text;
            this.active_type = 'text';
        },
        selectObject: function selectObject(object) {
            this.active_object = object;
            this.active_type = 'object';
        },
        selectObjectCategory: function selectObjectCategory(category) {
            this.active_object_category = category;
        },
        selectCollageCategory: function selectCollageCategory(category) {
            this.active_collage_category = category;
        },
        removeCollageFromPart: function removeCollageFromPart(index) {
            var self = this;

            if (confirm("Подтверждение удаления коллажа")) {
                self.client_parts[index].collage_type = 0;
                self.client_parts[index].frame = null;

                console.log(self.client_parts[index]);
            }
        },
        removeText: function removeText(index) {
            var self = this;

            if (self.template.texts.length < 2) {
                var notification = {
                    template: '<span><b>\u0414\u043B\u044F \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u0442\u0435\u043A\u0441\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0447\u0435\u043A\u0431\u043E\u043A\u0441 "\u041D\u0430\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430"</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'warning'
                });

                return;
            }

            if (confirm("Подтверждение удаления текста: " + self.template.texts[index].text)) {
                self.active_text = 0;
                self.active_type = 'text';

                self.template.texts = self.template.texts.filter(function (t, i) {
                    return i !== index;
                });
            }
        },
        removeObject: function removeObject(index) {
            var self = this;

            if (self.template.objects.length < 2) {
                var notification = {
                    template: '<span><b>\u0414\u043B\u044F \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0447\u0435\u043A\u0431\u043E\u043A\u0441 "\u041D\u0430\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430"</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'warning'
                });

                return;
            }

            if (confirm("Подтверждение удаления объекта")) {
                self.active_object = 0;
                self.active_type = 'object';

                self.template.objects = self.template.objects.filter(function (t, i) {
                    return i !== index;
                });
            }
        },
        toggleText: function toggleText() {
            var self = this;

            if (self.is_text_active) {
                self.template.texts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.default_text)));
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                setTimeout(function () {
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = '0px';

                    self.video = self.$refs.videoContainer;

                    self.video.addEventListener("playing", function () {
                        console.log('play ' + self.video.currentTime);

                        self.is_playing = true;
                    });

                    self.video.addEventListener("timeupdate", function () {
                        self.checkElementsVisibility(self.video.currentTime);
                    });

                    self.video.addEventListener("pause", function () {
                        console.log('pause ' + self.video.currentTime);

                        self.is_playing = false;
                    });
                }, 500);
            } else {
                self.template.texts = [];
                self.positions = [];
            }
        },
        toggleBackground: function toggleBackground() {
            if (this.template.texts[this.active_text].background_color === 'transparent') {
                this.setColor('#FFFFFF', 'background');
            } else {
                this.setColor('transparent', 'background');
            }
        },

        setTextPosition: function setTextPosition(x, y) {
            if (x) {
                this.template.texts[this.active_text].position_x = x;

                var centerX = 0.5 * 360 - this.$refs.draggableContainer[this.active_text].clientWidth / 2;

                this.$refs.draggableContainer[this.active_text].style.left = centerX + 'px';
            }

            if (y) {
                this.template.texts[this.active_text].position_y = y;

                var centerY = 0.5 * 640 - this.$refs.draggableContainer[this.active_text].clientHeight / 2;

                this.$refs.draggableContainer[this.active_text].style.top = centerY + 'px';
            }
        },
        setObjectPosition: function setObjectPosition(x, y) {
            if (x) {
                this.template.objects[this.active_object].position_x = x;

                var centerX = 0.5 * 360 - this.$refs.draggableContainer2[this.active_object].clientWidth / 2;

                this.$refs.draggableContainer2[this.active_object].style.left = centerX + 'px';
            }

            if (y) {
                this.template.objects[this.active_object].position_y = y;

                var centerY = 0.5 * 640 - this.$refs.draggableContainer2[this.active_object].clientHeight / 2;

                this.$refs.draggableContainer2[this.active_object].style.top = centerY + 'px';
            }
        },
        changeContentType: function changeContentType(index, type) {
            this.client_parts[index].content = type === 2 ? '#000000' : null;
        },
        changeEffectType: function changeEffectType(index, type) {

            if (type === 0) {
                return;
            }

            var from = 1;
            var to = 0.85;
            if (type === 2) {
                from = 0.85;
                to = 1;
            }

            this.client_parts[index].effect_values = {
                from: from,
                to: to,
                x: 0.5,
                y: 0.5
            };
        },
        changeEffectPosition: function changeEffectPosition(event, index) {
            var offsetX = void 0;
            var offsetY = void 0;

            if (event.target.className !== 'effect-preview') {
                var parent = event.target.parentElement;
                if (parent.className !== 'effect-preview') {
                    parent = parent.parentElement;
                } else {}

                offsetX = 0;
                offsetY = 0;
            } else {
                offsetX = event.offsetX < 0 ? 0 : event.offsetX;
                offsetY = event.offsetY < 0 ? 0 : event.offsetY;
            }

            this.client_parts[index].effect_values.x = (offsetX / 50).toFixed(2);
            if (this.client_parts[index].effect_values.x > 1) {
                this.client_parts[index].effect_values.x = 1;
            }

            this.client_parts[index].effect_values.y = (offsetY / 89).toFixed(2);
            if (this.client_parts[index].effect_values.y > 1) {
                this.client_parts[index].effect_values.y = 1;
            }
        },
        setColor: function setColor(color, type) {
            if (type === 'color') {
                this.template.texts[this.active_text].text_color = color;
            }

            if (type === 'background') {
                this.template.texts[this.active_text].background_color = color;
            }
        },
        setObjColor: function setObjColor(color) {
            this.template.objects[this.active_object].color = color;
        },
        changeVideoCount: function changeVideoCount(value) {
            var self = this;
            var oldParts = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.client_parts));

            if (isNaN(parseInt(value))) {
                return oldParts;
            }

            var newParts = [];
            for (var i = 0; i < value; i++) {
                newParts.push({
                    duration: '',
                    speed: '1.0',
                    effect_type: 0,
                    content_type: 0,
                    effect_values: { x: 0.5, y: 0.5 },
                    collage_type: 0,
                    frame: 0,
                    start_time: 0
                });
            }

            for (var _i = 0; _i < oldParts.length; _i++) {
                for (var j = 0; j < newParts.length; j++) {
                    if (_i === j) {
                        newParts[j] = oldParts[_i];
                    }
                }
            }

            this.client_parts = newParts;
        },

        showPreview: function showPreview() {
            this.is_playing = false;
            this.checkElementsVisibility(0);
            this.video.load();
        },
        checkElementsVisibility: function checkElementsVisibility(currentTime) {
            var self = this;

            var elements = [self.template.texts, self.template.objects];
            for (var o = 0; o < elements.length; o++) {

                var element = elements[o];
                for (var i = 0; i < element.length; i++) {
                    if (currentTime === 0) {
                        element[i].is_visible = 1;
                    } else {
                        if (parseFloat(element[i].time_start) < currentTime && parseFloat(element[i].time_end) > currentTime) {
                            element[i].is_visible = 1;
                        } else if (parseFloat(element[i].time_start) < currentTime && element[i].time_end === "") {
                            element[i].is_visible = 1;
                        } else {
                            element[i].is_visible = 0;
                        }
                    }
                }
            }
        },
        startInterval: function startInterval() {
            var self = this;

            this.interval = setInterval(function () {
                self.checkElementsVisibility(self.video.currentTime);
                if (self.template.duration && self.video.currentTime >= self.template.duration) {
                    self.video.load();
                }
            }, 30);
        },
        goBack: function goBack() {
            window.history.back();
        },
        getResources: function getResources() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/resources/', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.server_effects = response.data.effects;
                self.server_graphics = response.data.graphics;
                self.server_filters = response.data.filters;
                self.server_fonts = response.data.fonts;

                self.appendFonts();
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        appendFonts: function appendFonts() {

            var newStyle = document.createElement('style');
            for (var i = 0; i < this.server_fonts.length; i++) {
                var font = this.server_fonts[i];

                newStyle.appendChild(document.createTextNode('\n                    @font-face {\n                      font-family: \'' + font.name + '\';\n                      src: url(\'/static/fonts/' + font.src + '\');\n                    }\n                    '));

                this.fonts.push({
                    params: '\'' + font.name + '\', sans-serif;',
                    code: font.name,
                    name: font.name
                });
            }

            document.head.appendChild(newStyle);
        },
        showSVGModal: function showSVGModal() {
            this.show_svg_modal = true;
        },
        closeSVGModal: function closeSVGModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_svg_modal = false;
                this.is_object_changing = false;
                this.active_object_category = 'Arrows';
            }
        },
        // 888
        showCollageModal: function showCollageModal(index) {
            this.active_part_index = index;
            this.show_collage_modal = true;
        },
        closeCollageModal: function closeCollageModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_collage_modal = false;
            }
        },
        save: function save() {
            var _this = this;

            var self = this;

            var template = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.template));
            template.parts = self.client_parts;

            for (var i = 0; i < template.parts.length; i++) {
                if (template.parts[i].duration === null || template.parts[i].speed === null) {
                    var notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u043E\u0432 \u0432\u0438\u0434\u0435\u043E</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (template.song_insta) {
                var regex = /(\d{14,22})/gi;
                var match = regex.exec(template.song_insta);

                var reelId = match ? match[0] : null;
                template.song_insta = reelId;

                if (!reelId) {
                    var _notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 Reels Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (template.song_tiktok) {
                var parts = template.song_tiktok.split('/');

                if (parts.length > 3 && parts[3].length > 5) {
                    template.song_tiktok = parts[3];
                } else {

                    var _notification2 = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 TikTok Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification2,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (Math.abs(self.sumParts - template.duration) > 0.05) {

                var _notification3 = {
                    template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u043E\u0432 \u0432\u0438\u0434\u0435\u043E</b></span>'
                };

                self.$notifications.notify({
                    component: _notification3,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                return false;
            }

            if (this.video) {
                this.video.load();
            }

            self.waiting = true;

            setTimeout(function () {

                if (_this.is_text_active) {

                    for (var _i2 = 0; _i2 < self.template.texts.length; _i2++) {

                        var activeText = template.texts[_i2];

                        if (activeText.position_x !== 0.5) {
                            var centerX = _this.$refs.draggableContainer[_i2].offsetLeft + _this.$refs.draggableContainer[_i2].clientWidth / 2;

                            activeText.position_x = parseFloat((centerX / 360).toFixed(4));
                        }

                        if (activeText.position_y !== 0.5) {
                            var centerY = _this.$refs.draggableContainer[_i2].offsetTop + _this.$refs.draggableContainer[_i2].clientHeight / 2;

                            activeText.position_y = parseFloat((centerY / 640).toFixed(4));
                        }

                        activeText.letter_spacing = activeText.letter_spacing == "" ? 0 : activeText.letter_spacing;
                        activeText.line_spacing = activeText.line_spacing == "" ? 0 : activeText.line_spacing;
                        activeText.angle = activeText.angle == "" ? 0 : activeText.angle;
                        activeText.z_index = activeText.z_index == "" ? 0 : activeText.z_index;

                        activeText.font_size = parseFloat(activeText.font_size);
                        activeText.alpha = parseFloat(activeText.alpha);
                        activeText.letter_spacing = parseFloat(activeText.letter_spacing);
                        activeText.line_spacing = parseFloat(activeText.line_spacing);
                        activeText.time_start = parseFloat(activeText.time_start);
                        activeText.shadow_alpha = parseFloat(activeText.shadow_alpha);
                        activeText.shadow_blur = parseInt(activeText.shadow_blur);
                        activeText.animation_type = parseInt(activeText.animation_type);
                        activeText.animation_duration = parseFloat(activeText.animation_duration);
                        activeText.angle = parseInt(activeText.angle);
                        activeText.z_index = parseInt(activeText.z_index);
                        activeText.time_end = activeText.time_end === "" ? "" : parseFloat(activeText.time_end);

                        template.texts[_i2] = activeText;
                    }

                    for (var _i3 = 0; _i3 < self.template.objects.length; _i3++) {

                        var activeObj = template.objects[_i3];

                        activeObj.position_x = parseFloat(activeObj.position_x);
                        activeObj.position_y = parseFloat(activeObj.position_y);

                        activeObj.scale = parseFloat(activeObj.scale);
                        activeObj.alpha = parseFloat(activeObj.alpha);
                        activeObj.time_start = parseFloat(activeObj.time_start);
                        activeObj.animation_type = parseInt(activeObj.animation_type);
                        activeObj.animation_duration = parseFloat(activeObj.animation_duration);
                        activeObj.angle = activeObj.angle == "" ? 0 : parseInt(activeObj.angle);
                        activeObj.z_index = activeObj.z_index == "" ? 0 : parseInt(activeObj.z_index);
                        activeObj.time_end = activeObj.time_end === "" ? "" : parseFloat(activeObj.time_end);

                        delete activeObj.source;

                        template.objects[_i3] = activeObj;
                    }
                } else {
                    template.texts = [];
                    template.objects = [];
                }

                if (!template.is_copyrighted) {
                    template.song_insta = "";
                    template.song_tiktok = "";
                }

                template.release_date = template.release_date + ' ' + template.release_time + ':00';

                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_this.$hostname + '/admin/created/create', template, {
                    'headers': {
                        'Authorization': 'Bearer ' + _this.token
                    }
                }).then(function (response) {
                    var notification = {
                        template: '<span><b>\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.waiting = false;

                    self.$router.push('/memories');
                }).catch(function (error) {
                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;
                });
            }, 200);
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.template[data.file_type] = data.url;
                self.template[data.file_type + '_full'] = data.url_full;
                self.template[data.file_type + '_size'] = data.filesize;

                if (self.video) {
                    self.showPreview();
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        dragMouseDown: function dragMouseDown(event) {
            event.preventDefault();

            var path = event.composedPath ? event.composedPath() : event.path;
            var id = null;
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(path, function (p) {
                if (p.className === 'draggable-container') {
                    id = p.id;
                }
            });

            if (!id) {
                return;
            }

            if (id.indexOf('o') > -1) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'object';

                this.object_positions[this.draggable_index].clientX = event.clientX;
                this.object_positions[this.draggable_index].clientY = event.clientY;

                document.onmousemove = this.objectDrag;
                document.onmouseup = this.closeDragObject;
            } else {
                this.draggable_index = id;
                this.draggable_type = 'text';

                this.positions[this.draggable_index].clientX = event.clientX;
                this.positions[this.draggable_index].clientY = event.clientY;

                document.onmousemove = this.textDrag;
                document.onmouseup = this.closeDragText;
            }
        },
        elementDrag: function elementDrag(event) {
            event.preventDefault();

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX;
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY;
            this.positions[this.draggable_index].clientX = event.clientX;
            this.positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer[this.draggable_index].style.top = this.$refs.draggableContainer[this.draggable_index].offsetTop - this.positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer[this.draggable_index].style.left = this.$refs.draggableContainer[this.draggable_index].offsetLeft - this.positions[this.draggable_index].movementX + 'px';
        },
        textDrag: function textDrag(event) {
            event.preventDefault();

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX;
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY;
            this.positions[this.draggable_index].clientX = event.clientX;
            this.positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer[this.draggable_index].style.top = this.$refs.draggableContainer[this.draggable_index].offsetTop - this.positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer[this.draggable_index].style.left = this.$refs.draggableContainer[this.draggable_index].offsetLeft - this.positions[this.draggable_index].movementX + 'px';

            var centerX = this.$refs.draggableContainer[this.draggable_index].offsetLeft + this.$refs.draggableContainer[this.draggable_index].clientWidth / 2;
            var centerY = this.$refs.draggableContainer[this.draggable_index].offsetTop + this.$refs.draggableContainer[this.draggable_index].clientHeight / 2;

            this.template.texts[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.texts[this.draggable_index].position_y = parseFloat((centerY / 640).toFixed(4));
        },
        closeDragText: function closeDragText() {
            document.onmouseup = null;
            document.onmousemove = null;

            this.draggable_index = null;

            return false;
        },

        objectDrag: function objectDrag(event) {
            event.preventDefault();

            this.object_positions[this.draggable_index].movementX = this.object_positions[this.draggable_index].clientX - event.clientX;
            this.object_positions[this.draggable_index].movementY = this.object_positions[this.draggable_index].clientY - event.clientY;
            this.object_positions[this.draggable_index].clientX = event.clientX;
            this.object_positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer2[this.draggable_index].style.top = this.$refs.draggableContainer2[this.draggable_index].offsetTop - this.object_positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer2[this.draggable_index].style.left = this.$refs.draggableContainer2[this.draggable_index].offsetLeft - this.object_positions[this.draggable_index].movementX + 'px';

            this.syncObjectModelFromElement(this.draggable_index);
        },
        closeDragObject: function closeDragObject() {
            document.onmouseup = null;
            document.onmousemove = null;

            this.draggable_index = null;

            return false;
        },
        renderCollagePart: function renderCollagePart(index) {
            var layout = index.split(';');

            if (index) {
                var category = layout[0].split('_')[0];
                var collageId = layout[0];
                var partId = parseInt(layout[1]);
                var collages = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.collages, function (c) {
                    return c.name === category;
                });
                var collage = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(collages.data, function (c) {
                    return c.id === collageId;
                });

                return this.renderCollage(collage, 0.7, partId - 1);
            }
        },
        renderCollage: function renderCollage(layout) {
            var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var partId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


            var palette = ["#FFDFBA", "#FFFFBA", "#BAFFC9", "#BAE1FF", "#D7C4F3", "#C1F0F6", "#FAD6A5", "#F7C5CC", "#C9E4DE"];

            var containerStyle = "position:relative;" + ('width:' + 108 * scale + 'px;height:' + 192 * scale + 'px;') + "background:#f7f7f7;overflow:hidden;" + ('border: 1px solid ' + (partId === null && this.previous_collage_id === layout.id ? 'red' : '#000') + ';') + "box-shadow:0 6px 20px rgba(0,0,0,.08);";

            var html = '<div style="' + containerStyle + '">';

            for (var i = 0; i < layout.frames.length; i++) {
                var f = layout.frames[i];

                var left = f.x * 108 * scale;
                var top = f.y * 192 * scale;
                var width = f.width * 108 * scale;
                var height = f.height * 192 * scale;

                var color = palette[i % palette.length];

                var radiusStyle = "0px";
                if (f.crop && f.crop.type === "roundedCorner") {
                    var v = f.crop.value;
                    if (v < 0) v = 0;
                    if (v > 1) v = 1;
                    radiusStyle = v * Math.min(width, height) / 2 + "px";
                }

                var frameStyle = "position:absolute;" + "left:" + left + "px;top:" + top + "px;" + "width:" + width + "px;height:" + height + "px;" + "background:" + color + ";" + "border-radius:" + radiusStyle + ";overflow:hidden;" + "display:flex;align-items:center;justify-content:center;" + "color:rgba(0,0,0,.5);" + "font:600 12px sans-serif;";

                var params = layout.id + ';' + (i + 1) + ';' + f.x + ';' + f.y + ';' + f.width + ';' + f.height;

                html += '\n                          <div\n                            data-params="' + params + '"\n                            class="collage-item-part ' + (partId === i ? 'diagonal-lines' : '') + '"\n                            style="' + frameStyle + '"\n                          >\n                            ' + (i + 1) + '\n                          </div>\n                        ';
            }

            html += "</div>";
            return html;
        }
    }
});

/***/ }),

/***/ "pJH4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var TRANSPARENT_PIXEL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            gifFrameCache: {},
            gifFramePending: {}
        };
    },

    methods: {
        isGifSrc: function isGifSrc(src) {
            if (!src || typeof src !== 'string') {
                return false;
            }

            return (/\.gif$/i.test(src.split('?')[0])
            );
        },
        isSvgSrc: function isSvgSrc(src) {
            if (!src || typeof src !== 'string') {
                return false;
            }

            return (/\.svg$/i.test(src.split('?')[0])
            );
        },
        objectPlayerSrc: function objectPlayerSrc(object) {
            if (!object || !object.id) {
                return '';
            }

            if (this.isGifSrc(object.id)) {
                return this.gifFrameCache[object.id] || TRANSPARENT_PIXEL;
            }

            return this.graphicsUrl + object.id;
        },
        ensureFrozenGif: function ensureFrozenGif(filename) {
            if (!this.isGifSrc(filename)) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve('');
            }

            if (this.gifFrameCache[filename]) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(this.gifFrameCache[filename]);
            }

            return this.freezeGifFrame(filename);
        },
        freezeGifFrame: function freezeGifFrame(filename) {
            var _this = this;

            if (this.gifFramePending[filename]) {
                return this.gifFramePending[filename];
            }

            var fileUrl = this.graphicsUrl + filename;
            var pending = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$hostname + '/admin/services/graphics/file', {
                params: {
                    url: fileUrl
                },
                headers: {
                    Authorization: 'Bearer ' + (this.token || localStorage.getItem('token'))
                },
                responseType: 'blob'
            }).then(function (response) {
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                    var blobUrl = URL.createObjectURL(response.data);
                    var img = new Image();

                    img.onload = function () {
                        try {
                            var canvas = document.createElement('canvas');
                            canvas.width = img.naturalWidth || img.width;
                            canvas.height = img.naturalHeight || img.height;
                            canvas.getContext('2d').drawImage(img, 0, 0);
                            var dataUrl = canvas.toDataURL('image/png');
                            URL.revokeObjectURL(blobUrl);
                            _this.$set(_this.gifFrameCache, filename, dataUrl);
                            resolve(dataUrl);
                        } catch (e) {
                            URL.revokeObjectURL(blobUrl);
                            _this.$set(_this.gifFrameCache, filename, fileUrl);
                            resolve(fileUrl);
                        }
                    };

                    img.onerror = function () {
                        URL.revokeObjectURL(blobUrl);
                        _this.$set(_this.gifFrameCache, filename, fileUrl);
                        resolve(fileUrl);
                    };

                    img.src = blobUrl;
                });
            }).catch(function () {
                _this.$set(_this.gifFrameCache, filename, fileUrl);
                return fileUrl;
            });

            this.$set(this.gifFramePending, filename, pending);

            return pending;
        },
        loadRasterGraphic: function loadRasterGraphic(src) {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var img = new Image();

                img.onload = function () {
                    var size = {
                        width: img.width,
                        height: img.height
                    };

                    if (_this2.isGifSrc(src)) {
                        _this2.ensureFrozenGif(src).then(function () {
                            return resolve(size);
                        }, function () {
                            return resolve(size);
                        });
                        return;
                    }

                    resolve(size);
                };

                img.onerror = function () {
                    return reject(new Error('graphic load failed'));
                };
                img.src = _this2.graphicsUrl + src;
            });
        },
        placeGraphicObject: function placeGraphicObject(object) {
            var _this3 = this;

            var replacing = this.is_object_changing;
            this.is_object_changing = false;
            this.show_svg_modal = false;

            var addNew = function addNew(source, dimensions) {
                _this3.default_object.z_index = (_this3.template.texts.length || 0) + (_this3.template.objects.length || 0) + 1;
                var newObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.default_object));
                newObj.id = object.src;
                newObj.source = source;
                if (dimensions) {
                    newObj.dimensions = dimensions;
                }
                _this3.template.objects.push(newObj);
                _this3.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.default_positions)));
                _this3.active_object = _this3.template.objects.length - 1;
                _this3.active_type = 'object';
                _this3.$nextTick(function () {
                    if (typeof _this3.applyObjectContainerPosition === 'function') {
                        _this3.applyObjectContainerPosition(_this3.active_object);
                    }
                });
            };

            if (!this.isSvgSrc(object.src)) {
                return this.loadRasterGraphic(object.src).then(function (size) {
                    if (replacing) {
                        _this3.replaceActiveGraphic(object, 'Image', size.width, size.height, true);
                    } else {
                        addNew('Image', { width: size.width, height: size.height });
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }

            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$hostname + '/admin/services/graphics/svg/source', {
                params: {
                    url: this.graphicsUrl + object.src
                },
                headers: {
                    Authorization: 'Bearer ' + (this.token || localStorage.getItem('token'))
                }
            }).then(function (response) {
                if (replacing) {
                    var size = _this3.getGraphicSourceSize(response.data);
                    _this3.replaceActiveGraphic(object, response.data, size ? size.width : 0, size ? size.height : 0, false);
                } else {
                    addNew(response.data);
                }
            }).catch(function (error) {
                _this3.loading = false;
                console.log(error);
            });
        }
    }
});

/***/ }),

/***/ "pOGF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateGraphic',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            object: {
                status: 0,
                category_id: 0,
                src: null,
                src_full: null,
                is_premium: 0,
                no_color: 1,
                sort: 1
            },
            categories: []
        };
    },

    created: function created() {
        this.getCategories();
    },
    computed: {
        graphicsUrl: function graphicsUrl() {
            return this.$graphicsUrl;
        }
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/graphics');
        },
        isSvgSrc: function isSvgSrc(src) {
            if (!src || typeof src !== 'string') {
                return false;
            }

            return (/\.svg$/i.test(src.split('?')[0])
            );
        },
        getCategories: function getCategories() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/graphics/categories', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {
                self.categories = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var object = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.object));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/graphics/create', object, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0421\u0442\u0438\u043A\u0435\u0440 \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/graphics');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();
            var file = event.target.files[0];

            self.waiting = true;

            if (file && !self.isSvgSrc(file.name)) {
                self.object.no_color = 1;
            }

            formData.append('file', file);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.object.src = data.url;
                self.object.src_full = data.url_full;
                self.object.src_size = data.filesize;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        openResource: function openResource(url) {
            window.open(url, "_blank");
        }
    }
});

/***/ }),

/***/ "pUmS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('pc_status') ? localStorage.getItem('pc_status') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/post/categories/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/posts/categories/', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
                localStorage.setItem('posts_categories', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-posts-category',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('post/categories') < 1) {
            localStorage.setItem('pc_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "q9yi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            object: null,
            locales: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/effect/categories');
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/effects/categories/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.object = data.category;
                self.locales = data.locales;

                _.map(self.locales, function (l) {

                    var tModel = _.find(self.object.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var object = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.object));

            object.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            if (object.color[0] !== '#') {
                object.color = '#' + object.color;
            }

            if (object.color.length < 7) {
                var notification = {
                    template: '<span><b>\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0446\u0432\u0435\u0442\u0430 \u0444\u043E\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                return false;
            }

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/effects/categories/' + this.id + '/update', object, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                //self.$router.push('/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }

    }
});

/***/ }),

/***/ "qMsu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("ejaj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d513052_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("qqsO");
function injectStyle (ssrContext) {
  __webpack_require__("fn8/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d513052"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d513052_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qUkk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qg9l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");
var moment = __webpack_require__("PJh5");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            columns: ['period', 'my_feed', 'muse', 'nola', 'wallpapers', 'cleaner', 'other', 'summary', ''],
            data: [],
            summary: [],
            dateStart: '',
            dateEnd: '',
            type: "",
            dates_start: localStorage.getItem('r_dates_start') ? JSON.parse(localStorage.getItem('r_dates_start')) : [],
            dates_end: localStorage.getItem('r_dates_end') ? JSON.parse(localStorage.getItem('r_dates_end')) : [],
            loading: false
        };
    },

    filters: {
        toEasyDate: function toEasyDate(value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY');
            } else {
                return '';
            }
        },
        toMoneyFormat: function toMoneyFormat(value) {
            if (value) {
                return Intl.NumberFormat().format(value);
            } else {
                return '';
            }
        }
    },
    created: function created() {
        this.get();
    },
    methods: {
        // Imagine (3) + Framy (4) + Aura (5)
        other: function other(info) {
            if (!info) return 0;
            return [3, 4, 5].reduce(function (sum, i) {
                return sum + (parseFloat(info[i]) || 0);
            }, 0);
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/reports/create');
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-report',
                params: { id: id }
            });
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            var dateStart = this.dateStart === null ? '' : this.dateStart;
            var dateEnd = this.dateEnd === null ? '' : this.dateEnd;

            this.loading = true;

            axios.get(this.$hostname + '/admin/reports/', {
                'params': {
                    date_start: dateStart,
                    date_end: dateEnd
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.loading = false;
                self.data = response.data.reports;
                self.summary = response.data.sumArray;

                var reversed = _.reverse(self.data);
                if (self.dates_start.length < 1) {
                    _.map(reversed, function (d) {
                        self.dates_start.push(d.date_start);
                    });
                    localStorage.setItem('r_dates_start', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.dates_start));
                }
                if (self.dates_end.length < 1) {
                    _.map(reversed, function (d) {
                        self.dates_end.push(d.date_end);
                    });
                    localStorage.setItem('r_dates_end', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.dates_end));
                }
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        localStorage.setItem('r_dates_start', []);
        localStorage.setItem('r_dates_end', []);
        next();
    }
});

/***/ }),

/***/ "qnwY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditTab',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            object: null,
            categories: [],
            locales: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get();
        this.getCategories();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/tabs');
        },
        get: function get() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/tabs/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.object = data.tab;
                self.locales = data.locales;

                _.map(self.locales, function (l) {

                    var tModel = _.find(self.object.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        getCategories: function getCategories() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/categories/', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.categories = response.data;
                self.loading = false;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        save: function save() {
            var self = this;

            var tab = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.object));

            tab.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/tabs/' + this.id + '/update', tab, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0412\u043A\u043B\u0430\u0434\u043A\u0430 \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                //self.$router.push('/tabs');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }

    }
});

/***/ }),

/***/ "qqsO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[(_vm.track)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.is_premium),expression:"track.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.track.is_premium)?_vm._i(_vm.track.is_premium,null)>-1:(_vm.track.is_premium)},on:{"change":function($event){var $$a=_vm.track.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.track, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.track, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.track, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trendy-control"}},[_vm._v("Copyright free")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.is_free),expression:"track.is_free"}],staticClass:"form-check-inline",attrs:{"id":"trendy-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.track.is_free)?_vm._i(_vm.track.is_free,null)>-1:(_vm.track.is_free)},on:{"change":function($event){var $$a=_vm.track.is_free,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.track, "is_free", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.track, "is_free", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.track, "is_free", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Альбом")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.album_id),expression:"track.album_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.track, "album_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.albums),function(a){return (a.id > 2)?_c('option',{domProps:{"value":a.id}},[_vm._v(_vm._s(a.name))]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.status),expression:"track.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.track, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Артист","placeholder":""},model:{value:(_vm.track.artist),callback:function ($$v) {_vm.$set(_vm.track, "artist", $$v)},expression:"track.artist"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название","placeholder":""},model:{value:(_vm.track.title),callback:function ($$v) {_vm.$set(_vm.track, "title", $$v)},expression:"track.title"}}),_vm._v(" "),(!_vm.track.is_free)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на Reels audio","placeholder":""},model:{value:(_vm.track.song_insta),callback:function ($$v) {_vm.$set(_vm.track, "song_insta", $$v)},expression:"track.song_insta"}}):_vm._e(),_vm._v(" "),(!_vm.track.is_free)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на TikTok audio","placeholder":""},model:{value:(_vm.track.song_tiktok),callback:function ($$v) {_vm.$set(_vm.track, "song_tiktok", $$v)},expression:"track.song_tiktok"}}):_vm._e(),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Длительность","placeholder":""},model:{value:(_vm.track.duration),callback:function ($$v) {_vm.$set(_vm.track, "duration", $$v)},expression:"track.duration"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.track.sort),callback:function ($$v) {_vm.$set(_vm.track, "sort", $$v)},expression:"track.sort"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Фон: "),(_vm.track.image_src)?_c('span',[_c('span',{staticClass:"inline-link"}),_vm._v(" "),_c('span',{staticClass:"inline-link"},[(_vm.track.image_src_size >= 4)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.track.image_src_size)+"Mb")]):(_vm.track.image_src_size >= 2)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.track.image_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.track.image_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.track.image_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"device-block device1",attrs:{"src":_vm.track.image_src_full},on:{"click":function($event){$event.preventDefault();return _vm.openResource(_vm.track.image_src_full)}}}),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'image_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Аудио: "),(_vm.track.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.track.src_size >= 4)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]):(_vm.track.src_size >= 2)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.track.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"audioFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"audio/mp3"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.audioFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.track.album_id || !_vm.track.sort || !_vm.track.title || !_vm.track.artist || !_vm.track.src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Параметры")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.track)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Количество фрагментов","placeholder":""},on:{"input":_vm.changeTrackCount},model:{value:(_vm.track.count_parts),callback:function ($$v) {_vm.$set(_vm.track, "count_parts", $$v)},expression:"track.count_parts"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('fg-input',{attrs:{"type":"text","label":"Скопировать из шаблона (ID)","placeholder":""},model:{value:(_vm.templateIdToCopy),callback:function ($$v) {_vm.templateIdToCopy=$$v},expression:"templateIdToCopy"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","id":"btn-download","disabled":!_vm.templateIdToCopy},on:{"click":function($event){$event.preventDefault();return _vm.getTemplateById.apply(null, arguments)}}},[_vm._v("\n                                            Скопировать\n                                        ")])])]),_vm._v(" "),_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[(_vm.track.realAudioDuration)?_c('div',{staticClass:"realDuration"},[_vm._v("\n                                        Длительность из аудио:\n                                        "),_c('span',[_vm._v(_vm._s(_vm.track.realAudioDuration.toFixed(2)))])]):_vm._e(),_vm._v("\n                                    Длительность фрагментов:\n                                    "),(Math.abs(_vm.sumParts - _vm.track.duration) > 0)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.sumParts))]):_c('span',[_vm._v(_vm._s(_vm.sumParts))])]),_vm._v(" "),_vm._l((_vm.track.parts),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('span',{staticClass:"block-number"},[_vm._v(_vm._s(index + 1)+".")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('fg-input',{attrs:{"type":"text","label":"Длительность","placeholder":""},on:{"input":function($event){return _vm.formatDuration($event, index)}},model:{value:(_vm.track.parts[index].duration),callback:function ($$v) {_vm.$set(_vm.track.parts[index], "duration", $$v)},expression:"track.parts[index].duration"}})],1)])])])})],2)])]):_vm._e()])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rVgw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            waiting: false,
            token: localStorage.getItem('token'),
            client_release_date: null,
            client_release_time: '12:00',
            task: {
                project_id: 9,
                is_premium: "all",
                version: "all",
                token: "",
                list_key: null,
                release_date: null,
                push_payload: {
                    type: "1",
                    id: "",
                    template_id: ""
                }
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                },
                timeout: 60000
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                for (var i = 0; i < data.locales.length; i++) {
                    data.locales[i].code = data.locales[i].locale;
                }

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        create: function create() {
            var self = this;

            //this.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(self.$hostname + '/admin/services/push/tasks/create', self.task, {
                'headers': {
                    'Authorization': 'Bearer ' + self.token
                },
                timeout: 60000
            }).then(function (response) {

                setTimeout(function () {
                    self.waiting = false;

                    var notification = {
                        template: '<span><b>\u0417\u0430\u0434\u0430\u0447\u0430 \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.$router.push('/push-tasks');
                }, 3000);
            }).catch(function (error) {

                self.waiting = false;

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            this.task.locales = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            this.task.release_date = this.client_release_date + ' ' + this.client_release_time + ':00';

            this.waiting = true;

            if (this.task.token) {
                self.create();
            } else {

                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/push/tasks/audience', this.task, {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                }).then(function (response) {

                    if (confirm("Подтвердить отправку уведомления " + response.data + " пользователям")) {

                        self.create();
                    } else {
                        self.waiting = false;
                    }
                }).catch(function (error) {

                    self.waiting = false;

                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
                });
            }
        }
    }
});

/***/ }),

/***/ "rXY7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rdED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            font: null,
            locales: [],
            categories: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.getCategories();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/fonts');
        },
        getCategories: function getCategories() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/fonts/categories', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.categories = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.get(self.id);
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/fonts/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.font = data;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var font = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.font));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/fonts/' + this.id + '/update', font, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0428\u0440\u0438\u0444\u0442 \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.font.src = data.url;
                self.font.src_full = data.url_full;
                self.font.src_size = data.filesize;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }

    }
});

/***/ }),

/***/ "rkeS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rm95":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[(_vm.track)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.is_premium),expression:"track.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.track.is_premium)?_vm._i(_vm.track.is_premium,null)>-1:(_vm.track.is_premium)},on:{"change":function($event){var $$a=_vm.track.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.track, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.track, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.track, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trendy-control"}},[_vm._v("Популярный")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.is_trendy),expression:"track.is_trendy"}],staticClass:"form-check-inline",attrs:{"id":"trendy-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.track.is_trendy)?_vm._i(_vm.track.is_trendy,null)>-1:(_vm.track.is_trendy)},on:{"change":function($event){var $$a=_vm.track.is_trendy,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.track, "is_trendy", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.track, "is_trendy", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.track, "is_trendy", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Альбом")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.album_id),expression:"track.album_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.track, "album_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.albums),function(a){return (a.id !== 999)?_c('option',{domProps:{"value":a.id}},[_vm._v(_vm._s(a.name))]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.status),expression:"track.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.track, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Артист","placeholder":""},model:{value:(_vm.track.artist),callback:function ($$v) {_vm.$set(_vm.track, "artist", $$v)},expression:"track.artist"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название","placeholder":""},model:{value:(_vm.track.title),callback:function ($$v) {_vm.$set(_vm.track, "title", $$v)},expression:"track.title"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Длительность","readonly":"","placeholder":""},model:{value:(_vm.track.duration),callback:function ($$v) {_vm.$set(_vm.track, "duration", $$v)},expression:"track.duration"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.track.sort),callback:function ($$v) {_vm.$set(_vm.track, "sort", $$v)},expression:"track.sort"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Фон: "),(_vm.track.image_src)?_c('span',[_c('span',{staticClass:"inline-link"},[_c('a',{attrs:{"href":_vm.track.image_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'image_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Аудио: "),(_vm.track.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.track.src_size >= 4)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]):(_vm.track.src_size >= 2)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.track.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"audioFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"audio/mp3"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.audioFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.track.album_id || !_vm.track.sort || !_vm.track.title || !_vm.track.artist || !_vm.track.src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rwrd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.is_premium),expression:"object.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.object.is_premium)?_vm._i(_vm.object.is_premium,null)>-1:(_vm.object.is_premium)},on:{"change":function($event){var $$a=_vm.object.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.object, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.object, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.object, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.category_id),expression:"object.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return (c.id !== 999)?_c('option',{domProps:{"value":c.id}},[_vm._v("\n                                            "+_vm._s(c.name)+"\n                                        ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Доступно для редактирования")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.no_color),expression:"object.no_color"}],staticClass:"form-control",attrs:{"id":"status-control","disabled":!_vm.isSvgSrc(_vm.object.src),"aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "no_color", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Доступно")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Не доступно")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Стикер: "),(_vm.object.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.object.src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]):(_vm.object.src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.object.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),(_vm.object.src_full)?_c('img',{staticClass:"device-block device1",attrs:{"src":("" + (_vm.object.src_full))},on:{"click":function($event){$event.preventDefault();return _vm.openResource(_vm.object.src_full)}}}):_vm._e(),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":".gif,.svg,.png,.jpg,.jpeg,.webp,image/gif,image/svg+xml,image/png,image/jpeg,image/webp"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.category_id || !_vm.object.src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s8pP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            object: {
                status: 0,
                object_count: 0,
                translations: [],
                sort: 1
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/frame/categories');
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var object = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.object));

            object.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/frames/categories/create', object, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/frame/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }
    }
});

/***/ }),

/***/ "s980":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FramesCategories_vue__ = __webpack_require__("Ejjt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd307730_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FramesCategories_vue__ = __webpack_require__("Gxik");
function injectStyle (ssrContext) {
  __webpack_require__("6t5d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bd307730"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FramesCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd307730_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FramesCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sFCw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Graphics_vue__ = __webpack_require__("duiC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67dd3bf5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Graphics_vue__ = __webpack_require__("P9to");
function injectStyle (ssrContext) {
  __webpack_require__("xVza")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67dd3bf5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Graphics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67dd3bf5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Graphics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sNwX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("zBoB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_068b89ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("tU9Q");
function injectStyle (ssrContext) {
  __webpack_require__("hLOT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-068b89ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_068b89ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sO3G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("CHFh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_393f9372_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("M2Iw");
function injectStyle (ssrContext) {
  __webpack_require__("xG3w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-393f9372"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_393f9372_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'drop-down',
    props: {
        title: String,
        icon: String,
        tag: {
            type: String,
            default: 'li'
        }
    },
    data: function data() {
        return {
            isOpen: false
        };
    },

    methods: {
        toggleDropDown: function toggleDropDown() {
            this.isOpen = !this.isOpen;
            this.$emit('change', this.isOpen);
        },
        closeDropDown: function closeDropDown() {
            this.isOpen = false;
            this.$emit('change', this.isOpen);
        }
    }
});

/***/ }),

/***/ "tN2X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tO0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Фреймы")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryId),expression:"categoryId"}],staticClass:"form-control",attrs:{"id":"category-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('frr_category', _vm.categoryId)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('frr_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Поиск по ID","placeholder":""},model:{value:(_vm.filteredId),callback:function ($$v) {_vm.filteredId=$$v},expression:"filteredId"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Поиск по src","placeholder":""},model:{value:(_vm.filteredSrc),callback:function ($$v) {_vm.filteredSrc=$$v},expression:"filteredSrc"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'category')?_c('span',[_vm._v("категория")]):(column === 'src_full')?_c('span',[_vm._v("графика")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'src')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[_c('img',{staticClass:"device-block device1",attrs:{"src":("" + (item[column]))}})]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активен")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активен")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tTNm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tTt6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tU9Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.object.sort),callback:function ($$v) {_vm.$set(_vm.object, "sort", $$v)},expression:"object.sort"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tlV/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u6Ka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.image)?_c('div',{staticClass:"card-image"},[_vm._t("image")],2):_vm._e(),_vm._v(" "),(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uZPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditTag',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            tag: null,
            locales: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/tags');
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/tags/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.tag = data.tag;
                self.locales = data.locales;

                _.map(self.locales, function (l) {

                    var tModel = _.find(self.tag.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var tag = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tag));

            tag.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/tags/' + this.id + '/update', tag, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0422\u0435\u0433 \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                //self.$router.push('/tags');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }

    }
});

/***/ }),

/***/ "ufGv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uq3p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uzar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            data: {
                reports_src: null,
                reportsBRL_src: null,
                rates_src: null,
                revenue: 0,
                revenue_0: 0,
                revenue_1: 0,
                revenue_2: 0,
                revenue_3: 0,
                revenue_4: 0
            }
        };
    },

    created: function created() {},
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        upload: function upload() {
            var self = this;

            var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/reports/parse', data, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {
                self.waiting = false;

                var id = response.data.id;

                self.$router.push('/reports/');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {

            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/reports/file/upload', formData, {
                params: {
                    file_type: type,
                    reports: true
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.data[data.file_type] = data.url;
                self.data[data.file_type + '_full'] = data.url_full;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }
    }
});

/***/ }),

/***/ "vbaG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('gfcat_status') ? localStorage.getItem('gfcat_status') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/font/categories/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/fonts/categories', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
                localStorage.setItem('fonts-categories', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-fonts-category',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('font/categories') < 1) {
            localStorage.setItem('gfcat_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "vcJA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.is_premium),expression:"object.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.object.is_premium)?_vm._i(_vm.object.is_premium,null)>-1:(_vm.object.is_premium)},on:{"change":function($event){var $$a=_vm.object.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.object, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.object, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.object, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.category_id),expression:"object.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return (c.id !== 999)?_c('option',{domProps:{"value":c.id}},[_vm._v("\n                                            "+_vm._s(c.name)+"\n                                        ")]):_vm._e()}),0)]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название","placeholder":""},model:{value:(_vm.object.name),callback:function ($$v) {_vm.$set(_vm.object, "name", $$v)},expression:"object.name"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Метод наложения")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.params.mode),expression:"object.params.mode"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object.params, "mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Normal")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Add")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Multiply")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Screen")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Overlay")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Lighten")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("HardLight")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("SoftLight")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Прозрачность по умолчанию (от 1 до 0)","placeholder":""},model:{value:(_vm.object.params.opacity),callback:function ($$v) {_vm.$set(_vm.object.params, "opacity", $$v)},expression:"object.params.opacity"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Максимальная прозрачность (по умолчанию 1)","placeholder":""},model:{value:(_vm.object.params.max_opacity),callback:function ($$v) {_vm.$set(_vm.object.params, "max_opacity", $$v)},expression:"object.params.max_opacity"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.object.sort),callback:function ($$v) {_vm.$set(_vm.object, "sort", $$v)},expression:"object.sort"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Эффект: "),(_vm.object.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.object.src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]):(_vm.object.src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.object.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"device-block device1",attrs:{"src":_vm.object.src_full},on:{"click":function($event){$event.preventDefault();return _vm.openResource(_vm.eobject.src_full)}}}),_vm._v(" "),_c('div',[_c('input',{ref:"srcFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.srcFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('h4',{staticClass:"card-title",staticStyle:{"margin-top":"30px"},attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Превью (jpg): "),(_vm.object.preview_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.object.preview_src_size >= 0.1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.object.preview_src_size)+"Mb")]):(_vm.object.preview_src_size >= 0.05)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.object.preview_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.object.preview_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.object.preview_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"device-block device1",attrs:{"src":_vm.object.preview_src_full},on:{"click":function($event){$event.preventDefault();return _vm.openResource(_vm.object.preview_src_full)}}}),_vm._v(" "),_c('div',[_c('input',{ref:"previewSrcFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'preview_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.previewSrcFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.sort || !_vm.object.category_id || !_vm.object.src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vqQU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vwmR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'image_src_full', 'tracks_number', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('a_status') ? localStorage.getItem('a_status') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/albums/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/albums/', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-album',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('albums') < 1) {
            localStorage.setItem('a_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "vxzy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateTab',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            categories: [],
            object: {
                status: 0,
                type: 1,
                translations: [],
                params: {
                    category_id: null,
                    by_property: null
                },
                sort: 1
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
        this.getCategories();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/tabs');
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        getCategories: function getCategories() {
            var self = this;

            var token = localStorage.getItem('token');

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/categories/', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.categories = response.data;
                self.loading = false;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        save: function save() {
            var self = this;

            var tab = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.object));

            tab.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/tabs/create', tab, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0412\u043A\u043B\u0430\u0434\u043A\u0430 \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/tabs');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }
    }
});

/***/ }),

/***/ "w4xd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[(_vm.object)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                            Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-usage",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.openUsage.apply(null, arguments)}}},[_vm._v("\n                                Где используется этот фрейм\n                            ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.is_premium),expression:"object.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.object.is_premium)?_vm._i(_vm.object.is_premium,null)>-1:(_vm.object.is_premium)},on:{"change":function($event){var $$a=_vm.object.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.object, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.object, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.object, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.category_id),expression:"object.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return (c.id !== 999)?_c('option',{domProps:{"value":c.id}},[_vm._v("\n                                                "+_vm._s(c.name)+"\n                                            ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип наложения layout")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.type),expression:"object.type"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Над фреймом")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Под фреймом")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Src","placeholder":""},model:{value:(_vm.object.src),callback:function ($$v) {_vm.$set(_vm.object, "src", $$v)},expression:"object.src"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.object.sort),callback:function ($$v) {_vm.$set(_vm.object, "sort", $$v)},expression:"object.sort"}}),_vm._v(" "),_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Фрейм: "),(_vm.object.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.object.src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]):(_vm.object.src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.object.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.object.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"device-block device1",attrs:{"id":"preview-img","src":_vm.object.src_full},on:{"click":function($event){$event.preventDefault();return _vm.openResource(_vm.object.src_full)}}}),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'object_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.sort || !_vm.object.category_id || !_vm.object.src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                    Сохранить\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"btn btn-delete btn-danger btn-fill float-right btn-save",on:{"click":function($event){return _vm.remove()}}},[_vm._v("\n                                    Удалить\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6",staticStyle:{"background":"#C9D5DF"}},[_c('div',{staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"img-wrap"},[_c('img',{ref:"img",staticClass:"frame",attrs:{"id":"frame-img","src":_vm.object.src_full,"alt":""}}),_vm._v(" "),_vm._l((_vm.object.params),function(pa,index){return (pa.w && pa.h)?_c('div',{staticClass:"frame-layouts",attrs:{"id":("pa" + index)},domProps:{"innerHTML":_vm._s(_vm.layout_html(index))},on:{"click":function($event){return _vm.selectLayout(index)}}}):_vm._e()})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Layouts\n                                ")]),_vm._v(" "),_c('form',[(_vm.object)?_c('div',{staticClass:"texts-buttons"},[_vm._l((_vm.object.layouts),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_layout },attrs:{"type":"button"},on:{"click":function($event){return _vm.selectLayout(index)}}},[_vm._v("Layout "+_vm._s(index + 1)+"\n                                        ")])}),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill",attrs:{"type":"button"},on:{"click":function($event){return _vm.addLayout()}}},[_vm._v("+\n                                        ")])],2):_vm._e(),_vm._v(" "),_vm._l((_vm.object.params),function(rawData,index){return _c('div',{staticClass:"row frame-params",class:{ 'active' : index === _vm.active_layout }},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Ширина фрейма в Figma","placeholder":""},model:{value:(rawData.original_w),callback:function ($$v) {_vm.$set(rawData, "original_w", $$v)},expression:"rawData.original_w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Высота фрейма в Figma","placeholder":""},model:{value:(rawData.original_h),callback:function ($$v) {_vm.$set(rawData, "original_h", $$v)},expression:"rawData.original_h"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Ширина редактируемой области","placeholder":""},model:{value:(rawData.w),callback:function ($$v) {_vm.$set(rawData, "w", $$v)},expression:"rawData.w"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Высота редактируемой области","placeholder":""},model:{value:(rawData.h),callback:function ($$v) {_vm.$set(rawData, "h", $$v)},expression:"rawData.h"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ сверху","placeholder":""},model:{value:(rawData.y),callback:function ($$v) {_vm.$set(rawData, "y", $$v)},expression:"rawData.y"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Отступ слева","placeholder":""},model:{value:(rawData.x),callback:function ($$v) {_vm.$set(rawData, "x", $$v)},expression:"rawData.x"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Радиус верхний левый","placeholder":""},model:{value:(rawData.b_tl),callback:function ($$v) {_vm.$set(rawData, "b_tl", $$v)},expression:"rawData.b_tl"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус верхний правый","placeholder":""},model:{value:(rawData.b_tr),callback:function ($$v) {_vm.$set(rawData, "b_tr", $$v)},expression:"rawData.b_tr"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус нижний левый","placeholder":""},model:{value:(rawData.b_bl),callback:function ($$v) {_vm.$set(rawData, "b_bl", $$v)},expression:"rawData.b_bl"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Радиус нижний правый","placeholder":""},model:{value:(rawData.b_br),callback:function ($$v) {_vm.$set(rawData, "b_br", $$v)},expression:"rawData.b_br"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeLayout(_vm.active_layout)}}},[_vm._v("Удалить layout\n                                            ")])],1)])})],2)])])])],1)]):_vm._e()]),_vm._v(" "),(_vm.show_usage_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeUsage}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Где используется этот фрейм")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-close-modal",attrs:{"type":"button"},on:{"click":_vm.closeUsage}},[_vm._v("\n                            Закрыть\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.usage_loading)?_c('div',{staticClass:"usage-loader"}):_vm._e(),_vm._v(" "),(!_vm.usage_loading && !_vm.usage.templates.length && !_vm.usage.carousels.length)?_c('div',{staticClass:"usage-empty"},[_vm._v("\n                            Этот фрейм нигде не используется\n                        ")]):_vm._e(),_vm._v(" "),(!_vm.usage_loading && _vm.usage.templates.length)?_c('div',[_c('h5',{staticClass:"usage-section-title"},[_vm._v("Шаблоны "),_c('span',[_vm._v(_vm._s(_vm.usage.templates.length))])]),_vm._v(" "),_c('div',{staticClass:"usage-grid"},_vm._l((_vm.usage.templates),function(item){return _c('div',{key:'t-' + item.id,staticClass:"usage-card",on:{"click":function($event){return _vm.openTemplate(item.id)}}},[_c('div',{staticClass:"usage-preview"},[(_vm.isVideo(item.preview_src_full))?_c('video',{attrs:{"muted":"","loop":"","autoplay":"","playsinline":"","src":item.preview_src_full},domProps:{"muted":true}}):(item.preview_src_full)?_c('img',{attrs:{"src":item.preview_src_full,"alt":""}}):_c('div',{staticClass:"usage-preview-empty"},[_vm._v("нет превью")])]),_vm._v(" "),_c('div',{staticClass:"usage-meta"},[_c('div',{staticClass:"usage-id"},[_vm._v("#"+_vm._s(item.id))]),_vm._v(" "),_c('div',{staticClass:"usage-category"},[_vm._v(_vm._s(item.category))]),_vm._v(" "),(item.release_date)?_c('div',{staticClass:"usage-status text-primary"},[_vm._v("Запланировано")]):(item.status === 1)?_c('div',{staticClass:"usage-status text-success"},[_vm._v("Опубликовано")]):_c('div',{staticClass:"usage-status text-warning"},[_vm._v("Ожидает")])])])}),0)]):_vm._e(),_vm._v(" "),(!_vm.usage_loading && _vm.usage.carousels.length)?_c('div',[_c('h5',{staticClass:"usage-section-title"},[_vm._v("Карусели "),_c('span',[_vm._v(_vm._s(_vm.usage.carousels.length))])]),_vm._v(" "),_c('div',{staticClass:"usage-grid"},_vm._l((_vm.usage.carousels),function(item){return _c('div',{key:'c-' + item.id,staticClass:"usage-card",on:{"click":function($event){return _vm.openCarousel(item.id)}}},[_c('div',{staticClass:"usage-preview",class:{ 'is-square': item.ratio == 4 }},[(item.preview_src_full)?_c('img',{attrs:{"src":item.preview_src_full,"alt":""}}):_c('div',{staticClass:"usage-preview-empty"},[_vm._v("нет превью")])]),_vm._v(" "),_c('div',{staticClass:"usage-meta"},[_c('div',{staticClass:"usage-id"},[_vm._v("#"+_vm._s(item.id))]),_vm._v(" "),_c('div',{staticClass:"usage-category"},[_vm._v(_vm._s(item.category))]),_vm._v(" "),(item.status === 1)?_c('div',{staticClass:"usage-status text-success"},[_vm._v("Активен")]):_c('div',{staticClass:"usage-status text-warning"},[_vm._v("Не активен")]),_vm._v(" "),(item.parts && item.parts.length)?_c('div',{staticClass:"usage-parts"},[_vm._v("\n                                            слайды: "+_vm._s(item.parts.join(', '))+"\n                                        ")]):_vm._e()])])}),0)]):_vm._e()])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w5Qj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.is_premium),expression:"track.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.track.is_premium)?_vm._i(_vm.track.is_premium,null)>-1:(_vm.track.is_premium)},on:{"change":function($event){var $$a=_vm.track.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.track, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.track, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.track, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trendy-control"}},[_vm._v("Copyright free")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.is_free),expression:"track.is_free"}],staticClass:"form-check-inline",attrs:{"id":"trendy-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.track.is_free)?_vm._i(_vm.track.is_free,null)>-1:(_vm.track.is_free)},on:{"change":function($event){var $$a=_vm.track.is_free,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.track, "is_free", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.track, "is_free", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.track, "is_free", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Альбом")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.album_id),expression:"track.album_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.track, "album_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.albums),function(a){return (a.id > 2)?_c('option',{domProps:{"value":a.id}},[_vm._v(_vm._s(a.name))]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.status),expression:"track.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.track, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Артист","placeholder":""},model:{value:(_vm.track.artist),callback:function ($$v) {_vm.$set(_vm.track, "artist", $$v)},expression:"track.artist"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название","placeholder":""},model:{value:(_vm.track.title),callback:function ($$v) {_vm.$set(_vm.track, "title", $$v)},expression:"track.title"}}),_vm._v(" "),(!_vm.track.is_free)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на Reels audio","placeholder":""},model:{value:(_vm.track.song_insta),callback:function ($$v) {_vm.$set(_vm.track, "song_insta", $$v)},expression:"track.song_insta"}}):_vm._e(),_vm._v(" "),(!_vm.track.is_free)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на TikTok audio","placeholder":""},model:{value:(_vm.track.song_tiktok),callback:function ($$v) {_vm.$set(_vm.track, "song_tiktok", $$v)},expression:"track.song_tiktok"}}):_vm._e(),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Длительность","placeholder":""},model:{value:(_vm.track.duration),callback:function ($$v) {_vm.$set(_vm.track, "duration", $$v)},expression:"track.duration"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.track.sort),callback:function ($$v) {_vm.$set(_vm.track, "sort", $$v)},expression:"track.sort"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Фон: "),(_vm.track.image_src)?_c('span',[_c('span',{staticClass:"inline-link"}),_vm._v(" "),_c('span',{staticClass:"inline-link"},[(_vm.track.image_src_size >= 4)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.track.image_src_size)+"Mb")]):(_vm.track.image_src_size >= 2)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.track.image_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.track.image_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.track.image_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"device-block device1",attrs:{"src":_vm.track.image_src_full},on:{"click":function($event){$event.preventDefault();return _vm.openResource(_vm.track.image_src_full)}}}),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'image_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Аудио: "),(_vm.track.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.track.src_size >= 4)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]):(_vm.track.src_size >= 2)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.track.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"audioFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"audio/mp3"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.audioFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.track.album_id || !_vm.track.sort || !_vm.track.title || !_vm.track.artist || !_vm.track.src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Параметры")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.track)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Количество фрагментов","placeholder":""},on:{"input":_vm.changeTrackCount},model:{value:(_vm.track.count_parts),callback:function ($$v) {_vm.$set(_vm.track, "count_parts", $$v)},expression:"track.count_parts"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('fg-input',{attrs:{"type":"text","label":"Скопировать из шаблона (ID)","placeholder":""},model:{value:(_vm.templateIdToCopy),callback:function ($$v) {_vm.templateIdToCopy=$$v},expression:"templateIdToCopy"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","id":"btn-download","disabled":!_vm.templateIdToCopy},on:{"click":function($event){$event.preventDefault();return _vm.getTemplateById.apply(null, arguments)}}},[_vm._v("\n                                            Скопировать\n                                        ")])])]),_vm._v(" "),_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[(_vm.track.realAudioDuration)?_c('div',{staticClass:"realDuration"},[_vm._v("\n                                        Длительность из аудио:\n                                        "),_c('span',[_vm._v(_vm._s(_vm.track.realAudioDuration.toFixed(2)))])]):_vm._e(),_vm._v("\n                                    Длительность фрагментов:\n                                    "),(Math.abs(_vm.sumParts - _vm.track.duration) > 0)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.sumParts))]):_c('span',[_vm._v(_vm._s(_vm.sumParts))])]),_vm._v(" "),_vm._l((_vm.track.parts),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('span',{staticClass:"block-number"},[_vm._v(_vm._s(index + 1)+".")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('fg-input',{attrs:{"type":"text","label":"Длительность","placeholder":""},on:{"input":function($event){return _vm.formatDuration($event, index)}},model:{value:(_vm.track.parts[index].duration),callback:function ($$v) {_vm.$set(_vm.track.parts[index], "duration", $$v)},expression:"track.parts[index].duration"}})],1)])])])})],2)])]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wR3j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("YbGq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e07a95d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("PfAX");
function injectStyle (ssrContext) {
  __webpack_require__("HINT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e07a95d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e07a95d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wk3R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[(_vm.font)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.font.is_premium),expression:"font.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.font.is_premium)?_vm._i(_vm.font.is_premium,null)>-1:(_vm.font.is_premium)},on:{"change":function($event){var $$a=_vm.font.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.font, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.font, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.font, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.font.category_id),expression:"font.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.font, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v("\n                                            "+_vm._s(c.name)+"\n                                        ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.font.status),expression:"font.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.font, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название","placeholder":""},model:{value:(_vm.font.name),callback:function ($$v) {_vm.$set(_vm.font, "name", $$v)},expression:"font.name"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.font.sort),callback:function ($$v) {_vm.$set(_vm.font, "sort", $$v)},expression:"font.sort"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Шрифт: "),(_vm.font.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.font.src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.font.src_size)+"Mb")]):(_vm.font.image_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.font.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.font.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.font.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'font')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.font.category_id || !_vm.font.name || !_vm.font.src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x//Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("kP44");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40762496_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("nQI6");
function injectStyle (ssrContext) {
  __webpack_require__("lIQK")
  __webpack_require__("UQTq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40762496"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40762496_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xG3w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "xP3F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditMusicCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            album: null,
            locales: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/music/categories');
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/music/categories/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.album = data.album;
                self.locales = data.locales;

                _.map(self.locales, function (l) {

                    var tModel = _.find(self.album.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var album = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.album));

            album.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/music/categories/' + this.id + '/update', album, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0410\u043B\u044C\u0431\u043E\u043C \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        }

    }
});

/***/ }),

/***/ "xVco":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xVza":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xdsI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            object: {
                status: 0,
                object_count: 0,
                translations: [],
                sort: 1
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/graphic/categories');
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var object = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.object));

            object.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/graphics/categories/create', object, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/graphic/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }
    }
});

/***/ }),

/***/ "xtqh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xvC0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourcePreview_vue__ = __webpack_require__("Lehl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7836340_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourcePreview_vue__ = __webpack_require__("78V2");
function injectStyle (ssrContext) {
  __webpack_require__("hYIP")
  __webpack_require__("tlV/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7836340"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourcePreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7836340_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourcePreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y13M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.category_id),expression:"object.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return (c.id !== 999)?_c('option',{domProps:{"value":c.id}},[_vm._v("\n                                            "+_vm._s(c.name)+"\n                                        ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип контента")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.type),expression:"object.type"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Категория")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("По свойству")])])]),_vm._v(" "),(_vm.object.type == 2)?_c('fg-input',{attrs:{"type":"text","label":"Свойство","placeholder":""},model:{value:(_vm.object.params.by_property),callback:function ($$v) {_vm.$set(_vm.object.params, "by_property", $$v)},expression:"object.params.by_property"}}):_vm._e(),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке).\n                                          <br>Discover = <b>100</b>; Created by AI = <b>80</b>; Reels = <b>50</b>; TikTok = <b>40</b>;","placeholder":""},model:{value:(_vm.object.sort),callback:function ($$v) {_vm.$set(_vm.object, "sort", $$v)},expression:"object.sort"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.sort || !_vm.object.type || (!_vm.object.category_id && !_vm.object.params.by_property)},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y4V3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yFli":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("YGHn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef7e0bd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("Ky1W");
function injectStyle (ssrContext) {
  __webpack_require__("K7qa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ef7e0bd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef7e0bd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yUUj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yYt2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.object.status),expression:"object.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.object, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.object.sort),callback:function ($$v) {_vm.$set(_vm.object, "sort", $$v)},expression:"object.sort"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.object.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.object)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yeRO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("xP3F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9efeae7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("1IYL");
function injectStyle (ssrContext) {
  __webpack_require__("YCpc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9efeae7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9efeae7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z6Gw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[_c('notifications'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zBoB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            object: null,
            locales: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            this.$router.push('/font/categories');
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/fonts/categories/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.object = data.category;
                self.locales = data.locales;

                _.map(self.locales, function (l) {

                    var tModel = _.find(self.object.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var object = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.object));

            object.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/fonts/categories/' + this.id + '/update', object, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                //self.$router.push('/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }

    }
});

/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        routeName: function routeName() {
            var name = this.$route.name;

            return this.capitalizeFirstLetter(name);
        }
    },
    data: function data() {
        return {
            activeNotifications: false
        };
    },

    methods: {
        capitalizeFirstLetter: function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleNotificationDropDown: function toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications;
        },
        closeDropDown: function closeDropDown() {
            this.activeNotifications = false;
        },
        toggleSidebar: function toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        hideSidebar: function hideSidebar() {
            this.$sidebar.displaySidebar(false);
        },

        logout: function logout() {
            localStorage.removeItem('token');

            this.$router.push('/login');
        }
    }
});

/***/ }),

/***/ "zrYM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d0c5a935995a6b83e4b9.js